export default {
    "AccountCategory": {
        "constants": {
            "SAVING": 1,
            "CHECKING": 2,
            "TIME_DEPOSIT": 3,
            "GENERAL_ACCOUNT": 4,
            "SAVING_DEPOSIT": 5,
            "LARGE_TIME_DEPOSIT": 6,
            "ACCUMULATED_TIME_DEPOSIT": 7,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "account_categories"
    },
    "AccountLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "active_account_count": null,
            "id": 0,
            "operated_at": null,
            "operation": null,
            "user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "account_logs"
    },
    "Alert": {
        "constants": {
            "STEP_TO_PARENT_RESOURCE_NAME_MAP": {
                "candidate_steps": "candidate_step_resources",
                "company_steps": "company_step_resources"
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "display_name": "",
            "id": 0,
            "message": null,
            "ms_alert_id": null,
            "ms_alert_setting_id": null,
            "resource_id": null,
            "resource_type": null,
            "slice_id": null,
            "updated_at": null,
            "user_id": null,
            "alertSetting": null,
            "alertNotifications": null,
            "user": null,
            "candidate": null,
            "candidateStepResource": null,
            "company": null,
            "companyStepResource": null,
            "staff": null,
            "billingDestination": null,
            "dispatchDestination": null,
            "dispatchStaff": null,
            "dispatchWorkingPlace": null,
            "dispatchOrganizationUnit": null,
            "job": null,
            "dispatchJob": null,
            "contract": null,
            "candidateJobStepResource": null,
            "sale": null
        },
        "relations": {
            "alertSetting": "AlertSetting",
            "alertNotifications": "AlertNotification",
            "user": "User",
            "candidate": "Candidate",
            "candidateStepResource": "CandidateStepResource",
            "company": "Company",
            "companyStepResource": "CompanyStepResource",
            "staff": "Staff",
            "billingDestination": "BillingDestination",
            "dispatchDestination": "DispatchDestination",
            "dispatchStaff": "DispatchStaff",
            "dispatchWorkingPlace": "DispatchWorkingPlace",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "job": "Job",
            "dispatchJob": "DispatchJob",
            "contract": "Contract",
            "candidateJobStepResource": "CandidateJobStepResource",
            "sale": "Sale"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "alerts"
    },
    "AlertNotification": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "alert_id": null,
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "read_at": null,
            "updated_at": null,
            "user_id": null,
            "alert": null,
            "user": null
        },
        "relations": {
            "alert": "Alert",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "alert_notifications"
    },
    "AlertSetting": {
        "constants": {
            "RESOURCES": [
                5001,
                67,
                64,
                2,
                65,
                3,
                5041,
                5018,
                5027,
                5021,
                4,
                78,
                14,
                5023,
                5025
            ],
            "RESOURCE_STATE_DUMMY_PROPERTY_CATEGORY": {
                "id": 9999,
                "display_name": "進捗日時表示",
                "candidate_step_display_name": "人材対応日時表示"
            },
            "RESOURCE_STATE_PREFIX": "state-id-",
            "REJECT_PROPERTY_COLUMNS_FOR_REPLACE_EDITOR_CASCADER": [
                5092,
                273,
                5245,
                5343,
                5242,
                5243,
                5244,
                5389,
                5046,
                5116,
                5113,
                5114,
                5115,
                5386,
                5139,
                5082,
                5062,
                5072,
                73,
                164,
                129
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "auto_state_id": null,
            "auto_state_type": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "display_name": null,
            "id": 0,
            "is_enabled": "1",
            "memo": null,
            "message": null,
            "ms_alert_setting_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "user_id": null,
            "user": null,
            "alertSettingConditions": null,
            "alertSettingNotificationUsers": null,
            "alerts": null
        },
        "relations": {
            "user": "User",
            "alertSettingConditions": "AlertSettingCondition",
            "alertSettingNotificationUsers": "AlertSettingNotificationUser",
            "alerts": "Alert"
        },
        "appends": [
            "has_deleted_auto_state"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "alert_settings"
    },
    "AlertSettingCondition": {
        "constants": {
            "CONDITIONS_COUNT_LOWER_LIMIT": 1,
            "CONDITIONS_COUNT_UPPER_LIMIT": 5,
            "INPUT_CATEGORIES": [
                3,
                4,
                8,
                9,
                1,
                2,
                5,
                22,
                7,
                20,
                11,
                6,
                21,
                16
            ],
            "SAMPLE_PROPERTY_COLUMNS_FOR_MOCK_PARAMS": {
                "App\\Models\\Candidate": [
                    2,
                    40,
                    4,
                    6,
                    31,
                    8,
                    18
                ]
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "alert_setting_id": null,
            "id": 0,
            "params": null,
            "property_column_id": null,
            "search_mode_id": null,
            "state_id": null,
            "state_type": null,
            "alertSetting": null,
            "propertyColumn": null,
            "searchMode": null
        },
        "relations": {
            "alertSetting": "AlertSetting",
            "propertyColumn": "PropertyColumn",
            "searchMode": "SearchMode"
        },
        "appends": [
            "has_deleted_condition_model"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "alert_setting_conditions"
    },
    "AlertSettingNotificationUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "alert_setting_id": null,
            "id": 0,
            "property_column_id": null,
            "user_id": null,
            "alertSetting": null,
            "propertyColumn": null,
            "user": null
        },
        "relations": {
            "alertSetting": "AlertSetting",
            "propertyColumn": "PropertyColumn",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "alert_setting_notification_users"
    },
    "AmountOverShort": {
        "constants": {
            "RESOURCE_TYPE_COMPANY": "App\\Models\\Company",
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "RESOURCE_TYPE_CANDIDATE": "App\\Models\\Candidate",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "allowance_id": null,
            "amount_over_short_type_id": null,
            "base_employment_insurance_boolean_default_type_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "id": 0,
            "invoice_amount": null,
            "invoice_taxation_type_id": null,
            "name": null,
            "payment_amount": null,
            "payment_taxation_type_id": null,
            "resource_id": null,
            "resource_type": null,
            "tax_rate_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "year_end_adjustment_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchMaster",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "amount_over_shorts"
    },
    "ApiRequestLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "client_id": null,
            "created_at": null,
            "id": 0,
            "method": null,
            "processed_time_ms": null,
            "request_host": null,
            "resource_name": null,
            "status_code": null,
            "updated_at": null,
            "user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "api_request_logs"
    },
    "ApiV2ErrorLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "api_request_log_id": null,
            "created_at": null,
            "id": 0,
            "response_body": null,
            "updated_at": null,
            "apiRequestLog": null
        },
        "relations": {
            "apiRequestLog": "ApiRequestLog"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "api_v2_error_logs"
    },
    "AppConstants": {
        "constants": {
            "BIRTH_DATE_YEAR_OPTION_FIRST_DIFF": -100,
            "BIRTH_DATE_YEAR_OPTION_LAST_DIFF": -15,
            "DATETIME_FORMAT_MOMENT": "YYYY-MM-DD HH:mm:ss",
            "DATE_FORMAT_MOMENT": "YYYY-MM-DD",
            "ID_MASK": "**",
            "IMAGE_RATIO_VERTICAL": {
                "sideRatio": 3,
                "verticalRatio": 4,
                "sidePixel": 285,
                "verticalPixel": 380
            },
            "NO_DATA": "--",
            "NO_ASSIGN_USER_ID": -1,
            "MASTER_CACHE_MINUTES": -1,
            "HTTP_ERROR_NOT_FOUND": 404,
            "HTTP_ERROR_CONFLICT": 409,
            "HTTP_OK": 200,
            "FIRST_PAGE": 1,
            "MINLENGTH_USER_NAME": 25,
            "INVALID_DISPATCH_PERIOD_DAYS": 30,
            "RETIREMENT_AGE": 60,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "app_constants"
    },
    "AttendancePrimaryObjectModel": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "BackgroundJob": {
        "constants": {
            "STATUS_WAITING": 1,
            "STATUS_PROCESSING": 2,
            "STATUS_COMPLETED": 3,
            "STATUS_FAILED": 4,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "background_job_status_id": null,
            "completed_at": null,
            "created_at": null,
            "error_info": null,
            "id": 0,
            "job_class": null,
            "job_data": null,
            "queued_at": null,
            "started_at": null,
            "updated_at": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "background_jobs"
    },
    "BaseAmountOverShortDay": {
        "constants": {
            "WEEKDAY_COLUMN_NAMES": [
                "is_monday",
                "is_tuesday",
                "is_wednesday",
                "is_thursday",
                "is_friday",
                "is_saturday",
                "is_sunday"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "base_amount_over_short_days"
    },
    "BillingDestination": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "billingDestinationState",
                "company",
                "user"
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "code": "code_normalized"
            },
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "billing_destination_state_id": null,
            "code": null,
            "code_normalized": null,
            "company_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "full_text": null,
            "id": 0,
            "name": null,
            "name_normalized": null,
            "prefecture_id": null,
            "referenced_invoice_fraction_process_id": null,
            "referenced_payment_fraction_process_id": null,
            "state_updated_at": null,
            "updated_at": null,
            "updated_user_id": null,
            "user_id": null,
            "zip": null,
            "freeItems": null,
            "billingDestinationState": null,
            "company": null,
            "prefecture": null,
            "user": null,
            "invoiceDatum": null,
            "mails": null,
            "contracts": null,
            "users": null
        },
        "relations": {
            "billingDestinationState": "BillingDestinationState",
            "company": "Company",
            "prefecture": "Prefecture",
            "user": "User",
            "invoiceDatum": "InvoiceDatum",
            "mails": "Mail",
            "contracts": "Contract",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "billing_destinations"
    },
    "BillingDestinationState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "billing_destination_states"
    },
    "CalcRecordsMapping": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "billing_destination_id": null,
            "candidate_id": null,
            "company_id": null,
            "contract_id": null,
            "created_at": null,
            "dispatch_destination_id": null,
            "id": 0,
            "job_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "calc_records_mappings"
    },
    "Candidate": {
        "constants": {
            "CSS_AFFIX": "candidate",
            "SHARE_CONVERT_COLUMNS": [
                "circumstance_id",
                "hope_employment_category_id",
                "hope_industry_id",
                "hope_occupation_id",
                "prefecture_id",
                "roudoukyoku_category_id",
                "sex_id",
                "medium_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [
                "id",
                "name",
                "kana",
                "birth_date",
                "age",
                "tel",
                "portable_tel",
                "candidate_state_id",
                "name_normalized",
                "created_at",
                "updated_at",
                "deleted_at"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "candidateState"
            ],
            "HIDDEN_PROPERTY_COLUMN_IDS_FOR_FREE_BOOLEAN": [
                18,
                21
            ],
            "PROFILE_RELATIONS": [
                "candidateState",
                "careers",
                "educations",
                "prefecture",
                "sex"
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "kana": "kana_normalized",
                "code": "code_normalized"
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "address_sub_map": null,
            "age": null,
            "applied": null,
            "birth_date": null,
            "candidate_state_id": null,
            "caution": null,
            "circumstance_id": null,
            "code": null,
            "code_normalized": null,
            "created_at": null,
            "deleted_at": null,
            "distributed_at": null,
            "email": null,
            "english_skill": null,
            "feed_number": null,
            "figure": null,
            "full_text": null,
            "hope_company": null,
            "hope_employment_category_id": null,
            "hope_fee": null,
            "hope_industry_id": null,
            "hope_job_change_season": null,
            "hope_occupation_id": null,
            "hope_place": null,
            "id": 0,
            "is_married": null,
            "is_possible_bulk_mail": "1",
            "job_change_number": null,
            "kana": null,
            "kana_normalized": null,
            "medium_detail": null,
            "medium_id": null,
            "memo": null,
            "mhlw_occupation_id": null,
            "myric_mypage_invitation_date": null,
            "myric_mypage_login_date": null,
            "myric_mypage_state_id": null,
            "myric_mypage_token": null,
            "name": null,
            "name_normalized": null,
            "office_email": null,
            "portable_email": null,
            "portable_tel": null,
            "prefecture_id": null,
            "qualification": null,
            "rank_id": null,
            "request": null,
            "roudoukyoku_category_id": null,
            "sex_id": null,
            "state_updated_at": null,
            "station": null,
            "tel": null,
            "toeic": null,
            "updated_at": null,
            "valid_end_date": null,
            "zip": null,
            "freeItems": null,
            "candidateState": null,
            "sex": null,
            "prefecture": null,
            "rank": null,
            "roudoukyokuCategory": null,
            "circumstance": null,
            "employmentCategory": null,
            "industry": null,
            "occupation": null,
            "medium": null,
            "candidateDispatchBasic": null,
            "candidateDispatchInsurance": null,
            "educations": null,
            "careers": null,
            "candidateFiles": null,
            "candidateJobSteps": null,
            "sales": null,
            "candidateSteps": null,
            "candidatePhoto": null,
            "candidateUsers": null,
            "mails": null,
            "importedRecords": null,
            "candidateJobStepResources": null,
            "contracts": null,
            "conflictDateManagements": null,
            "candidateConflictDateManagements": null,
            "conflictDateDefaults": null,
            "candidateWage": null,
            "paymentDatum": null,
            "candidateCareerCounsellings": null,
            "candidateEducationAndTrainings": null,
            "candidateEmploymentStabilityMeasures": null,
            "candidateEmploymentPlacementDispatches": null,
            "users": null
        },
        "relations": {
            "candidateState": "CandidateState",
            "sex": "Sex",
            "prefecture": "Prefecture",
            "rank": "Rank",
            "roudoukyokuCategory": "RoudoukyokuCategory",
            "circumstance": "Circumstance",
            "employmentCategory": "EmploymentCategory",
            "industry": "Industry",
            "occupation": "Occupation",
            "medium": "Medium",
            "candidateDispatchBasic": "CandidateDispatchBasic",
            "candidateDispatchInsurance": "CandidateDispatchInsurance",
            "educations": "Education",
            "careers": "Career",
            "candidateFiles": "CandidateFile",
            "candidateJobSteps": "CandidateJobStep",
            "sales": "Sale",
            "candidateSteps": "CandidateStep",
            "candidatePhoto": "CandidatePhoto",
            "candidateUsers": "CandidateUser",
            "mails": "Mail",
            "importedRecords": "ImportedRecord",
            "candidateJobStepResources": "CandidateJobStepResource",
            "contracts": "Contract",
            "conflictDateManagements": "ConflictDateManagement",
            "candidateConflictDateManagements": "CandidateConflictDateManagement",
            "conflictDateDefaults": "ConflictDateDefault",
            "candidateWage": "CandidateWage",
            "paymentDatum": "PaymentDatum",
            "candidateCareerCounsellings": "CandidateCareerCounselling",
            "candidateEducationAndTrainings": "CandidateEducationAndTraining",
            "candidateEmploymentStabilityMeasures": "CandidateEmploymentStabilityMeasure",
            "candidateEmploymentPlacementDispatches": "CandidateEmploymentPlacementDispatch",
            "users": "User"
        },
        "appends": [
            "age",
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidates"
    },
    "CandidateCareerCounselling": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "counselling_datetime": null,
            "counselling_detail": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_career_staff_id": null,
            "id": 0,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "candidate": null,
            "dispatchSourceCareerStaff": null,
            "candidateUsers": null,
            "candidateDispatchBasics": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "dispatchSourceCareerStaff": "DispatchSourceCareerStaff",
            "candidateUsers": "CandidateUser",
            "candidateDispatchBasics": "CandidateDispatchBasic",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_career_counsellings"
    },
    "CandidateConflictDateManagement": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "conflict_date": null,
            "contract_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_organization_unit_id": null,
            "dispatch_start_date": null,
            "id": 0,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "contract": null,
            "candidate": null,
            "dispatchDestination": null,
            "dispatchOrganizationUnit": null,
            "users": null
        },
        "relations": {
            "contract": "Contract",
            "candidate": "Candidate",
            "dispatchDestination": "DispatchDestination",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\ConflictDateManagement",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "conflict_date_managements"
    },
    "CandidateDispatchBasic": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "agreement_employment_type_id": null,
            "business_form_expire_date": null,
            "candidate_id": null,
            "continue_working_type_id": null,
            "created_at": null,
            "created_user_id": null,
            "dispatch_source_id": null,
            "employment_period_end_date": null,
            "employment_period_start_date": null,
            "employment_period_type_id": null,
            "entrance_date": null,
            "id": 0,
            "paid_leave_consumed_days": null,
            "paid_leave_remain_days": null,
            "payment_closed_date_id": null,
            "payment_date_id": null,
            "payment_time_type_id": null,
            "payment_type_id": null,
            "retirement_date": null,
            "single_parent_deduction_id": null,
            "spot_prohibition_exception_type_id": null,
            "tax_table_section_type_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "wish_career_counselling_type_id": null,
            "systemDefaultOptionDateOnlyType": null,
            "systemDefaultOptionDayOfTheWeekType": null,
            "candidate": null,
            "dispatchSource": null
        },
        "relations": {
            "systemDefaultOptionDateOnlyType": "SystemDefaultOptionDateOnlyType",
            "systemDefaultOptionDayOfTheWeekType": "SystemDefaultOptionDayOfTheWeekType",
            "candidate": "Candidate",
            "dispatchSource": "DispatchSource"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_dispatch_basics"
    },
    "CandidateDispatchInsurance": {
        "constants": {
            "JUNE": 6,
            "JULY": 7,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "created_at": null,
            "created_user_id": null,
            "employee_pension_id": null,
            "employee_pension_reason": null,
            "employment_insurance_reason": null,
            "has_employee_pension": null,
            "has_employment_insurance": null,
            "has_health_insurance": null,
            "has_nursing_insurance": null,
            "health_insurance_rate": null,
            "health_insurance_reason": null,
            "id": 0,
            "nursing_insurance_rate": null,
            "nursing_insurance_reason": null,
            "pension_standard_reward_id": null,
            "resident_tax_august_may": null,
            "resident_tax_july": null,
            "resident_tax_june": null,
            "standard_monthly_salary": null,
            "standard_reward_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "welfare_pension_fund_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_dispatch_insurances"
    },
    "CandidateEducationAndTraining": {
        "constants": {
            "EDUCATION_TRAINING_ID_DIVISOR": 10000,
            "EDUCATION_TRAINING_ID_NUMBER_OF_DIGITS": 4,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_TYPES": {
                "キャリアアップ": 5103,
                "安全衛生教育": 5104,
                "その他": 5105
            },
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "contract_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "education_training_id": null,
            "id": 0,
            "property_table_id": null,
            "training_datetime": null,
            "training_detail": null,
            "training_entity_type_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "user_id": null,
            "wages": null,
            "freeItems": null,
            "candidate": null,
            "contract": null,
            "user": null,
            "candidateUsers": null,
            "candidateDispatchBasics": null,
            "contracts": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "contract": "Contract",
            "user": "User",
            "candidateUsers": "CandidateUser",
            "candidateDispatchBasics": "CandidateDispatchBasic",
            "contracts": "Contract",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_education_and_trainings"
    },
    "CandidateEmploymentPlacementDispatch": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "created_at": null,
            "created_user_id": null,
            "datetime": null,
            "deleted_at": null,
            "id": 0,
            "memo": null,
            "state_of_progress_type_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "candidate": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_employment_placement_dispatches"
    },
    "CandidateEmploymentStabilityMeasure": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "contract_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "hope_classification_type_id": null,
            "hope_detail": null,
            "hope_hearing_datetime": null,
            "id": 0,
            "performed_classification_type_id": null,
            "performed_datetime": null,
            "performed_detail": null,
            "result_classification_type_id": null,
            "result_datetime": null,
            "result_detail": null,
            "updated_at": null,
            "updated_user_id": null,
            "user_id": null,
            "freeItems": null,
            "candidate": null,
            "contract": null,
            "candidateUsers": null,
            "candidateDispatchBasics": null,
            "user": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "contract": "Contract",
            "candidateUsers": "CandidateUser",
            "candidateDispatchBasics": "CandidateDispatchBasic",
            "user": "User",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_employment_stability_measures"
    },
    "CandidateFile": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "file_id": null,
            "id": 0,
            "candidate": null,
            "file": null
        },
        "relations": {
            "candidate": "Candidate",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_files"
    },
    "CandidateHopeJob": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "id": 0,
            "job_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_hope_jobs"
    },
    "CandidateJobStep": {
        "constants": {
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "candidate_id",
                "job_id"
            ],
            "MAIL_USE_COLUMNS": [
                "interviewer",
                "start_at",
                "end_at",
                "memo"
            ],
            "BULK_UPDATE_LIMIT": 50,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_correspondence_user_id": null,
            "candidate_id": null,
            "candidate_job_step_resource_id": null,
            "candidate_job_step_state_id": null,
            "create_user_id": null,
            "created_at": null,
            "deleted_at": null,
            "due_date": null,
            "end_at": null,
            "id": 0,
            "interviewer": null,
            "is_latested": "0",
            "job_correspondence_user_id": null,
            "job_id": null,
            "mail_id": null,
            "memo": null,
            "start_at": null,
            "updated_at": null,
            "user_id": null,
            "candidateJobStepState": null,
            "candidate": null,
            "job": null,
            "dispatchJob": null,
            "sales": null,
            "user": null,
            "schedules": null,
            "candidateJobStepResource": null,
            "candidateCorrespondenceUser": null,
            "jobCorrespondenceUser": null,
            "createUser": null,
            "staff": null,
            "tasks": null
        },
        "relations": {
            "candidateJobStepState": "CandidateJobStepState",
            "candidate": "Candidate",
            "job": "Job",
            "dispatchJob": "DispatchJob",
            "sales": "Sale",
            "user": "User",
            "schedules": "Schedule",
            "candidateJobStepResource": "CandidateJobStepResource",
            "candidateCorrespondenceUser": "User",
            "jobCorrespondenceUser": "User",
            "createUser": "User",
            "staff": "Staff",
            "tasks": "Task"
        },
        "appends": [
            "localizedStartAt",
            "localizedEndAt"
        ],
        "parents": [
            "App\\Models\\Bases\\StepModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_job_steps"
    },
    "CandidateJobStepResource": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [
                "candidate",
                "job",
                "job.company",
                "candidateJobSteps",
                "dispatchJob",
                "dispatchJob.company"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "id",
                "candidate_id",
                "job_id"
            ],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "created_at": null,
            "deleted_at": null,
            "full_text": null,
            "id": 0,
            "job_id": null,
            "updated_at": null,
            "freeItems": null,
            "candidate": null,
            "job": null,
            "company": null,
            "dispatchJob": null,
            "candidateJobSteps": null,
            "contracts": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "job": "Job",
            "company": "Company",
            "dispatchJob": "DispatchJob",
            "candidateJobSteps": "CandidateJobStep",
            "contracts": "Contract",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_job_step_resources"
    },
    "CandidateJobStepState": {
        "constants": {
            "NO_CANDIDATE_JOB_STEP": 0,
            "MAIL": 1,
            "TELEPHONE": 2,
            "INTERVIEW_COMPLETE": 3,
            "MATCHING": 4,
            "MATCHING_TALENT_DECLINE": 5,
            "MATCHING_JOB_DECLINE": 6,
            "MATCHING_CONFIRMED": 7,
            "CASE_INTRODUCTION": 8,
            "CASE_INTRODUCTION_DECLINE": 9,
            "INHOUSE_RECOMMENDATION": 10,
            "INHOUSE_RECOMMENDATION_FAILED": 11,
            "WRITTEN_EXAM": 12,
            "WRITTEN_EXAM_PASSED": 13,
            "WRITTEN_EXAM_FAILED": 14,
            "WRITTEN_EXAM_DECLINE": 15,
            "DOCUMENT": 16,
            "DOCUMENT_PASSED": 17,
            "DOCUMENT_FAILED": 18,
            "DOCUMENT_DECLINE": 19,
            "FIRST_INTERVIEW": 20,
            "FIRST_INTERVIEW_PASSED": 21,
            "FIRST_INTERVIEW_FAILED": 22,
            "FIRST_INTERVIEW_DECLINE": 23,
            "SECOND_INTERVIEW": 24,
            "SECOND_INTERVIEW_PASSED": 25,
            "SECOND_INTERVIEW_FAILED": 26,
            "SECOND_INTERVIEW_DECLINE": 27,
            "FINAL_INTERVIEW": 28,
            "FINAL_INTERVIEW_FAILED": 29,
            "FINAL_INTERVIEW_DECLINE": 30,
            "JOB_OFFER": 31,
            "JOB_OFFER_DECLINE": 32,
            "JOINED": 33,
            "INTERVIEW_ADJUSTMENT": 34,
            "STATE_HP_NAME": "自社HPからの応募",
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "can_search": "0",
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "is_before_matching": "0",
            "is_closed_state": "0",
            "is_progress": "0",
            "is_sales_state": "0",
            "is_summary": "0",
            "is_sync_schedule": "0",
            "name": null,
            "position": null,
            "updated_at": null,
            "candidateJobSteps": null,
            "candidateJobStepStateTransitions": null,
            "alertSettingConditions": null
        },
        "relations": {
            "candidateJobSteps": "CandidateJobStep",
            "candidateJobStepStateTransitions": "CandidateJobStepStateTransition",
            "alertSettingConditions": "AlertSettingCondition"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_job_step_states"
    },
    "CandidateJobStepStateTransition": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "before_candidate_job_step_state_id": null,
            "created_at": null,
            "id": 0,
            "next_candidate_job_step_state_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_job_step_state_transitions"
    },
    "CandidatePhoto": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "file_id": null,
            "id": 0,
            "candidate": null,
            "file": null
        },
        "relations": {
            "candidate": "Candidate",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_photos"
    },
    "CandidateState": {
        "constants": {
            "CLOSE_STATE_ID": 14,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "color": null,
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "candidates": null
        },
        "relations": {
            "candidates": "Candidate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_states"
    },
    "CandidateStep": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "candidate:id,name"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_STORE": [
                "candidate_job_step_state_id"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "candidate_id",
                "candidate_job_step_state_id"
            ],
            "SYSTEM_USE_COLUMNS": [
                "created_at",
                "updated_at"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "candidate_step_resource_id": null,
            "candidate_step_state_id": null,
            "correspondence_user_id": null,
            "create_user_id": null,
            "created_at": null,
            "deleted_at": null,
            "end_at": null,
            "id": 0,
            "memo": null,
            "start_at": null,
            "updated_at": null,
            "user_id": null,
            "candidate": null,
            "candidateStepState": null,
            "user": null,
            "candidateStepResource": null,
            "schedules": null
        },
        "relations": {
            "candidate": "Candidate",
            "candidateStepState": "CandidateStepState",
            "user": "User",
            "candidateStepResource": "CandidateStepResource",
            "schedules": "Schedule"
        },
        "appends": [
            "localizedStartAt",
            "localizedEndAt"
        ],
        "parents": [
            "App\\Models\\Bases\\StepModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_steps"
    },
    "CandidateStepResource": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [
                "candidate",
                "candidateSteps"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "id",
                "candidate_id"
            ],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "created_at": null,
            "deleted_at": null,
            "full_text": null,
            "id": 0,
            "updated_at": null,
            "freeItems": null,
            "candidate": null,
            "candidateSteps": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "candidateSteps": "CandidateStep",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_step_resources"
    },
    "CandidateStepState": {
        "constants": {
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "MAIL": 1,
            "TELEPHONE": 2,
            "INTERVIEW_COMPLETE": 3,
            "INTERVIEW_ADJUSTMENT": 34,
            "INTERVIEW_CANCEL": 35,
            "BULK_MAIL": 10001,
            "ACES_MEET": 10002,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "can_search": "0",
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "is_sync_schedule": "0",
            "name": null,
            "position": null,
            "updated_at": null,
            "candidateSteps": null
        },
        "relations": {
            "candidateSteps": "CandidateStep"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_step_states"
    },
    "CandidateUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "updated_at": null,
            "user_id": null,
            "candidate": null,
            "user": null
        },
        "relations": {
            "candidate": "Candidate",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_users"
    },
    "CandidateWage": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "id": 0,
            "payment_basic_unit_wage": null,
            "payment_early_attendance_boolean_approve_type_id": null,
            "payment_half_holiday_allocation_hour": null,
            "payment_leave_deduction": null,
            "payment_legal_holiday_unit_wage": null,
            "payment_legal_over_time_unit_wage": null,
            "payment_night_extra_unit_wage": null,
            "payment_non_legal_over_time_month_45_unit_wage": null,
            "payment_non_legal_over_time_month_60_unit_wage": null,
            "payment_non_legal_over_time_unit_wage": null,
            "payment_over_weekly_legal_working_hour_unit_wage": null,
            "payment_prescribed_holiday_unit_wage": null,
            "payment_prescribed_hour_short_deduction": null,
            "payment_wage_type_id": null,
            "payment_weekly_legal_working_hour": null,
            "prescribed_working_hours": null,
            "working_days": null,
            "candidate": null
        },
        "relations": {
            "candidate": "Candidate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_wages"
    },
    "Career": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "company_name": null,
            "created_at": null,
            "custom_text_1": null,
            "custom_text_2": null,
            "custom_text_3": null,
            "custom_text_4": null,
            "custom_text_5": null,
            "data_position": null,
            "deleted_at": null,
            "department": null,
            "detail": null,
            "employee_number": null,
            "employment_category_id": null,
            "entrance_date": null,
            "fee": null,
            "id": 0,
            "industry_id": null,
            "occupation_id": null,
            "post": null,
            "retirement_date": null,
            "retirement_reason": null,
            "updated_at": null,
            "industry": null,
            "occupation": null,
            "employmentCategory": null,
            "candidate": null
        },
        "relations": {
            "industry": "Industry",
            "occupation": "Occupation",
            "employmentCategory": "EmploymentCategory",
            "candidate": "Candidate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "careers"
    },
    "Circumstance": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "circumstances"
    },
    "ClaimRepresentativeDispatchSourceStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5388,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_source_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\DispatchJobSourceStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_source_staff_multi_assignments"
    },
    "ClaimRepresentativeDispatchStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5123,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\DispatchJobStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_staff_multi_assignments"
    },
    "ClosedModel": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\AttendancePrimaryObjectModel",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "CommanderDispatchStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5124,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\DispatchJobStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_staff_multi_assignments"
    },
    "Company": {
        "constants": {
            "CSS_AFFIX": "company",
            "SHARE_CONVERT_COLUMNS": [
                "prefecture_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [
                "id",
                "name",
                "company_state_id",
                "tel",
                "created_at",
                "updated_at",
                "deleted_at"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "companyState"
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "kana": "kana_normalized",
                "code": "code_normalized"
            },
            "COMPANY_CACHE_TAG_SUFFIX": "company_query",
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "advantage": null,
            "affiliate": null,
            "average_age": null,
            "bank": null,
            "capital": null,
            "code": null,
            "code_normalized": null,
            "company_state_id": null,
            "competitor": null,
            "created_at": null,
            "deleted_at": null,
            "employee_number": null,
            "environment": null,
            "establishment_date": null,
            "fee_rate": null,
            "foreign_capital_rate": null,
            "full_text": null,
            "future": null,
            "id": 0,
            "kana": null,
            "kana_normalized": null,
            "memo": null,
            "name": null,
            "name_normalized": null,
            "other_office": null,
            "parent_company_id": null,
            "prefecture_id": null,
            "public": null,
            "representative": null,
            "sales": null,
            "state_updated_at": null,
            "stockholder": null,
            "structure": null,
            "summary": null,
            "tel": null,
            "updated_at": null,
            "url": null,
            "zip": null,
            "freeItems": null,
            "jobs": null,
            "dispatchJobs": null,
            "staffs": null,
            "prefecture": null,
            "candidateJobSteps": null,
            "companyState": null,
            "companySteps": null,
            "companyFiles": null,
            "mails": null,
            "companyUsers": null,
            "companyPhotos": null,
            "importedRecords": null,
            "dispatchDestinations": null,
            "billingDestinations": null,
            "users": null
        },
        "relations": {
            "jobs": "Job",
            "dispatchJobs": "DispatchJob",
            "staffs": "Staff",
            "prefecture": "Prefecture",
            "candidateJobSteps": "CandidateJobStep",
            "companyState": "CompanyState",
            "companySteps": "CompanyStep",
            "companyFiles": "CompanyFile",
            "mails": "Mail",
            "companyUsers": "CompanyUser",
            "companyPhotos": "CompanyPhoto",
            "importedRecords": "ImportedRecord",
            "dispatchDestinations": "DispatchDestination",
            "billingDestinations": "BillingDestination",
            "users": "User"
        },
        "appends": [
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "companies"
    },
    "CompanyFile": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "company_id": null,
            "file_id": null,
            "id": 0,
            "company": null,
            "file": null
        },
        "relations": {
            "company": "Company",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_files"
    },
    "CompanyPhoto": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "company_id": null,
            "file_id": null,
            "id": 0,
            "company": null,
            "file": null
        },
        "relations": {
            "company": "Company",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_photos"
    },
    "CompanyState": {
        "constants": {
            "CLOSE_STATE_ID": 3,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "color": null,
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "companies": null
        },
        "relations": {
            "companies": "Company"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_states"
    },
    "CompanyStep": {
        "constants": {
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "company",
                "staff"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "company_id": null,
            "company_step_resource_id": null,
            "company_step_state_id": null,
            "correspondence_user_id": null,
            "create_user_id": null,
            "created_at": null,
            "deleted_at": null,
            "end_at": null,
            "id": 0,
            "mail_id": null,
            "memo": null,
            "staff_id": null,
            "start_at": null,
            "updated_at": null,
            "user_id": null,
            "companyStepState": null,
            "company": null,
            "staff": null,
            "companySteps": null,
            "user": null,
            "companyStepResource": null
        },
        "relations": {
            "companyStepState": "CompanyStepState",
            "company": "Company",
            "staff": "Staff",
            "companySteps": "CompanyStep",
            "user": "User",
            "companyStepResource": "CompanyStepResource"
        },
        "appends": [
            "localizedStartAt",
            "localizedEndAt"
        ],
        "parents": [
            "App\\Models\\Bases\\StepModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_steps"
    },
    "CompanyStepResource": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [
                "company",
                "companySteps",
                "companySteps.staff"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "id",
                "company_id"
            ],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "company_id": null,
            "created_at": null,
            "deleted_at": null,
            "full_text": null,
            "id": 0,
            "updated_at": null,
            "freeItems": null,
            "company": null,
            "companySteps": null,
            "users": null
        },
        "relations": {
            "company": "Company",
            "companySteps": "CompanyStep",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_step_resources"
    },
    "CompanyStepState": {
        "constants": {
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "BUSINESS_MEETING": 1,
            "MEETING": 2,
            "MAIL": 3,
            "TELEPHONE": 4,
            "OTHER": 5,
            "BULK_MAIL": 10001,
            "ACES_MEET": 10002,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "companySteps": null
        },
        "relations": {
            "companySteps": "CompanyStep"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_step_states"
    },
    "CompanyUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "company_id": null,
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "updated_at": null,
            "user_id": null,
            "company": null,
            "user": null
        },
        "relations": {
            "company": "Company",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "company_users"
    },
    "ConflictDateDefault": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "conflict_date": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_organization_unit_id": null,
            "id": 0,
            "memo": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "candidate": null,
            "dispatchOrganizationUnit": null,
            "users": null
        },
        "relations": {
            "candidate": "Candidate",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "conflict_date_defaults"
    },
    "ConflictDateManagement": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "conflict_date": null,
            "contract_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_organization_unit_id": null,
            "dispatch_start_date": null,
            "id": 0,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "contract": null,
            "candidate": null,
            "dispatchDestination": null,
            "dispatchOrganizationUnit": null,
            "users": null
        },
        "relations": {
            "contract": "Contract",
            "candidate": "Candidate",
            "dispatchDestination": "DispatchDestination",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "conflict_date_managements"
    },
    "Contract": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\BillingDestination": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ]
                ],
                "App\\Models\\DispatchOrganizationUnit": [
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ],
                "App\\Models\\DispatchDestination": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ]
                ],
                "App\\Models\\TravelExpense": [
                    [
                        null,
                        "App\\Models\\Company"
                    ],
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "DISPATCH_LIMIT_YEARS": 3,
            "INITIAL_INDEX_RELATIONS": [
                "contractState"
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "code": "code_normalized"
            },
            "DISABLE_COLUMNS_FOR_APIV2_STORE": [
                "candidate_id",
                "job_id",
                "company_id",
                "dispatch_destination_id"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "candidate_job_step_resource_id",
                "candidate_id",
                "job_id",
                "company_id",
                "dispatch_destination_id"
            ],
            "NOT_PAST_VALIDATE_DISPATCH_DATES_ATTRS": [
                "dispatch_start_date",
                "dispatch_end_date"
            ],
            "NOT_PAST_VALIDATE_DISPATCH_DATES_RULERS": [
                "contracted_conflict_date",
                "contracted_dispatch_destination_conflict_date"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "absent_end_date": null,
            "absent_start_date": null,
            "absentee_name": null,
            "absentee_work": null,
            "billing_destination_id": null,
            "candidate_id": null,
            "candidate_job_step_resource_id": null,
            "code": null,
            "code_normalized": null,
            "company_id": null,
            "contract_state_id": null,
            "contracted_conflict_date": null,
            "contracted_dispatch_destination_conflict_date": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_organization_unit_id": null,
            "dispatch_source_id": null,
            "dispatch_start_date": null,
            "due_date": null,
            "employment_category_id": null,
            "employment_insurance_industry_id": null,
            "full_text": null,
            "id": 0,
            "industry_id": null,
            "is_target_over_age_60_boolean_type_id": null,
            "job_id": null,
            "not_limited_as_conflict_date_reason": null,
            "number_of_monthly_due_date": null,
            "number_of_regular_monthly_due_date": null,
            "occupation_id": null,
            "referenced_amount_over_short_id": null,
            "referenced_dispatch_working_place_id": null,
            "referenced_wage_id": null,
            "state_updated_at": null,
            "term_limit_type_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "candidateJobSteps": null,
            "candidateJobStepResource": null,
            "candidate": null,
            "company": null,
            "job": null,
            "contractState": null,
            "dispatchDestination": null,
            "dispatchOrganizationUnit": null,
            "billingDestination": null,
            "contractStaffMultiAssignments": null,
            "contractSourceStaffMultiAssignments": null,
            "contractWorkingPlace": null,
            "contractWorkingHour": null,
            "contractWage": null,
            "contractRepresentativeDispatchStaffs": null,
            "contractClaimRepresentativeDispatchStaffs": null,
            "contractCommanderDispatchStaffs": null,
            "contractRepresentativeDispatchSourceStaffs": null,
            "contractClaimRepresentativeDispatchSourceStaffs": null,
            "contractExplanationDispatchSourceStaffs": null,
            "contractFiles": null,
            "contractAmountOverShorts": null,
            "amountOverShorts": null,
            "dispatchJob": null,
            "calcRecordsMapping": null,
            "dispatchStaffs": null,
            "dispatchSourceStaffs": null,
            "contractMemos": null,
            "industry": null,
            "occupation": null,
            "employmentCategory": null,
            "dispatchSource": null,
            "travelExpense": null,
            "conflictDateManagement": null,
            "candidateEducationAndTrainings": null,
            "candidateEmploymentStabilityMeasures": null,
            "users": null
        },
        "relations": {
            "candidateJobSteps": "CandidateJobStep",
            "candidateJobStepResource": "CandidateJobStepResource",
            "candidate": "Candidate",
            "company": "Company",
            "job": "Job",
            "contractState": "ContractState",
            "dispatchDestination": "DispatchDestination",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "billingDestination": "BillingDestination",
            "contractStaffMultiAssignments": "ContractStaffMultiAssignment",
            "contractSourceStaffMultiAssignments": "ContractSourceStaffMultiAssignment",
            "contractWorkingPlace": "ContractWorkingPlace",
            "contractWorkingHour": "ContractWorkingHour",
            "contractWage": "ContractWage",
            "contractRepresentativeDispatchStaffs": "ContractRepresentativeDispatchStaff",
            "contractClaimRepresentativeDispatchStaffs": "ContractClaimRepresentativeDispatchStaff",
            "contractCommanderDispatchStaffs": "ContractCommanderDispatchStaff",
            "contractRepresentativeDispatchSourceStaffs": "ContractRepresentativeDispatchSourceStaff",
            "contractClaimRepresentativeDispatchSourceStaffs": "ContractClaimRepresentativeDispatchSourceStaff",
            "contractExplanationDispatchSourceStaffs": "ContractExplanationDispatchSourceStaff",
            "contractFiles": "ContractFile",
            "contractAmountOverShorts": "ContractAmountOverShort",
            "amountOverShorts": "AmountOverShort",
            "dispatchJob": "DispatchJob",
            "calcRecordsMapping": "CalcRecordsMapping",
            "dispatchStaffs": "DispatchStaff",
            "dispatchSourceStaffs": "DispatchSourceStaff",
            "contractMemos": "ContractMemo",
            "industry": "Industry",
            "occupation": "Occupation",
            "employmentCategory": "EmploymentCategory",
            "dispatchSource": "DispatchSource",
            "travelExpense": "TravelExpense",
            "conflictDateManagement": "ConflictDateManagement",
            "candidateEducationAndTrainings": "CandidateEducationAndTraining",
            "candidateEmploymentStabilityMeasures": "CandidateEmploymentStabilityMeasure",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contracts"
    },
    "ContractAmountOverShort": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "allowance_id": null,
            "amount_over_short_type_id": null,
            "base_employment_insurance_boolean_default_type_id": null,
            "contract_id": null,
            "id": 0,
            "invoice_amount": null,
            "invoice_taxation_type_id": null,
            "max_repeat_times": null,
            "name": null,
            "norepeat_date": null,
            "payment_amount": null,
            "payment_taxation_type_id": null,
            "repeat_boolean_existence_type_id": null,
            "repeat_end_date": null,
            "repeat_interval_number": null,
            "repeat_interval_type_id": null,
            "repeat_monthly_type_id": null,
            "repeat_start_date": null,
            "tax_rate_id": null,
            "year_end_adjustment_id": null,
            "contract": null,
            "contractAmountOverShortDay": null
        },
        "relations": {
            "contract": "Contract",
            "contractAmountOverShortDay": "ContractAmountOverShortDay"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_amount_over_shorts"
    },
    "ContractAmountOverShortDay": {
        "constants": {
            "WEEKDAY_COLUMN_NAMES": [
                "is_monday",
                "is_tuesday",
                "is_wednesday",
                "is_thursday",
                "is_friday",
                "is_saturday",
                "is_sunday"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_amount_over_short_id": null,
            "id": 0,
            "is_friday": null,
            "is_monday": null,
            "is_saturday": null,
            "is_sunday": null,
            "is_thursday": null,
            "is_tuesday": null,
            "is_wednesday": null,
            "contractAmountOverShort": null
        },
        "relations": {
            "contractAmountOverShort": "ContractAmountOverShort"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\BaseAmountOverShortDay",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_amount_over_short_days"
    },
    "ContractAttendancePrimaryObjectModel": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\AttendancePrimaryObjectModel",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "ContractClaimRepresentativeDispatchSourceStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5391,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_source_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ContractSourceStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_source_staff_multi_assignments"
    },
    "ContractClaimRepresentativeDispatchStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5252,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ContractStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_staff_multi_assignments"
    },
    "ContractCommanderDispatchStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5253,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ContractStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_staff_multi_assignments"
    },
    "ContractExplanationDispatchSourceStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 21205,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_source_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ContractSourceStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_source_staff_multi_assignments"
    },
    "ContractFile": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "file_id": null,
            "id": 0,
            "contract": null,
            "file": null
        },
        "relations": {
            "contract": "Contract",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_files"
    },
    "ContractMemo": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "contract_memo_type_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "id": 0,
            "memo": null,
            "memo_date": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "contract": null,
            "users": null
        },
        "relations": {
            "contract": "Contract",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_memos"
    },
    "ContractRepresentativeDispatchSourceStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5390,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_source_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ContractSourceStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_source_staff_multi_assignments"
    },
    "ContractRepresentativeDispatchStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5251,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ContractStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_staff_multi_assignments"
    },
    "ContractSourceStaffMultiAssignment": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_source_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_source_staff_multi_assignments"
    },
    "ContractStaffMultiAssignment": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "dispatch_staff_id": null,
            "id": 0,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_staff_multi_assignments"
    },
    "ContractState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_states"
    },
    "ContractWage": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "contract_id": null,
            "id": 0,
            "invoice_basic_unit_wage": null,
            "invoice_early_attendance_boolean_approve_type_id": null,
            "invoice_half_holiday_allocation_hour": null,
            "invoice_leave_deduction": null,
            "invoice_legal_holiday_unit_wage": null,
            "invoice_legal_over_time_unit_wage": null,
            "invoice_night_extra_unit_wage": null,
            "invoice_non_legal_over_time_month_45_unit_wage": null,
            "invoice_non_legal_over_time_month_60_unit_wage": null,
            "invoice_non_legal_over_time_unit_wage": null,
            "invoice_over_weekly_legal_working_hour_unit_wage": null,
            "invoice_prescribed_holiday_unit_wage": null,
            "invoice_prescribed_hour_short_deduction": null,
            "invoice_wage_type_id": null,
            "invoice_weekly_legal_working_hour": null,
            "payment_basic_unit_wage": null,
            "payment_early_attendance_boolean_approve_type_id": null,
            "payment_half_holiday_allocation_hour": null,
            "payment_leave_deduction": null,
            "payment_legal_holiday_unit_wage": null,
            "payment_legal_over_time_unit_wage": null,
            "payment_night_extra_unit_wage": null,
            "payment_non_legal_over_time_month_45_unit_wage": null,
            "payment_non_legal_over_time_month_60_unit_wage": null,
            "payment_non_legal_over_time_unit_wage": null,
            "payment_over_weekly_legal_working_hour_unit_wage": null,
            "payment_prescribed_holiday_unit_wage": null,
            "payment_prescribed_hour_short_deduction": null,
            "payment_wage_type_id": null,
            "payment_weekly_legal_working_hour": null,
            "contract": null
        },
        "relations": {
            "contract": "Contract"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_wages"
    },
    "ContractWorkingHour": {
        "constants": {
            "MINUTES_OF_AN_HOUR": 60,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "break_minutes": null,
            "contract_id": null,
            "id": 0,
            "midnight_break_minutes": null,
            "prescribed_working_time": null,
            "scheduled_end_time": null,
            "scheduled_start_time": null,
            "working_days": null,
            "contract": null
        },
        "relations": {
            "contract": "Contract"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_working_hours"
    },
    "ContractWorkingPlace": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "contract_id": null,
            "department_name": null,
            "id": 0,
            "memo": null,
            "name": null,
            "nearest_station": null,
            "prefecture_id": null,
            "tel": null,
            "zip": null,
            "contract": null,
            "prefecture": null
        },
        "relations": {
            "contract": "Contract",
            "prefecture": "Prefecture"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "contract_working_places"
    },
    "DateType": {
        "constants": {
            "DATE_TYPE_MONTH": 1,
            "DATE_TYPE_DATE": 2,
            "DATE_TYPE_DATETIME": 3,
            "DATE_TYPE_TIME": 4,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "date_types"
    },
    "DeleteResourceRelationMapping": {
        "constants": {
            "TYPE": "delete",
            "TYPE_DELETE": "delete",
            "TYPE_BATCH_MAIL": "batch_mail",
            "TYPE_EXPORT_GROUP": "export_group",
            "TYPE_FREE_ITEMS": "free_items",
            "TYPE_REPORTS": "reports",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "child_property_table_id": null,
            "id": 0,
            "parent_property_table_id": null,
            "type": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\ResourceRelationMapping",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "resource_relation_mappings"
    },
    "Department": {
        "constants": {
            "DEFAULT_DEPARTMENT_ID": 1,
            "DEFAULT_DEPARTMENT_NAME": "デフォルト部署",
            "DEFAULT_DEPARTMENT_POSITION": 1,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "departments"
    },
    "DetailComponentType": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "detail_component_types"
    },
    "DispatchDestination": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\TravelExpense": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ]
                ]
            },
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "dispatchDestinationState",
                "company",
                "user"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "code": "code_normalized"
            },
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "code": null,
            "code_normalized": null,
            "company_id": null,
            "conflict_date": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_destination_state_id": null,
            "full_text": null,
            "id": 0,
            "name": null,
            "name_normalized": null,
            "prefecture_id": null,
            "state_updated_at": null,
            "updated_at": null,
            "updated_user_id": null,
            "user_id": null,
            "zip": null,
            "freeItems": null,
            "user": null,
            "company": null,
            "prefecture": null,
            "dispatchDestinationState": null,
            "dispatchStaffs": null,
            "dispatchOrganizationUnits": null,
            "dispatchWorkingPlaces": null,
            "dispatchJobs": null,
            "mails": null,
            "contracts": null,
            "conflictDateManagements": null,
            "dispatchDestinationConflictDateManagements": null,
            "travelExpense": null,
            "users": null
        },
        "relations": {
            "user": "User",
            "company": "Company",
            "prefecture": "Prefecture",
            "dispatchDestinationState": "DispatchDestinationState",
            "dispatchStaffs": "DispatchStaff",
            "dispatchOrganizationUnits": "DispatchOrganizationUnit",
            "dispatchWorkingPlaces": "DispatchWorkingPlace",
            "dispatchJobs": "DispatchJob",
            "mails": "Mail",
            "contracts": "Contract",
            "conflictDateManagements": "ConflictDateManagement",
            "dispatchDestinationConflictDateManagements": "DispatchDestinationConflictDateManagement",
            "travelExpense": "TravelExpense",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_destinations"
    },
    "DispatchDestinationConflictDateManagement": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "conflict_date": null,
            "contract_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_organization_unit_id": null,
            "dispatch_start_date": null,
            "id": 0,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "contract": null,
            "candidate": null,
            "dispatchDestination": null,
            "dispatchOrganizationUnit": null,
            "users": null
        },
        "relations": {
            "contract": "Contract",
            "candidate": "Candidate",
            "dispatchDestination": "DispatchDestination",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\ConflictDateManagement",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "conflict_date_managements"
    },
    "DispatchDestinationState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "color": null,
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_destination_states"
    },
    "DispatchJob": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\BillingDestination": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ]
                ],
                "App\\Models\\DispatchOrganizationUnit": [
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ],
                "App\\Models\\DispatchDestination": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ]
                ],
                "App\\Models\\TravelExpense": [
                    [
                        null,
                        "App\\Models\\Company"
                    ],
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "CSS_AFFIX": "dispatch_job",
            "INITIAL_SEARCH_COLUMNS": [
                "id",
                "title",
                "company_id",
                "dispatch_job_state_id",
                "dispatch_destination_id",
                "dispatch_organization_unit_id",
                "billing_destination_id",
                "is_dispatch",
                "dispatch_start_date",
                "dispatch_end_date",
                "created_at",
                "updated_at",
                "deleted_at"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "company",
                "dispatchJobState",
                "jobUsers",
                "jobUsers.user"
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "code": "code_normalized"
            },
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id",
                "dispatch_destination_id"
            ],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "access": null,
            "age_limit": null,
            "background": null,
            "billing_company_id": null,
            "billing_destination_id": null,
            "business_hours": null,
            "cabinet_order_industry_type_id": null,
            "code": null,
            "code_normalized": null,
            "company_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "department": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_job_state_id": null,
            "dispatch_job_type_id": null,
            "dispatch_organization_unit_id": null,
            "dispatch_source_id": null,
            "dispatch_start_date": null,
            "employment_category_id": null,
            "employment_insurance_industry_id": null,
            "fee_memo": null,
            "full_text": null,
            "holiday": null,
            "hope_num": null,
            "id": 0,
            "industry_id": null,
            "interview_count": null,
            "interview_process": null,
            "is_company_name_public": null,
            "is_dispatch": null,
            "is_specific_manufacturing_operation_type_id": null,
            "is_target_over_age_60_boolean_type_id": null,
            "is_trial": null,
            "is_web": null,
            "japan_std_occupation_id": null,
            "job_state_id": null,
            "max_age": null,
            "max_yearly_salary": null,
            "medium_id": null,
            "memo": null,
            "mhlw_occupation_id": null,
            "min_age": null,
            "min_yearly_salary": null,
            "must_skill": null,
            "occupation_id": null,
            "occupation_name": null,
            "place": null,
            "place_sub_map": null,
            "post": null,
            "prefecture_id": null,
            "qualification": null,
            "reason": null,
            "referenced_amount_over_short_id": null,
            "referenced_dispatch_working_place_id": null,
            "referenced_wage_id": null,
            "role_detail": null,
            "roudoukyoku_category_id": null,
            "staff_id": null,
            "state_updated_at": null,
            "title": null,
            "transfer": null,
            "trial_detail": null,
            "updated_at": null,
            "updated_user_id": null,
            "valid_end_date": null,
            "want_skill": null,
            "welfare": null,
            "freeItems": null,
            "company": null,
            "industry": null,
            "occupation": null,
            "employmentCategory": null,
            "prefecture": null,
            "staff": null,
            "dispatchJobState": null,
            "dispatchDestination": null,
            "dispatchOrganizationUnit": null,
            "billingDestination": null,
            "dispatchJobFiles": null,
            "dispatchStaffs": null,
            "dispatchJobStaffMultiAssignments": null,
            "dispatchJobSourceStaffMultiAssignments": null,
            "dispatchJobWorkingPlace": null,
            "dispatchJobWorkingHour": null,
            "dispatchJobWage": null,
            "dispatchJobAmountOverShorts": null,
            "amountOverShorts": null,
            "jobUsers": null,
            "representativeDispatchStaffs": null,
            "claimRepresentativeDispatchStaffs": null,
            "commanderDispatchStaffs": null,
            "representativeDispatchSourceStaffs": null,
            "claimRepresentativeDispatchSourceStaffs": null,
            "contracts": null,
            "candidateJobSteps": null,
            "roudoukyokuCategory": null,
            "jobFiles": null,
            "candidateJobStepResources": null,
            "dispatchSource": null,
            "dispatchSourceStaffs": null,
            "travelExpense": null,
            "users": null
        },
        "relations": {
            "company": "Company",
            "industry": "Industry",
            "occupation": "Occupation",
            "employmentCategory": "EmploymentCategory",
            "prefecture": "Prefecture",
            "staff": "Staff",
            "dispatchJobState": "DispatchJobState",
            "dispatchDestination": "DispatchDestination",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "billingDestination": "BillingDestination",
            "dispatchJobFiles": "DispatchJobFile",
            "dispatchStaffs": "DispatchStaff",
            "dispatchJobStaffMultiAssignments": "DispatchJobStaffMultiAssignment",
            "dispatchJobSourceStaffMultiAssignments": "DispatchJobSourceStaffMultiAssignment",
            "dispatchJobWorkingPlace": "DispatchJobWorkingPlace",
            "dispatchJobWorkingHour": "DispatchJobWorkingHour",
            "dispatchJobWage": "DispatchJobWage",
            "dispatchJobAmountOverShorts": "DispatchJobAmountOverShort",
            "amountOverShorts": "AmountOverShort",
            "jobUsers": "JobUser",
            "representativeDispatchStaffs": "RepresentativeDispatchStaff",
            "claimRepresentativeDispatchStaffs": "ClaimRepresentativeDispatchStaff",
            "commanderDispatchStaffs": "CommanderDispatchStaff",
            "representativeDispatchSourceStaffs": "RepresentativeDispatchSourceStaff",
            "claimRepresentativeDispatchSourceStaffs": "ClaimRepresentativeDispatchSourceStaff",
            "contracts": "Contract",
            "candidateJobSteps": "CandidateJobStep",
            "roudoukyokuCategory": "RoudoukyokuCategory",
            "jobFiles": "JobFile",
            "candidateJobStepResources": "CandidateJobStepResource",
            "dispatchSource": "DispatchSource",
            "dispatchSourceStaffs": "DispatchSourceStaff",
            "travelExpense": "TravelExpense",
            "users": "User"
        },
        "appends": [
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "jobs"
    },
    "DispatchJobAmountOverShort": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "allowance_id": null,
            "amount_over_short_type_id": null,
            "base_employment_insurance_boolean_default_type_id": null,
            "id": 0,
            "invoice_amount": null,
            "invoice_taxation_type_id": null,
            "job_id": null,
            "max_repeat_times": null,
            "name": null,
            "norepeat_date": null,
            "payment_amount": null,
            "payment_taxation_type_id": null,
            "repeat_boolean_existence_type_id": null,
            "repeat_end_date": null,
            "repeat_interval_number": null,
            "repeat_interval_type_id": null,
            "repeat_monthly_type_id": null,
            "repeat_start_date": null,
            "tax_rate_id": null,
            "year_end_adjustment_id": null,
            "dispatchJob": null,
            "dispatchJobAmountOverShortDay": null
        },
        "relations": {
            "dispatchJob": "DispatchJob",
            "dispatchJobAmountOverShortDay": "DispatchJobAmountOverShortDay"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_amount_over_shorts"
    },
    "DispatchJobAmountOverShortDay": {
        "constants": {
            "WEEKDAY_COLUMN_NAMES": [
                "is_monday",
                "is_tuesday",
                "is_wednesday",
                "is_thursday",
                "is_friday",
                "is_saturday",
                "is_sunday"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_job_amount_over_short_id": null,
            "id": 0,
            "is_friday": null,
            "is_monday": null,
            "is_saturday": null,
            "is_sunday": null,
            "is_thursday": null,
            "is_tuesday": null,
            "is_wednesday": null,
            "dispatchJobAmountOverShort": null
        },
        "relations": {
            "dispatchJobAmountOverShort": "DispatchJobAmountOverShort"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\BaseAmountOverShortDay",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_amount_over_short_days"
    },
    "DispatchJobFile": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_job_id": null,
            "file_id": null,
            "id": 0,
            "file": null
        },
        "relations": {
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_files"
    },
    "DispatchJobSourceStaffMultiAssignment": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_source_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_source_staff_multi_assignments"
    },
    "DispatchJobStaffMultiAssignment": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_staff_multi_assignments"
    },
    "DispatchJobState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "color": null,
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_states"
    },
    "DispatchJobWage": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "invoice_basic_unit_wage": null,
            "invoice_early_attendance_boolean_approve_type_id": null,
            "invoice_half_holiday_allocation_hour": null,
            "invoice_leave_deduction": null,
            "invoice_legal_holiday_unit_wage": null,
            "invoice_legal_over_time_unit_wage": null,
            "invoice_night_extra_unit_wage": null,
            "invoice_non_legal_over_time_month_45_unit_wage": null,
            "invoice_non_legal_over_time_month_60_unit_wage": null,
            "invoice_non_legal_over_time_unit_wage": null,
            "invoice_over_weekly_legal_working_hour_unit_wage": null,
            "invoice_prescribed_holiday_unit_wage": null,
            "invoice_prescribed_hour_short_deduction": null,
            "invoice_wage_type_id": null,
            "invoice_weekly_legal_working_hour": null,
            "job_id": null,
            "payment_basic_unit_wage": null,
            "payment_early_attendance_boolean_approve_type_id": null,
            "payment_half_holiday_allocation_hour": null,
            "payment_leave_deduction": null,
            "payment_legal_holiday_unit_wage": null,
            "payment_legal_over_time_unit_wage": null,
            "payment_night_extra_unit_wage": null,
            "payment_non_legal_over_time_month_45_unit_wage": null,
            "payment_non_legal_over_time_month_60_unit_wage": null,
            "payment_non_legal_over_time_unit_wage": null,
            "payment_over_weekly_legal_working_hour_unit_wage": null,
            "payment_prescribed_holiday_unit_wage": null,
            "payment_prescribed_hour_short_deduction": null,
            "payment_wage_type_id": null,
            "payment_weekly_legal_working_hour": null,
            "dispatchJob": null
        },
        "relations": {
            "dispatchJob": "DispatchJob"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_wages"
    },
    "DispatchJobWorkingHour": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "break_minutes": null,
            "id": 0,
            "job_id": null,
            "midnight_break_minutes": null,
            "prescribed_working_time": null,
            "scheduled_end_time": null,
            "scheduled_start_time": null,
            "working_days": null,
            "dispatchJob": null
        },
        "relations": {
            "dispatchJob": "DispatchJob"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_working_hours"
    },
    "DispatchJobWorkingPlace": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "department_name": null,
            "id": 0,
            "job_id": null,
            "memo": null,
            "name": null,
            "nearest_station": null,
            "prefecture_id": null,
            "tel": null,
            "zip": null,
            "dispatchJob": null,
            "prefecture": null
        },
        "relations": {
            "dispatchJob": "DispatchJob",
            "prefecture": "Prefecture"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_working_places"
    },
    "DispatchMaster": {
        "constants": {
            "RESOURCE_TYPE_COMPANY": "App\\Models\\Company",
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "RESOURCE_TYPE_CANDIDATE": "App\\Models\\Candidate",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "DispatchOrganizationUnit": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "dispatchOrganizationUnitState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "dispatch_destination_id"
            ],
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "code": "code_normalized"
            },
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "code": null,
            "code_normalized": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_organization_unit_state_id": null,
            "full_text": null,
            "id": 0,
            "name": null,
            "name_normalized": null,
            "resource_id": null,
            "resource_type": null,
            "state_updated_at": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "dispatchOrganizationUnitState": null,
            "mails": null,
            "dispatchDestination": null,
            "conflictDateManagements": null,
            "conflictDateDefaults": null,
            "user": null,
            "users": null
        },
        "relations": {
            "dispatchOrganizationUnitState": "DispatchOrganizationUnitState",
            "mails": "Mail",
            "dispatchDestination": "DispatchDestination",
            "conflictDateManagements": "ConflictDateManagement",
            "conflictDateDefaults": "ConflictDateDefault",
            "user": "User",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPolymorphicPrimaryObjectModel",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_organization_units"
    },
    "DispatchOrganizationUnitState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_organization_unit_states"
    },
    "DispatchPolymorphicPrimaryObjectModel": {
        "constants": {
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "code": "code_normalized"
            },
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "DispatchPrimaryObjectModel": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "DispatchSource": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "dispatchSourceState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_state_id": null,
            "id": 0,
            "name": null,
            "prefecture_id": null,
            "state_updated_at": null,
            "tel": null,
            "updated_at": null,
            "updated_user_id": null,
            "welfare_pension_fund_id": null,
            "zip": null,
            "freeItems": null,
            "dispatchSourceState": null,
            "prefecture": null,
            "dispatchSourceStaffs": null,
            "dispatchSourceEducationTrainingCareers": null,
            "dispatchSourceEducationTrainingSafeties": null,
            "dispatchSourceEducationTrainingOthers": null,
            "dispatchSourceCareerStaffs": null,
            "dispatchSourceReportSetting": null,
            "users": null
        },
        "relations": {
            "dispatchSourceState": "DispatchSourceState",
            "prefecture": "Prefecture",
            "dispatchSourceStaffs": "DispatchSourceStaff",
            "dispatchSourceEducationTrainingCareers": "DispatchSourceEducationTrainingCareer",
            "dispatchSourceEducationTrainingSafeties": "DispatchSourceEducationTrainingSafety",
            "dispatchSourceEducationTrainingOthers": "DispatchSourceEducationTrainingOther",
            "dispatchSourceCareerStaffs": "DispatchSourceCareerStaff",
            "dispatchSourceReportSetting": "DispatchSourceReportSetting",
            "users": "User"
        },
        "appends": [
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_sources"
    },
    "DispatchSourceCareerStaff": {
        "constants": {
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "dispatch_source_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "assignment_date": null,
            "concurrently_dispatch_staff": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_id": null,
            "has_knowledge": null,
            "has_work_experience": null,
            "id": 0,
            "internal_external_type_id": null,
            "job_classification_type_id": null,
            "name": null,
            "retirement_date": null,
            "simple_state_id": null,
            "state_updated_at": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "dispatchSource": null,
            "candidateCareerCounsellings": null,
            "users": null
        },
        "relations": {
            "dispatchSource": "DispatchSource",
            "candidateCareerCounsellings": "CandidateCareerCounselling",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_career_staffs"
    },
    "DispatchSourceEducationTrainingCareer": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "DispatchSourceReportState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "bear_training_cost_type_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_id": null,
            "education_training_classification_type_id": null,
            "id": 0,
            "note": null,
            "simple_state_id": null,
            "state_updated_at": null,
            "target_workers_classification_1_type_id": null,
            "target_workers_classification_2_type_id": null,
            "time_per_session": null,
            "title": null,
            "training_entity_type_id": null,
            "training_method_type_id": null,
            "type": "キャリアアップ",
            "updated_at": null,
            "updated_user_id": null,
            "wage_payment_training_type_id": null,
            "freeItems": null,
            "propertyColumn": null,
            "dispatchSource": null,
            "candidateEducationAndTrainings": null,
            "users": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn",
            "dispatchSource": "DispatchSource",
            "candidateEducationAndTrainings": "CandidateEducationAndTraining",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_education_training_careers"
    },
    "DispatchSourceEducationTrainingOther": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "DispatchSourceReportState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "bear_training_cost_type_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_id": null,
            "education_entity_type_id": null,
            "id": 0,
            "note": null,
            "other_training_method_type_id": null,
            "simple_state_id": null,
            "state_updated_at": null,
            "time_per_session": null,
            "title": null,
            "type": "その他",
            "updated_at": null,
            "updated_user_id": null,
            "wage_payment_training_type_id": null,
            "freeItems": null,
            "dispatchSource": null,
            "candidateEducationAndTrainings": null,
            "users": null
        },
        "relations": {
            "dispatchSource": "DispatchSource",
            "candidateEducationAndTrainings": "CandidateEducationAndTraining",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_education_training_others"
    },
    "DispatchSourceEducationTrainingSafety": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "DispatchSourceReportState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_id": null,
            "education_entity_type_id": null,
            "education_method_type_id": null,
            "id": 0,
            "labor_safety_health_act_or_regulations_1_type_id": null,
            "labor_safety_health_act_or_regulations_2_type_id": null,
            "note": null,
            "simple_state_id": null,
            "state_updated_at": null,
            "time_per_session": null,
            "title": null,
            "type": "安全衛生教育",
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "dispatchSource": null,
            "candidateEducationAndTrainings": null,
            "users": null
        },
        "relations": {
            "dispatchSource": "DispatchSource",
            "candidateEducationAndTrainings": "CandidateEducationAndTraining",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_education_training_safeties"
    },
    "DispatchSourceReportSetting": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "attach_labor_agreement": null,
            "company_scale_type_id": null,
            "consolidated_balance_sheet_note": null,
            "created_at": null,
            "created_user_id": null,
            "detail_margin_ratio_publication": null,
            "dispatch_source_id": null,
            "employment_agencies_license_code": null,
            "execution_contract_work": null,
            "execution_piecework_contract": null,
            "group_company_names": null,
            "id": 0,
            "industry_classification_name": null,
            "industry_classification_number": null,
            "margin_ratio_publication_on_the_document": null,
            "margin_ratio_publication_on_the_net": null,
            "margin_ratio_publication_on_the_other_way": null,
            "note": null,
            "number_of_businesses_type": null,
            "number_of_employees_type": null,
            "parent_company_name": null,
            "parent_company_note": null,
            "parent_dispatch_business_license_code": null,
            "parent_employment_agencies_license_code": null,
            "second_business_employment_agencies": null,
            "updated_at": null,
            "updated_user_id": null,
            "use_consolidated_balance_sheet": null,
            "dispatchSource": null
        },
        "relations": {
            "dispatchSource": "DispatchSource"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_report_settings"
    },
    "DispatchSourceStaff": {
        "constants": {
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "dispatch_source_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_source_id": null,
            "dispatch_source_staff_state_id": null,
            "id": 0,
            "name": null,
            "state_updated_at": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "dispatchSourceStaffState": null,
            "dispatchSource": null,
            "users": null
        },
        "relations": {
            "dispatchSourceStaffState": "DispatchSourceStaffState",
            "dispatchSource": "DispatchSource",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_staffs"
    },
    "DispatchSourceStaffMultiAssignment": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "DispatchSourceStaffState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_staff_states"
    },
    "DispatchSourceState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_source_states"
    },
    "DispatchStaff": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "dispatchStaffState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "dispatch_destination_id"
            ],
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "code": "code_normalized"
            },
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "code": null,
            "code_normalized": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "dispatch_staff_state_id": null,
            "full_text": null,
            "id": 0,
            "name": null,
            "name_normalized": null,
            "resource_id": null,
            "resource_type": null,
            "state_updated_at": null,
            "updated_at": null,
            "updated_user_id": null,
            "freeItems": null,
            "dispatchStaffState": null,
            "mails": null,
            "dispatchDestination": null,
            "user": null,
            "users": null
        },
        "relations": {
            "dispatchStaffState": "DispatchStaffState",
            "mails": "Mail",
            "dispatchDestination": "DispatchDestination",
            "user": "User",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPolymorphicPrimaryObjectModel",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_staffs"
    },
    "DispatchStaffMultiAssignment": {
        "constants": {
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "DispatchStaffState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_staff_states"
    },
    "DispatchState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "DispatchWorkingPlace": {
        "constants": {
            "INITIAL_INDEX_RELATIONS": [
                "dispatchWorkingPlaceState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "dispatch_destination_id"
            ],
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "code": "code_normalized"
            },
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "code": null,
            "code_normalized": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "department_name": null,
            "dispatch_working_place_state_id": null,
            "full_text": null,
            "id": 0,
            "memo": null,
            "name": null,
            "name_normalized": null,
            "nearest_station": null,
            "prefecture_id": null,
            "resource_id": null,
            "resource_type": null,
            "state_updated_at": null,
            "tel": null,
            "updated_at": null,
            "updated_user_id": null,
            "zip": null,
            "freeItems": null,
            "dispatchWorkingPlaceState": null,
            "mails": null,
            "dispatchDestination": null,
            "prefecture": null,
            "user": null,
            "users": null
        },
        "relations": {
            "dispatchWorkingPlaceState": "DispatchWorkingPlaceState",
            "mails": "Mail",
            "dispatchDestination": "DispatchDestination",
            "prefecture": "Prefecture",
            "user": "User",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchPolymorphicPrimaryObjectModel",
            "App\\Models\\Bases\\DispatchPrimaryObjectModel",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_working_places"
    },
    "DispatchWorkingPlaceState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchState",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_working_place_states"
    },
    "DownloadFileCreationQueueLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "output_item_id": null,
            "output_item_type": null,
            "updated_at": null,
            "user_id": null,
            "exportSetting": null,
            "user": null,
            "downloadTargetModels": null,
            "candidates": null,
            "companies": null,
            "jobs": null,
            "sales": null,
            "downloadFileServerCreationLog": null
        },
        "relations": {
            "exportSetting": "ExportSetting",
            "user": "User",
            "downloadTargetModels": "DownloadTargetModel",
            "candidates": "Candidate",
            "companies": "Company",
            "jobs": "Job",
            "sales": "Sale",
            "downloadFileServerCreationLog": "DownloadFileServerCreationLog"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "download_file_creation_queue_logs"
    },
    "DownloadFileServerCreationLog": {
        "constants": [],
        "properties": {
            "created_at": null,
            "download_file_creation_queue_log_id": null,
            "expires_at": null,
            "extension": null,
            "file_name": null,
            "id": 0,
            "s3_path": null,
            "updated_at": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "download_file_server_creation_logs"
    },
    "DownloadTargetModel": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "download_file_creation_queue_log_id": null,
            "id": 0,
            "model_id": null,
            "model_type": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "download_target_models"
    },
    "DownloadedFileLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "download_file_server_creation_log_id": null,
            "id": 0,
            "updated_at": null,
            "user_id": null,
            "downloadFileServerCreationLog": null
        },
        "relations": {
            "downloadFileServerCreationLog": "DownloadFileServerCreationLog"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "downloaded_file_logs"
    },
    "Education": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "course": null,
            "created_at": null,
            "custom_text_1": null,
            "custom_text_2": null,
            "custom_text_3": null,
            "custom_text_4": null,
            "custom_text_5": null,
            "data_position": null,
            "deleted_at": null,
            "entrance_date": null,
            "graduation_date": null,
            "id": 0,
            "school": null,
            "school_category_id": null,
            "updated_at": null,
            "candidate": null,
            "schoolCategory": null
        },
        "relations": {
            "candidate": "Candidate",
            "schoolCategory": "SchoolCategory"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "educations"
    },
    "EmploymentCategory": {
        "constants": {
            "REGULAR_EMPLOYEE": 1,
            "TEMPORARY_EMPLOYEE": 2,
            "CONTRACT_EMPLOYEE": 3,
            "PART_TIME_JOB": 4,
            "OUTSOURCING": 5,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "employment_categories"
    },
    "ExportSetting": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "MEDIA_ROW_OFFSET_ID": 10001,
            "CANDIDATES": "人材全項目出力",
            "COMPANIES": "会社全項目出力",
            "JOBS": "紹介求人全項目出力",
            "SALES": "売上全項目出力",
            "CANDIDATE_JOB_STEPS": "進捗全項目出力",
            "CANDIDATE_JOB_STEP_RESOURCES": "進捗全項目出力",
            "RECRUIT_CANDIDATE": "応募者全項目出力",
            "COMPANY_STEPS": "会社対応全項目出力",
            "DASHBOARD_CANDIDATE_JOB_STEPS": "ダッシュボード進捗全項目出力",
            "STAFFS": "会社担当者全項目出力",
            "BILLING_DESTINATIONS": "請求先全項目出力",
            "DISPATCH_DESTINATIONS": "派遣先全項目出力",
            "DISPATCH_STAFFS": "派遣先担当者全項目出力",
            "DISPATCH_JOBS": "派遣求人全項目出力",
            "CONTRACTS": "契約全項目出力",
            "CONFLICT_DATE_MANAGEMENTS": "抵触日全項目出力",
            "DISPATCH_WORKING_PLACES": "就業現場全項目出力",
            "DISPATCH_ORGANIZATION_UNIT": "組織単位全項目出力",
            "CANDIDATE_STEPS": "対応状況出力",
            "INVOICE_CONTRACT_ATTENDANCE_SUMMARY": "勤怠サマリー(請求)全項目出力",
            "INVOICE_CONTRACT_ATTENDANCE_BREAKDOWNS": "勤怠内訳(請求)全項目出力",
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORTS": "勤怠過不足金(請求)全項目出力",
            "PAYMENT_CONTRACT_ATTENDANCE_SUMMARY": "勤怠サマリー(支払)全項目出力",
            "PAYMENT_CONTRACT_ATTENDANCE_BREAKDOWNS": "勤怠内訳(支払)全項目出力",
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORTS": "勤怠過不足金(支払)全項目出力",
            "INVOICE_CLOSED_ATTENDANCE_SUMMARY": "勤怠締めサマリー全項目出力",
            "INVOICE_CLOSED_ATTENDANCE_BREAKDOWNS": "勤怠締め内訳全項目出力",
            "INVOICE_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORTS": "勤怠締め過不足金全項目出力",
            "PAYMENT_CLOSED_ATTENDANCE_SUMMARY": "勤怠締めサマリー全項目出力",
            "PAYMENT_CLOSED_ATTENDANCE_BREAKDOWNS": "勤怠締め内訳全項目出力",
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORTS": "勤怠締め過不足金全項目出力",
            "INVOICE_CLOSED_INVOICE_SUMMARY": "請求サマリー全項目出力",
            "INVOICE_CLOSED_INVOICE_BREAKDOWNS": "請求内訳全項目出力",
            "PAYMENT_CLOSED_PAYMENT_SUMMARY": "支払サマリー全項目出力",
            "PAYMENT_CLOSED_PAYMENT_BREAKDOWNS": "支払内訳全項目出力",
            "CANDIDATE_CAREER_COUNSELLINGS": "キャリア相談全項目出力",
            "CANDIDATE_EDUCATION_AND_TRAININGS": "教育訓練全項目出力",
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURES": "雇用安定措置全項目出力",
            "CANDIDATES_ID": 1,
            "COMPANIES_ID": 2,
            "JOBS_ID": 3,
            "SALES_ID": 4,
            "CANDIDATE_JOB_STEPS_ID": 5,
            "CANDIDATE_STEP_ID": 6,
            "COMPANY_STEPS_ID": 7,
            "DASHBOARD_CANDIDATE_JOB_STEPS_ID": 8,
            "SYSTEM_ADMIN_TOOLS_STAFFS_ID": 9,
            "STAFFS_ID": 10,
            "BILLING_DESTINATIONS_ID": 11,
            "DISPATCH_DESTINATIONS_ID": 12,
            "DISPATCH_STAFFS_ID": 13,
            "DISPATCH_JOBS_ID": 14,
            "CANDIDATE_JOB_STEP_RESOURCES_ID": 15,
            "CONTRACTS_ID": 16,
            "CONFLICT_DATE_MANAGEMENTS_ID": 17,
            "INVOICE_CONTRACT_ATTENDANCE_SUMMARY_ID": 18,
            "INVOICE_CONTRACT_ATTENDANCE_BREAKDOWN_ID": 19,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORTS_ID": 20,
            "PAYMENT_CONTRACT_ATTENDANCE_SUMMARY_ID": 21,
            "PAYMENT_CONTRACT_ATTENDANCE_BREAKDOWN_ID": 22,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORTS_ID": 23,
            "INVOICE_CLOSED_ATTENDANCE_SUMMARY_ID": 24,
            "INVOICE_CLOSED_ATTENDANCE_BREAKDOWN_ID": 25,
            "INVOICE_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORTS_ID": 26,
            "INVOICE_CLOSED_INVOICE_SUMMARY_ID": 27,
            "INVOICE_CLOSED_INVOICE_BREAKDOWN_ID": 28,
            "PAYMENT_CLOSED_ATTENDANCE_SUMMARY_ID": 29,
            "PAYMENT_CLOSED_ATTENDANCE_BREAKDOWN_ID": 30,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORTS_ID": 31,
            "PAYMENT_CLOSED_PAYMENT_SUMMARY_ID": 32,
            "PAYMENT_CLOSED_PAYMENT_BREAKDOWN_ID": 33,
            "CANDIDATE_CAREER_COUNSELLINGS_ID": 34,
            "CANDIDATE_EDUCATION_AND_TRAININGS_ID": 35,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURES_ID": 36,
            "DISPATCH_WORKING_PLACE_ID": 37,
            "DISPATCH_ORGANIZATION_UNIT_ID": 38,
            "OLD_CANDIDATES_ID": 101,
            "OLD_COMPANIES_ID": 102,
            "OLD_JOBS_ID": 103,
            "OLD_SALES_ID": 104,
            "OLD_CANDIDATE_JOB_STEPS_ID": 105,
            "OLD_CANDIDATE_STEP_ID": 106,
            "OLD_COMPANY_STEPS_ID": 107,
            "OLD_STAFFS_ID": 110,
            "ALL_EXPORT_SETTING_TABLES": {
                "2": 1,
                "3": 2,
                "4": 3,
                "5079": 17
            },
            "ALL_PARENTS_EXPORT_SETTING_TABLES": {
                "14": 10,
                "5001": 11,
                "5018": 12,
                "5021": 13,
                "5027": 14,
                "5013": 6,
                "5014": 7,
                "5012": 15,
                "5041": 16
            },
            "HAKEN_ALL_EXPORT_SETTING_TABLES": {
                "2": 1,
                "3": 2,
                "4": 3,
                "14": 10,
                "5012": 5,
                "78": 4,
                "5001": 11,
                "5018": 12,
                "5021": 13,
                "5027": 14,
                "64": 6,
                "65": 7,
                "5041": 16,
                "5079": 17,
                "5089": 18,
                "5090": 21,
                "5065": 24,
                "5067": 27,
                "5069": 29,
                "5071": 32,
                "5023": 37,
                "5025": 38
            },
            "ATTENDANCE_ALL_EXPORT_SETTING_TABLES": [
                19,
                20,
                22,
                23,
                24,
                25,
                26,
                28,
                29,
                30,
                31,
                33
            ],
            "ATTENDANCE_EXPORT_SETTING_DETAILS": [
                19,
                20,
                21,
                22,
                23,
                25,
                26,
                28,
                30,
                31,
                33
            ],
            "CSV_TYPE_NAMES": {
                "2": "人材CSV",
                "3": "会社情報CSV",
                "4": "紹介求人CSV",
                "14": "会社担当者CSV",
                "67": "進捗CSV",
                "5012": "進捗CSV",
                "78": "売上CSV",
                "5001": "請求先CSV",
                "5018": "派遣先CSV",
                "5021": "派遣先担当者CSV",
                "5027": "派遣求人CSV",
                "64": "人材対応CSV",
                "65": "会社対応CSV",
                "5041": "契約CSV",
                "5067": "請求一覧サマリーCSV",
                "5071": "支払一覧サマリーCSV",
                "5089": "勤怠サマリー(請求)CSV",
                "5090": "勤怠サマリー(支払)CSV",
                "5074": "勤怠内訳",
                "5064": "勤怠過不足金",
                "5065": "勤怠締めサマリーCSV",
                "5092": "勤怠締め内訳CSV",
                "5094": "勤怠締め過不足金CSV",
                "5069": "勤怠締めサマリーCSV",
                "5093": "勤怠締め内訳CSV",
                "5095": "勤怠締め過不足金CSV",
                "5106": "キャリア相談CSV",
                "5107": "教育訓練CSV",
                "5108": "雇用安定措置CSV",
                "5025": "組織単位CSV",
                "5023": "就業現場CSV",
                "5075": "苦情処理CSV"
            },
            "CSV_OPTION_ATTENDANCE_NAMES": {
                "5089": "(請求)CSV",
                "5090": "(支払)CSV",
                "5065": "請求一覧内訳CSV",
                "5069": "支払一覧内訳CSV"
            },
            "RIKUNABI_NEXT": "リクナビNEXT",
            "MEDIA_EN": 10001,
            "MEDIA_RIKUNABI_NEXT": 10002,
            "MEDIA_ECAREERFA": 10003,
            "MEDIA_NIKKEI": 10004,
            "MEDIA_MYNAVI": 10005,
            "MEDIA_MYNAVI_AGENT": 10006
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "encoding": "1",
            "id": 0,
            "is_export_header": "1",
            "is_system_default": "0",
            "name": null,
            "option_value": "",
            "position": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyTable": null,
            "exportSettingDetails": null,
            "exportSettingHeaders": null
        },
        "relations": {
            "propertyTable": "PropertyTable",
            "exportSettingDetails": "ExportSettingDetail",
            "exportSettingHeaders": "ExportSettingHeader"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "export_settings"
    },
    "ExportSettingDetail": {
        "constants": {
            "SPECIAL_COLUMNS": [
                {
                    "propertyColumnId": 203,
                    "propertyCategoryId": 2,
                    "propertyTableId": 2,
                    "displayName": "candidates.user"
                },
                {
                    "propertyColumnId": 204,
                    "propertyCategoryId": 12,
                    "propertyTableId": 3,
                    "displayName": "companies.user"
                },
                {
                    "propertyColumnId": 205,
                    "propertyCategoryId": 16,
                    "propertyTableId": 4,
                    "displayName": "jobs.user"
                },
                {
                    "propertyColumnId": 5222,
                    "propertyCategoryId": 5111,
                    "propertyTableId": 5027,
                    "displayName": "dispatch_jobs.user"
                }
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "combine_character": null,
            "created_at": null,
            "data_position": null,
            "export_setting_id": null,
            "fixed_value": null,
            "id": 0,
            "max_size": null,
            "position": null,
            "prefix": null,
            "property_column_id": null,
            "property_table_id": null,
            "suffix": null,
            "updated_at": null,
            "exportSetting": null,
            "propertyTable": null,
            "propertyColumn": null,
            "exportSettingReplacements": null
        },
        "relations": {
            "exportSetting": "ExportSetting",
            "propertyTable": "PropertyTable",
            "propertyColumn": "PropertyColumn",
            "exportSettingReplacements": "ExportSettingReplacement"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "export_setting_details"
    },
    "ExportSettingHeader": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "export_setting_id": null,
            "id": 0,
            "position": null,
            "value": null,
            "exportSetting": null
        },
        "relations": {
            "exportSetting": "ExportSetting"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "export_setting_headers"
    },
    "ExportSettingReplacement": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "export_setting_detail_id": null,
            "id": 0,
            "is_full_matching": null,
            "new_substring": null,
            "old_substring": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "export_setting_replacements"
    },
    "Extension": {
        "constants": {
            "AGENCY_MANAGEMENT": "agency_management",
            "TODO": "todo",
            "DASHBOARD_COMPANY": "dashboard_company",
            "AGENT_BULK_MAIL": "agent_bulk_mail",
            "DASHBOARD_SETTING": "dashboard_setting",
            "CANDIDATE_JOB_STEP_STATE_SETTING": "candidate_job_step_state_setting",
            "SEARCH_COLUMN_SETTINGS": "search_column_setting",
            "SCHEDULE_CANDIDATE_JOB_STEP": "schedule_candidate_job_step",
            "CANDIDATE_JOB_STEP_SEARCH": "candidate_job_step_search",
            "CANDIDATE_JOB_STEP_IMPORT": "candidate_job_step_import",
            "COMPANY_STEP_SEARCH": "company_step_search",
            "API_V2": "api_v2",
            "HOMEPAGE_LINKAGE": "homepage_linkage",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "can_deploy": null,
            "id": 0,
            "is_enabled": null,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "extensions"
    },
    "FeeType": {
        "constants": {
            "INTRODUCTION": 1,
            "RECEPTION": 2,
            "OFFICE": 3,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "updated_at": null,
            "sales": null
        },
        "relations": {
            "sales": "Sale"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "fee_types"
    },
    "File": {
        "constants": [],
        "properties": {
            "created_at": null,
            "directory": null,
            "file_name": null,
            "id": 0,
            "unique_file_name": null,
            "updated_at": null,
            "reportCategories": null
        },
        "relations": {
            "reportCategories": "ReportCategory"
        },
        "appends": [],
        "parents": [
            "MatchinGood\\EloquentStorage\\EloquentStorage",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "files"
    },
    "FileCategory": {
        "constants": {
            "CSV": 1,
            "TSV": 2,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null,
            "position": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "file_categories"
    },
    "FileModel": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "FixedDefault": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "property_column_id": null,
            "updated_at": null,
            "value": null,
            "propertyColumn": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "fixed_defaults"
    },
    "FractionProcess": {
        "constants": {
            "RESOURCE_TYPE_COMPANY": "App\\Models\\Company",
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "RESOURCE_TYPE_CANDIDATE": "App\\Models\\Candidate",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "calc_time_unit": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "first_day_of_the_week_type_id": null,
            "id": 0,
            "less_yen_rounding_type_id": null,
            "name": null,
            "resource_id": null,
            "resource_type": null,
            "rounding_unit_type_id": null,
            "tax_rounding_type_id": null,
            "time_rounding_type_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "systemDefaultOptionDayOfTheWeekType": null,
            "systemDefaultOptionRoundingUnitType": null
        },
        "relations": {
            "systemDefaultOptionDayOfTheWeekType": "SystemDefaultOptionDayOfTheWeekType",
            "systemDefaultOptionRoundingUnitType": "SystemDefaultOptionRoundingUnitType"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchMaster",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "fraction_processes"
    },
    "FreeBooleanItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_boolean_items"
    },
    "FreeBooleanOption": {
        "constants": {
            "USERS_ENABLED_ID": 1,
            "CANDIDATES_IS_MARRIED_ID": 2,
            "JOBS_IS_WEB_ID": 3,
            "JOBS_IS_COMPANY_NAME_PUBLIC_ID": 4,
            "JOBS_IS_TRIAL_ID": 5,
            "AGENTS_IS_POSSIBLE_BULK_MAIL_ID": 6,
            "STAFFS_IS_POSSIBLE_BULK_MAIL_ID": 7,
            "CANDIDATES_IS_POSSIBLE_BULK_MAIL_ID": 8,
            "DISPATCH_JOBS_IS_WEB_ID": 9,
            "DISPATCH_JOBS_IS_COMPANY_NAME_PUBLIC_ID": 10,
            "CONTRACTS_IS_WEB_ID": 11,
            "CONTRACTS_IS_COMPANY_NAME_PUBLIC_ID": 12,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "false_text": null,
            "free_item_config_id": null,
            "id": 0,
            "true_text": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_boolean_options"
    },
    "FreeCalcItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_calc_items"
    },
    "FreeCheckboxItem": {
        "constants": {
            "DATA_COLUMN_NAME": "free_checkbox_option_id",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "free_checkbox_option_id": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null,
            "freeCheckboxOption": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig",
            "freeCheckboxOption": "FreeCheckboxOption"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_checkbox_items"
    },
    "FreeCheckboxOption": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "free_item_config_id": null,
            "free_items_group_id": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "freeItemConfig": null,
            "freeCheckboxItems": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig",
            "freeCheckboxItems": "FreeCheckboxItem"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_checkbox_options"
    },
    "FreeDateItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_date_items"
    },
    "FreeDatetimeItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_datetime_items"
    },
    "FreeHtmlItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_html_items"
    },
    "FreeItemConfig": {
        "constants": {
            "DEFAULT_FREE_ITEM_VALUE_KEY": "data",
            "SELECT_FREE_ITEM_VALUE_KEY": "free_select_option_id",
            "CHECKBOX_FREE_ITEM_VALUE_KEY": "free_checkbox_option_id",
            "RADIO_FREE_ITEM_VALUE_KEY": "free_radio_option_id",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "position": null,
            "property_column_id": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyTable": null,
            "propertyColumn": null,
            "freeRadioOptions": null,
            "freeSelectOptions": null,
            "freeCheckboxOptions": null,
            "freeBooleanOption": null,
            "freeTextItem": null,
            "freeTextareaItem": null,
            "freeSelectItem": null,
            "freeCheckboxItem": null,
            "freeUrlItem": null,
            "freeDateItem": null,
            "freeNumberItem": null,
            "freeRadioItem": null,
            "freeBooleanItem": null,
            "freeHtmlItem": null,
            "freeTimeItem": null,
            "freeMailItem": null,
            "freeTelItem": null,
            "freeCalcItem": null,
            "freeDatetimeItem": null
        },
        "relations": {
            "propertyTable": "PropertyTable",
            "propertyColumn": "PropertyColumn",
            "freeRadioOptions": "FreeRadioOption",
            "freeSelectOptions": "FreeSelectOption",
            "freeCheckboxOptions": "FreeCheckboxOption",
            "freeBooleanOption": "FreeBooleanOption",
            "freeTextItem": "FreeTextItem",
            "freeTextareaItem": "FreeTextareaItem",
            "freeSelectItem": "FreeSelectItem",
            "freeCheckboxItem": "FreeCheckboxItem",
            "freeUrlItem": "FreeUrlItem",
            "freeDateItem": "FreeDateItem",
            "freeNumberItem": "FreeNumberItem",
            "freeRadioItem": "FreeRadioItem",
            "freeBooleanItem": "FreeBooleanItem",
            "freeHtmlItem": "FreeHtmlItem",
            "freeTimeItem": "FreeTimeItem",
            "freeMailItem": "FreeMailItem",
            "freeTelItem": "FreeTelItem",
            "freeCalcItem": "FreeCalcItem",
            "freeDatetimeItem": "FreeDatetimeItem"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_item_configs"
    },
    "FreeItemsGroup": {
        "constants": {
            "FREE_ITEMS_IS_AGREEMENT_WORKER_LIMITED": 1,
            "HONORIFIC_TITLE": 2,
            "APPLICABLE_RELATED_DISPATCH_DESTINATION": 3,
            "EMPLOYMENT_PERIOD": 4,
            "HAS_INSURANCE": 5,
            "HAS_RULE_EMPLOYMENT_PERIOD": 6,
            "EXCEPTION_BUSINESS_NUMBER": 7,
            "FULL_TIME_WORK": 8,
            "PAYMENT_DAY": 9,
            "PAYMENT_MONTH": 10,
            "LIMITED_AGREEMENT_DISPATCH_WORKER": 11,
            "EMPLOYMENT_PERIOD_FIXED_TERM_OR_INDEFINITE": 12,
            "TYPES_OF_INSURANCE": 13,
            "SALARY_CATEGORY_FOR_JOB_POSTING": 14,
            "JOB_WHETHER_OR_NOT_THE_CONTRACT_HAS_BEEN_RENEWED": 15,
            "DISPATCH_WHETHER_OR_NOT_THE_CONTRACT_HAS_BEEN_RENEWED": 16,
            "TOTAL_EMPLOYMENT_PERIOD": 17,
            "DISPATCH_FREE_ITEMS_GROUPS": [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "input_category_id": null,
            "is_plan_dispatch_basic": "1",
            "is_plan_dispatch_bill": "0",
            "is_plan_dispatch_payroll": "1",
            "is_plan_employment_agency": "1",
            "is_plan_spot": "1",
            "is_system_default": "0",
            "name": null,
            "updated_at": null,
            "propertyColumns": null,
            "freeSelectOption": null,
            "freeCheckboxOption": null,
            "freeRadioOption": null,
            "inputCategory": null
        },
        "relations": {
            "propertyColumns": "PropertyColumn",
            "freeSelectOption": "FreeSelectOption",
            "freeCheckboxOption": "FreeCheckboxOption",
            "freeRadioOption": "FreeRadioOption",
            "inputCategory": "InputCategory"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_items_groups"
    },
    "FreeMailItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "CAN_SEND_BULK_COLUMN_NAME": "can_send_bulk",
            "ADD_DATA_COLUMN_NAMES": [
                "can_send_bulk"
            ],
            "CAN_SEND_BULK_TRUE": 1,
            "CAN_SEND_BULK_FALSE": 0,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "can_send_bulk": "0",
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_mail_items"
    },
    "FreeMonthItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\FreeDateItem",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_date_items"
    },
    "FreeNumberItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_number_items"
    },
    "FreeRadioItem": {
        "constants": {
            "DATA_COLUMN_NAME": "free_radio_option_id",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "free_item_config_id": null,
            "free_radio_option_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null,
            "freeRadioOption": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig",
            "freeRadioOption": "FreeRadioOption"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_radio_items"
    },
    "FreeRadioOption": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "free_item_config_id": null,
            "free_items_group_id": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "freeItemConfig": null,
            "freeRadioItems": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig",
            "freeRadioItems": "FreeRadioItem"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_radio_options"
    },
    "FreeReferenceItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_text_items"
    },
    "FreeSelectItem": {
        "constants": {
            "DATA_COLUMN_NAME": "free_select_option_id",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "free_item_config_id": null,
            "free_select_option_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null,
            "freeSelectOption": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig",
            "freeSelectOption": "FreeSelectOption"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_select_items"
    },
    "FreeSelectOption": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "free_item_config_id": null,
            "free_items_group_id": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "freeItemConfig": null,
            "freeSelectItems": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig",
            "freeSelectItems": "FreeSelectItem"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_select_options"
    },
    "FreeTelItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_tel_items"
    },
    "FreeTextItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_text_items"
    },
    "FreeTextareaItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_textarea_items"
    },
    "FreeTimeItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_time_items"
    },
    "FreeUrlItem": {
        "constants": {
            "DATA_COLUMN_NAME": "data",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "data": null,
            "free_item_config_id": null,
            "id": 0,
            "object_id": null,
            "updated_at": null,
            "freeItemConfig": null
        },
        "relations": {
            "freeItemConfig": "FreeItemConfig"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "free_url_items"
    },
    "GoogleAccount": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "token": null,
            "updated_at": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "google_accounts"
    },
    "IframeJobFreeWord": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "full_text": null,
            "id": 0,
            "job_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "iframe_job_free_words"
    },
    "ImportErrorColumn": {
        "constants": {
            "CSV_OUTPUT_COUNT": 100,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "column": null,
            "id": 0,
            "imported_file_id": null,
            "message": null,
            "property_column_id": null,
            "row": null,
            "propertyColumn": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "import_error_columns"
    },
    "ImportSetting": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "MEDIA_ROW_OFFSET_ID": 10001,
            "MEDIA_RIKUNABI_NEXT": 10001,
            "MEDIA_RIKUNABI_NEXT_OLD": 10002,
            "MEDIA_EN": 10003,
            "MEDIA_ECAREERFA": 10004,
            "MEDIA_BIZ_REACH": 10005,
            "MEDIA_NIKKEI": 10006,
            "MEDIA_MYNAVI": 10007,
            "MEDIA_MYNAVI_AGENT": 10008,
            "MEDIA_MYNAVI_AGENT_JOB": 10009,
            "MEDIA_DODA_MAPS": 10010,
            "MEDIA_ECAREEAFA_JOB": 10011,
            "MEDIA_DODA": 10012,
            "MEDIA_BIZ_REACH_RECRUITER": 10014,
            "MEDIA_DODA_MAPS_NAME": "DODA MAPS",
            "CANDIDATE_CAREER_COUNSELLINGS_ID": 1,
            "CANDIDATE_EDUCATION_AND_TRAININGS_ID": 2,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURES_ID": 3,
            "CANDIDATE_CAREER_COUNSELLINGS": "キャリア相談全項目",
            "CANDIDATE_EDUCATION_AND_TRAININGS": "教育訓練全項目",
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURES": "雇用安定措置全項目",
            "EMPLOYMENT_AGENCY_PLAN_PROPERTY_TABLE_IDS": [
                2,
                3,
                4,
                14,
                64,
                65,
                67
            ],
            "DISPATCH_PLAN_PROPERTY_TABLE_IDS": [
                2,
                3,
                4,
                14,
                64,
                65,
                5001,
                67,
                5018,
                5023,
                5025,
                5052,
                5054,
                5021,
                5027,
                5041,
                5106,
                5107,
                5108
            ],
            "PARENT_TABLE_IDS": {
                "4": 3,
                "5018": 3,
                "5001": 3,
                "14": 3,
                "5021": 5018,
                "5023": 5018,
                "5025": 5018,
                "5054": 5052,
                "5027": 5018,
                "64": 2,
                "65": 3,
                "67": [
                    2,
                    4
                ],
                "5041": [
                    2,
                    5027
                ],
                "5074": [
                    2,
                    5041,
                    5027
                ],
                "5064": [
                    2,
                    5041,
                    5027
                ],
                "5108": 2,
                "5107": 2,
                "5106": 2
            },
            "CHILD_TABLE_IDS": {
                "2": [
                    20,
                    22,
                    5076,
                    5077,
                    18,
                    5096,
                    5097
                ],
                "64": [],
                "67": [],
                "3": [
                    19
                ],
                "65": [],
                "4": [
                    14,
                    23
                ],
                "78": [],
                "5001": [
                    5035
                ],
                "14": [],
                "5018": [],
                "5021": [],
                "5023": [],
                "5025": [],
                "5041": [
                    5045,
                    5044,
                    5046,
                    5049,
                    5050,
                    5051,
                    5060,
                    5061
                ],
                "5052": [],
                "5054": [],
                "5027": [
                    5038,
                    5040,
                    5039,
                    5030,
                    5031,
                    5032,
                    5033,
                    5052,
                    5058,
                    5059,
                    5034
                ],
                "5074": [],
                "5064": [],
                "5106": [],
                "5107": [],
                "5108": []
            },
            "STEP_PARENT_RESOURCE_TABLE_IDS_FOR_IMPORT": [
                2,
                3,
                4
            ],
            "BUSINESS_REPORT_PARENT_RESOURCE_TABLE_IDS_FOR_IMPORT": [
                2
            ],
            "BASIC_INFO_COLUMN_FOR_IMPORT_STEP_PARENT_RESOURCE": [
                165,
                2,
                163,
                45,
                148
            ],
            "BASIC_INFO_COLUMN_FOR_IMPORT_BUSINESS_REPORT_PARENT_RESOURCE": [
                165,
                2
            ],
            "NOT_SELECT_COLUMN_FOR_IMPORT_BUSINESS_REPORT_RESOURCE": [
                7290,
                7300,
                7315
            ],
            "BASIC_INFO_COLUMN_FOR_IMPORT_PARENT_PROPERTY_COLUMNS": [
                165,
                2,
                5045,
                5048,
                5110
            ],
            "BASIC_INFO_COLUMN_FOR_IMPORT_PARENT_PROPERTY_COLUMNS_BY_PROPERTY_TABLE": {
                "5074": [
                    165,
                    5,
                    5239,
                    5110
                ],
                "5064": [
                    165,
                    5,
                    5239,
                    5110
                ]
            },
            "CAN_NOT_CREATE_PARENT_RESOURCE_FOR_PROPERTY_TABLES": [
                5021,
                5023,
                5025,
                5027,
                5041,
                5074,
                5064
            ]
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "file_category_id": null,
            "id": 0,
            "is_check_columns_required": "0",
            "is_ignore_first_line": null,
            "name": null,
            "position": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyTable": null,
            "importSettingDetails": null,
            "fileCategory": null
        },
        "relations": {
            "propertyTable": "PropertyTable",
            "importSettingDetails": "ImportSettingDetail",
            "fileCategory": "FileCategory"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "import_settings"
    },
    "ImportSettingDetail": {
        "constants": {
            "SPECIAL_COLUMNS": {
                "203": {
                    "propertyColumnId": 203,
                    "propertyCategoryId": 2,
                    "propertyTableId": 2,
                    "displayName": "candidates.user"
                },
                "204": {
                    "propertyColumnId": 204,
                    "propertyCategoryId": 12,
                    "propertyTableId": 3,
                    "displayName": "companies.user"
                },
                "205": {
                    "propertyColumnId": 205,
                    "propertyCategoryId": 16,
                    "propertyTableId": 4,
                    "displayName": "jobs.user"
                },
                "5222": {
                    "propertyColumnId": 5222,
                    "propertyCategoryId": 5111,
                    "propertyTableId": 5027,
                    "displayName": "dispatch_jobs.user"
                }
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "csv_column": null,
            "deleted_at": null,
            "delimiter": null,
            "divided_element_number": null,
            "group_number": null,
            "id": 0,
            "import_setting_id": null,
            "is_auto_add_option": "0",
            "position": null,
            "prefix": "",
            "property_column_id": null,
            "property_table_id": null,
            "suffix": "",
            "updated_at": null,
            "importSetting": null,
            "propertyTable": null,
            "propertyColumn": null,
            "importSettingReplacements": null
        },
        "relations": {
            "importSetting": "ImportSetting",
            "propertyTable": "PropertyTable",
            "propertyColumn": "PropertyColumn",
            "importSettingReplacements": "ImportSettingReplacement"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "import_setting_details"
    },
    "ImportSettingReplacement": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "delimiter": null,
            "id": 0,
            "import_setting_detail_id": null,
            "is_full_matching": null,
            "new_substring": null,
            "old_substring": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "import_setting_replacements"
    },
    "ImportedFile": {
        "constants": {
            "ERROR_TYPE_TIMEOUT": 1,
            "ERROR_TYPE_UNEXPECTED_ERROR": 2,
            "ERROR_TYPE_VALIDATION_ERROR": 3,
            "MEGA_BYTE": 1048576,
            "MAX_FILE_SIZE": 52428800,
            "MAX_ROW_COUNT": 10000,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "error_count": null,
            "error_type_id": null,
            "file_id": null,
            "id": 0,
            "import_setting_id": null,
            "is_success": "0",
            "success_count": null,
            "updated_at": null,
            "importedRecords": null,
            "importSetting": null,
            "importErrorColumns": null,
            "downloadFileCreationQueueLog": null,
            "file": null
        },
        "relations": {
            "importedRecords": "ImportedRecord",
            "importSetting": "ImportSetting",
            "importErrorColumns": "ImportErrorColumn",
            "downloadFileCreationQueueLog": "DownloadFileCreationQueueLog",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "imported_files"
    },
    "ImportedRecord": {
        "constants": {
            "CREATE_MODE": 0,
            "UPDATE_MODE": 1,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "imported_file_id": null,
            "mode": "0",
            "object_id": null,
            "object_type": null,
            "updated_at": null,
            "importedFile": null
        },
        "relations": {
            "importedFile": "ImportedFile"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "imported_records"
    },
    "Industry": {
        "constants": {
            "MAX_NAME_LENGTH": 255
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "depth": null,
            "id": 0,
            "lft": null,
            "name": null,
            "parent_id": null,
            "rgt": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Node",
            "Baum\\Node",
            "Baum\\Extensions\\Eloquent\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "industries"
    },
    "InputCategory": {
        "constants": {
            "TEXT": 1,
            "TEXTAREA": 2,
            "SELECT": 3,
            "CHECKBOX": 4,
            "URL": 5,
            "DATE": 6,
            "NUMBER": 7,
            "RADIO": 8,
            "BOOLEAN": 9,
            "FILE": 10,
            "MONTH": 11,
            "EMAIL": 12,
            "CALENDAR": 14,
            "SEQUENCE": 15,
            "TIME": 16,
            "REFERENCE": 18,
            "CALC": 20,
            "DATETIME": 21,
            "TEL": 22,
            "VIRTUAL_RELATION_SELECT": 1001,
            "VIRTUAL_RELATION_MULTI_SELECT": 1002,
            "OPTION_INPUT_CATEGORY": [
                3,
                4,
                8
            ],
            "SCOPED_INPUT_CATEGORY": [
                1,
                2,
                5,
                7
            ],
            "FREE_ITEM_GROUP": [
                1,
                2,
                3,
                4,
                5,
                11,
                6,
                7,
                8,
                9,
                22,
                20,
                12,
                21,
                16
            ],
            "TYPE_STRING": "string",
            "TYPE_NUMBER": "number",
            "TYPE_DATE": "date",
            "TYPE_SINGLE_SELECT": "single_select",
            "TYPE_MULTI_SELECT": "multi_select",
            "STRING_GROUP": [
                1,
                2,
                5,
                10,
                12,
                22
            ],
            "TEXT_GROUP": [
                1,
                5,
                12,
                22
            ],
            "NUMBER_GROUP": [
                7,
                9
            ],
            "DATE_GROUP": [
                6,
                11,
                14,
                16,
                21
            ],
            "YEAR_MONTH_DATE_GROUP": [
                6,
                11,
                21
            ],
            "SINGLE_SELECT_GROUP": [
                3,
                8
            ],
            "MULTI_SELECT_GROUP": [
                4
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "display_name": null,
            "id": 0,
            "name": null,
            "position": null,
            "type": null,
            "propertyColumns": null
        },
        "relations": {
            "propertyColumns": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "input_categories"
    },
    "InvoiceDatum": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "billing_closing_day_date_only_type_id": null,
            "billing_destination_id": null,
            "calc_time_unit": null,
            "first_day_of_the_week_type_id": null,
            "fraction_rounding_type_id": null,
            "id": 0,
            "rounding_unit_type_id": null,
            "tax_rounding_type_id": null,
            "time_rounding_type_id": null,
            "systemDefaultOptionDateOnlyType": null,
            "systemDefaultOptionRoundingType": null,
            "systemDefaultOptionTaxRoundingType": null,
            "systemDefaultOptionTimeRoundingType": null,
            "systemDefaultOptionDayOfTheWeekType": null,
            "systemDefaultOptionRoundingUnitType": null
        },
        "relations": {
            "systemDefaultOptionDateOnlyType": "SystemDefaultOptionDateOnlyType",
            "systemDefaultOptionRoundingType": "SystemDefaultOptionRoundingType",
            "systemDefaultOptionTaxRoundingType": "SystemDefaultOptionTaxRoundingType",
            "systemDefaultOptionTimeRoundingType": "SystemDefaultOptionTimeRoundingType",
            "systemDefaultOptionDayOfTheWeekType": "SystemDefaultOptionDayOfTheWeekType",
            "systemDefaultOptionRoundingUnitType": "SystemDefaultOptionRoundingUnitType"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "invoice_data"
    },
    "Job": {
        "constants": {
            "CSS_AFFIX": "job",
            "SHARE_CONVERT_COLUMNS": [
                "employment_category_id",
                "industry_id",
                "occupation_id",
                "prefecture_id",
                "roudoukyoku_category_id",
                "job_state_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [
                "id",
                "company_id",
                "job_state_id",
                "title",
                "created_at",
                "updated_at",
                "deleted_at"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "company",
                "jobState"
            ],
            "HIDDEN_PROPERTY_COLUMN_IDS_FOR_FREE_BOOLEAN": [
                77,
                78,
                94
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "code": "code_normalized"
            },
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id"
            ],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "access": null,
            "age_limit": null,
            "background": null,
            "billing_company_id": null,
            "billing_destination_id": null,
            "business_hours": null,
            "cabinet_order_industry_type_id": null,
            "code": null,
            "code_normalized": null,
            "company_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "department": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_job_state_id": null,
            "dispatch_job_type_id": null,
            "dispatch_organization_unit_id": null,
            "dispatch_source_id": null,
            "dispatch_start_date": null,
            "employment_category_id": null,
            "employment_insurance_industry_id": null,
            "fee_memo": null,
            "full_text": null,
            "holiday": null,
            "hope_num": null,
            "id": 0,
            "industry_id": null,
            "interview_count": null,
            "interview_process": null,
            "is_company_name_public": null,
            "is_dispatch": null,
            "is_specific_manufacturing_operation_type_id": null,
            "is_target_over_age_60_boolean_type_id": null,
            "is_trial": null,
            "is_web": null,
            "japan_std_occupation_id": null,
            "job_state_id": null,
            "max_age": null,
            "max_yearly_salary": null,
            "medium_id": null,
            "memo": null,
            "mhlw_occupation_id": null,
            "min_age": null,
            "min_yearly_salary": null,
            "must_skill": null,
            "occupation_id": null,
            "occupation_name": null,
            "place": null,
            "place_sub_map": null,
            "post": null,
            "prefecture_id": null,
            "qualification": null,
            "reason": null,
            "referenced_amount_over_short_id": null,
            "referenced_dispatch_working_place_id": null,
            "referenced_wage_id": null,
            "role_detail": null,
            "roudoukyoku_category_id": null,
            "staff_id": null,
            "state_updated_at": null,
            "title": null,
            "transfer": null,
            "trial_detail": null,
            "updated_at": null,
            "updated_user_id": null,
            "valid_end_date": null,
            "want_skill": null,
            "welfare": null,
            "freeItems": null,
            "company": null,
            "jobState": null,
            "industry": null,
            "occupation": null,
            "employmentCategory": null,
            "prefecture": null,
            "roudoukyokuCategory": null,
            "candidateJobSteps": null,
            "sales": null,
            "jobFiles": null,
            "staff": null,
            "jobUsers": null,
            "iframeJobFreeWord": null,
            "jobPhoto": null,
            "importedRecords": null,
            "candidateJobStepResources": null,
            "users": null
        },
        "relations": {
            "company": "Company",
            "jobState": "JobState",
            "industry": "Industry",
            "occupation": "Occupation",
            "employmentCategory": "EmploymentCategory",
            "prefecture": "Prefecture",
            "roudoukyokuCategory": "RoudoukyokuCategory",
            "candidateJobSteps": "CandidateJobStep",
            "sales": "Sale",
            "jobFiles": "JobFile",
            "staff": "Staff",
            "jobUsers": "JobUser",
            "iframeJobFreeWord": "IframeJobFreeWord",
            "jobPhoto": "JobPhoto",
            "importedRecords": "ImportedRecord",
            "candidateJobStepResources": "CandidateJobStepResource",
            "users": "User"
        },
        "appends": [
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "jobs"
    },
    "JobFile": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "file_id": null,
            "id": 0,
            "job_id": null,
            "job": null,
            "file": null
        },
        "relations": {
            "job": "Job",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "job_files"
    },
    "JobPhoto": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "file_id": null,
            "id": 0,
            "job_id": null,
            "job": null,
            "file": null
        },
        "relations": {
            "job": "Job",
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "job_photos"
    },
    "JobState": {
        "constants": {
            "ACTIVE_STATE_ID": 1,
            "PENDING_STATE_ID": 2,
            "CLOSE_STATE_ID": 3,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "color": null,
            "created_at": null,
            "id": 0,
            "is_system_default": "0",
            "name": null,
            "position": null,
            "updated_at": null,
            "jobs": null
        },
        "relations": {
            "jobs": "Job"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "job_states"
    },
    "JobUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "job_id": null,
            "updated_at": null,
            "user_id": null,
            "job": null,
            "user": null
        },
        "relations": {
            "job": "Job",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "job_users"
    },
    "Locale": {
        "constants": {
            "JA": 1,
            "EN": 2,
            "CHS": 3,
            "CHT": 4,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "code": null,
            "datetime_format": null,
            "id": 0,
            "name": null,
            "position": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "locales"
    },
    "LoginHistory": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "continuous_failure_times": null,
            "id": 0,
            "ip_address": null,
            "is_login_succeeded": null,
            "lock_limit_time": null,
            "login_id": null,
            "login_time": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "login_histories"
    },
    "Mail": {
        "constants": {
            "FULL_TEXT_MERGE_COLUMNS": [
                "uid",
                "to_address",
                "to_name",
                "from_address",
                "from_name",
                "cc_addresses",
                "bcc_addresses",
                "subject",
                "body"
            ],
            "RECEIVE_MAILS_DISPLAY": "受信",
            "SEND_MAILS_DISPLAY": "送信",
            "TRASH_MAILS_DISPLAY": "ゴミ箱",
            "ICON_STYLES": {
                "CANDIDATE": "common_history_icon_candidate",
                "STAFF": "common_history_icon_staff",
                "COMPANY": "common_history_icon_company",
                "USER": "common_history_icon_user",
                "DISPATCH_STAFF": "common_history_icon_dispatch_staff",
                "OTHER": "common_history_icon_other"
            },
            "SEND_ICON_SHARP": "icon_paper_plane",
            "RECEIVE_ICON_SHARP": "icon_mail",
            "CATEGORY_RECEIVE": "RECEIVE",
            "CATEGORY_SEND": "SEND",
            "TARGET_CANDIDATE": "CANDIDATE",
            "TARGET_COMPANY": "COMPANY",
            "TARGET_STAFF": "STAFF",
            "TARGET_USER": "USER",
            "TARGET_AGENT": "AGENT",
            "TARGET_OTHER": "OTHER",
            "TARGET_BILLING_DESTINATION": "BILLING_DESTINATION",
            "TARGET_DISPATCH_DESTINATION": "DISPATCH_DESTINATION",
            "TARGET_DISPATCH_ORGANIZATION_UNIT": "DISPATCH_ORGANIZATION_UNIT",
            "TARGET_DISPATCH_STAFF": "DISPATCH_STAFF",
            "TARGET_DISPATCH_WORKING_PLACE": "DISPATCH_WORKING_PLACE",
            "TARGET_TO_PROPERTY_TABLE_MAPPINGS": {
                "COMPANY": 3,
                "BILLING_DESTINATION": 5001,
                "DISPATCH_DESTINATION": 5018,
                "DISPATCH_STAFF": 5021,
                "DISPATCH_ORGANIZATION_UNIT": 5025,
                "DISPATCH_WORKING_PLACE": 5023
            },
            "TARGET_TO_COLUMN_NAME_MAPPINGS": {
                "CANDIDATE": "candidate_id",
                "COMPANY": "company_id",
                "STAFF": "staff_id",
                "USER": "target_user_id",
                "AGENT": "agent_id",
                "BILLING_DESTINATION": "billing_destination_id",
                "DISPATCH_DESTINATION": "dispatch_destination_id",
                "DISPATCH_STAFF": "dispatch_staff_id",
                "DISPATCH_ORGANIZATION_UNIT": "dispatch_organization_unit_id",
                "DISPATCH_WORKING_PLACE": "dispatch_working_place_id"
            },
            "STRATEGY_CANDIDATES": "candidates",
            "STRATEGY_COMPANIES": "companies",
            "STRATEGY_AGENCIES": "agencies",
            "STRATEGY_JOBS": "jobs",
            "STRATEGY_STAFFS": "staffs",
            "STRATEGY_BASE_COMPANIES": "baseCompanies",
            "STRATEGY_DISPATCH_STAFFS": "dispatch_staffs",
            "STRATEGY_DISPATCH_JOBS": "dispatchJobs",
            "STRATEGY_DISPATCH_DESTINATIONS": "dispatch_destinations",
            "STRATEGY_DISPATCH_WORKING_PLACES": "dispatch_working_places",
            "STRATEGY_DISPATCH_ORGANIZATION_UNITS": "dispatch_organization_units",
            "STRATEGY_BILLING_DESTINATIONS": "billing_destinations",
            "MAIL_FORMAT_REGEX": "\/^([a-zA-Z0-9])+([a-zA-Z0-9\\._\\+-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\\._-]+)+$\/u",
            "MAIL_ADDRESS_DELIMITER": "; ",
            "ASSIST_INSERT_OPTION_ROOTS": [
                2,
                3,
                5001,
                5018,
                5021,
                5025,
                5023,
                14
            ],
            "ASSIST_INSERT_OPTION_PROPERTY_TABLES": [
                2,
                3,
                20,
                22,
                14,
                5001,
                5018,
                5021,
                5035
            ],
            "SPECIAL_PROPERTY_TABLES_FOR_ASSIST_INSERT_OPTION": [
                5023,
                5025
            ],
            "CHILD_PROPERTY_TABLES_FOR_BILLING_DESTINATION": [
                5035
            ],
            "STRATEGY_TO_PROPERTY_TABLE_MAPPINGS": {
                "candidates": 2,
                "baseCompanies": 3,
                "jobs": 14,
                "companies": 14,
                "staffs": 14,
                "dispatchJobs": 14,
                "dispatch_destinations": 5018,
                "dispatch_staffs": 5021,
                "dispatch_organization_units": 5025,
                "dispatch_working_places": 5023,
                "billing_destinations": 5001
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "agent_id": null,
            "bcc_addresses": null,
            "billing_destination_id": null,
            "body": null,
            "candidate_id": null,
            "category": null,
            "cc_addresses": null,
            "company_id": null,
            "created_at": null,
            "deleted_at": null,
            "dispatch_destination_id": null,
            "dispatch_organization_unit_id": null,
            "dispatch_staff_id": null,
            "dispatch_working_place_id": null,
            "from_address": null,
            "from_name": null,
            "full_text": null,
            "id": 0,
            "is_forwarded": null,
            "is_trash": null,
            "is_unwanted": null,
            "mail_batch_id": null,
            "mail_type_id": null,
            "receive_mail_state_id": "0",
            "send_mail_state_id": "0",
            "sent_at": null,
            "staff_id": null,
            "subject": null,
            "target": null,
            "target_user_id": null,
            "to_address": null,
            "to_name": null,
            "uid": null,
            "updated_at": null,
            "user_id": null,
            "receiveMailState": null,
            "sendMailState": null,
            "mailAttachments": null,
            "user": null,
            "mailBatch": null,
            "mailStarredUsers": null,
            "candidate": null,
            "staff": null,
            "company": null,
            "billingDestination": null,
            "dispatchDestination": null,
            "dispatchStaff": null,
            "dispatchOrganizationUnit": null,
            "dispatchWorkingPlace": null
        },
        "relations": {
            "receiveMailState": "ReceiveMailState",
            "sendMailState": "SendMailState",
            "mailAttachments": "MailAttachment",
            "user": "User",
            "mailBatch": "MailBatch",
            "mailStarredUsers": "MailStarredUser",
            "candidate": "Candidate",
            "staff": "Staff",
            "company": "Company",
            "billingDestination": "BillingDestination",
            "dispatchDestination": "DispatchDestination",
            "dispatchStaff": "DispatchStaff",
            "dispatchOrganizationUnit": "DispatchOrganizationUnit",
            "dispatchWorkingPlace": "DispatchWorkingPlace"
        },
        "appends": [
            "escapedBody"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mails"
    },
    "MailAttachment": {
        "constants": {
            "SHOW_BALLOON_COUNT": 3,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "deleted_at": null,
            "file_id": null,
            "id": 0,
            "mail_id": null,
            "file": null
        },
        "relations": {
            "file": "File"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_attachments"
    },
    "MailBatch": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "start_at": null,
            "updated_at": null,
            "user_id": null,
            "mails": null,
            "user": null
        },
        "relations": {
            "mails": "Mail",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_batches"
    },
    "MailHeaderLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "header_log": null,
            "id": 0,
            "mail_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_header_logs"
    },
    "MailReceiveProtocol": {
        "constants": {
            "POP3": 1,
            "POP3_SSL": 2,
            "IMAP": 3,
            "IMAP_SSL": 4,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "imap_option": null,
            "name": null,
            "port": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_receive_protocols"
    },
    "MailStarredUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "mail_id": null,
            "updated_at": null,
            "user_id": null,
            "mail": null,
            "user": null
        },
        "relations": {
            "mail": "Mail",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_starred_users"
    },
    "MailTemplate": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "body": null,
            "created_at": null,
            "id": 0,
            "mail_template_category_id": null,
            "name": null,
            "position": null,
            "subject": null,
            "updated_at": null,
            "mailTemplateCategory": null,
            "mailTemplateUserPositions": null
        },
        "relations": {
            "mailTemplateCategory": "MailTemplateCategory",
            "mailTemplateUserPositions": "MailTemplateUserPosition"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_templates"
    },
    "MailTemplateCategory": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "mailTemplates": null
        },
        "relations": {
            "mailTemplates": "MailTemplate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_template_categories"
    },
    "MailTemplateUserPosition": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "mail_template_id": null,
            "position": null,
            "updated_at": null,
            "user_id": null,
            "mailTemplate": null
        },
        "relations": {
            "mailTemplate": "MailTemplate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_template_user_positions"
    },
    "MailType": {
        "constants": {
            "GMAIL": 1,
            "IMAP": 2,
            "OFFICE365": 3,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mail_types"
    },
    "MasterSetting": {
        "constants": {
            "NEST_ROOT_ID": 1,
            "NEST_INITIAL_DEPTH": 1,
            "NO_DEPTH": 0,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "master_settings"
    },
    "MatchingSetting": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "is_default_setting": "0",
            "matching_search_type_id": null,
            "name": null,
            "position": null,
            "updated_at": null,
            "matchingSettingDetails": null,
            "matchingSettingType": null
        },
        "relations": {
            "matchingSettingDetails": "MatchingSettingDetails",
            "matchingSettingType": "MatchingSettingType"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "matching_settings"
    },
    "MatchingSettingDetailColumn": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "matching_setting_detail_id": null,
            "property_column_id": null,
            "updated_at": null,
            "propertyColumn": null,
            "matchingSettingDetails": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn",
            "matchingSettingDetails": "MatchingSettingDetails"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "matching_setting_detail_columns"
    },
    "MatchingSettingDetailFixedValue": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "fixed_value": null,
            "id": 0,
            "matching_setting_detail_id": null,
            "updated_at": null,
            "matchingSettingDetails": null
        },
        "relations": {
            "matchingSettingDetails": "MatchingSettingDetails"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "matching_setting_detail_fixed_values"
    },
    "MatchingSettingDetails": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "detail_type": null,
            "id": 0,
            "matching_setting_id": null,
            "search_column_id": null,
            "search_mode_id": null,
            "updated_at": null,
            "matchingSetting": null,
            "searchColumn": null,
            "matchingSettingDetailColumn": null,
            "matchingSettingDetailFixedValue": null
        },
        "relations": {
            "matchingSetting": "MatchingSetting",
            "searchColumn": "SearchColumn",
            "matchingSettingDetailColumn": "MatchingSettingDetailColumn",
            "matchingSettingDetailFixedValue": "MatchingSettingDetailFixedValue"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "matching_setting_details"
    },
    "MatchingSettingType": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "column_property_table_id": null,
            "id": 0,
            "name": null,
            "search_property_table_id": null,
            "matchingSetting": null
        },
        "relations": {
            "matchingSetting": "MatchingSetting"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "matching_setting_types"
    },
    "Medium": {
        "constants": {
            "MEDIA_ROW_OFFSET_ID": 10001,
            "USER_ROW_OFFSET_ID": 10001,
            "MEDIA_HP_NAME": "自社HP"
        },
        "properties": {
            "deleted_at": null,
            "id": 0,
            "name": null,
            "position": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "media"
    },
    "MediumIndustryCode": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "external_industry_code": null,
            "external_industry_name": null,
            "id": 0,
            "industry_id": null,
            "medium_id": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "medium_industry_codes"
    },
    "MediumOccupationCode": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "external_occupation_code": null,
            "external_occupation_name": null,
            "id": 0,
            "medium_id": null,
            "occupation_id": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "medium_occupation_codes"
    },
    "MetaColumn": {
        "constants": {
            "WHITELIST_VALIDATION_NAME": "is_valid_whitelist",
            "REQUIRED_VALIDATION_NAME": "is_valid_required",
            "UNSIGNED_VALIDATION_NAME": "is_valid_gte_zero",
            "MAX_LENGTH_VALIDATION_NAME": "is_valid_max_length",
            "DATETIME_LIKE_FORMAT_VALIDATION_NAME": "is_valid_datetime_format",
            "TYPE_MATCH_VALIDATION_NAME": "is_valid_type_match",
            "DECIMAL_PRECISION_VALIDATION_NAME": "is_valid_decimal_precision",
            "URL_FORMAT_VALIDATION_NAME": "is_valid_url_format",
            "TEL_FORMAT_VALIDATION_NAME": "is_valid_tel_format",
            "MAIL_FORMAT_VALIDATION_NAME": "is_valid_mail_format",
            "MAIL_DOMAIN_VALIDATION_NAME": "is_valid_mail_domain",
            "VALIDATION_NAMES": [
                "is_valid_whitelist",
                "is_valid_required",
                "is_valid_gte_zero",
                "is_valid_max_length",
                "is_valid_datetime_format",
                "is_valid_type_match",
                "is_valid_decimal_precision",
                "is_valid_url_format",
                "is_valid_tel_format",
                "is_valid_mail_format",
                "is_valid_mail_domain"
            ],
            "VALIDATION_DISABLED": 0,
            "VALIDATION_ENABLED": 1,
            "BULK_INSERT_TEMPLATE": {
                "property_column_id": null,
                "table_name": null,
                "column_name": null,
                "is_valid_whitelist": 0,
                "is_valid_required": 0,
                "is_valid_gte_zero": 0,
                "is_valid_max_length": 0,
                "is_valid_datetime_format": 0,
                "is_valid_type_match": 0,
                "is_valid_decimal_precision": 0,
                "is_valid_url_format": 0,
                "is_valid_tel_format": 0,
                "is_valid_mail_format": 0,
                "is_valid_mail_domain": 0
            },
            "INTEGER_DATA_TYPE": [
                "bigint",
                "int",
                "smallint"
            ],
            "TEXT_DATA_TYPE": [
                "char",
                "varchar",
                "text",
                "mediumtext"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "character_maximum_length": null,
            "column_name": null,
            "data_type": null,
            "id": 0,
            "is_valid_datetime_format": "0",
            "is_valid_decimal_precision": "0",
            "is_valid_gte_zero": "0",
            "is_valid_mail_domain": "0",
            "is_valid_mail_format": "0",
            "is_valid_max_length": "0",
            "is_valid_required": "0",
            "is_valid_tel_format": "0",
            "is_valid_type_match": "0",
            "is_valid_url_format": "0",
            "is_valid_whitelist": "0",
            "property_column_id": null,
            "table_name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "meta_columns"
    },
    "MicroServiceReport": {
        "constants": {
            "STATUS_WAITING": "WAITING",
            "STATUS_RECIEVED": "RECIEVED",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "ms_report_id": null,
            "report_id": null,
            "status": null,
            "updated_at": null,
            "user_id": null,
            "user": null,
            "report": null
        },
        "relations": {
            "user": "User",
            "report": "Report"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "micro_service_reports"
    },
    "Migration": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "batch": null,
            "id": 0,
            "migration": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "migrations"
    },
    "Model": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0
        },
        "relations": [],
        "appends": [],
        "parents": [
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "models"
    },
    "MultiAssignment": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "MypageDashboard": {
        "constants": {
            "CATEGORY_PROPERTY_TABLE_OF_CANDIDATES": 2,
            "CATEGORY_PROPERTY_TABLE_OF_COMPANIES": 3,
            "CATEGORY_PROPERTY_TABLE_OF_JOBS": 4,
            "DASHBOARD_CACHE_TAG_SUFFIX": "dashboard_query",
            "SPECIAL_COLUMNS": [
                {
                    "propertyColumnId": 203,
                    "propertyCategoryId": 2,
                    "propertyTableId": 2,
                    "displayName": "candidates.user"
                },
                {
                    "propertyColumnId": 204,
                    "propertyCategoryId": 12,
                    "propertyTableId": 3,
                    "displayName": "companies.user"
                },
                {
                    "propertyColumnId": 205,
                    "propertyCategoryId": 16,
                    "propertyTableId": 4,
                    "displayName": "jobs.user"
                }
            ],
            "INPUT_CATEGORIES": {
                "isUpdateRelation": [
                    3,
                    8,
                    9
                ],
                "notReadOnly": [
                    1,
                    2,
                    3,
                    5,
                    7
                ]
            },
            "LINKABLE_PROPERTY_COLUMN_IDS": [
                165,
                2,
                163,
                45,
                148,
                75,
                5110,
                5226,
                5045,
                5048
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "category_property_table_id": null,
            "created_at": null,
            "deleted_at": null,
            "display_name": null,
            "display_property_column_id": null,
            "display_property_table_id": null,
            "id": 0,
            "is_link": "0",
            "is_update_relation": "0",
            "position": null,
            "readonly": "0",
            "updated_at": null,
            "displayPropertyColumn": null,
            "displayPropertyTable": null,
            "categoryPropertyTable": null
        },
        "relations": {
            "displayPropertyColumn": "PropertyColumn",
            "displayPropertyTable": "PropertyTable",
            "categoryPropertyTable": "PropertyTable"
        },
        "appends": [
            "aliasColumnName",
            "headerLabel"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "mypage_dashboards"
    },
    "Node": {
        "constants": [],
        "properties": {
            "id": 0
        },
        "relations": [],
        "appends": [],
        "parents": [
            "Baum\\Node",
            "Baum\\Extensions\\Eloquent\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "nodes"
    },
    "Notification": {
        "constants": [],
        "properties": {
            "created_at": null,
            "data": null,
            "id": 0,
            "notifiable_id": null,
            "notifiable_type": null,
            "read_at": null,
            "source_id": null,
            "source_type": null,
            "type": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [
            "meta"
        ],
        "parents": [
            "Illuminate\\Notifications\\DatabaseNotification",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "notifications"
    },
    "NumberColumn": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_REFUND": 15187,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_COLLECTION": 15188,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_REFUND": 15189,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_COLLECTION": 15190,
            "EDITABLE_INPUT_CATEGORIES": [
                7,
                20
            ]
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "property_column_id": null,
            "step": "1.00",
            "unit": null,
            "updated_at": null,
            "propertyColumn": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "number_columns"
    },
    "OauthClient": {
        "constants": {
            "SCOPE_SEARCH": "search",
            "SCOPE_SHOW": "show",
            "SCOPE_UPDATE": "update",
            "SCOPE_STORE": "store",
            "SCOPE_DESTROY": "destroy",
            "SCOPE_NOTIFICATION": "notification",
            "SCOPE_TYPES": [
                "search",
                "show",
                "update",
                "store",
                "destroy"
            ],
            "RESOURCE_ACCOUNT": "account",
            "RESOURCE_APPLY": "apply",
            "RESOURCE_CANDIDATES": "candidates",
            "RESOURCE_CANDIDATE_ACTIVITIES": "candidate-activities",
            "RESOURCE_COMPANY": "companies",
            "RESOURCE_COMPANY_ACTIVITIES": "company-activities",
            "RESOURCE_FILES": "files",
            "RESOURCE_JOBS": "jobs",
            "RESOURCE_MASTERS": "masters",
            "RESOURCE_NOTIFICATIONS": "notifications",
            "RESOURCE_SALES": "sales",
            "RESOURCE_SCHEDULES": "schedules",
            "RESOURCE_STAFFS": "staffs",
            "RESOURCE_TASKS": "tasks",
            "RESOURCE_USERS": "users",
            "RESOURCE_ALERTS": "alerts",
            "RESOURCE_ALERT_NOTIFICATIONS": "alert-notifications",
            "RESOURCE_BILLING_DESTINATIONS": "billing-destinations",
            "RESOURCE_DISPATCH_DESTINATIONS": "dispatch-destinations",
            "RESOURCE_DISPATCH_JOBS": "dispatch-jobs",
            "RESOURCE_DISPATCH_STAFFS": "dispatch-staffs",
            "RESOURCE_DISPATCH_WORKING_PLACES": "dispatch-working-places",
            "RESOURCE_DISPATCH_ORGANIZATION_UNITS": "dispatch-organization-units",
            "RESOURCE_CONTRACTS": "contracts",
            "RESOURCE_DISPATCH_SOURCES": "dispatch-sources",
            "RESOURCE_DISPATCH_SOURCE_STAFFS": "dispatch-source-staffs",
            "RESOURCE_MAILS": "mails",
            "RESOURCE_LINE_OPTIONS": "line-options",
            "RESOURCE_TYPES": [
                "account",
                "apply",
                "candidates",
                "candidate-activities",
                "companies",
                "company-activities",
                "files",
                "jobs",
                "masters",
                "notifications",
                "mails",
                "sales",
                "schedules",
                "staffs",
                "tasks",
                "users",
                "alerts",
                "alert-notifications",
                "billing-destinations",
                "dispatch-destinations",
                "dispatch-staffs",
                "dispatch-jobs",
                "dispatch-working-places",
                "dispatch-organization-units",
                "contracts",
                "dispatch-sources",
                "dispatch-source-staffs",
                "line-options"
            ],
            "UNRELEASED_RESOURCE_TYPES": [],
            "PRIVATE_RESOURCE_TYPES": [
                "mails"
            ],
            "RESOURCE_SCOPE_DISABLE_MAPS": {
                "account": [
                    "search",
                    "store",
                    "destroy"
                ],
                "users": [
                    "store",
                    "update",
                    "destroy"
                ],
                "masters": [
                    "search",
                    "store",
                    "update",
                    "destroy"
                ],
                "files": [
                    "search"
                ],
                "notifications": [
                    "search",
                    "show",
                    "update",
                    "destroy"
                ],
                "alerts": [
                    "search"
                ],
                "alert-notifications": [
                    "search"
                ],
                "mails": [
                    "search",
                    "show",
                    "update",
                    "destroy"
                ],
                "line-options": [
                    "search",
                    "show",
                    "update",
                    "destroy"
                ]
            },
            "HP_CONNECTION_APP_ID": 100,
            "ALERT_SETTING_APP_ID": 101,
            "SSO_HP_CONNECTION_APP_ID": 102,
            "MYPAGE_APP_ID": 103,
            "SSO_MYPAGE_APP_ID": 104,
            "MAP_MATCHING_APP_ID": 105,
            "SSO_MAP_MATCHING_APP_ID": 106,
            "MYRIC_MYPAGE_APP_ID": 107,
            "SSO_LINE_OPTION_APP_ID": 108,
            "LINE_OPTION_APP_ID": 109,
            "ACES_MEET_APP_ID": 110,
            "PASSWORD_GRANT": "password",
            "CLIENT_CREDENTIALS": "client_credentials",
            "AUTHORIZATION_CODE": "authorization_code",
            "ALLOWED_GRANT_TYPES": [
                "password",
                "client_credentials",
                "authorization_code"
            ],
            "SSO_CLIENT_IDS": [
                102
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "allow_ip_addresses": null,
            "created_at": null,
            "grant_type": null,
            "id": 0,
            "is_enabled": "1",
            "is_enforce_token_owner_restriction": "1",
            "is_system_default": "0",
            "name": null,
            "password_client": null,
            "personal_access_client": null,
            "redirect": null,
            "revoked": null,
            "scope": null,
            "secret": null,
            "updated_at": null,
            "user_id": null,
            "apiRequestLogs": null,
            "user": null
        },
        "relations": {
            "apiRequestLogs": "ApiRequestLog",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "oauth_clients"
    },
    "Occupation": {
        "constants": {
            "MAX_NAME_LENGTH": 255
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "depth": null,
            "id": 0,
            "lft": null,
            "name": null,
            "parent_id": null,
            "rgt": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Node",
            "Baum\\Node",
            "Baum\\Extensions\\Eloquent\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "occupations"
    },
    "OuterCandidate": {
        "constants": {
            "CSS_AFFIX": "candidate",
            "SHARE_CONVERT_COLUMNS": [
                "circumstance_id",
                "hope_employment_category_id",
                "hope_industry_id",
                "hope_occupation_id",
                "prefecture_id",
                "roudoukyoku_category_id",
                "sex_id",
                "medium_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [
                "id",
                "name",
                "kana",
                "birth_date",
                "age",
                "tel",
                "portable_tel",
                "candidate_state_id",
                "name_normalized",
                "created_at",
                "updated_at",
                "deleted_at"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "candidateState"
            ],
            "HIDDEN_PROPERTY_COLUMN_IDS_FOR_FREE_BOOLEAN": [
                18,
                21
            ],
            "PROFILE_RELATIONS": [
                "candidateState",
                "careers",
                "educations",
                "prefecture",
                "sex"
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "name": "name_normalized",
                "kana": "kana_normalized",
                "code": "code_normalized"
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "address_sub_map": null,
            "age": null,
            "applied": null,
            "birth_date": null,
            "candidate_state_id": null,
            "caution": null,
            "circumstance_id": null,
            "code": null,
            "code_normalized": null,
            "created_at": null,
            "deleted_at": null,
            "distributed_at": null,
            "email": null,
            "english_skill": null,
            "feed_number": null,
            "figure": null,
            "full_text": null,
            "hope_company": null,
            "hope_employment_category_id": null,
            "hope_fee": null,
            "hope_industry_id": null,
            "hope_job_change_season": null,
            "hope_occupation_id": null,
            "hope_place": null,
            "id": 0,
            "is_married": null,
            "is_possible_bulk_mail": "1",
            "job_change_number": null,
            "kana": null,
            "kana_normalized": null,
            "medium_detail": null,
            "medium_id": null,
            "memo": null,
            "mhlw_occupation_id": null,
            "myric_mypage_invitation_date": null,
            "myric_mypage_login_date": null,
            "myric_mypage_state_id": null,
            "myric_mypage_token": null,
            "name": null,
            "name_normalized": null,
            "office_email": null,
            "portable_email": null,
            "portable_tel": null,
            "prefecture_id": null,
            "qualification": null,
            "rank_id": null,
            "request": null,
            "roudoukyoku_category_id": null,
            "sex_id": null,
            "state_updated_at": null,
            "station": null,
            "tel": null,
            "toeic": null,
            "updated_at": null,
            "valid_end_date": null,
            "zip": null,
            "freeItems": null,
            "candidateState": null,
            "sex": null,
            "prefecture": null,
            "rank": null,
            "roudoukyokuCategory": null,
            "circumstance": null,
            "employmentCategory": null,
            "industry": null,
            "occupation": null,
            "medium": null,
            "candidateDispatchBasic": null,
            "candidateDispatchInsurance": null,
            "educations": null,
            "careers": null,
            "candidateFiles": null,
            "candidateJobSteps": null,
            "sales": null,
            "candidateSteps": null,
            "candidatePhoto": null,
            "candidateUsers": null,
            "mails": null,
            "importedRecords": null,
            "candidateJobStepResources": null,
            "contracts": null,
            "conflictDateManagements": null,
            "candidateConflictDateManagements": null,
            "conflictDateDefaults": null,
            "candidateWage": null,
            "paymentDatum": null,
            "candidateCareerCounsellings": null,
            "candidateEducationAndTrainings": null,
            "candidateEmploymentStabilityMeasures": null,
            "candidateEmploymentPlacementDispatches": null,
            "users": null
        },
        "relations": {
            "candidateState": "CandidateState",
            "sex": "Sex",
            "prefecture": "Prefecture",
            "rank": "Rank",
            "roudoukyokuCategory": "RoudoukyokuCategory",
            "circumstance": "Circumstance",
            "employmentCategory": "EmploymentCategory",
            "industry": "Industry",
            "occupation": "Occupation",
            "medium": "Medium",
            "candidateDispatchBasic": "CandidateDispatchBasic",
            "candidateDispatchInsurance": "CandidateDispatchInsurance",
            "educations": "Education",
            "careers": "Career",
            "candidateFiles": "CandidateFile",
            "candidateJobSteps": "CandidateJobStep",
            "sales": "Sale",
            "candidateSteps": "CandidateStep",
            "candidatePhoto": "CandidatePhoto",
            "candidateUsers": "CandidateUser",
            "mails": "Mail",
            "importedRecords": "ImportedRecord",
            "candidateJobStepResources": "CandidateJobStepResource",
            "contracts": "Contract",
            "conflictDateManagements": "ConflictDateManagement",
            "candidateConflictDateManagements": "CandidateConflictDateManagement",
            "conflictDateDefaults": "ConflictDateDefault",
            "candidateWage": "CandidateWage",
            "paymentDatum": "PaymentDatum",
            "candidateCareerCounsellings": "CandidateCareerCounselling",
            "candidateEducationAndTrainings": "CandidateEducationAndTraining",
            "candidateEmploymentStabilityMeasures": "CandidateEmploymentStabilityMeasure",
            "candidateEmploymentPlacementDispatches": "CandidateEmploymentPlacementDispatch",
            "users": "User"
        },
        "appends": [
            "age",
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Candidate",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidates"
    },
    "OuterCandidateJobStep": {
        "constants": {
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "candidate_id",
                "job_id"
            ],
            "MAIL_USE_COLUMNS": [
                "interviewer",
                "start_at",
                "end_at",
                "memo"
            ],
            "BULK_UPDATE_LIMIT": 50,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_correspondence_user_id": null,
            "candidate_id": null,
            "candidate_job_step_resource_id": null,
            "candidate_job_step_state_id": null,
            "create_user_id": null,
            "created_at": null,
            "deleted_at": null,
            "due_date": null,
            "end_at": null,
            "id": 0,
            "interviewer": null,
            "is_latested": "0",
            "job_correspondence_user_id": null,
            "job_id": null,
            "mail_id": null,
            "memo": null,
            "start_at": null,
            "updated_at": null,
            "user_id": null,
            "candidateJobStepState": null,
            "candidate": null,
            "job": null,
            "dispatchJob": null,
            "sales": null,
            "user": null,
            "schedules": null,
            "candidateJobStepResource": null,
            "candidateCorrespondenceUser": null,
            "jobCorrespondenceUser": null,
            "createUser": null,
            "staff": null,
            "tasks": null
        },
        "relations": {
            "candidateJobStepState": "CandidateJobStepState",
            "candidate": "Candidate",
            "job": "Job",
            "dispatchJob": "DispatchJob",
            "sales": "Sale",
            "user": "User",
            "schedules": "Schedule",
            "candidateJobStepResource": "CandidateJobStepResource",
            "candidateCorrespondenceUser": "User",
            "jobCorrespondenceUser": "User",
            "createUser": "User",
            "staff": "Staff",
            "tasks": "Task"
        },
        "appends": [
            "localizedStartAt",
            "localizedEndAt"
        ],
        "parents": [
            "App\\Models\\CandidateJobStep",
            "App\\Models\\Bases\\StepModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "candidate_job_steps"
    },
    "OuterJob": {
        "constants": {
            "CSS_AFFIX": "job",
            "SHARE_CONVERT_COLUMNS": [
                "employment_category_id",
                "industry_id",
                "occupation_id",
                "prefecture_id",
                "roudoukyoku_category_id",
                "job_state_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [
                "id",
                "company_id",
                "job_state_id",
                "title",
                "created_at",
                "updated_at",
                "deleted_at"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "company",
                "jobState"
            ],
            "HIDDEN_PROPERTY_COLUMN_IDS_FOR_FREE_BOOLEAN": [
                77,
                78,
                94
            ],
            "NORMALIZED_COLUMN_MAPPINGS": {
                "code": "code_normalized"
            },
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id"
            ],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "access": null,
            "age_limit": null,
            "background": null,
            "billing_company_id": null,
            "billing_destination_id": null,
            "business_hours": null,
            "cabinet_order_industry_type_id": null,
            "code": null,
            "code_normalized": null,
            "company_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "department": null,
            "dispatch_destination_id": null,
            "dispatch_end_date": null,
            "dispatch_job_state_id": null,
            "dispatch_job_type_id": null,
            "dispatch_organization_unit_id": null,
            "dispatch_source_id": null,
            "dispatch_start_date": null,
            "employment_category_id": null,
            "employment_insurance_industry_id": null,
            "fee_memo": null,
            "full_text": null,
            "holiday": null,
            "hope_num": null,
            "id": 0,
            "industry_id": null,
            "interview_count": null,
            "interview_process": null,
            "is_company_name_public": null,
            "is_dispatch": null,
            "is_specific_manufacturing_operation_type_id": null,
            "is_target_over_age_60_boolean_type_id": null,
            "is_trial": null,
            "is_web": null,
            "japan_std_occupation_id": null,
            "job_state_id": null,
            "max_age": null,
            "max_yearly_salary": null,
            "medium_id": null,
            "memo": null,
            "mhlw_occupation_id": null,
            "min_age": null,
            "min_yearly_salary": null,
            "must_skill": null,
            "occupation_id": null,
            "occupation_name": null,
            "place": null,
            "place_sub_map": null,
            "post": null,
            "prefecture_id": null,
            "qualification": null,
            "reason": null,
            "referenced_amount_over_short_id": null,
            "referenced_dispatch_working_place_id": null,
            "referenced_wage_id": null,
            "role_detail": null,
            "roudoukyoku_category_id": null,
            "staff_id": null,
            "state_updated_at": null,
            "title": null,
            "transfer": null,
            "trial_detail": null,
            "updated_at": null,
            "updated_user_id": null,
            "valid_end_date": null,
            "want_skill": null,
            "welfare": null,
            "freeItems": null,
            "company": null,
            "jobState": null,
            "industry": null,
            "occupation": null,
            "employmentCategory": null,
            "prefecture": null,
            "roudoukyokuCategory": null,
            "candidateJobSteps": null,
            "sales": null,
            "jobFiles": null,
            "staff": null,
            "jobUsers": null,
            "iframeJobFreeWord": null,
            "jobPhoto": null,
            "importedRecords": null,
            "candidateJobStepResources": null,
            "users": null
        },
        "relations": {
            "company": "Company",
            "jobState": "JobState",
            "industry": "Industry",
            "occupation": "Occupation",
            "employmentCategory": "EmploymentCategory",
            "prefecture": "Prefecture",
            "roudoukyokuCategory": "RoudoukyokuCategory",
            "candidateJobSteps": "CandidateJobStep",
            "sales": "Sale",
            "jobFiles": "JobFile",
            "staff": "Staff",
            "jobUsers": "JobUser",
            "iframeJobFreeWord": "IframeJobFreeWord",
            "jobPhoto": "JobPhoto",
            "importedRecords": "ImportedRecord",
            "candidateJobStepResources": "CandidateJobStepResource",
            "users": "User"
        },
        "appends": [
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Job",
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "jobs"
    },
    "OuterUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "SYSTEM_ADMIN_USER_ID": 10001,
            "ALERT_USER_ID": 10002,
            "HP_APP_ID": 10003,
            "MYPAGE_USER_ID": 10004,
            "MAP_MATCHING_USER_ID": 10005,
            "MYRIC_MYPAGE_USER_ID": 10006,
            "LINE_OPTION_USER_ID": 10007,
            "ACES_MEET_USER_ID": 10008,
            "NONE": "NONE",
            "POP_BEFORE_SMTP": "POP_BEFORE_SMTP",
            "SMTP_AUTH": "SMTP_AUTH",
            "TLS": "tls",
            "SSL": "ssl",
            "SHARE_CONVERT_COLUMNS": [
                "locale_id",
                "timezone_id",
                "user_role_id"
            ],
            "GRANT_PERMISSION": "grant",
            "ABSTRACT_USER_PREFIX": "property-column-id-",
            "ABSTRACT_USER_PROPERTY_COLUMNS": {
                "2": [
                    203
                ],
                "3": [
                    204
                ],
                "4": [
                    204,
                    205
                ],
                "5018": [
                    204,
                    5052
                ],
                "67": [
                    203,
                    204,
                    205,
                    5222
                ],
                "5001": [
                    204,
                    5213
                ],
                "64": [
                    203
                ],
                "65": [
                    204
                ],
                "5041": [
                    203,
                    204,
                    5222
                ],
                "5027": [
                    204,
                    5052,
                    5222
                ],
                "5025": [
                    204,
                    5052
                ],
                "5021": [
                    204,
                    5052
                ],
                "5023": [
                    204,
                    5052
                ],
                "78": [
                    181,
                    182,
                    205
                ],
                "14": [
                    204
                ]
            }
        },
        "properties": {
            "can_receive_mail_auto": "0",
            "created_at": null,
            "deleted_at": null,
            "department_id": null,
            "display_name": null,
            "email": null,
            "enabled": "1",
            "id": 0,
            "is_mail_confirmed": "1",
            "is_system_default": "0",
            "last_mail_import_succeed_at": null,
            "locale_id": null,
            "mail_receive_protocol_id": null,
            "password": null,
            "pop_account": null,
            "pop_password": null,
            "pop_port": null,
            "pop_server": null,
            "position": null,
            "release_note_id": null,
            "remember_token": null,
            "signature": null,
            "smtp_account": null,
            "smtp_auth_method": "NONE",
            "smtp_encryption": null,
            "smtp_password": null,
            "smtp_port": null,
            "smtp_server": null,
            "timezone_id": "1",
            "updated_at": null,
            "user_role_id": null,
            "CURRENT_CONNECTIONS": null,
            "MAX_SESSION_CONTROLLED_MEMORY": null,
            "MAX_SESSION_TOTAL_MEMORY": null,
            "TOTAL_CONNECTIONS": null,
            "USER": null,
            "freeItems": null,
            "downloadFileServerCreationLogs": null,
            "oauthClients": null,
            "googleAccount": null,
            "userRole": null,
            "locale": null,
            "timezone": null,
            "userMailOauth2Datum": null,
            "mailBatches": null,
            "userPermissions": null,
            "mailStarredUsers": null,
            "userSession": null,
            "tasks": null,
            "candidates": null,
            "jobs": null,
            "companies": null,
            "dispatchJobs": null,
            "mailReceiveProtocol": null,
            "mails": null,
            "schedules": null,
            "department": null,
            "userPasswordManagementSetting": null,
            "passwordChangeHistories": null,
            "mailTemplateUserPositions": null,
            "billingDestinations": null,
            "dispatchDestinations": null,
            "notifications": null
        },
        "relations": {
            "downloadFileServerCreationLogs": "DownloadFileServerCreationLog",
            "oauthClients": "OauthClient",
            "googleAccount": "GoogleAccount",
            "userRole": "UserRole",
            "locale": "Locale",
            "timezone": "Timezone",
            "userMailOauth2Datum": "UserMailOauth2Datum",
            "mailBatches": "MailBatch",
            "userPermissions": "UserPermission",
            "mailStarredUsers": "MailStarredUser",
            "userSession": "UserSession",
            "tasks": "Task",
            "candidates": "Candidate",
            "jobs": "Job",
            "companies": "Company",
            "dispatchJobs": "DispatchJob",
            "mailReceiveProtocol": "MailReceiveProtocol",
            "mails": "Mail",
            "schedules": "Schedule",
            "department": "Department",
            "userPasswordManagementSetting": "UserPasswordManagementSetting",
            "passwordChangeHistories": "PasswordChangeHistory",
            "mailTemplateUserPositions": "MailTemplateUserPosition",
            "billingDestinations": "BillingDestination",
            "dispatchDestinations": "DispatchDestination",
            "notifications": "Notification"
        },
        "appends": [
            "can_send_mail",
            "is_logged_in"
        ],
        "parents": [
            "App\\Models\\User",
            "Illuminate\\Foundation\\Auth\\User",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "users"
    },
    "PaidLeave": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "id": 0,
            "start_date": null,
            "updated_at": null,
            "updated_user_id": null,
            "paidLeaveProperty": null
        },
        "relations": {
            "paidLeaveProperty": "PaidLeaveProperty"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "paid_leaves"
    },
    "PaidLeaveDayDetail": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "leave_times_type_id": null,
            "paid_leave_days": null,
            "paid_leave_property_id": null,
            "yearly_working_day_type_id": null,
            "paidLeaveProperty": null
        },
        "relations": {
            "paidLeaveProperty": "PaidLeaveProperty"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "paid_leave_day_details"
    },
    "PaidLeaveProperty": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "initial_paid_leave_activate_month": null,
            "is_second_paid_leave_year_after": null,
            "paid_leave_id": null,
            "second_paid_leave_fix_date": null,
            "paidLeave": null,
            "paidLeaveDayDetails": null
        },
        "relations": {
            "paidLeave": "PaidLeave",
            "paidLeaveDayDetails": "PaidLeaveDayDetail"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "paid_leave_properties"
    },
    "PasswordChangeHistory": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "password": null,
            "user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "password_change_histories"
    },
    "PasswordManagementSetting": {
        "constants": {
            "PASSWORD_POLICY_SETTING_ATTRIBUTE_NAMES": [
                "is_password_policy_enabled",
                "password_character_type_uppercase",
                "password_character_type_lowercase",
                "password_character_type_number",
                "password_character_type_symbol",
                "password_length",
                "is_initial_password_change_required"
            ],
            "PASSWORD_EXPIRATION_DATE_SETTING_ATTRIBUTE_NAMES": [
                "is_password_expiration_date_enabled",
                "password_enabled_days"
            ],
            "PASSWORD_HISTORY_SETTING_ATTRIBUTE_NAMES": [
                "is_password_history_enabled",
                "past_password_reuse_unavailable_times"
            ],
            "ACCOUNT_LOCK_SETTING_ATTRIBUTE_NAMES": [
                "is_account_lock_enabled",
                "login_failure_times",
                "elapsed_time_until_release"
            ],
            "BOOL_VALUE_ATTRIBUTE_NAMES": [
                "is_password_policy_enabled",
                "password_character_type_uppercase",
                "password_character_type_lowercase",
                "password_character_type_number",
                "password_character_type_symbol",
                "is_initial_password_change_required",
                "is_password_expiration_date_enabled",
                "is_password_history_enabled",
                "is_account_lock_enabled"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "elapsed_time_until_release": null,
            "id": 0,
            "is_account_lock_enabled": null,
            "is_initial_password_change_required": null,
            "is_password_expiration_date_enabled": null,
            "is_password_history_enabled": null,
            "is_password_policy_enabled": null,
            "login_failure_times": null,
            "password_character_type_lowercase": null,
            "password_character_type_number": null,
            "password_character_type_symbol": null,
            "password_character_type_uppercase": null,
            "password_enabled_days": null,
            "password_length": null,
            "past_password_reuse_unavailable_times": null,
            "updated_at": null,
            "updated_user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "password_management_settings"
    },
    "PasswordReset": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "email": null,
            "id": 0,
            "token": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "password_resets"
    },
    "PaymentDateSetting": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "created_user_id": null,
            "id": 0,
            "monthly_payment_closed_date_id": null,
            "monthly_payment_date_id": null,
            "monthly_payment_type_id": null,
            "updated_at": null,
            "updated_user_id": null,
            "weekly_payment_closed_date_id": null,
            "weekly_payment_date_id": null,
            "weekly_payment_type_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "payment_date_settings"
    },
    "PaymentDatum": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "calc_time_unit": null,
            "candidate_id": null,
            "first_day_of_the_week_type_id": null,
            "fraction_rounding_type_id": null,
            "id": 0,
            "insurance_rounding_type_id": null,
            "rounding_unit_type_id": null,
            "time_rounding_type_id": null,
            "systemDefaultOptionRoundingType": null,
            "systemDefaultOptionTimeRoundingType": null,
            "systemDefaultOptionDayOfTheWeekType": null,
            "systemDefaultOptionRoundingUnitType": null
        },
        "relations": {
            "systemDefaultOptionRoundingType": "SystemDefaultOptionRoundingType",
            "systemDefaultOptionTimeRoundingType": "SystemDefaultOptionTimeRoundingType",
            "systemDefaultOptionDayOfTheWeekType": "SystemDefaultOptionDayOfTheWeekType",
            "systemDefaultOptionRoundingUnitType": "SystemDefaultOptionRoundingUnitType"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "payment_data"
    },
    "Prefecture": {
        "constants": {
            "FOREIGN": 48,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "prefectures"
    },
    "PrimaryObjectModel": {
        "constants": {
            "INITIAL_SEARCH_COLUMNS": [],
            "INITIAL_INDEX_RELATIONS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "PropertyCategory": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "CANDIDATE_FREE_WORD": 1,
            "CANDIDATE_BASIC_INFO": 2,
            "EDUCATION_CATEGORY": 3,
            "CAREER_CATEGORY": 4,
            "CANDIDATE_CIRCUMSTANCE": 5,
            "CANDIDATE_HOPE": 6,
            "CANDIDATE_ENGLISH_SKILL": 7,
            "OTHER": 8,
            "CANDIDATE_FREE_ITEM": 9,
            "CANDIDATE_FILES": 10,
            "COMPANY_FREE_WORD": 11,
            "COMPANY_BASIC_INFO": 12,
            "COMPANY_DETAIL": 13,
            "COMPANY_FREE_INPUT": 14,
            "JOB_FREE_WORD": 15,
            "JOB_BASIC_INFO": 16,
            "JOB_DETAIL": 17,
            "JOB_REQUIREMENT": 18,
            "JOB_FREE_INPUT": 19,
            "FREE_WORDS": [
                1,
                11,
                15
            ],
            "JOB_FILE": 20,
            "STAFF": 21,
            "SALES_BASIC_INFO": 22,
            "FEE_INFO": 23,
            "SALES_OTHER": 24,
            "AGENCY": 25,
            "AGENT": 26,
            "SALE_REFUND_BASIC_INFO": 27,
            "SALE_REFUND_BANK_INFO": 28,
            "SALE_REFUND_FEE_INFO": 29,
            "SALE_REFUND_OTHER": 30,
            "SETTINGS_BASIC_INFO": 31,
            "SETTINGS_BANK_INFO": 32,
            "CANDIDATE_JOB_STEPS_BASIC_INFO": 33,
            "CANDIDATE_JOB_STEPS_CANDIDATE": 34,
            "CANDIDATE_JOB_STEPS_JOB": 35,
            "STATIC_FUNCTION_DATE": 36,
            "COMPANY_STEPS_BASIC_INFO": 37,
            "USERS_BASIC_INFO": 38,
            "CANDIDATE_STEPS_BASIC_INFO": 39,
            "TASK_BASIC_INFO": 40,
            "SCHEDULE_BASIC_INFO": 41,
            "MYRIC_OPTIONS_INFO": 42,
            "DISPATCH_REPORT": 5001,
            "DISPATCH_WORKING_NOTICE_AND_CONDITION_EXPLICIT": 5002,
            "DISPATCH_DISCRETE_CONTRACT": 5003,
            "DISPATCH_WORKING_CONDITIONS": 5004,
            "SALES_RETIREMENT_INFO": 5005,
            "SALES_REFUND_INFO": 5006,
            "SALES_REFUND_DESTINATION_INFO": 5007,
            "CANDIDATE_JOB_STEP_RESOURCES_BASIC_INFO": 5008,
            "CANDIDATE_STEP_STATES_BASIC_INFO": 5009,
            "CANDIDATE_JOB_STEP_RESOURCES_SEARCH_BASIC_INFO": 5010,
            "CANDIDATE_JOB_STEP_RESOURCES_CANDIDATE": 5011,
            "CANDIDATE_JOB_STEP_RESOURCES_JOB": 5012,
            "SALE_FREE_WORD": 5013,
            "CANDIDATE_STEP_RESOURCES_BASIC_INFO": 5014,
            "COMPANY_STEP_RESOURCES_BASIC_INFO": 5015,
            "CANDIDATE_JOB_STEP_RESOURCE_FREE_WORD": 5016,
            "CANDIDATE_STEP_RESOURCE_FREE_WORD": 5017,
            "COMPANY_STEP_RESOURCE_FREE_WORD": 5100,
            "DISPATCH_DESTINATION_FREE_WORD": 5101,
            "DISPATCH_DESTINATION_BASIC_INFO": 5102,
            "DISPATCH_STAFF_BASIC_INFO": 5103,
            "DISPATCH_STAFF_SYSTEM_INFO": 5104,
            "DISPATCH_WORKING_PLACE_BASIC_INFO": 5105,
            "DISPATCH_WORKING_PLACE_SYSTEM_INFO": 5106,
            "DISPATCH_ORGANIZATION_UNIT_BASIC_INFO": 5107,
            "DISPATCH_ORGANIZATION_UNIT_SYSTEM_INFO": 5108,
            "BILLING_DESTINATION_BASIC_INFO": 5109,
            "BILLING_DESTINATION_SYSTEM_INFO": 5110,
            "DISPATCH_JOB_BASIC_INFO": 5111,
            "DISPATCH_JOB_SYSTEM_INFO": 5112,
            "DISPATCH_JOB_DETAIL": 5113,
            "DISPATCH_JOB_REQUIREMENT": 5114,
            "DISPATCH_JOB_WORKING_PLACES": 5115,
            "DISPATCH_JOB_WORKING_HOURS": 5116,
            "DISPATCH_JOB_WAGES": 5117,
            "DISPATCH_JOB_AMOUNT_OVER_SHORTS": 5118,
            "DISPATCH_STAFF_FREE_WORD": 5119,
            "DISPATCH_WORKING_PLACE_FREE_WORD": 5120,
            "DISPATCH_ORGANIZATION_UNIT_FREE_WORD": 5121,
            "BILLING_DESTINATION_INVOICE_DATA": 5122,
            "BILLING_DESTINATION_PAYMENT_DATA": 5123,
            "BILLING_DESTINATION_FREE_WORD": 5124,
            "DISPATCH_JOB_FREE_WORD": 5125,
            "STAFF_FREE_WORD": 5126,
            "CONTRACT_BASIC_INFO": 5127,
            "CONTRACT_SYSTEM_INFO": 5128,
            "CONTRACT_WORKING_PLACES": 5131,
            "CONTRACT_WORKING_HOURS": 5132,
            "CONTRACT_WAGES": 5133,
            "CONTRACT_AMOUNT_OVER_SHORTS": 5134,
            "CONTRACT_FREE_WORD": 5135,
            "DISPATCH_SOURCE_BASIC_INFO": 5136,
            "DISPATCH_SOURCE_SYSTEM_INFO": 5137,
            "DISPATCH_SOURCE_STAFF_BASIC_INFO": 5138,
            "DISPATCH_SOURCE_STAFF_SYSTEM_INFO": 5139,
            "STAFF_SYSTEM_INFO": 5140,
            "DISPATCH_DESTINATION_SYSTEM_INFO": 5141,
            "CONTRACT_TERM_LIMIT": 5142,
            "SALES_SYSTEM_INFO": 5143,
            "CONTRACT_MEMO_BASIC_INFO": 5155,
            "CONTRACT_MEMO_SYSTEM_INFO": 5156,
            "CANDIDATE_DISPATCH_BASIC_INFO": 5157,
            "CANDIDATE_SOCIAL_INSURANCE_RELATED": 5158,
            "CONTRACT_MEMO_REPORT_CASCADER": 5159,
            "CS_MASTER_COMPANY_WORKER_DISPATCH_INDIVIDUAL_CONTRACT": 5262,
            "CS_MASTER_DISPATCH_DESTINATION_WORKER_DISPATCH_INDIVIDUAL_CONTRACT": 5265,
            "CS_MASTER_CONTRACT_WORKING_CONDITION_NOTICE_AND_WORKING_CONDITION_STATEMENT": 5269,
            "CS_MASTER_CONTRACT_WORKER_DISPATCH_INDIVIDUAL_CONTRACT": 5270,
            "CS_MASTER_DISPATCH_JOB_WORKER_DISPATCH_INDIVIDUAL_CONTRACT": 5274,
            "ACTUAL_AMOUNT_OVER_SHORTS": 7000,
            "INVOICE_CLOSED_ATTENDANCE_INVOICE_INFO": 7001,
            "INVOICE_CLOSED_ATTENDANCE_SYSTEM_INFO": 7002,
            "INVOICE_CLOSED_INVOICE_INVOICE_INFO": 7003,
            "INVOICE_CLOSED_INVOICE_SYSTEM_INFO": 7004,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_INFO": 7005,
            "PAYMENT_CLOSED_ATTENDANCE_SYSTEM_INFO": 7006,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_INFO": 7007,
            "PAYMENT_CLOSED_PAYMENT_SYSTEM_INFO": 7008,
            "ATTENDANCES": 7009,
            "DISPATCH_SPOT_JOB_FREE_WORD": 7010,
            "DISPATCH_SPOT_JOB_SPOT_DUE_DATE": 7011,
            "DISPATCH_SPOT_JOB_BASIC_INFO": 7012,
            "CONFLICT_DATE_MANAGEMENT_BASIC_INFO": 7013,
            "CONFLICT_DATE_DEFAULT_BASIC_INFO": 7014,
            "CONTRACT_DISPATCH_MANAGEMENT_LEDGER": 7016,
            "CONTRACT_DISPATCH_DESTINATION_MANAGEMENT_LEDGER": 7017,
            "CANDIDATE_NOTIFICATION_OF_WORKING_CONDITIONS_AND_CLARIFICATION_OF_WORKING_CONDITIONS": 7018,
            "CANDIDATE_DISPATCH_MANAGEMENT_LEDGER": 7019,
            "COMPANY_DISPATCH_DESTINATION_MANAGEMENT_LEDGER": 7020,
            "CANDIDATE_CONFLICT_DATE_DEFAULTS": 7021,
            "DISPATCH_DESTINATION_DISPATCH_DESTINATION_MANAGEMENT_LEDGER": 7022,
            "DISPATCH_JOB_DISPATCH_DESTINATION_MANAGEMENT_LEDGER": 7023,
            "INVOICE_CONTRACT_ATTENDANCES": 7024,
            "PAYMENT_CONTRACT_ATTENDANCES": 7025,
            "INVOICE_CLOSED_ATTENDANCES": 7026,
            "PAYMENT_CLOSED_ATTENDANCES": 7027,
            "PAYMENT_CLOSED_ATTENDANCE_DEDUCTIONS": 7028,
            "CANDIDATE_WAGES": 7029,
            "INVOICE_CLOSED_INVOICES": 7030,
            "CANDIDATE_PAYMENT_DATA": 7031,
            "INVOICE_COPY_ATTENDANCES": 7032,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORTS": 7033,
            "PAYMENT_COPY_ATTENDANCES": 7034,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORTS": 7035,
            "ATTENDANCE_CALCULATIONS": 7036,
            "DISPATCH_SOURCE_REPORT_SETTING_COMPANY_SCALE": 7037,
            "DISPATCH_SOURCE_REPORT_SETTING_INDUSTRY_CLASSIFICATION": 7038,
            "DISPATCH_SOURCE_REPORT_SETTING_SECOND_BUSINESS_EMPLOYMENT_AGENCIES": 7039,
            "DISPATCH_SOURCE_REPORT_SETTING_PARENT_COMPANY": 7040,
            "DISPATCH_SOURCE_REPORT_SETTING_EXECUTION_CONTRACT_WORK": 7041,
            "DISPATCH_SOURCE_REPORT_SETTING_NOTE": 7042,
            "DISPATCH_SOURCE_REPORT_SETTING_MARGIN_RATIO_PUBLICATION": 7043,
            "DISPATCH_SOURCE_REPORT_SETTING_CONSOLIDATED_BALANCE_SHEET": 7044,
            "DISPATCH_SOURCE_CAREER_STAFF_BASIC_INFO": 7045,
            "DISPATCH_SOURCE_CAREER_STAFF_SYSTEM_INFO": 7046,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_BASIC_INFO": 7047,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_SYSTEM_INFO": 7048,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_BASIC_INFO": 7049,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_SYSTEM_INFO": 7050,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_BASIC_INFO": 7051,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_SYSTEM_INFO": 7052,
            "DISPATCH_SOURCE_REPORT_SETTING_ACTUAL_RESULTS_TYPE": 7053,
            "CANDIDATE_CAREER_COUNSELLING_BASIC_INFO": 7054,
            "CANDIDATE_CAREER_COUNSELLING_SYSTEM_INFO": 7055,
            "CANDIDATE_EDUCATION_AND_TRAINING_BASIC_INFO": 7056,
            "CANDIDATE_EDUCATION_AND_TRAINING_SYSTEM_INFO": 7057,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_BASIC_INFO": 7058,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_SYSTEM_INFO": 7059,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_BASIC_INFO": 7060,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_SYSTEM_INFO": 7061,
            "CANDIDATE_JOB_STEP_RESOURCES_MANAGE_INFORMATION_REPORT": 7065,
            "SYSTEM_USE_CATEGORIES": [
                1,
                10,
                11,
                15,
                20,
                5013,
                5016,
                5017,
                5100,
                5101,
                5119,
                5120,
                5121,
                5124,
                5125,
                5126,
                5135,
                7021
            ],
            "RESOURCE_EXTERNAL_TABLES": {
                "5115": "working_place",
                "5116": "working_hour",
                "5117": "wage",
                "5131": "working_place",
                "5132": "working_hour",
                "5133": "wage",
                "4": "careers",
                "3": "educations",
                "28": "refund",
                "29": "refund",
                "5157": "dispatch_basic",
                "5158": "dispatch_insurance",
                "7029": "wage",
                "7037": "report_setting",
                "7038": "report_setting",
                "7039": "report_setting",
                "7040": "report_setting",
                "7041": "report_setting",
                "7042": "report_setting"
            },
            "ONE_CHILD_CATEGORIES": [
                28,
                29
            ],
            "MAIL_PRINT_CATEGORY_FOR_DISPATCH_JOBS": [
                5115,
                5116,
                5117
            ],
            "NOT_HAVE_CHILD_CASCADER_PROPERTY_TABLES": [
                82
            ],
            "WOKING_CONDITION_CATEGORIES": [
                5115,
                5116,
                5117,
                5131,
                5132,
                5133,
                7029
            ],
            "SYSTEM_INFO_CATEGORIES": [
                5141,
                5110,
                5140,
                5104,
                5106,
                5108,
                5137,
                5139,
                5112,
                7055,
                7057,
                7059
            ],
            "DISABLED_CATEGORIES_FOR_ATTENDANCE_LOCK": [
                5133,
                5132,
                5122,
                7031
            ]
        },
        "properties": {
            "created_at": null,
            "display_name": null,
            "id": 0,
            "is_child_category": null,
            "is_display": "1",
            "is_system_default": "0",
            "name": null,
            "position": null,
            "property_tab_id": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyTab": null,
            "propertyTable": null,
            "propertyColumns": null,
            "searchColumns": null
        },
        "relations": {
            "propertyTab": "PropertyTab",
            "propertyTable": "PropertyTable",
            "propertyColumns": "PropertyColumn",
            "searchColumns": "SearchColumn"
        },
        "appends": [
            "isDefaultCategory",
            "should_display",
            "hasChildCascader"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_categories"
    },
    "PropertyColumn": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "TRUE_TEXT_COLUMN": "true_text",
            "FALSE_TEXT_COLUMN": "false_text",
            "DEFAULT_VALUE_TYPE_FIXED": "fixed",
            "DEFAULT_VALUE_TYPE_RESOURCE": "resource",
            "DELETE_COLUMN_API_V2": "delete",
            "FREE_WORD_SEARCH": 1,
            "CANDIDATE_NAME": 2,
            "CANDIDATE_KANA": 3,
            "CANDIDATE_STATE_ID": 4,
            "CANDIDATE_CODE": 5,
            "BIRTH_DATE": 6,
            "CANDIDATE_AGE": 7,
            "CANDIDATE_SEX_ID": 8,
            "CANDIDATE_ZIP": 9,
            "CANDIDATE_PREFECTURE_ID": 10,
            "CANDIDATE_ADDRESS": 11,
            "CANDIDATE_STATION": 12,
            "CANDIDATE_TEL": 13,
            "CANDIDATE_PORTABLE_TEL": 14,
            "CANDIDATE_EMAIL": 15,
            "CANDIDATE_PORTABLE_EMAIL": 16,
            "CANDIDATE_OFFICE_EMAIL": 17,
            "CANDIDATE_IS_MARRIED": 18,
            "CANDIDATE_FEED_NUMBER": 19,
            "CANDIDATE_CAUTION": 20,
            "CANDIDATE_IS_POSSIBLE_BULK": 21,
            "CANDIDATE_FIGURE": 22,
            "CANDIDATE_RANK_ID": 23,
            "CANDIDATE_JOB_CHANGE_NUMBER": 24,
            "CANDIDATE_ROUDOUKYOKU_CATEGORY_ID": 25,
            "CANDIDATE_CIRCUMSTANCE_ID": 26,
            "CANDIDATE_APPLIED": 28,
            "CANDIDATE_HOPE_COMPANY": 29,
            "CANDIDATE_HOPE_JOB_CHANGE_SEASON": 30,
            "CANDIDATE_HOPE_FEE": 31,
            "CANDIDATE_HOPE_PLACE": 32,
            "CANDIDATE_HOPE_EMPLOYMENT_CATEGORY_ID": 33,
            "CANDIDATE_TOEIC": 34,
            "CANDIDATE_ENGLISH_SKILL": 35,
            "CANDIDATE_QUALIFICATION": 36,
            "CANDIDATE_REQUEST": 37,
            "CANDIDATE_MEDIUM_ID": 38,
            "CANDIDATE_MEDIUM_DETAIL": 39,
            "CANDIDATE_MEMO": 40,
            "CANDIDATE_DISTRIBUTED_AT": 41,
            "CANDIDATE_PHOTO_FILE_PATH": 42,
            "COMPANY_CODE": 43,
            "COMPANY_STATE_ID": 44,
            "COMPANY_NAME": 45,
            "COMPANY_KANA": 46,
            "COMPANY_ESTABLISHMENT_DATE": 47,
            "COMPANY_CAPITAL": 48,
            "COMPANY_EMPLOYEE_NUMBER": 49,
            "COMPANY_SALES": 50,
            "COMPANY_TEL": 51,
            "COMPANY_ZIP": 52,
            "COMPANY_PREFECTURE_ID": 53,
            "COMPANY_ADDRESS": 54,
            "COMPANY_REPRESENTATIVE": 55,
            "COMPANY_AVERAGE_AGE": 56,
            "COMPANY_PUBLIC": 57,
            "COMPANY_FOREIGN_CAPITAL_RATE": 58,
            "COMPANY_URL": 59,
            "COMPANY_SUMMARY": 61,
            "COMPANY_STRUCTURE": 62,
            "COMPANY_ADVANTAGE": 63,
            "COMPANY_FUTURE": 64,
            "COMPANY_COMPETITOR": 65,
            "COMPANY_ENVIRONMENT": 66,
            "COMPANY_STOCKHOLDER": 67,
            "COMPANY_AFFILIATE": 68,
            "COMPANY_OTHER_OFFICE": 69,
            "COMPANY_BANK": 70,
            "COMPANY_MEMO": 71,
            "JOB_CODE": 72,
            "JOB_COMPANY_ID": 73,
            "JOB_BILLING_COMPANY_ID": 74,
            "JOB_TITLE": 75,
            "JOB_STATE_ID": 76,
            "JOB_IS_WEB": 77,
            "JOB_IS_COMPANY_NAME_PUBLIC": 78,
            "JOB_DEPARTMENT": 79,
            "JOB_OCCUPATION_ID": 80,
            "JOB_INDUSTRY_ID": 81,
            "JOB_POST": 82,
            "JOB_EMPLOYMENT_CATEGORY_ID": 83,
            "JOB_PREFECTURE_ID": 84,
            "JOB_PLACE": 85,
            "JOB_ACCESS": 86,
            "JOB_BUSINESS_HOURS": 87,
            "JOB_MIN_YEARLY_SALARY": 88,
            "JOB_MAX_YEARLY_SALARY": 89,
            "JOB_WELFARE": 90,
            "JOB_HOLIDAY": 91,
            "JOB_QUALIFICATION": 92,
            "JOB_HOPE_NUM": 93,
            "JOB_IS_TRIAL": 94,
            "JOB_TRANSFER": 95,
            "JOB_AGE_LIMIT": 96,
            "JOB_BACKGROUND": 97,
            "JOB_ROUDOUKYOKU_CATEGORY_ID": 98,
            "JOB_FEE_MEMO": 99,
            "JOB_ROLE_DETAIL": 100,
            "JOB_INTERVIEW_COUNT": 101,
            "JOB_INTERVIEW_PROCESS": 102,
            "JOB_MEMO": 103,
            "JOB_MIN_AGE": 104,
            "JOB_MAX_AGE": 105,
            "JOB_REASON": 106,
            "JOB_MUST_SKILL": 107,
            "JOB_WANT_SKILL": 108,
            "CANDIDATE_FILE_NAME": 109,
            "EDUCATION_CANDIDATE_ID": 110,
            "EDUCATION_SCHOOL_CATEGORY_ID": 111,
            "EDUCATION_SCHOOL": 112,
            "EDUCATION_COURSE": 113,
            "EDUCATION_ENTRANCE_DATE": 114,
            "EDUCATION_GRADUATION_DATE": 115,
            "CAREER_CANDIDATE_ID": 116,
            "CAREER_COMPANY_NAME": 117,
            "CAREER_DEPARTMENT": 118,
            "CAREER_POST": 119,
            "CAREER_INDUSTRY_ID": 120,
            "CAREER_OCCUPATION_ID": 121,
            "CAREER_EMPLOYMENT_CATEGORY_ID": 122,
            "CAREER_FEE": 123,
            "CAREER_EMPLOYEE_NUMBER": 124,
            "CAREER_ENTRANCE_DATE": 125,
            "CAREER_RETIREMENT_DATE": 126,
            "CAREER_DETAIL": 127,
            "CAREER_RETIREMENT_REASON": 128,
            "STAFF_COMPANY_ID": 129,
            "STAFF_NAME": 130,
            "STAFF_KANA": 131,
            "STAFF_DEPARTMENT": 132,
            "STAFF_POST": 133,
            "STAFF_TELL": 134,
            "STAFF_PORTABLE_TEL": 135,
            "STAFF_EMAIL": 136,
            "STAFF_FAX": 137,
            "STAFF_IS_POSSIBLE_BULK_MAIL": 138,
            "STAFF_ZIP": 139,
            "STAFF_PREFECTURE_ID": 140,
            "STAFF_ADDRESS": 141,
            "STAFF_MEMO": 142,
            "FILE_NAME": 143,
            "STAFF_NAME_NORMALIZED": 160,
            "STAFF_KANA_NORMALIZED": 161,
            "SETTING_COMPANY_NAME": 144,
            "SETTING_ADDRESS": 145,
            "SETTING_CHIEF_NAME": 146,
            "USER_NAME": 147,
            "JOB_ID": 148,
            "INDUSTRY_NAME": 149,
            "COMPANY_STEP_MEMO": 150,
            "CANDIDATE_HOPE_INDUSTRY": 151,
            "CANDIDATE_HOPE_OCCUPATION": 152,
            "CANDIDATE_NAME_NORMALIZED": 153,
            "CANDIDATE_KANA_NORMALIZED": 154,
            "CANDIDATE_CODE_NORMALIZED": 155,
            "COMPANY_NAME_NORMALIZED": 156,
            "COMPANY_KANA_NORMALIZED": 157,
            "COMPANY_CODE_NORMALIZED": 158,
            "JOB_CODE_NORMALIZED": 159,
            "JOB_TRIAL_DETAIL": 162,
            "COMPANY_ID": 163,
            "JOB_STAFF_ID": 164,
            "CANDIDATE_ID": 165,
            "CANDIDATE_PHOTO_ID": 166,
            "COMPANY_STEP_STATE_NAME": 167,
            "SALES_CODE": 168,
            "SALES_ENTRANCE_DATE": 169,
            "SALES_DUE_TO_PAYMENT": 170,
            "SALES_MEMO": 171,
            "SALES_RETIREMENT_DATE": 172,
            "SALES_ANNUAL_INCOME": 173,
            "SALES_RATE": 174,
            "SALES_FLAT_FEE": 175,
            "SALES_TAX_RATE_ID": 176,
            "SALES_ROUND_TYPE_ID": 177,
            "SALES_CANDIDATE_NAME": 178,
            "SALES_COMPANY_NAME": 179,
            "SALES_CREATE_AT": 180,
            "SALES_CANDIDATE_USER_NAME": 181,
            "SALES_COMPANY_USER_NAME": 182,
            "SALES_STATE": 183,
            "CANDIDATE_JOB_STEP_CANDIDATE_ID": 184,
            "CANDIDATE_JOB_STEP_USER_ID": 185,
            "CANDIDATE_JOB_STEP_JOB_ID": 186,
            "CANDIDATE_JOB_STEP_INTERVIEWER": 187,
            "CANDIDATE_JOB_STEP_START_AT": 188,
            "CANDIDATE_JOB_STEP_END_AT": 189,
            "CANDIDATE_JOB_STEP_MAIL_ID": 190,
            "CANDIDATE_JOB_STEP_CANDIDATE_JOB_STEP_STATE_ID": 191,
            "CANDIDATE_JOB_STEP_MEMO": 192,
            "CANDIDATE_CREATED_AT": 193,
            "CANDIDATE_UPDATED_AT": 194,
            "COMPANY_CREATED_AT": 195,
            "COMPANY_UPDATED_AT": 196,
            "JOB_CREATED_AT": 197,
            "JOB_UPDATED_AT": 198,
            "AGENCY_NAME": 199,
            "AGENCY_ZIP": 200,
            "AGENCY_PREFECTURE_ID": 201,
            "AGENCY_ADDRESS": 202,
            "CANDIDATE_USER_USER_ID": 203,
            "COMPANY_USER_USER_ID": 204,
            "JOB_USER_USER_ID": 205,
            "AGENT_AGENCY_ID": 206,
            "AGENT_NAME": 207,
            "AGENT_KANA": 208,
            "AGENT_DEPARTMENT": 209,
            "AGENT_POST": 210,
            "AGENT_TEL": 211,
            "AGENT_PORTABLE_TEL": 212,
            "AGENT_EMAIL": 213,
            "COMPANY_FEE_RATE": 214,
            "SETTING_ZIP": 215,
            "SETTING_TEL": 216,
            "SETTING_FAX": 217,
            "SETTING_BANK": 218,
            "SETTING_ACCOUNT_TYPE": 219,
            "SETTING_ACCOUNT_NAME": 220,
            "SETTING_ACCOUNT_NUMBER": 221,
            "SALES_INCLUDE_TAX": 222,
            "SALES_EXCLUDE_TAX": 223,
            "CANDIDATE_JOB_STEP_CREATED_AT": 224,
            "CANDIDATE_JOB_STEP_ENTERED_DATE": 225,
            "JOB_OCCUPATION_NAME": 226,
            "ROUDOUKYOKU_CATEGORY_NAME": 227,
            "ROUDOUKYOKU_CATEGORY_TOTAL_SALES": 228,
            "ROUDOUKYOKU_FOREIGN_JOB_COUNT": 229,
            "ROUDOUKYOKU_FOREIGN_JOB_COUNT_WITH_DELETED": 230,
            "ROUDOUKYOKU_FOREIGN_CANDIDATE_COUNT": 231,
            "ROUDOUKYOKU_FOREIGN_NEW_CANDIDATE_JOB_STEP_COUNT": 232,
            "ROUDOUKYOKU_FOREIGN_ENTERED_CANDIDATE_COUNT": 233,
            "ROUDOUKYOKU_DOMESTIC_JOB_COUNT": 234,
            "ROUDOUKYOKU_DOMESTIC_CANDIDATE_COUNT": 235,
            "ROUDOUKYOKU_DOMESTIC_NEW_CANDIDATE_JOB_STEP_COUNT": 236,
            "ROUDOUKYOKU_DOMESTIC_ENTERED_CANDIDATE_COUNT": 237,
            "AGENT_IS_POSSIBLE_BULK_MAIL": 238,
            "SALES_TOTAL_PAYMENT": 239,
            "SALE_REFUNDS_RETIREMENT_DATE": 240,
            "SALE_REFUNDS_RETIREMENT_RESEARCH_CATEGORY": 241,
            "SALE_REFUNDS_RETIREMENT_RESEARCH_DATE": 242,
            "SALE_REFUNDS_DATE": 243,
            "SALE_REFUNDS_SCHEDULE_DATE": 244,
            "SALE_REFUNDS_BANK_NAME": 245,
            "SALE_REFUNDS_BANK_BRANCH_NAME": 246,
            "SALE_REFUNDS_BANK_ACCOUNT_CATEGORY_ID": 247,
            "SALE_REFUNDS_BANK_ACCOUNT_NUMBER": 248,
            "SALE_REFUNDS_BANK_ACCOUNT_NAME": 249,
            "SALE_REFUNDS_RATE": 250,
            "SALE_REFUNDS_FEE": 251,
            "SALE_REFUNDS_TAX_RATE_ID": 252,
            "SALE_REFUNDS_ROUNDING_TYPE_ID": 253,
            "SALE_REFUNDS_REASON": 254,
            "JOB_VALID_END_DATE": 255,
            "CANDIDATE_VALID_END_DATE": 256,
            "SALE_CANDIDATE_JOB_STEP_ID": 257,
            "SALE_RESEARCHED_AT": 258,
            "SALE_RESEARCH_CATEGORY": 259,
            "JOB_DELETED_AT": 260,
            "STATIC_FUNCTIONS_EXPORT_AT": 261,
            "ROUDOUKYOKU_DOMESTIC_REGULAR_EMPLOYEE_ENTERED_CANDIDATE_COUNT": 262,
            "ROUDOUKYOKU_DOMESTIC_SIX_MONTH_RETIRED_CANDIDATE_COUNT": 263,
            "ROUDOUKYOKU_DOMESTIC_EXCEPT_REGULAR_EMPLOYEE_ENTERED_CANDIDATE_COUNT": 264,
            "ROUDOUKYOKU_FOREIGN_REGULAR_EMPLOYEE_ENTERED_CANDIDATE_COUNT": 265,
            "ROUDOUKYOKU_FOREIGN_SIX_MONTH_RETIRED_CANDIDATE_COUNT": 266,
            "ROUDOUKYOKU_FOREIGN_EXCEPT_REGULAR_EMPLOYEE_ENTERED_CANDIDATE_COUNT": 267,
            "CANDIDATE_DELETED_AT": 268,
            "COMPANY_DELETED_AT": 269,
            "SALES_PAYMENT_DATE": 270,
            "COMPANY_STEP_ID": 271,
            "COMPANY_STEP_COMPANY_ID": 272,
            "COMPANY_STEP_STAFF_ID": 273,
            "COMPANY_STEP_USER_ID": 274,
            "COMPANY_STEP_START_AT": 275,
            "COMPANY_STEP_END_AT": 276,
            "COMPANY_STEP_MAIL_ID": 277,
            "COMPANY_STEP_COMPANY_STEP_STATE_ID": 278,
            "COMPANY_STEP_CREATED_AT": 279,
            "COMPANY_STEP_UPDATED_AT": 280,
            "COMPANY_STEP_DELETED_AT": 281,
            "USER_DEPARTMENT_ID": 282,
            "JOB_EMPLOYMENT_START_DATE": 283,
            "JOB_EMPLOYMENT_END_DATE": 284,
            "ROUDOUKYOKU_DOMESTIC_REGULAR_JOB_COUNT": 285,
            "EDUCATION_ID": 396,
            "CAREER_ID": 397,
            "CANDIDATE_JOB_STEP_ID": 288,
            "SALE_ID": 289,
            "SALE_REFUND_ID": 290,
            "STAFF_ID": 291,
            "FILE_ID": 292,
            "CANDIDATE_FILE_FILE_ID": 293,
            "CANDIDATE_PHOTO_FILE_ID": 294,
            "USER_ID": 295,
            "TASK_ID": 296,
            "TASK_START_AT": 297,
            "TASK_MEMO": 298,
            "TASK_FINISHED_AT": 299,
            "TASK_USER_ID": 300,
            "TASK_CREATED_AT": 301,
            "SCHEDULE_COMPANY_COMPANY_ID": 313,
            "SCHEDULE_ROOM_ROOM_ID": 314,
            "SCHEDULE_USER_USER_ID": 316,
            "SETTING_ACCOUNT_EMAIL": 317,
            "JOB_FILE_FILE_ID": 318,
            "JOB_PHOTO_FILE_ID": 319,
            "COMPANY_FILE_FILE_ID": 320,
            "COMPANY_PHOTO_FILE_ID": 321,
            "CANDIDATE_STEP_ID": 322,
            "CANDIDATE_STEP_CANDIDATE_ID": 323,
            "CANDIDATE_STEP_USER_ID": 324,
            "CANDIDATE_STEP_START_AT": 325,
            "CANDIDATE_STEP_END_AT": 326,
            "CANDIDATE_STEP_CANDIDATE_JOB_STEP_STATE_ID": 327,
            "CANDIDATE_STEP_CANDIDATE_STEP_STATE_ID": 327,
            "CANDIDATE_STEP_MEMO": 328,
            "CANDIDATE_STEP_DELETED_AT": 329,
            "CANDIDATE_STEP_CREATED_AT": 330,
            "CANDIDATE_STEP_UPDATED_AT": 331,
            "MEETING_SCHEDULE_ID": 333,
            "MEETING_SCHEDULE_SCHEDULE_CATEGORY_ID": 334,
            "MEETING_SCHEDULE_START_AT": 335,
            "MEETING_SCHEDULE_END_AT": 336,
            "MEETING_SCHEDULE_MEMO": 337,
            "MEETING_SCHEDULE_CREATED_AT": 338,
            "VISITOR_SCHEDULE_ID": 339,
            "VISITOR_SCHEDULE_SCHEDULE_CATEGORY_ID": 340,
            "VISITOR_SCHEDULE_START_AT": 341,
            "VISITOR_SCHEDULE_END_AT": 342,
            "VISITOR_SCHEDULE_CREATED_AT": 343,
            "VISITOR_SCHEDULE_FREE_CANDIDATE": 344,
            "SALES_SCHEDULE_ID": 346,
            "SALES_SCHEDULE_SCHEDULE_CATEGORY_ID": 347,
            "SALES_SCHEDULE_START_AT": 348,
            "SALES_SCHEDULE_END_AT": 349,
            "SALES_SCHEDULE_CREATED_AT": 350,
            "SALES_SCHEDULE_FREE_COMPANY": 351,
            "SALES_SCHEDULE_FREE_STAFF": 352,
            "SCHEDULE_STAFF_STAFF_ID": 353,
            "OTHER_SCHEDULE_ID": 354,
            "OTHER_SCHEDULE_SCHEDULE_CATEGORY_ID": 355,
            "OTHER_SCHEDULE_START_AT": 356,
            "OTHER_SCHEDULE_END_AT": 357,
            "OTHER_SCHEDULE_MEMO": 358,
            "OTHER_SCHEDULE_CREATED_AT": 359,
            "VISITOR_USER_RESOURCE_USER_RESOURCE_TYPE": 360,
            "VISITOR_USER_RESOURCE_USER_RESOURCE_ID": 361,
            "CANDIDATE_JOB_STEP_UPDATED_AT": 362,
            "CANDIDATE_JOB_STEP_DELETED_AT": 363,
            "SALES_UPDATED_AT": 364,
            "SALES_DELETED_AT": 365,
            "SALE_REFUNDS_CREATED_AT": 366,
            "SALE_REFUNDS_UPDATED_AT": 367,
            "SALE_REFUNDS_DELETE": 368,
            "EDUCATION_CREATED_AT": 369,
            "EDUCATION_UPDATED_AT": 370,
            "EDUCATION_DELETE": 371,
            "CAREER_CREATED_AT": 372,
            "CAREER_UPDATED_AT": 373,
            "CAREER_DELETE": 374,
            "STAFF_CREATED_AT": 375,
            "STAFF_UPDATED_AT": 376,
            "STAFF_DELETED_AT": 377,
            "USER_EMAIL": 378,
            "USER_USER_ROLE_ID": 379,
            "USER_ENABLED": 380,
            "USER_TIMEZONE_ID": 381,
            "USER_CREATED_AT": 382,
            "USER_UPDATED_AT": 383,
            "USER_DELETED_AT": 384,
            "SCHEDULE_CANDIDATE_CANDIDATE_ID": 385,
            "VISITOR_SCHEDULE_STAFF_STAFF_ID": 386,
            "CANDIDATE_USER_DELETE": 387,
            "COMPANY_USER_DELETE": 388,
            "JOB_USER_DELETE": 389,
            "SCHEDULE_CANDIDATE_DELETE": 390,
            "SCHEDULE_COMPANY_DELETE": 391,
            "SCHEDULE_STAFF_DELETE": 392,
            "SCHEDULE_ROOM_DELETE": 393,
            "SCHEDULE_USER_DELETE": 394,
            "VISITOR_SCHEDULE_STAFF_DELETE": 395,
            "SALES_FEE_TYPE_ID": 286,
            "SALES_BASIS_FOR_FEE_CALCULATION": 287,
            "CANDIDATE_EDUCATION_CUSTOM_TEXT_1": 501,
            "CANDIDATE_EDUCATION_CUSTOM_TEXT_2": 502,
            "CANDIDATE_EDUCATION_CUSTOM_TEXT_3": 503,
            "CANDIDATE_EDUCATION_CUSTOM_TEXT_4": 504,
            "CANDIDATE_EDUCATION_CUSTOM_TEXT_5": 505,
            "CANDIDATE_CAREER_CUSTOM_TEXT_1": 506,
            "CANDIDATE_CAREER_CUSTOM_TEXT_2": 507,
            "CANDIDATE_CAREER_CUSTOM_TEXT_3": 508,
            "CANDIDATE_CAREER_CUSTOM_TEXT_4": 509,
            "CANDIDATE_CAREER_CUSTOM_TEXT_5": 510,
            "CANDIDATE_ADDRESS_SUB_MAP": 511,
            "JOB_PLACE_SUB_MAP": 512,
            "DISPATCH_JOB_PLACE_SUB_MAP": 513,
            "JOB_PASSIVE_SMOKING_PREVENTION": 514,
            "SETTING_INVOICE_REGISTRATION_NUMBER": 515,
            "CANDIDATE_MHLW_OCCUPATION_ID": 516,
            "JOB_MHLW_OCCUPATION_ID": 517,
            "JAPAN_STD_OCCUPATION_ID": 518,
            "CANDIDATE_STEP_CORRESPONDENCE_USER_ID": 519,
            "CANDIDATE_STEP_CREATE_USER_ID": 520,
            "COMPANY_STEP_CORRESPONDENCE_USER_ID": 521,
            "COMPANY_STEP_CREATE_USER_ID": 522,
            "CANDIDATE_JOB_STEP_CANDIDATE_CORRESPONDENCE_USER_ID": 523,
            "CANDIDATE_JOB_STEP_JOB_CORRESPONDENCE_USER_ID": 524,
            "CANDIDATE_JOB_STEP_CREATE_USER_ID": 525,
            "SALES_REPORT_REMARKS": 526,
            "CANDIDATE_MYRIC_MYPAGE_STATE_ID": 527,
            "CANDIDATE_MYRIC_MYPAGE_LOGIN_DATE": 528,
            "CANDIDATE_MYRIC_MYPAGE_TOKEN": 529,
            "CANDIDATE_MYRIC_MYPAGE_INVITATION_DATE": 530,
            "CANDIDATE_JOB_STEP_RESOURCES_CANDIDATE_ID": 5001,
            "CANDIDATE_JOB_STEP_RESOURCES_JOB_ID": 5002,
            "CANDIDATE_JOB_STEP_RESOURCES_FULL_TEXT": 5003,
            "CANDIDATE_JOB_STEP_RESOURCES_CREATED_AT": 5004,
            "CANDIDATE_JOB_STEP_RESOURCES_UPDATED_AT": 5005,
            "CANDIDATE_JOB_STEP_RESOURCES_DELETED_AT": 5006,
            "CANDIDATE_JOB_STEPS_CANDIDATE_JOB_STEP_RESOURCE_ID": 5007,
            "CANDIDATE_JOB_STEP_RESOURCES_COMPANY_ID": 5008,
            "CANDIDATE_JOB_STEP_RESOURCES_IS_DISPATCH": 5009,
            "SALE_REFUNDS_TOTAL_REFUND_AMOUNT": 5025,
            "SALES_AMOUNT_OF_SALES": 5026,
            "SALE_REFUNDS_AMOUNT_OF_REFUNDS": 5027,
            "CANDIDATE_JOB_STEP_RESOURCES_ID": 5028,
            "CANDIDATE_STEP_RESOURCES_ID": 5029,
            "CANDIDATE_STEP_RESOURCES_CANDIDATE_ID": 5030,
            "CANDIDATE_STEP_RESOURCES_CREATED_AT": 5031,
            "CANDIDATE_STEP_RESOURCES_UPDATED_AT": 5032,
            "CANDIDATE_STEP_RESOURCES_DELETED_AT": 5033,
            "COMPANY_STEP_RESOURCES_ID": 5034,
            "COMPANY_STEP_RESOURCES_COMPANY_ID": 5035,
            "COMPANY_STEP_RESOURCES_CREATED_AT": 5036,
            "COMPANY_STEP_RESOURCES_UPDATED_AT": 5037,
            "COMPANY_STEP_RESOURCES_DELETED_AT": 5038,
            "CANDIDATE_JOB_STEP_DELETE": 5039,
            "COMPANY_STEP_DELETE": 5040,
            "CANDIDATE_STEP_CANDIDATE_STEP_RESOURECE_ID": 5041,
            "CANDIDATE_STEP_DELETE": 5042,
            "COMPANY_STEP_COMPANY_STEP_RESOURECE_ID": 5043,
            "PREVIOUS_JOB_OR_CURRENT_JOB": 5044,
            "DISPATCH_DESTINATION_ID": 5045,
            "DISPATCH_DESTINATION_COMPANY_ID": 5046,
            "DISPATCH_DESTINATION_DISPATCH_DESTINATION_STATE_ID": 5047,
            "DISPATCH_DESTINATION_NAME": 5048,
            "DISPATCH_DESTINATION_ZIP": 5049,
            "DISPATCH_DESTINATION_PREFECTURE_ID": 5050,
            "DISPATCH_DESTINATION_ADDRESS": 5051,
            "DISPATCH_DESTINATION_USER_ID": 5052,
            "DISPATCH_DESTINATION_DELETED_AT": 5053,
            "DISPATCH_DESTINATION_CREATED_AT": 5054,
            "DISPATCH_DESTINATION_UPDATED_AT": 5055,
            "DISPATCH_DESTINATION_CREATED_USER_ID": 5056,
            "DISPATCH_DESTINATION_UPDATED_USER_ID": 5057,
            "DISPATCH_DESTINATION_FULL_TEXT": 5058,
            "DISPATCH_DESTINATION_NAME_NORMALIZED": 5059,
            "DISPATCH_STAFF_ID": 5060,
            "DISPATCH_STAFF_COMPANY_ID": 5061,
            "DISPATCH_STAFF_DISPATCH_DESTINATION_ID": 5062,
            "DISPATCH_STAFF_DISPATCH_STAFF_STATE_ID": 5063,
            "DISPATCH_STAFF_CODE": 5064,
            "DISPATCH_STAFF_NAME": 5065,
            "DISPATCH_STAFF_CREATED_AT": 5066,
            "DISPATCH_STAFF_UPDATED_AT": 5067,
            "DISPATCH_STAFF_CREATED_USER_ID": 5068,
            "DISPATCH_STAFF_UPDATED_USER_ID": 5069,
            "DISPATCH_WORKING_PLACE_ID": 5070,
            "DISPATCH_WORKING_PLACE_COMPANY_ID": 5071,
            "DISPATCH_WORKING_PLACE_DISPATCH_DESTINATION_ID": 5072,
            "DISPATCH_WORKING_PLACE_DISPATCH_WORKING_PLACE_STATE_ID": 5073,
            "DISPATCH_WORKING_PLACE_CODE": 5074,
            "DISPATCH_WORKING_PLACE_NAME": 5075,
            "DISPATCH_WORKING_PLACE_CREATED_AT": 5076,
            "DISPATCH_WORKING_PLACE_UPDATED_AT": 5077,
            "DISPATCH_WORKING_PLACE_CREATED_USER_ID": 5078,
            "DISPATCH_WORKING_PLACE_UPDATED_USER_ID": 5079,
            "DISPATCH_ORGANIZATION_UNIT_ID": 5080,
            "DISPATCH_ORGANIZATION_UNIT_COMPANY_ID": 5081,
            "DISPATCH_ORGANIZATION_UNIT_DISPATCH_DESTINATION_ID": 5082,
            "DISPATCH_ORGANIZATION_UNIT_DISPATCH_ORGANIZATION_UNIT_STATE_ID": 5083,
            "DISPATCH_ORGANIZATION_UNIT_CODE": 5084,
            "DISPATCH_ORGANIZATION_UNIT_NAME": 5085,
            "DISPATCH_ORGANIZATION_UNIT_CREATED_AT": 5086,
            "DISPATCH_ORGANIZATION_UNIT_UPDATED_AT": 5087,
            "DISPATCH_ORGANIZATION_UNIT_CREATED_USER_ID": 5088,
            "DISPATCH_ORGANIZATION_UNIT_UPDATED_USER_ID": 5089,
            "BILLING_DESTINATION_ID": 5090,
            "BILLING_DESTINATION_BILLING_DESTINATION_STATE_ID": 5091,
            "BILLING_DESTINATION_COMPANY_ID": 5092,
            "BILLING_DESTINATION_CODE": 5093,
            "BILLING_DESTINATION_NAME": 5094,
            "BILLING_DESTINATION_ZIP": 5095,
            "BILLING_DESTINATION_PREFECTURE_ID": 5096,
            "BILLING_DESTINATION_ADDRESS": 5097,
            "BILLING_DESTINATION_CREATED_AT": 5098,
            "BILLING_DESTINATION_UPDATED_AT": 5099,
            "BILLING_DESTINATION_CREATED_USER_ID": 5100,
            "BILLING_DESTINATION_UPDATED_USER_ID": 5101,
            "DISPATCH_DESTINATION_CODE": 5102,
            "DISPATCH_DESTINATION_CODE_NORMALIZED": 5103,
            "DISPATCH_STAFF_NAME_NORMALIZED": 5104,
            "DISPATCH_STAFF_CODE_NORMALIZED": 5105,
            "DISPATCH_WORKING_PLACE_NAME_NORMALIZED": 5106,
            "DISPATCH_WORKING_PLACE_CODE_NORMALIZED": 5107,
            "DISPATCH_ORGANIZATION_UNIT_NAME_NORMALIZED": 5108,
            "DISPATCH_ORGANIZATION_UNIT_CODE_NORMALIZED": 5109,
            "DISPATCH_JOB_ID": 5110,
            "DISPATCH_JOB_DISPATCH_JOB_STATE_ID": 5111,
            "DISPATCH_JOB_CODE": 5112,
            "DISPATCH_JOB_COMPANY_ID": 5113,
            "DISPATCH_JOB_DISPATCH_DESTINATION_ID": 5114,
            "DISPATCH_JOB_DISPATCH_ORGANIZATION_UNIT_ID": 5115,
            "DISPATCH_JOB_BILLING_DESTINATION_ID": 5116,
            "DISPATCH_JOB_EMPLOYMENT_CATEGORY_ID": 5117,
            "DISPATCH_JOB_OCCUPATION_ID": 5118,
            "DISPATCH_JOB_INDUSTRY_ID": 5119,
            "DISPATCH_JOB_DISPATCH_START_DATE": 5120,
            "DISPATCH_JOB_DISPATCH_END_DATE": 5121,
            "REPRESENTATIVE_DISPATCH_STAFF_DISPATCH_STAFF_ID": 5122,
            "CLAIM_REPRESENTATIVE_DISPATCH_STAFF_DISPATCH_STAFF_ID": 5123,
            "COMMANDER_DISPATCH_STAFF_DISPATCH_STAFF_ID": 5124,
            "DISPATCH_JOB_CONFLICT_DATE": 5125,
            "DISPATCH_JOB_IS_TARGET_OVER_AGE_60_BOOLEAN_TYPE_ID": 5126,
            "DISPATCH_JOB_IS_WEB": 5127,
            "DISPATCH_JOB_IS_COMPANY_NAME_PUBLIC": 5128,
            "DISPATCH_JOB_DEPARTMENT": 5129,
            "DISPATCH_JOB_POST": 5130,
            "DISPATCH_JOB_PREFECTURE_ID": 5131,
            "DISPATCH_JOB_PLACE": 5132,
            "DISPATCH_JOB_ACCESS": 5133,
            "DISPATCH_JOB_BUSINESS_HOURS": 5134,
            "DISPATCH_JOB_WELFARE": 5135,
            "DISPATCH_JOB_HOLIDAY": 5136,
            "DISPATCH_JOB_QUALIFICATION": 5137,
            "DISPATCH_JOB_BACKGROUND": 5138,
            "DISPATCH_JOB_STAFF_ID": 5139,
            "DISPATCH_JOB_CREATED_AT": 5140,
            "DISPATCH_JOB_OCCUPATION_NAME": 5141,
            "DISPATCH_JOB_FEE_MEMO": 5142,
            "DISPATCH_JOB_ROLE_DETAIL": 5143,
            "DISPATCH_JOB_MEMO": 5144,
            "DISPATCH_JOB_MIN_AGE": 5145,
            "DISPATCH_JOB_MAX_AGE": 5146,
            "DISPATCH_JOB_REASON": 5147,
            "DISPATCH_JOB_MUST_SKILL": 5148,
            "DISPATCH_JOB_WANT_SKILL": 5149,
            "DISPATCH_JOB_CREATED_USER_ID": 5150,
            "DISPATCH_JOB_UPDATED_USER_ID": 5151,
            "DISPATCH_JOB_WORKING_PLACE_NAME": 5152,
            "DISPATCH_JOB_WORKING_PLACE_NEAREST_STATION": 5153,
            "DISPATCH_JOB_WORKING_PLACE_TEL": 5154,
            "DISPATCH_JOB_WORKING_PLACE_MEMO": 5155,
            "DISPATCH_JOB_WORKING_HOUR_WORKING_DAYS": 5156,
            "DISPATCH_JOB_WORKING_HOUR_SCHEDULED_START_TIME": 5157,
            "DISPATCH_JOB_WORKING_HOUR_SCHEDULED_END_TIME": 5158,
            "DISPATCH_JOB_WORKING_HOUR_BREAK_MINUTES": 5159,
            "DISPATCH_JOB_WORKING_HOUR_MIDNIGHT_BREAK_MINUTES": 5160,
            "DISPATCH_JOB_WORKING_HOUR_PRESCRIBED_WORKING_TIME": 5161,
            "DISPATCH_JOB_WAGE_INVOICE_WAGE_TYPE_ID": 5163,
            "DISPATCH_JOB_INVOICE_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 5165,
            "DISPATCH_JOB_WAGE_INVOICE_BASIC_UNIT_WAGE": 5166,
            "DISPATCH_JOB_WAGE_INVOICE_LEGAL_OVER_TIME_UNIT_WAGE": 5167,
            "DISPATCH_JOB_WAGE_INVOICE_NON_LEGAL_OVER_TIME_UNIT_WAGE": 5168,
            "DISPATCH_JOB_WAGE_INVOICE_LEGAL_HOLIDAY_UNIT_WAGE": 5169,
            "DISPATCH_JOB_WAGE_INVOICE_PRESCRIBED_HOLIDAY_UNIT_WAGE": 5170,
            "DISPATCH_JOB_WAGE_INVOICE_NIGHT_EXTRA_UNIT_WAGE": 5171,
            "DISPATCH_JOB_WAGE_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 5172,
            "DISPATCH_JOB_WAGE_INVOICE_WEEKLY_LEGAL_WORKING_HOUR": 5173,
            "DISPATCH_JOB_WAGE_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 5174,
            "DISPATCH_JOB_WAGE_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 5175,
            "DISPATCH_JOB_WAGE_INVOICE_LEAVE_DEDUCTION": 5176,
            "DISPATCH_JOB_WAGE_INVOICE_PRESCRIBED_HOUR_SHORT_DEDUCTION": 5177,
            "DISPATCH_JOB_WAGE_PAYMENT_WAGE_TYPE_ID": 5178,
            "DISPATCH_JOB_PAYMENT_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 5180,
            "DISPATCH_JOB_WAGE_PAYMENT_BASIC_UNIT_WAGE": 5181,
            "DISPATCH_JOB_WAGE_PAYMENT_LEGAL_OVER_TIME_UNIT_WAGE": 5182,
            "DISPATCH_JOB_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_UNIT_WAGE": 5183,
            "DISPATCH_JOB_WAGE_PAYMENT_LEGAL_HOLIDAY_UNIT_WAGE": 5184,
            "DISPATCH_JOB_WAGE_PAYMENT_PRESCRIBED_HOLIDAY_UNIT_WAGE": 5185,
            "DISPATCH_JOB_WAGE_PAYMENT_NIGHT_EXTRA_UNIT_WAGE": 5186,
            "DISPATCH_JOB_WAGE_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 5187,
            "DISPATCH_JOB_WAGE_PAYMENT_WEEKLY_LEGAL_WORKING_HOUR": 5188,
            "DISPATCH_JOB_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 5189,
            "DISPATCH_JOB_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 5190,
            "DISPATCH_JOB_WAGE_PAYMENT_LEAVE_DEDUCTION": 5191,
            "DISPATCH_JOB_WAGE_PAYMENT_PRESCRIBED_HOUR_SHORT_DEDUCTION": 5192,
            "INVOICE_DATA_BILLING_CLOSING_DAY_DATE_ONLY_TYPE_ID": 5193,
            "INVOICE_DATA_CALC_TIME_UNIT": 5194,
            "INVOICE_DATA_TIME_ROUNDING_TYPE_ID": 5195,
            "INVOICE_DATA_FRACTION_ROUNDING_TYPE_ID": 5196,
            "INVOICE_DATA_TAX_ROUNDING_TYPE_ID": 5197,
            "PAYMENT_DATA_CALC_TIME_UNIT": 5198,
            "PAYMENT_DATA_TIME_ROUNDING_TYPE_ID": 5199,
            "PAYMENT_DATA_FRACTION_ROUNDING_TYPE_ID": 5200,
            "DISPATCH_JOB_UPDATED_AT": 5201,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_INVOICE_AMOUNT": 5202,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_INVOICE_TAXATION_TYPE_ID": 5203,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_PAYMENT_AMOUNT": 5204,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_PAYMENT_TAXATION_TYPE_ID": 5205,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_BASE_EMPLOYMENT_INSURANCE_BOOLEAN_DEFAULT_TYPE_ID": 5206,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_BOOLEAN_EXISTENCE_TYPE_ID": 5207,
            "INVOICE_DATA_ID": 5208,
            "INVOICE_DATA_DELETE": 5209,
            "PAYMENT_DATA_ID": 5210,
            "PAYMENT_DATA_DELETE": 5211,
            "BILLING_DESTINATION_DELETED_AT": 5212,
            "BILLING_DESTINATION_USER_ID": 5213,
            "DISPATCH_JOB_WORKING_PLACE_ID": 5214,
            "DISPATCH_JOB_WORKING_PLACE_DELETE": 5215,
            "DISPATCH_JOB_WORKING_HOUR_ID": 5216,
            "DISPATCH_JOB_WORKING_HOUR_DELETE": 5217,
            "DISPATCH_JOB_WAGE_ID": 5218,
            "DISPATCH_JOB_WAGE_DELETE": 5219,
            "DISPATCH_JOB_USER_DELETE": 5220,
            "DISPATCH_JOB_DELETED_AT": 5221,
            "DISPATCH_JOB_USER_USER_ID": 5222,
            "REPRESENTATIVE_DISPATCH_STAFF_DELETE": 5223,
            "CLAIM_REPRESENTATIVE_DISPATCH_STAFF_DELETE": 5224,
            "COMMANDER_DISPATCH_STAFF_DELETE": 5225,
            "DISPATCH_JOB_TITLE": 5226,
            "BILLING_DESTINATION_NAME_NORMALIZED": 5227,
            "BILLING_DESTINATION_CODE_NORMALIZED": 5228,
            "DISPATCH_JOB_CODE_NORMALIZED": 5229,
            "STAFF_CREATED_USER_ID": 5230,
            "STAFF_UPDATED_USER_ID": 5231,
            "STAFF_STAFF_STATE_ID": 5232,
            "DISPATCH_ORGANIZATION_UNIT_RESOURCE_ID": 5233,
            "DISPATCH_ORGANIZATION_UNIT_RESOURCE_TYPE": 5234,
            "DISPATCH_STAFF_RESOURCE_ID": 5235,
            "DISPATCH_STAFF_RESOURCE_TYPE": 5236,
            "DISPATCH_WORKING_PLACE_RESOURCE_ID": 5237,
            "DISPATCH_WORKING_PLACE_RESOURCE_TYPE": 5238,
            "CONTRACT_ID": 5239,
            "CONTRACT_CONTRACT_STATE_ID": 5240,
            "CONTRACT_CODE": 5241,
            "CONTRACT_COMPANY_ID": 5242,
            "CONTRACT_DISPATCH_DESTINATION_ID": 5243,
            "CONTRACT_DISPATCH_ORGANIZATION_UNIT_ID": 5244,
            "CONTRACT_BILLING_DESTINATION_ID": 5245,
            "CONTRACT_EMPLOYMENT_CATEGORY_ID": 5246,
            "CONTRACT_OCCUPATION_ID": 5247,
            "CONTRACT_INDUSTRY_ID": 5248,
            "CONTRACT_DISPATCH_START_DATE": 5249,
            "CONTRACT_DISPATCH_END_DATE": 5250,
            "CONTRACT_CONFLICT_DATE": 5254,
            "CONTRACT_IS_TARGET_OVER_AGE_60_BOOLEAN_TYPE_ID": 5255,
            "CONTRACT_CREATED_AT": 5269,
            "CONTRACT_CREATED_USER_ID": 5279,
            "CONTRACT_UPDATED_USER_ID": 5280,
            "CONTRACT_UPDATED_AT": 5281,
            "CONTRACT_DELETED_AT": 5283,
            "CONTRACT_CODE_NORMALIZED": 5286,
            "CONTRACT_CANDIDATE_JOB_STEP_RESOURCE_ID": 5342,
            "CONTRACT_CANDIDATE_ID": 5343,
            "CONTRACT_JOB_ID": 5344,
            "CONTRACT_REPRESENTATIVE_DISPATCH_STAFF_DISPATCH_STAFF_ID": 5251,
            "CONTRACT_CLAIM_REPRESENTATIVE_DISPATCH_STAFF_DISPATCH_STAFF_ID": 5252,
            "CONTRACT_COMMANDER_DISPATCH_STAFF_DISPATCH_STAFF_ID": 5253,
            "CONTRACT_REPRESENTATIVE_DISPATCH_STAFF_DELETE": 5345,
            "CONTRACT_CLAIM_REPRESENTATIVE_DISPATCH_STAFF_DELETE": 5346,
            "CONTRACT_COMMANDER_DISPATCH_STAFF_DELETE": 5347,
            "CONTRACT_WORKING_PLACE_ID": 5287,
            "CONTRACT_WORKING_PLACE_NAME": 5288,
            "CONTRACT_WORKING_PLACE_NEAREST_STATION": 5289,
            "CONTRACT_WORKING_PLACE_TEL": 5290,
            "CONTRACT_WORKING_PLACE_MEMO": 5291,
            "CONTRACT_WORKING_PLACE_DELETE": 5292,
            "CONTRACT_WORKING_HOUR_ID": 5293,
            "CONTRACT_WORKING_HOUR_WORKING_DAYS": 5294,
            "CONTRACT_WORKING_HOUR_SCHEDULED_START_TIME": 5295,
            "CONTRACT_WORKING_HOUR_SCHEDULED_END_TIME": 5296,
            "CONTRACT_WORKING_HOUR_BREAK_MINUTES": 5297,
            "CONTRACT_WORKING_HOUR_MIDNIGHT_BREAK_MINUTES": 5298,
            "CONTRACT_WORKING_HOUR_PRESCRIBED_WORKING_TIME": 5299,
            "CONTRACT_WORKING_HOUR_DELETE": 5300,
            "CONTRACT_WAGE_ID": 5301,
            "CONTRACT_WAGE_INVOICE_WAGE_TYPE_ID": 5302,
            "CONTRACT_WAGE_INVOICE_LESS_YEN_ROUNDING_TYPE_ID": 5303,
            "CONTRACT_WAGE_INVOICE_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 5304,
            "CONTRACT_WAGE_INVOICE_BASIC_UNIT_WAGE": 5305,
            "CONTRACT_WAGE_INVOICE_LEGAL_OVER_TIME_UNIT_WAGE": 5306,
            "CONTRACT_WAGE_INVOICE_NON_LEGAL_OVER_TIME_UNIT_WAGE": 5307,
            "CONTRACT_WAGE_INVOICE_LEGAL_HOLIDAY_UNIT_WAGE": 5308,
            "CONTRACT_WAGE_INVOICE_PRESCRIBED_HOLIDAY_UNIT_WAGE": 5309,
            "CONTRACT_WAGE_INVOICE_NIGHT_EXTRA_UNIT_WAGE": 5310,
            "CONTRACT_WAGE_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 5311,
            "CONTRACT_WAGE_INVOICE_WEEKLY_LEGAL_WORKING_HOUR": 5312,
            "CONTRACT_WAGE_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 5313,
            "CONTRACT_WAGE_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 5314,
            "CONTRACT_WAGE_INVOICE_LEAVE_DEDUCTION": 5315,
            "CONTRACT_WAGE_INVOICE_PRESCRIBED_HOUR_SHORT_DEDUCTION": 5316,
            "CONTRACT_WAGE_PAYMENT_WAGE_TYPE_ID": 5317,
            "CONTRACT_WAGE_PAYMENT_LESS_YEN_ROUNDING_TYPE_ID": 5318,
            "CONTRACT_WAGE_PAYMENT_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 5319,
            "CONTRACT_WAGE_PAYMENT_BASIC_UNIT_WAGE": 5320,
            "CONTRACT_WAGE_PAYMENT_LEGAL_OVER_TIME_UNIT_WAGE": 5321,
            "CONTRACT_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_UNIT_WAGE": 5322,
            "CONTRACT_WAGE_PAYMENT_LEGAL_HOLIDAY_UNIT_WAGE": 5323,
            "CONTRACT_WAGE_PAYMENT_PRESCRIBED_HOLIDAY_UNIT_WAGE": 5324,
            "CONTRACT_WAGE_PAYMENT_NIGHT_EXTRA_UNIT_WAGE": 5325,
            "CONTRACT_WAGE_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 5326,
            "CONTRACT_WAGE_PAYMENT_WEEKLY_LEGAL_WORKING_HOUR": 5327,
            "CONTRACT_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 5328,
            "CONTRACT_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 5329,
            "CONTRACT_WAGE_PAYMENT_LEAVE_DEDUCTION": 5330,
            "CONTRACT_WAGE_PAYMENT_PRESCRIBED_HOUR_SHORT_DEDUCTION": 5331,
            "CONTRACT_WAGE_DELETE": 5332,
            "CONTRACT_AMOUNT_OVER_SHORT_INVOICE_AMOUNT": 5333,
            "CONTRACT_AMOUNT_OVER_SHORT_INVOICE_TAXATION_TYPE_ID": 5334,
            "CONTRACT_AMOUNT_OVER_SHORT_PAYMENT_AMOUNT": 5335,
            "CONTRACT_AMOUNT_OVER_SHORT_PAYMENT_TAXATION_TYPE_ID": 5336,
            "CONTRACT_AMOUNT_OVER_SHORT_BASE_EMPLOYMENT_INSURANCE_BOOLEAN_DEFAULT_TYPE_ID": 5337,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_BOOLEAN_EXISTENCE_TYPE_ID": 5338,
            "DISPATCH_JOB_ROUDOUKYOKU_CATEGORY_ID": 5339,
            "CANDIDATE_JOB_STEP_RESOURCES_CANDIDATE_JOB_STEP_ID": 5340,
            "CANDIDATE_JOB_STEP_RESOURCES_DISPATCH_DESTINATION_ID": 5341,
            "DISPATCH_SOURCE_ID": 5348,
            "DISPATCH_SOURCE_DISPATCH_SOURCE_STATE_ID": 5349,
            "DISPATCH_SOURCE_NAME": 5350,
            "DISPATCH_SOURCE_ZIP": 5351,
            "DISPATCH_SOURCE_PREFECTURE_ID": 5352,
            "DISPATCH_SOURCE_ADDRESS": 5353,
            "DISPATCH_SOURCE_DELETED_AT": 5354,
            "DISPATCH_SOURCE_CREATED_AT": 5355,
            "DISPATCH_SOURCE_UPDATED_AT": 5356,
            "DISPATCH_SOURCE_CREATED_USER_ID": 5357,
            "DISPATCH_SOURCE_UPDATED_USER_ID": 5358,
            "DISPATCH_SOURCE_STAFF_ID": 5359,
            "DISPATCH_SOURCE_STAFF_DISPATCH_SOURCE_STAFF_STATE_ID": 5360,
            "DISPATCH_SOURCE_STAFF_DISPATCH_SOURCE_ID": 5361,
            "DISPATCH_SOURCE_STAFF_NAME": 5362,
            "DISPATCH_SOURCE_STAFF_CREATED_AT": 5363,
            "DISPATCH_SOURCE_STAFF_UPDATED_AT": 5364,
            "DISPATCH_SOURCE_STAFF_DELETED_AT": 5365,
            "DISPATCH_SOURCE_STAFF_CREATED_USER_ID": 5366,
            "DISPATCH_SOURCE_STAFF_UPDATED_USER_ID": 5367,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_ID": 5368,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_START_DATE": 5369,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_INTERVAL_NUMBER": 5370,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_INTERVAL_TYPE_ID": 5371,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_MONTHLY_TYPE_ID": 5372,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_END_DATE": 5373,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_MAX_REPEAT_TIMES": 5374,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DELETE": 5375,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_ID": 5376,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_DISPATCH_JOB_AMOUNT_OVER_SHORT_ID": 5377,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_MONDAY": 5378,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_TUESDAY": 5379,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_WEDNESDAY": 5380,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_THURSDAY": 5381,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_FRIDAY": 5382,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_SATURDAY": 5383,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_IS_SUNDAY": 5384,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAY_DELETE": 5385,
            "DISPATCH_JOB_DISPATCH_SOURCE_ID": 5386,
            "DISPATCH_JOB_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_ID": 5387,
            "DISPATCH_JOB_CLAIM_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_ID": 5388,
            "CONTRACT_DISPATCH_SOURCE_ID": 5389,
            "CONTRACT_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_ID": 5390,
            "CONTRACT_CLAIM_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_ID": 5391,
            "DISPATCH_WORKING_PLACE_NEAREST_STATION": 5392,
            "DISPATCH_WORKING_PLACE_TEL": 5393,
            "DISPATCH_WORKING_PLACE_MEMO": 5394,
            "CONTRACT_AMOUNT_OVER_SHORT_ID": 5395,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_START_DATE": 5396,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_INTERVAL_NUMBER": 5397,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_INTERVAL_TYPE_ID": 5398,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_MONTHLY_TYPE_ID": 5399,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_END_DATE": 5400,
            "CONTRACT_AMOUNT_OVER_SHORT_MAX_REPEAT_TIMES": 5401,
            "CONTRACT_AMOUNT_OVER_SHORT_DELETE": 5402,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_ID": 5403,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_MONDAY": 5404,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_TUESDAY": 5405,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_WEDNESDAY": 5406,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_THURSDAY": 5407,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_FRIDAY": 5408,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_SATURDAY": 5409,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_IS_SUNDAY": 5410,
            "CONTRACT_AMOUNT_OVER_SHORT_DAY_DELETE": 5411,
            "CONTRACT_TERM_LIMIT_TYPE_ID": 5413,
            "CONTRACT_NUMBER_OF_MONTHLY_DUE_DATE": 5414,
            "CONTRACT_NUMBER_OF_REGULAR_MONTHLY_DUE_DATE": 5415,
            "CONTRACT_ABSENTEE_NAME": 5416,
            "CONTRACT_ABSENTEE_WORK": 5417,
            "CONTRACT_ABSENT_START_DATE": 5418,
            "CONTRACT_ABSENT_END_DATE": 5419,
            "ACTUAL_AMOUNT_OVER_SHORT_ID": 5420,
            "ACTUAL_AMOUNT_OVER_SHORT_CONTRACT_ID": 5421,
            "ACTUAL_AMOUNT_OVER_SHORT_CONTRACT_AMOUNT_OVER_SHORT_ID": 5422,
            "ACTUAL_AMOUNT_OVER_SHORT_INVOICE_CLOSED_ATTENDANCE_ID": 5423,
            "ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_CLOSED_ATTENDANCE_ID": 5424,
            "ACTUAL_AMOUNT_OVER_SHORT_AMOUNT_OVER_SHORT_TYPE_ID": 5425,
            "ACTUAL_AMOUNT_OVER_SHORT_OCCURANCE_DATE": 5426,
            "ACTUAL_AMOUNT_OVER_SHORT_INVOICE_AMOUNT_OVER_SHORT_AMOUNT": 5427,
            "ACTUAL_AMOUNT_OVER_SHORT_INVOICE_TAXATION_TYPE_ID": 5428,
            "ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_AMOUNT_OVER_SHORT_AMOUNT": 5429,
            "ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_TAXATION_TYPE_ID": 5430,
            "ACTUAL_AMOUNT_OVER_SHORT_BASE_EMPLOYMENT_INSURANCE_BOOLEAN_DEFAULT_TYPE_ID": 5431,
            "ACTUAL_AMOUNT_OVER_SHORT_CREATED_AT": 5432,
            "ACTUAL_AMOUNT_OVER_SHORT_UPDATED_AT": 5433,
            "ACTUAL_AMOUNT_OVER_SHORT_CREATED_USER_ID": 5434,
            "ACTUAL_AMOUNT_OVER_SHORT_UPDATED_USER_ID": 5435,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_REPEAT_WEEK_DAYS": 5436,
            "CONTRACT_AMOUNT_OVER_SHORT_REPEAT_WEEK_DAYS": 5437,
            "DISPATCH_JOB_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_DELETE": 5438,
            "DISPATCH_JOB_CLAIM_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_DELETE": 5439,
            "CONTRACT_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_DELETE": 5440,
            "CONTRACT_CLAIM_REPRESENTATIVE_DISPATCH_SOURCE_STAFF_DELETE": 5441,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_AMOUNT_OVER_SHORT_TYPE_ID": 5442,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_NOREPEAT_DATE": 5443,
            "CONTRACT_AMOUNT_OVER_SHORT_AMOUNT_OVER_SHORT_TYPE_ID": 5444,
            "CONTRACT_AMOUNT_OVER_SHORT_NOREPEAT_DATE": 5445,
            "BILLING_DESTINATION_REFERENCED_INVOICE_FRACTION_PROCESS_ID": 5477,
            "BILLING_DESTINATION_REFERENCED_PAYMENT_FRACTION_PROCESS_ID": 5478,
            "DISPATCH_JOB_REFERENCED_AMOUNT_OVER_SHORT_ID": 5479,
            "DISPATCH_JOB_REFERENCED_WAGE_ID": 5480,
            "DISPATCH_JOB_REFERENCED_DISPATCH_WORKING_PLACE_ID": 5481,
            "CONTRACT_REFERENCED_AMOUNT_OVER_SHORT_ID": 5482,
            "CONTRACT_REFERENCED_WAGE_ID": 5483,
            "CONTRACT_REFERENCED_DISPATCH_WORKING_PLACE_ID": 5484,
            "CONTRACT_MEMO_ID": 5654,
            "CONTRACT_MEMO_CONTRACT_ID": 5655,
            "CONTRACT_MEMO_CONTRACT_MEMO_TYPE_ID": 5656,
            "CONTRACT_MEMO_MEMO_DATE": 5657,
            "CONTRACT_MEMO_MEMO": 5658,
            "CONTRACT_MEMO_CREATED_AT": 5659,
            "CONTRACT_MEMO_UPDATED_AT": 5660,
            "CONTRACT_MEMO_DELETED_AT": 5661,
            "CONTRACT_MEMO_CREATED_USER_ID": 5662,
            "CONTRACT_MEMO_UPDATED_USER_ID": 5663,
            "CANDIDATE_DISPATCH_BASIC_ID": 5664,
            "CANDIDATE_DISPATCH_BASIC_ENTRANCE_DATE": 5665,
            "CANDIDATE_DISPATCH_BASIC_RETIREMENT_DATE": 5666,
            "CANDIDATE_DISPATCH_BASIC_PAID_LEAVE_CONSUMED_DAYS": 5667,
            "CANDIDATE_DISPATCH_BASIC_PAID_LEAVE_REMAIN_DAYS": 5668,
            "CANDIDATE_DISPATCH_BASIC_PAYMENT_TIME_TYPE_ID": 5669,
            "CANDIDATE_DISPATCH_INSURANCE_ID": 5670,
            "CANDIDATE_DISPATCH_INSURANCE_RESIDENT_TAX_JUNE": 5671,
            "CANDIDATE_DISPATCH_INSURANCE_RESIDENT_TAX_JULY": 5672,
            "CANDIDATE_DISPATCH_INSURANCE_RESIDENT_TAX_AUGUST_MAY": 5673,
            "CANDIDATE_DISPATCH_INSURANCE_HAS_EMPLOYMENT_INSURANCE": 5674,
            "CANDIDATE_DISPATCH_INSURANCE_HAS_HEALTH_INSURANCE": 5675,
            "CANDIDATE_DISPATCH_INSURANCE_HAS_EMPLOYEE_PENSION": 5676,
            "CANDIDATE_DISPATCH_INSURANCE_HAS_NURSING_INSURANCE": 5677,
            "CANDIDATE_DISPATCH_INSURANCE_STANDARD_MONTHLY_SALARY": 5678,
            "CONTRACT_WAGE_INVOICE_STAFF_PAYMENT_SITE": 5679,
            "DISPATCH_JOB_CABINET_ORDER_INDUSTRY_TYPE_ID": 5680,
            "CONTRACT_MEMO_TYPE_CLAIM_DISPATCH_SOURCE": 5681,
            "CONTRACT_MEMO_TYPE_CLAIM_DISPATCH_DESTINATION": 5682,
            "CONTRACT_MEMO_TYPE_EDUCATION": 5683,
            "CONTRACT_MEMO_TYPE_CAREER_CONSULTING": 5684,
            "CONTRACT_MEMO_TYPE_EMPLOYMENT_STABILITY": 5685,
            "DISPATCH_JOB_PASSIVE_SMOKING_PREVENTION": 5724,
            "CS_MASTER_PROPERTY_COLUMNS_HEAD": 5686,
            "CS_MASTER_DISPATCH_SOURCE_STAFF_AFFILIATION": 5746,
            "CS_MASTER_DISPATCH_SOURCE_STAFF_POSITION": 5747,
            "CS_MASTER_DISPATCH_SOURCE_STAFF_TEL": 5748,
            "CS_MASTER_DISPATCH_SOURCE_STAFF_MOBILE": 5749,
            "CS_MASTER_DISPATCH_SOURCE_STAFF_MEMO": 5750,
            "CS_MASTER_CONTRACT_EMPLOYMENT_PERIOD": 5751,
            "CS_MASTER_CONTRACTS_EMPLOYMENT_PERIOD_TYPE_ID": 5761,
            "CS_MASTER_CONTRACTS_INDIVIDUAL_CONTRACT_DATE": 5767,
            "CS_MASTER_IS_DISPATCHED_WORKER_SUBJECT_TO_THE_AGREEMENT": 5774,
            "CS_MASTER_DISPATCH_JOB_WORKER_DISPATCH_INDIVIDUAL_CONTRACT_DETAIL_REMARKS": 5797,
            "CS_MASTER_DISPATCH_JOB_FULL_TIME_WORK": 5798,
            "CS_MASTER_BUSINESS_EXCEPTION_NUMBER": 5805,
            "CS_MASTER_DISPATCH_DESTINATION_RELEVANT_DISPATCH_DESTINATION": 5806,
            "CS_MASTER_BILLING_DESTINATION_PAYMENT_MONTH": 5807,
            "CS_MASTER_BILLING_DESTINATION_PAYMENT_DAY": 5808,
            "CS_MASTER_COMPANY_LIMIT_AGREEMENT_EMPLOYMENT_TYPE_ID": 5829,
            "CS_MASTER_DISPATCH_DESTINATION_LIMIT_AGREEMENT_EMPLOYMENT_TYPE_ID": 5830,
            "CS_MASTER_DISPATCH_JOB_LIMIT_AGREEMENT_EMPLOYMENT_TYPE_ID": 5831,
            "CS_MASTER_CONTRACTS_LIMIT_AGREEMENT_EMPLOYMENT_TYPE_ID": 5832,
            "CS_MASTER_CONTRACT_WORKER_DISPATCH_INDIVIDUAL_CONTRACT_DETAIL_REMARKS": 5834,
            "CS_MASTER_PROPERTY_COLUMNS_END": 6999,
            "DISPATCH_DESTINATION_TRAVEL_EXPENSE_ID": 7001,
            "DISPATCH_JOB_TRAVEL_EXPENSE_ID": 7002,
            "CONTRACT_TRAVEL_EXPENSE_ID": 7003,
            "CONTRACT_CALCULATED_CONFLICT_DATE": 7004,
            "DISPATCH_WORKING_PLACE_DEPARTMENT_NAME": 7005,
            "DISPATCH_WORKING_PLACE_ZIP": 7006,
            "DISPATCH_WORKING_PLACE_PREFECTURE_ID": 7007,
            "DISPATCH_WORKING_PLACE_ADDRESS": 7008,
            "DISPATCH_JOB_WORKING_PLACE_DEPARTMENT_NAME": 7009,
            "DISPATCH_JOB_WORKING_PLACE_ZIP": 7010,
            "DISPATCH_JOB_WORKING_PLACE_PREFECTURE_ID": 7011,
            "DISPATCH_JOB_WORKING_PLACE_ADDRESS": 7012,
            "CONTRACT_WORKING_PLACE_DEPARTMENT_NAME": 7013,
            "CONTRACT_WORKING_PLACE_ZIP": 7014,
            "CONTRACT_WORKING_PLACE_PREFECTURE_ID": 7015,
            "CONTRACT_WORKING_PLACE_ADDRESS": 7016,
            "CONFLICT_DATE_MANAGEMENT_ID": 7017,
            "CONFLICT_DATE_MANAGEMENT_CONTRACT_ID": 7018,
            "CONFLICT_DATE_MANAGEMENT_CANDIDATE_ID": 7019,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_DESTINATION_ID": 7020,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_ORGANIZATION_UNIT_ID": 7021,
            "CONFLICT_DATE_MANAGEMENT_CREATED_AT": 7022,
            "CONFLICT_DATE_MANAGEMENT_UPDATED_AT": 7023,
            "CONFLICT_DATE_MANAGEMENT_CREATED_USER_ID": 7024,
            "CONFLICT_DATE_MANAGEMENT_UPDATED_USER_ID": 7025,
            "DISPATCH_DESTINATION_CONFLICT_DATE": 7026,
            "CANDIDATE_DISPATCH_BASIC_EMPLOYMENT_PERIOD_START_DATE": 7027,
            "CANDIDATE_DISPATCH_BASIC_EMPLOYMENT_PERIOD_END_DATE": 7028,
            "CANDIDATE_DISPATCH_BASIC_EMPLOYMENT_PERIOD_TYPE_ID": 7029,
            "CANDIDATE_DISPATCH_BASIC_AGREEMENT_EMPLOYMENT_TYPE_ID": 7030,
            "CANDIDATE_DISPATCH_BASIC_BUSINESS_FORM_EXPIRE_DATE": 7031,
            "CANDIDATE_DISPATCH_INSURANCE_EMPLOYMENT_INSURANCE_REASON": 7032,
            "CANDIDATE_DISPATCH_INSURANCE_HEALTH_INSURANCE_REASON": 7033,
            "CANDIDATE_DISPATCH_INSURANCE_EMPLOYEE_PENSION_REASON": 7034,
            "CANDIDATE_DISPATCH_INSURANCE_NURSING_INSURANCE_REASON": 7035,
            "DISPATCH_JOB_DISPATCH_JOB_TYPE_ID": 7036,
            "CANDIDATE_JOB_STEP_DUE_DATE": 7037,
            "CONTRACT_DUE_DATE": 7038,
            "DISPATCH_SPOT_JOB_SPOT_DUE_DATE": 7039,
            "DISPATCH_JOB_STAFF_MULTI_ASSIGNMENT_DISPATCH_STAFF_ID": 7040,
            "CONTRACT_STAFF_MULTI_ASSIGNMENT_DISPATCH_STAFF_ID": 7041,
            "DISPATCH_JOB_SOURCE_STAFF_MULTI_ASSIGNMENT_DISPATCH_SOURCE_STAFF_ID": 7042,
            "CONTRACT_SOURCE_STAFF_MULTI_ASSIGNMENT_DISPATCH_SOURCE_STAFF_ID": 7043,
            "CONTRACT_REFERENCE_DISPATCH_DESTINATION_CONFLICT_DATE": 7044,
            "CONTRACT_REFERENCE_CANDIDATE_CONFLICT_DATE": 7045,
            "CONTRACT_CANDIDATE_CONFLICT_DATE": 7046,
            "TRAVEL_EXPENSE_ID": 7047,
            "TRAVEL_EXPENSE_NAME": 7048,
            "TRAVEL_EXPENSE_COMPANY_ID": 7049,
            "TRAVEL_EXPENSE_DISPATCH_DESTINATION_ID": 7050,
            "TRAVEL_EXPENSE_INVOICE_EXPENSE_PROVISION_TYPE_ID": 7051,
            "TRAVEL_EXPENSE_INVOICE_OR_LIMIT": 7052,
            "TRAVEL_EXPENSE_PAYMENT_EXPENSE_PROVISION_TYPE_ID": 7053,
            "TRAVEL_EXPENSE_PAYMENT_OR_LIMIT": 7054,
            "FRACTION_PROCESS_ID": 7055,
            "FRACTION_PROCESS_NAME": 7056,
            "FRACTION_PROCESS_COMPANY_ID": 7057,
            "FRACTION_PROCESS_CALC_TIME_UNIT": 7058,
            "FRACTION_PROCESS_TIME_ROUNDING_TYPE_ID": 7059,
            "FRACTION_PROCESS_LESS_YEN_ROUNDING_TYPE_ID": 7060,
            "FRACTION_PROCESS_TAX_ROUNDING_TYPE_ID": 7061,
            "AMOUNT_OVER_SHORT_ID": 7062,
            "AMOUNT_OVER_SHORT_NAME": 7063,
            "AMOUNT_OVER_SHORT_COMPANY_ID": 7064,
            "AMOUNT_OVER_SHORT_DISPATCH_DESTINATION_ID": 7065,
            "AMOUNT_OVER_SHORT_AMOUNT_OVER_SHORT_TYPE_ID": 7066,
            "AMOUNT_OVER_SHORT_INVOICE_AMOUNT": 7067,
            "AMOUNT_OVER_SHORT_INVOICE_TAXATION_TYPE_ID": 7068,
            "AMOUNT_OVER_SHORT_PAYMENT_AMOUNT": 7069,
            "AMOUNT_OVER_SHORT_PAYMENT_TAXATION_TYPE_ID": 7070,
            "AMOUNT_OVER_SHORT_BASE_EMPLOYMENT_INSURANCE_BOOLEAN_DEFAULT_TYPE_ID": 7071,
            "WAGE_ID": 7072,
            "WAGE_NAME": 7073,
            "WAGE_COMPANY_ID": 7074,
            "WAGE_DISPATCH_DESTINATION_ID": 7075,
            "WAGE_WORKING_DAYS": 7076,
            "WAGE_PRESCRIBED_WORKING_HOURS": 7077,
            "WAGE_INVOICE_WAGE_TYPE_ID": 7078,
            "WAGE_INVOICE_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 7079,
            "WAGE_INVOICE_BASIC_UNIT_WAGE": 7080,
            "WAGE_INVOICE_LEGAL_OVER_TIME_UNIT_WAGE": 7081,
            "WAGE_INVOICE_NON_LEGAL_OVER_TIME_UNIT_WAGE": 7082,
            "WAGE_INVOICE_LEGAL_HOLIDAY_UNIT_WAGE": 7083,
            "WAGE_INVOICE_PRESCRIBED_HOLIDAY_UNIT_WAGE": 7084,
            "WAGE_INVOICE_NIGHT_EXTRA_UNIT_WAGE": 7085,
            "WAGE_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 7086,
            "WAGE_INVOICE_WEEKLY_LEGAL_WORKING_HOUR": 7087,
            "WAGE_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 7088,
            "WAGE_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 7089,
            "WAGE_INVOICE_LEAVE_DEDUCTION": 7090,
            "WAGE_INVOICE_PRESCRIBED_HOUR_SHORT_DEDUCTION": 7091,
            "WAGE_PAYMENT_WAGE_TYPE_ID": 7092,
            "WAGE_PAYMENT_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 7093,
            "WAGE_PAYMENT_BASIC_UNIT_WAGE": 7094,
            "WAGE_PAYMENT_LEGAL_OVER_TIME_UNIT_WAGE": 7095,
            "WAGE_PAYMENT_NON_LEGAL_OVER_TIME_UNIT_WAGE": 7096,
            "WAGE_PAYMENT_LEGAL_HOLIDAY_UNIT_WAGE": 7097,
            "WAGE_PAYMENT_PRESCRIBED_HOLIDAY_UNIT_WAGE": 7098,
            "WAGE_PAYMENT_NIGHT_EXTRA_UNIT_WAGE": 7099,
            "WAGE_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 7100,
            "WAGE_PAYMENT_WEEKLY_LEGAL_WORKING_HOUR": 7101,
            "WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 7102,
            "WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 7103,
            "WAGE_PAYMENT_LEAVE_DEDUCTION": 7104,
            "WAGE_PAYMENT_PRESCRIBED_HOUR_SHORT_DEDUCTION": 7105,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_START_DATE": 7106,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_END_DATE": 7107,
            "CONFLICT_DATE_MANAGEMENT_CONFLICT_DATE": 7108,
            "CONFLICT_DATE_MANAGEMENT_DELETED_AT": 7109,
            "CONTRACT_CONTRACTED_CONFLICT_DATE": 7110,
            "CONTRACT_CONTRACTED_DISPATCH_DESTINATION_CONFLICT_DATE": 7111,
            "ALERT_ID": 7112,
            "ALERT_SERVER_ALERT_ID": 7113,
            "ALERT_ALERT_SETTING_ID": 7114,
            "ALERT_RESOURCE_TYPE": 7115,
            "ALERT_RESOURCE_ID": 7116,
            "ALERT_SLICE_ID": 7117,
            "ALERT_DISPLAY_NAME": 7118,
            "ALERT_MESSAGE": 7119,
            "ALERT_USER_ID": 7120,
            "ALERT_CREATED_AT": 7121,
            "ALERT_UPDATED_AT": 7122,
            "ALERT_DELETED_AT": 7123,
            "ALERT_NOTIFICATION_ID": 7124,
            "ALERT_NOTIFICATION_ALERT_ID": 7125,
            "ALERT_NOTIFICATION_USER_ID": 7126,
            "ALERT_NOTIFICATION_READ_AT": 7127,
            "ALERT_NOTIFICATION_CREATED_AT": 7128,
            "ALERT_NOTIFICATION_UPDATED_AT": 7129,
            "ALERT_NOTIFICATION_DELETED_AT": 7130,
            "ALERT_NOTIFICATION_DELETE": 7131,
            "CONFLICT_DATE_DEFAULT_ID": 7132,
            "CONFLICT_DATE_DEFAULT_CANDIDATE_ID": 7133,
            "CONFLICT_DATE_DEFAULT_DISPATCH_ORGANIZATION_UNIT_ID": 7134,
            "CONFLICT_DATE_DEFAULT_CONFLICT_DATE": 7135,
            "CONFLICT_DATE_DEFAULT_MEMO": 7136,
            "CONFLICT_DATE_DEFAULT_CREATED_USER_ID": 7137,
            "CONFLICT_DATE_DEFAULT_UPDATED_USER_ID": 7138,
            "CONFLICT_DATE_DEFAULT_CREATED_AT": 7139,
            "CONFLICT_DATE_DEFAULT_UPDATED_AT": 7140,
            "CONFLICT_DATE_DEFAULT_DELETED_AT": 7141,
            "CONTRACT_NOT_LIMITED_AS_CONFLICT_DATE_REASON": 7143,
            "COMPANY_WORKER_DISPATCH_INDIVIDUAL_CONTRACT_MEMO": 7145,
            "COMPANY_DISPATCH_DESTINATION_MANAGEMENT_LEDGER_MEMO": 7146,
            "DISPATCH_DESTINATION_WORKER_DISPATCH_INDIVIDUAL_CONTRACT_MEMO": 7147,
            "DISPATCH_DESTINATION_DISPATCH_DESTINATION_MANAGEMENT_LEDGER_MEMO": 7148,
            "CANDIDATE_NOTIFICATION_OF_WORKING_CONDITIONS_AND_CLARIFICATION_OF_WORKING_CONDITIONS_MEMO": 7149,
            "DISPATCH_JOB_WORKER_DISPATCH_INDIVIDUAL_CONTRACT_MEMO": 7150,
            "CANDIDATE_DISPATCH_MANAGEMENT_LEDGER_MEMO": 7151,
            "DISPATCH_JOB_DISPATCH_DESTINATION_MANAGEMENT_LEDGER_MEMO": 7152,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_ID": 7153,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_CANDIDATE_ID": 7154,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_DISPATCH_ORGANIZATION_UNIT_ID": 7155,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_CONFLICT_DATE": 7156,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_MEMO": 7157,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_CREATED_USER_ID": 7158,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_UPDATED_USER_ID": 7159,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_CREATED_AT": 7160,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_UPDATED_AT": 7161,
            "CANDIDATE_CONFLICT_DATE_DEFAULT_DELETED_AT": 7162,
            "CONTRACT_NOTIFICATION_OF_WORKING_CONDITIONS_AND_CLARIFICATION_OF_WORKING_CONDITIONS_MEMO": 7164,
            "CONTRACT_WORKER_DISPATCH_INDIVIDUAL_CONTRACT_MEMO": 7165,
            "CONTRACT_DISPATCH_MANAGEMENT_LEDGER_MEMO": 7166,
            "CONTRACT_DISPATCH_DESTINATION_MANAGEMENT_LEDGER_MEMO": 7167,
            "CONTRACT_MEMO_TYPE_EDUCATION_FROM_DISPATCH_DESTINATION": 7168,
            "CANDIDATE_DISPATCH_BASIC_SPOT_PROHIBITION_EXCEPTION_TYPE_ID": 7169,
            "CANDIDATE_DISPATCH_BASIC_TAX_TABLE_SECTION_TYPE_ID": 7170,
            "DISPATCH_STAFF_DELETED_AT": 7171,
            "DISPATCH_WORKING_PLACE_DELETED_AT": 7172,
            "DISPATCH_ORGANIZATION_UNIT_DELETED_AT": 7173,
            "CANDIDATE_STATE_UPDATED_AT": 7174,
            "COMPANY_STATE_UPDATED_AT": 7175,
            "BILLING_DESTINATION_STATE_UPDATED_AT": 7176,
            "STAFF_STATE_UPDATED_AT": 7177,
            "DISPATCH_DESTINATION_STATE_UPDATED_AT": 7178,
            "DISPATCH_STAFF_STATE_UPDATED_AT": 7179,
            "DISPATCH_WORKING_PLACE_STATE_UPDATED_AT": 7180,
            "DISPATCH_ORGANIZATION_UNIT_STATE_UPDATED_AT": 7181,
            "JOB_STATE_UPDATED_AT": 7182,
            "DISPATCH_JOB_STATE_UPDATED_AT": 7183,
            "CONTRACT_STATE_UPDATED_AT": 7184,
            "SALE_STATE_UPDATED_AT": 7185,
            "DISPATCH_SOURCE_STATE_UPDATED_AT": 7186,
            "DISPATCH_SOURCE_STAFF_STATE_UPDATED_AT": 7187,
            "CANDIDATE_USER_DEPARTMENT_ID": 7188,
            "COMPANY_USER_DEPARTMENT_ID": 7189,
            "JOB_USER_DEPARTMENT_ID": 7190,
            "DISPATCH_JOB_USER_DEPARTMENT_ID": 7191,
            "DISPATCH_SOURCE_REPORT_SETTING_ID": 7192,
            "DISPATCH_SOURCE_REPORT_SETTING_DISPATCH_SOURCE_ID": 7193,
            "DISPATCH_SOURCE_REPORT_SETTING_COMPANY_SCALE_TYPE_ID": 7194,
            "DISPATCH_SOURCE_REPORT_SETTING_INDUSTRY_CLASSIFICATION_NAME": 7195,
            "DISPATCH_SOURCE_REPORT_SETTING_INDUSTRY_CLASSIFICATION_NUMBER": 7196,
            "DISPATCH_SOURCE_REPORT_SETTING_SECOND_BUSINESS_EMPLOYMENT_AGENCIES": 7197,
            "DISPATCH_SOURCE_REPORT_SETTING_EMPLOYMENT_AGENCIES_LICENSE_CODE": 7198,
            "DISPATCH_SOURCE_REPORT_SETTING_PARENT_COMPANY_NAME": 7199,
            "DISPATCH_SOURCE_REPORT_SETTING_PARENT_COMPANY_NOTE": 7200,
            "DISPATCH_SOURCE_REPORT_SETTING_PARENT_DISPATCH_BUSINESS_LICENSE_CODE": 7201,
            "DISPATCH_SOURCE_REPORT_SETTING_PARENT_EMPLOYMENT_AGENCIES_LICENSE_CODE": 7202,
            "DISPATCH_SOURCE_REPORT_SETTING_EXECUTION_CONTRACT_WORK": 7203,
            "DISPATCH_SOURCE_REPORT_SETTING_EXECUTION_PIECEWORK_CONTRACT": 7204,
            "DISPATCH_SOURCE_REPORT_SETTING_NOTE": 7205,
            "DISPATCH_SOURCE_REPORT_SETTING_ATTACH_LABOR_AGREEMENT": 7206,
            "DISPATCH_SOURCE_REPORT_SETTING_MARGIN_RATIO_PUBLICATION_ON_THE_NET": 7207,
            "DISPATCH_SOURCE_REPORT_SETTING_MARGIN_RATIO_PUBLICATION_ON_THE_DOCUMENT": 7208,
            "DISPATCH_SOURCE_REPORT_SETTING_MARGIN_RATIO_PUBLICATION_ON_THE_OTHER_WAY": 7209,
            "DISPATCH_SOURCE_REPORT_SETTING_DETAIL_MARGIN_RATIO_PUBLICATION": 7210,
            "DISPATCH_SOURCE_REPORT_SETTING_USE_CONSOLIDATED_BALANCE_SHEET": 7211,
            "DISPATCH_SOURCE_REPORT_SETTING_CONSOLIDATED_BALANCE_SHEET_NOTE": 7212,
            "DISPATCH_SOURCE_REPORT_SETTING_GROUP_COMPANY_NAMES": 7213,
            "DISPATCH_SOURCE_REPORT_SETTING_CREATED_AT": 7214,
            "DISPATCH_SOURCE_REPORT_SETTING_UPDATED_AT": 7215,
            "DISPATCH_SOURCE_CAREER_STAFF_ID": 7216,
            "DISPATCH_SOURCE_CAREER_STAFF_DISPATCH_SOURCE_ID": 7217,
            "DISPATCH_SOURCE_CAREER_STAFF_STATE_ID": 7218,
            "DISPATCH_SOURCE_CAREER_STAFF_NAME": 7219,
            "DISPATCH_SOURCE_CAREER_STAFF_JOB_CLASSIFICATION_TYPE_ID": 7220,
            "DISPATCH_SOURCE_CAREER_STAFF_INTERNAL_EXTERNAL_TYPE_ID": 7221,
            "DISPATCH_SOURCE_CAREER_STAFF_CONCURRENTLY_DISPATCH_STAFF": 7222,
            "DISPATCH_SOURCE_CAREER_STAFF_HAS_WORK_EXPERIENCE": 7223,
            "DISPATCH_SOURCE_CAREER_STAFF_HAS_KNOWLEDGE": 7224,
            "DISPATCH_SOURCE_CAREER_STAFF_ASSIGNMENT_DATE": 7225,
            "DISPATCH_SOURCE_CAREER_STAFF_RETIREMENT_DATE": 7226,
            "DISPATCH_SOURCE_CAREER_STAFF_DELETED_AT": 7227,
            "DISPATCH_SOURCE_CAREER_STAFF_CREATED_AT": 7228,
            "DISPATCH_SOURCE_CAREER_STAFF_UPDATED_AT": 7229,
            "DISPATCH_SOURCE_CAREER_STAFF_CREATED_USER_ID": 7230,
            "DISPATCH_SOURCE_CAREER_STAFF_UPDATED_USER_ID": 7231,
            "DISPATCH_SOURCE_CAREER_STAFF_STATE_UPDATED_AT": 7232,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_ID": 7233,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_DISPATCH_SOURCE_ID": 7234,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TYPE": 7235,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TITLE": 7236,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_STATE_ID": 7237,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_EDUCATION_TRAINING_CLASSIFICATION_TYPE_ID": 7238,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TARGET_WORKERS_CLASSIFICATION_1_TYPE_ID": 7239,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TARGET_WORKERS_CLASSIFICATION_2_TYPE_ID": 7240,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TRAINING_METHOD_TYPE_ID": 7241,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TRAINING_ENTITY_TYPE_ID": 7242,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_BEAR_TRAINING_COST_TYPE_ID": 7243,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_WAGE_PAYMENT_TRAINING_TYPE_ID": 7244,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_TIME_PER_SESSION": 7245,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_NOTE": 7246,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_DELETED_AT": 7247,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_CREATED_AT": 7248,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_UPDATED_AT": 7249,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_CREATED_USER_ID": 7250,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_UPDATED_USER_ID": 7251,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_STATE_UPDATED_AT": 7252,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_ID": 7253,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_DISPATCH_SOURCE_ID": 7254,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_TYPE": 7255,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_TITLE": 7256,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_STATE_ID": 7257,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_EDUCATION_ENTITY_TYPE_ID": 7258,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_TIME_PER_SESSION": 7259,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_1_TYPE_ID": 7260,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_2_TYPE_ID": 7261,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_EDUCATION_METHOD_TYPE_ID": 7262,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_NOTE": 7263,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_DELETED_AT": 7264,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_CREATED_AT": 7265,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_UPDATED_AT": 7266,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_CREATED_USER_ID": 7267,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_UPDATED_USER_ID": 7268,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_STATE_UPDATED_AT": 7269,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_ID": 7270,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_DISPATCH_SOURCE_ID": 7271,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_TYPE": 7272,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_TITLE": 7273,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_STATE_ID": 7274,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_EDUCATION_ENTITY_TYPE_ID": 7275,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_BEAR_TRAINING_COST_TYPE_ID": 7276,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_WAGE_PAYMENT_TRAINING_TYPE_ID": 7277,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_TIME_PER_SESSION": 7278,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_OTHER_TRAINING_METHOD_TYPE_ID": 7279,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_NOTE": 7280,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_DELETED_AT": 7281,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_CREATED_AT": 7282,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_UPDATED_AT": 7283,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_CREATED_USER_ID": 7284,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_UPDATED_USER_ID": 7285,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_STATE_UPDATED_AT": 7286,
            "DISPATCH_SOURCE_REPORT_SETTING_NUMBER_OF_EMPLOYEES_TYPE": 7287,
            "DISPATCH_SOURCE_REPORT_SETTING_NUMBER_OF_BUSINESSES_TYPE": 7288,
            "CANDIDATE_CAREER_COUNSELLING_ID": 7289,
            "CANDIDATE_CAREER_COUNSELLING_CANDIDATE_ID": 7290,
            "CANDIDATE_CAREER_COUNSELLING_DISPATCH_SOURCE_CAREER_STAFF_ID": 7291,
            "CANDIDATE_CAREER_COUNSELLING_COUNSELLING_DATETIME": 7292,
            "CANDIDATE_CAREER_COUNSELLING_COUNSELLING_DETAIL": 7293,
            "CANDIDATE_CAREER_COUNSELLING_DELETED_AT": 7294,
            "CANDIDATE_CAREER_COUNSELLING_CREATED_USER_ID": 7295,
            "CANDIDATE_CAREER_COUNSELLING_UPDATED_USER_ID": 7296,
            "CANDIDATE_CAREER_COUNSELLING_CREATED_AT": 7297,
            "CANDIDATE_CAREER_COUNSELLING_UPDATED_AT": 7298,
            "CANDIDATE_EDUCATION_AND_TRAINING_ID": 7299,
            "CANDIDATE_EDUCATION_AND_TRAINING_CANDIDATE_ID": 7300,
            "CANDIDATE_EDUCATION_AND_TRAINING_CONTRACT_ID": 7301,
            "CANDIDATE_EDUCATION_AND_TRAINING_PROPERTY_TABLE_ID": 7302,
            "CANDIDATE_EDUCATION_AND_TRAINING_EDUCATION_TRAINING_ID": 7303,
            "CANDIDATE_EDUCATION_AND_TRAINING_TRAINING_ENTITY_TYPE_ID": 7304,
            "CANDIDATE_EDUCATION_AND_TRAINING_USER_ID": 7305,
            "CANDIDATE_EDUCATION_AND_TRAINING_TRAINING_DATETIME": 7306,
            "CANDIDATE_EDUCATION_AND_TRAINING_WAGES": 7307,
            "CANDIDATE_EDUCATION_AND_TRAINING_TRAINING_DETAIL": 7308,
            "CANDIDATE_EDUCATION_AND_TRAINING_DELETED_AT": 7309,
            "CANDIDATE_EDUCATION_AND_TRAINING_CREATED_USER_ID": 7310,
            "CANDIDATE_EDUCATION_AND_TRAINING_UPDATED_USER_ID": 7311,
            "CANDIDATE_EDUCATION_AND_TRAINING_CREATED_AT": 7312,
            "CANDIDATE_EDUCATION_AND_TRAINING_UPDATED_AT": 7313,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_ID": 7314,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_CANDIDATE_ID": 7315,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_CONTRACT_ID": 7316,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_USER_ID": 7317,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_HOPE_HEARING_DATETIME": 7318,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_HOPE_CLASSIFICATION_TYPE_ID": 7319,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_HOPE_DETAIL": 7320,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_PERFORMED_DATETIME": 7321,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_PERFORMED_CLASSIFICATION_TYPE_ID": 7322,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_PERFORMED_DETAIL": 7323,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_DELETED_AT": 7324,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_CREATED_USER_ID": 7325,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_UPDATED_USER_ID": 7326,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_CREATED_AT": 7327,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_UPDATED_AT": 7328,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_ID": 7329,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_CANDIDATE_ID": 7330,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_STATE_OF_PROGRESS_TYPE_ID": 7331,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_DATETIME": 7332,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_MEMO": 7333,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_DELETED_AT": 7334,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_CREATED_USER_ID": 7335,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_UPDATED_USER_ID": 7336,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_CREATED_AT": 7337,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_UPDATED_AT": 7338,
            "CANDIDATE_EDUCATION_AND_TRAINING_EDUCATION_TRAINING_TITLE": 7339,
            "CANDIDATE_DISPATCH_BASIC_DISPATCH_SOURCE_ID": 7340,
            "CANDIDATE_JOB_STEP_RESOURCES_MANAGE_INFORMATION_REPORT_MEMO": 7342,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_RESULT_DATETIME": 7346,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_RESULT_CLASSIFICATION_TYPE_ID": 7347,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_RESULT_DETAIL": 7348,
            "CANDIDATE_DISPATCH_BASIC_CONTINUE_WORKING_TYPE_ID": 7343,
            "CANDIDATE_DISPATCH_BASIC_WISH_CAREER_COUNSELLING_TYPE_ID": 7344,
            "DISPATCH_JOB_IS_SPECIFIC_MANUFACTURING_OPERATION_TYPE_ID": 7345,
            "INVOICE_CLOSED_ATTENDANCE_ID": 15446,
            "INVOICE_CLOSED_ATTENDANCE_INVOICE_CLOSED_INVOICE_ID": 15447,
            "INVOICE_CLOSED_ATTENDANCE_INVOICE_CLOSED_ATTENDANCE_STATE_ID": 15448,
            "INVOICE_CLOSED_ATTENDANCE_WORKING_HOURS": 15449,
            "INVOICE_CLOSED_ATTENDANCE_WORKING_HOUR_AMOUNT": 15450,
            "INVOICE_CLOSED_ATTENDANCE_BASIC_TIME": 15451,
            "INVOICE_CLOSED_ATTENDANCE_BASIC_AMOUNT": 15452,
            "INVOICE_CLOSED_ATTENDANCE_LEGAL_OVER_TIME": 15453,
            "INVOICE_CLOSED_ATTENDANCE_LEGAL_OVER_TIME_AMOUNT": 15454,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME": 15455,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_AMOUNT": 15456,
            "INVOICE_CLOSED_ATTENDANCE_NIGHT_EXTRA_TIME": 15457,
            "INVOICE_CLOSED_ATTENDANCE_NIGHT_EXTRA_AMOUNT": 15458,
            "INVOICE_CLOSED_ATTENDANCE_OVER_WEEKLY_LEGAL_WORKING_HOUR": 15459,
            "INVOICE_CLOSED_ATTENDANCE_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 15460,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 15461,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 15462,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 15463,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 15464,
            "INVOICE_CLOSED_ATTENDANCE_LEAVE_DEDUCTION_TIME": 15465,
            "INVOICE_CLOSED_ATTENDANCE_LEAVE_DEDUCTION_AMOUNT": 15466,
            "INVOICE_CLOSED_ATTENDANCE_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 15467,
            "INVOICE_CLOSED_ATTENDANCE_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 15468,
            "INVOICE_CLOSED_ATTENDANCE_TRANSPORTATION_FEE": 15469,
            "INVOICE_CLOSED_ATTENDANCE_ADVANCE_PAYMENT_AMOUNT_WITH_TAX": 15470,
            "INVOICE_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX": 15471,
            "INVOICE_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX": 15472,
            "INVOICE_CLOSED_ATTENDANCE_CREATED_AT": 15473,
            "INVOICE_CLOSED_ATTENDANCE_UPDATED_AT": 15474,
            "INVOICE_CLOSED_ATTENDANCE_CREATED_USER_ID": 15475,
            "INVOICE_CLOSED_ATTENDANCE_UPDATED_USER_ID": 15476,
            "INVOICE_CLOSED_ATTENDANCE_DELETE": 15477,
            "PAYMENT_CLOSED_ATTENDANCE_ID": 15478,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_CLOSED_PAYMENT_ID": 15479,
            "PAYMENT_CLOSED_ATTENDANCE_NUMBER_OF_WORKING_DAYS": 15480,
            "PAYMENT_CLOSED_ATTENDANCE_NUMBER_OF_PAID_LEAVES": 15481,
            "PAYMENT_CLOSED_ATTENDANCE_NUMBER_OF_LEGAL_HOLIDAYS": 15482,
            "PAYMENT_CLOSED_ATTENDANCE_NUMBER_OF_PRESCRIBED_HOLIDAYS": 15483,
            "PAYMENT_CLOSED_ATTENDANCE_NUMBER_OF_NO_WORKING_DAYS": 15484,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_CLOSED_ATTENDANCE_STATE_ID": 15485,
            "PAYMENT_CLOSED_ATTENDANCE_WORKING_HOURS": 15486,
            "PAYMENT_CLOSED_ATTENDANCE_WORKING_HOUR_AMOUNT": 15487,
            "PAYMENT_CLOSED_ATTENDANCE_BASIC_TIME": 15488,
            "PAYMENT_CLOSED_ATTENDANCE_BASIC_AMOUNT": 15489,
            "PAYMENT_CLOSED_ATTENDANCE_LEGAL_OVER_TIME": 15490,
            "PAYMENT_CLOSED_ATTENDANCE_LEGAL_OVER_TIME_AMOUNT": 15491,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME": 15492,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_AMOUNT": 15493,
            "PAYMENT_CLOSED_ATTENDANCE_NIGHT_EXTRA_TIME": 15494,
            "PAYMENT_CLOSED_ATTENDANCE_NIGHT_EXTRA_AMOUNT": 15495,
            "PAYMENT_CLOSED_ATTENDANCE_OVER_WEEKLY_LEGAL_WORKING_HOUR": 15496,
            "PAYMENT_CLOSED_ATTENDANCE_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 15497,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 15498,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 15499,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 15500,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 15501,
            "PAYMENT_CLOSED_ATTENDANCE_LEAVE_DEDUCTION_TIME": 15502,
            "PAYMENT_CLOSED_ATTENDANCE_LEAVE_DEDUCTION_AMOUNT": 15503,
            "PAYMENT_CLOSED_ATTENDANCE_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 15504,
            "PAYMENT_CLOSED_ATTENDANCE_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 15505,
            "PAYMENT_CLOSED_ATTENDANCE_TRANSPORTATION_FEE": 15506,
            "PAYMENT_CLOSED_ATTENDANCE_ADVANCE_PAYMENT_AMOUNT_WITH_TAX": 15507,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX": 15508,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX": 15509,
            "PAYMENT_CLOSED_ATTENDANCE_CREATED_AT": 15510,
            "PAYMENT_CLOSED_ATTENDANCE_UPDATED_AT": 15511,
            "PAYMENT_CLOSED_ATTENDANCE_CREATED_USER_ID": 15512,
            "PAYMENT_CLOSED_ATTENDANCE_UPDATED_USER_ID": 15513,
            "PAYMENT_CLOSED_ATTENDANCE_DELETE": 15514,
            "INVOICE_CLOSED_INVOICE_ID": 15515,
            "INVOICE_CLOSED_INVOICE_INVOICE_DATE": 15516,
            "INVOICE_CLOSED_INVOICE_PAYMENT_LIMIT_DATE": 15517,
            "INVOICE_CLOSED_INVOICE_INVOICE_CLOSED_INVOICE_STATE_ID": 15518,
            "INVOICE_CLOSED_INVOICE_WORKING_HOURS": 15519,
            "INVOICE_CLOSED_INVOICE_WORKING_HOUR_AMOUNT": 15520,
            "INVOICE_CLOSED_INVOICE_BASIC_TIME": 15521,
            "INVOICE_CLOSED_INVOICE_BASIC_AMOUNT": 15522,
            "INVOICE_CLOSED_INVOICE_LEGAL_OVER_TIME": 15523,
            "INVOICE_CLOSED_INVOICE_LEGAL_OVER_TIME_AMOUNT": 15524,
            "INVOICE_CLOSED_INVOICE_NON_LEGAL_OVER_TIME": 15525,
            "INVOICE_CLOSED_INVOICE_NON_LEGAL_OVER_TIME_AMOUNT": 15526,
            "INVOICE_CLOSED_INVOICE_NIGHT_EXTRA_TIME": 15527,
            "INVOICE_CLOSED_INVOICE_NIGHT_EXTRA_AMOUNT": 15528,
            "INVOICE_CLOSED_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR": 15529,
            "INVOICE_CLOSED_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 15530,
            "INVOICE_CLOSED_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 15531,
            "INVOICE_CLOSED_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 15532,
            "INVOICE_CLOSED_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 15533,
            "INVOICE_CLOSED_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 15534,
            "INVOICE_CLOSED_INVOICE_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 15535,
            "INVOICE_CLOSED_INVOICE_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 15536,
            "INVOICE_CLOSED_INVOICE_TRANSPORTATION_FEE": 15537,
            "INVOICE_CLOSED_INVOICE_ADVANCE_PAYMENT_AMOUNT_WITH_TAX": 15538,
            "INVOICE_CLOSED_INVOICE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX": 15539,
            "INVOICE_CLOSED_INVOICE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX": 15540,
            "INVOICE_CLOSED_INVOICE_INVOICE_CALCULATED_DATE": 15541,
            "INVOICE_CLOSED_INVOICE_CREATED_AT": 15542,
            "INVOICE_CLOSED_INVOICE_UPDATED_AT": 15543,
            "INVOICE_CLOSED_INVOICE_DELETED_AT": 15544,
            "INVOICE_CLOSED_INVOICE_CREATED_USER_ID": 15545,
            "INVOICE_CLOSED_INVOICE_UPDATED_USER_ID": 15546,
            "INVOICE_CLOSED_INVOICE_DELETE": 15547,
            "PAYMENT_CLOSED_PAYMENT_ID": 15585,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_SCHEDULE_DATE": 15586,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_DATE": 15587,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_CLOSED_PAYMENT_STATE_ID": 15588,
            "PAYMENT_CLOSED_PAYMENT_WORKING_HOURS": 15589,
            "PAYMENT_CLOSED_PAYMENT_WORKING_HOUR_AMOUNT": 15590,
            "PAYMENT_CLOSED_PAYMENT_BASIC_TIME": 15591,
            "PAYMENT_CLOSED_PAYMENT_BASIC_AMOUNT": 15592,
            "PAYMENT_CLOSED_PAYMENT_LEGAL_OVER_TIME": 15593,
            "PAYMENT_CLOSED_PAYMENT_LEGAL_OVER_TIME_AMOUNT": 15594,
            "PAYMENT_CLOSED_PAYMENT_NON_LEGAL_OVER_TIME": 15595,
            "PAYMENT_CLOSED_PAYMENT_NON_LEGAL_OVER_TIME_AMOUNT": 15596,
            "PAYMENT_CLOSED_PAYMENT_NIGHT_EXTRA_TIME": 15597,
            "PAYMENT_CLOSED_PAYMENT_NIGHT_EXTRA_AMOUNT": 15598,
            "PAYMENT_CLOSED_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR": 15599,
            "PAYMENT_CLOSED_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 15600,
            "PAYMENT_CLOSED_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 15601,
            "PAYMENT_CLOSED_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 15602,
            "PAYMENT_CLOSED_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 15603,
            "PAYMENT_CLOSED_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 15604,
            "PAYMENT_CLOSED_PAYMENT_LEAVE_DEDUCTION_TIME": 15605,
            "PAYMENT_CLOSED_PAYMENT_LEAVE_DEDUCTION_AMOUNT": 15606,
            "PAYMENT_CLOSED_PAYMENT_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 15607,
            "PAYMENT_CLOSED_PAYMENT_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 15608,
            "PAYMENT_CLOSED_PAYMENT_TRANSPORTATION_FEE": 15609,
            "PAYMENT_CLOSED_PAYMENT_ADVANCE_PAYMENT_AMOUNT_WITH_TAX": 15610,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX": 15611,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX": 15612,
            "PAYMENT_CLOSED_PAYMENT_EMPLOYMENT_INSURANCE_FEE": 15613,
            "PAYMENT_CLOSED_PAYMENT_HEALTH_INSURANCE_FEE": 15614,
            "PAYMENT_CLOSED_PAYMENT_NURSING_INSURANCE_FEE": 15615,
            "PAYMENT_CLOSED_PAYMENT_EMPLOYEE_PENSION": 15616,
            "PAYMENT_CLOSED_PAYMENT_RESIDENT_TAX": 15617,
            "PAYMENT_CLOSED_PAYMENT_WITHHOLDING_INCOME_TAX": 15618,
            "PAYMENT_CLOSED_PAYMENT_TOTAL_AMOUNT_OF_PAYMENT": 15619,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OF_DEDUCTION": 15620,
            "PAYMENT_CLOSED_PAYMENT_NET_AMOUNT_OF_PAYMENT": 15621,
            "PAYMENT_CLOSED_PAYMENT_CREDIT": 15622,
            "PAYMENT_CLOSED_PAYMENT_CREATED_AT": 15623,
            "PAYMENT_CLOSED_PAYMENT_UPDATED_AT": 15624,
            "PAYMENT_CLOSED_PAYMENT_DELETED_AT": 15625,
            "PAYMENT_CLOSED_PAYMENT_CREATED_USER_ID": 15626,
            "PAYMENT_CLOSED_PAYMENT_UPDATED_USER_ID": 15627,
            "PAYMENT_CLOSED_PAYMENT_DELETE": 15628,
            "ACTUAL_AMOUNT_OVER_SHORT_DELETE": 15629,
            "ATTENDANCE_ID": 15637,
            "ATTENDANCE_CONTRACT_ID": 15638,
            "ATTENDANCE_ATTENDANCE_TYPE_ID": 15639,
            "ATTENDANCE_ATTENDANCE_DATE": 15640,
            "ATTENDANCE_SCHEDULED_START_TIME": 15641,
            "ATTENDANCE_SCHEDULED_END_TIME": 15642,
            "ATTENDANCE_BREAK_MINUTES": 15643,
            "ATTENDANCE_MIDNIGHT_BREAK_MINUTES": 15644,
            "ATTENDANCE_PERFORMED_START_TIME": 15645,
            "ATTENDANCE_PERFORMED_END_TIME": 15646,
            "ATTENDANCE_INVOICE_TRANSPORTATION_EXPENSES": 15647,
            "ATTENDANCE_PAYMENT_TRANSPORTATION": 15648,
            "ATTENDANCE_CREATED_AT": 15649,
            "ATTENDANCE_UPDATED_AT": 15650,
            "ATTENDANCE_CREATED_USER_ID": 15651,
            "ATTENDANCE_UPDATED_USER_ID": 15652,
            "ATTENDANCE_DELETE": 15653,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_CALCULATED_DATE": 15655,
            "ATTENDANCE_IS_LIKE_NOT_WORKING": 15656,
            "ATTENDANCE_MEMO": 15657,
            "CANDIDATE_DISPATCH_BASIC_PAYMENT_CLOSED_DATE_ID": 15658,
            "CANDIDATE_DISPATCH_BASIC_PAYMENT_TYPE_ID": 15659,
            "CANDIDATE_DISPATCH_BASIC_PAYMENT_DATE_ID": 15660,
            "ATTENDANCE_INVOICE_CONTRACT_ATTENDANCE_ID": 15661,
            "ATTENDANCE_PAYMENT_CONTRACT_ATTENDANCE_ID": 15662,
            "INVOICE_CONTRACT_ATTENDANCE_ID": 15663,
            "INVOICE_CONTRACT_ATTENDANCE_CONTRACT_ID": 15664,
            "INVOICE_CONTRACT_ATTENDANCE_CLOSING_START_DATE": 15665,
            "INVOICE_CONTRACT_ATTENDANCE_CLOSING_END_DATE": 15666,
            "INVOICE_CONTRACT_ATTENDANCE_WORKING_DAYS": 15667,
            "INVOICE_CONTRACT_ATTENDANCE_PAID_LEAVES": 15668,
            "INVOICE_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS": 15669,
            "INVOICE_CONTRACT_ATTENDANCE_SCHEDULED_HOLIDAYS": 15670,
            "INVOICE_CONTRACT_ATTENDANCE_LIKE_NOT_WORKING_DAYS": 15671,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_WORKING_TIME": 15672,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_WORKING_TIME_ON_BILLING_SIDE_YEN": 15673,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_WORKING_TIME_ON_PAYER_SIDE_YEN": 15674,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_BASIC_TIME": 15675,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_BASIC_TIME_ON_BILLING_SIDE_YEN": 15676,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_BASIC_TIME_ON_PAYER_SIDE_YEN": 15677,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_LEGAL_OVERTIME_TIME": 15678,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_LEGAL_OVERTIME_TIME_ON_BILLING_SIDE_YEN": 15679,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_LEGAL_OVERTIME_TIME_ON_PAYER_SIDE_YEN": 15680,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_NON_LEGAL_OVERTIME_TIME": 15681,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_NON_LEGAL_OVERTIME_TIME_ON_BILLING_SIDE_YEN": 15682,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_NON_LEGAL_OVERTIME_TIME_ON_PAYER_SIDE_YEN": 15683,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_MIDNIGHT_TIME": 15684,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_MIDNIGHT_TIME_ON_BILLING_SIDE_YEN": 15685,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_MIDNIGHT_TIME_ON_PAYER_SIDE_YEN": 15686,
            "INVOICE_CONTRACT_ATTENDANCE_OVER_REGULATION_TIME_PER_WEEK": 15687,
            "INVOICE_CONTRACT_ATTENDANCE_OVER_REGULATION_TIME_PER_WEEK_ON_BILLING_SIDE_YEN": 15688,
            "INVOICE_CONTRACT_ATTENDANCE_OVER_REGULATION_TIME_PER_WEEK_ON_PAYER_SIDE_YEN": 15689,
            "INVOICE_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_45_PER_MONTH": 15690,
            "INVOICE_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_45_PER_MONTH_ON_BILLING_SIDE_YEN": 15691,
            "INVOICE_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_45_PER_MONTH_ON_PAYER_SIDE_YEN": 15692,
            "INVOICE_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_60_PER_MONTH": 15693,
            "INVOICE_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_60_PER_MONTH_ON_BILLING_SIDE_YEN": 15694,
            "INVOICE_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_60_PER_MONTH_ON_PAYER_SIDE_YEN": 15695,
            "INVOICE_CONTRACT_ATTENDANCE_ABSENCE_EXEMPTION_TIME": 15696,
            "INVOICE_CONTRACT_ATTENDANCE_ABSENCE_EXEMPTION_TIME_ON_BILLING_SIDE_YEN": 15697,
            "INVOICE_CONTRACT_ATTENDANCE_ABSENCE_EXEMPTION_TIME_ON_PAYER_SIDE_YEN": 15698,
            "INVOICE_CONTRACT_ATTENDANCE_LACK_OF_PREDETERMINED_DEDUCTION_TIME": 15699,
            "INVOICE_CONTRACT_ATTENDANCE_LACK_OF_PREDETERMINED_DEDUCTION_TIME_ON_BILLING_SIDE_YEN": 15700,
            "INVOICE_CONTRACT_ATTENDANCE_LACK_OF_PREDETERMINED_DEDUCTION_TIME_ON_PAYER_SIDE_YEN": 15701,
            "PAYMENT_CONTRACT_ATTENDANCE_ID": 15702,
            "PAYMENT_CONTRACT_ATTENDANCE_CONTRACT_ID": 15703,
            "PAYMENT_CONTRACT_ATTENDANCE_CANDIDATE_ID": 15704,
            "PAYMENT_CONTRACT_ATTENDANCE_WORKING_DAYS": 15705,
            "PAYMENT_CONTRACT_ATTENDANCE_PAID_LEAVES": 15706,
            "PAYMENT_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS": 15707,
            "PAYMENT_CONTRACT_ATTENDANCE_SCHEDULED_HOLIDAYS": 15708,
            "PAYMENT_CONTRACT_ATTENDANCE_LIKE_NOT_WORKING_DAYS": 15709,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_WORKING_TIME": 15710,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_WORKING_TIME_ON_BILLING_SIDE_YEN": 15711,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_WORKING_TIME_ON_PAYER_SIDE_YEN": 15712,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_BASIC_TIME": 15713,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_BASIC_TIME_ON_BILLING_SIDE_YEN": 15714,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_BASIC_TIME_ON_PAYER_SIDE_YEN": 15715,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_LEGAL_OVERTIME_TIME": 15716,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_LEGAL_OVERTIME_TIME_ON_BILLING_SIDE_YEN": 15717,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_LEGAL_OVERTIME_TIME_ON_PAYER_SIDE_YEN": 15718,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_NON_LEGAL_OVERTIME_TIME": 15719,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_NON_LEGAL_OVERTIME_TIME_ON_BILLING_SIDE_YEN": 15720,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_NON_LEGAL_OVERTIME_TIME_ON_PAYER_SIDE_YEN": 15721,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_MIDNIGHT_TIME": 15722,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_MIDNIGHT_TIME_ON_BILLING_SIDE_YEN": 15723,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_MIDNIGHT_TIME_ON_PAYER_SIDE_YEN": 15724,
            "PAYMENT_CONTRACT_ATTENDANCE_OVER_REGULATION_TIME_PER_WEEK": 15725,
            "PAYMENT_CONTRACT_ATTENDANCE_OVER_REGULATION_TIME_PER_WEEK_ON_BILLING_SIDE_YEN": 15726,
            "PAYMENT_CONTRACT_ATTENDANCE_OVER_REGULATION_TIME_PER_WEEK_ON_PAYER_SIDE_YEN": 15727,
            "PAYMENT_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_45_PER_MONTH": 15728,
            "PAYMENT_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_45_PER_MONTH_ON_BILLING_SIDE_YEN": 15729,
            "PAYMENT_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_45_PER_MONTH_ON_PAYER_SIDE_YEN": 15730,
            "PAYMENT_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_60_PER_MONTH": 15731,
            "PAYMENT_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_60_PER_MONTH_ON_BILLING_SIDE_YEN": 15732,
            "PAYMENT_CONTRACT_ATTENDANCE_NO_LEGAL_OVERTIME_MORE_THAN_60_PER_MONTH_ON_PAYER_SIDE_YEN": 15733,
            "PAYMENT_CONTRACT_ATTENDANCE_ABSENCE_EXEMPTION_TIME": 15734,
            "PAYMENT_CONTRACT_ATTENDANCE_ABSENCE_EXEMPTION_TIME_ON_BILLING_SIDE_YEN": 15735,
            "PAYMENT_CONTRACT_ATTENDANCE_ABSENCE_EXEMPTION_TIME_ON_PAYER_SIDE_YEN": 15736,
            "PAYMENT_CONTRACT_ATTENDANCE_LACK_OF_PREDETERMINED_DEDUCTION_TIME": 15737,
            "PAYMENT_CONTRACT_ATTENDANCE_LACK_OF_PREDETERMINED_DEDUCTION_TIME_ON_BILLING_SIDE_YEN": 15738,
            "PAYMENT_CONTRACT_ATTENDANCE_LACK_OF_PREDETERMINED_DEDUCTION_TIME_ON_PAYER_SIDE_YEN": 15739,
            "PAYMENT_CONTRACT_ATTENDANCE_CLOSING_START_DATE": 15740,
            "PAYMENT_CONTRACT_ATTENDANCE_CLOSING_END_DATE": 15741,
            "INVOICE_CONTRACT_ATTENDANCE_NO_REGISTER_ACHIEVEMENT": 15742,
            "INVOICE_CONTRACT_ATTENDANCE_NO_CONTRACT_ATTENDANCE": 15743,
            "CALC_RECORDS_MAPPINGS_CONTRACT_ID": 15744,
            "CALC_RECORDS_MAPPINGS_CANDIDATE_ID": 15745,
            "CALC_RECORDS_MAPPINGS_COMPANY_ID": 15746,
            "CALC_RECORDS_MAPPINGS_JOB_ID": 15747,
            "CALC_RECORDS_MAPPINGS_DISPATCH_DESTINATION_ID": 15748,
            "CALC_RECORDS_MAPPINGS_BILLING_DESTINATION_ID": 15749,
            "ATTENDANCE_URL": 15750,
            "CALC_RECORDS_MAPPINGS_DISPATCH_SOURCE_ID": 15751,
            "CALC_RECORDS_MAPPINGS_INVOICE_CONTRACT_ATTENDANCE_ID": 15752,
            "CALC_RECORDS_MAPPINGS_PAYMENT_CONTRACT_ATTENDANCE_ID": 15753,
            "CALC_RECORDS_MAPPINGS_INVOICE_CLOSED_ATTENDANCE_ID": 15754,
            "CALC_RECORDS_MAPPINGS_PAYMENT_CLOSED_ATTENDANCE_ID": 15755,
            "CALC_RECORDS_MAPPINGS_INVOICE_CLOSED_INVOICE_ID": 15756,
            "CALC_RECORDS_MAPPINGS_PAYMENT_CLOSED_PAYMENT_ID": 15757,
            "ACTUAL_AMOUNT_OVER_SHORT_NAME": 15758,
            "ACTUAL_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_ID": 15759,
            "INVOICE_COPY_ATTENDANCE_ID": 15760,
            "INVOICE_COPY_ATTENDANCE_INVOICE_CLOSED_ATTENDANCE_ID": 15761,
            "INVOICE_COPY_ATTENDANCE_ATTENDANCE_TYPE_ID": 15762,
            "INVOICE_COPY_ATTENDANCE_ATTENDANCE_DATE": 15763,
            "INVOICE_COPY_ATTENDANCE_IS_LIKE_NOT_WORKING": 15764,
            "INVOICE_COPY_ATTENDANCE_SCHEDULED_START_TIME": 15765,
            "INVOICE_COPY_ATTENDANCE_SCHEDULED_END_TIME": 15766,
            "INVOICE_COPY_ATTENDANCE_BREAK_MINUTES": 15767,
            "INVOICE_COPY_ATTENDANCE_MIDNIGHT_BREAK_MINUTES": 15768,
            "INVOICE_COPY_ATTENDANCE_PERFORMED_START_TIME": 15769,
            "INVOICE_COPY_ATTENDANCE_PERFORMED_END_TIME": 15770,
            "INVOICE_COPY_ATTENDANCE_INVOICE_TRANSPORTATION_EXPENSES": 15771,
            "INVOICE_COPY_ATTENDANCE_PAYMENT_TRANSPORTATION": 15772,
            "INVOICE_COPY_ATTENDANCE_MEMO": 15773,
            "INVOICE_COPY_ATTENDANCE_CREATED_AT": 15774,
            "INVOICE_COPY_ATTENDANCE_UPDATED_AT": 15775,
            "INVOICE_COPY_ATTENDANCE_CREATED_USER_ID": 15776,
            "INVOICE_COPY_ATTENDANCE_UPDATED_USER_ID": 15777,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_ID": 15778,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_CONTRACT_AMOUNT_OVER_SHORT_ID": 15779,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_INVOICE_CLOSED_ATTENDANCE_ID": 15780,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_AMOUNT_OVER_SHORT_TYPE_ID": 15781,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_OCCURANCE_DATE": 15782,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_INVOICE_AMOUNT_OVER_SHORT_AMOUNT": 15783,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_INVOICE_TAXATION_TYPE_ID": 15784,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_AMOUNT_OVER_SHORT_AMOUNT": 15785,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_TAXATION_TYPE_ID": 15786,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_BASE_EMPLOYMENT_INSURANCE_BOOLEAN_DEFAULT_TYPE_ID": 15787,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_NAME": 15788,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_ID": 15789,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_ID": 15790,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_CONTRACT_AMOUNT_OVER_SHORT_ID": 15791,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_CLOSED_ATTENDANCE_ID": 15792,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_AMOUNT_OVER_SHORT_TYPE_ID": 15793,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_OCCURANCE_DATE": 15794,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_INVOICE_AMOUNT_OVER_SHORT_AMOUNT": 15795,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_INVOICE_TAXATION_TYPE_ID": 15796,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_AMOUNT_OVER_SHORT_AMOUNT": 15797,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_TAXATION_TYPE_ID": 15798,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_BASE_EMPLOYMENT_INSURANCE_BOOLEAN_DEFAULT_TYPE_ID": 15799,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_NAME": 15800,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_ID": 15801,
            "ACTUAL_AMOUNT_OVER_SHORT_INVOICE_CONTRACT_ATTENDANCE_ID": 15802,
            "ACTUAL_AMOUNT_OVER_SHORT_PAYMENT_CONTRACT_ATTENDANCE_ID": 15803,
            "PAYMENT_CLOSED_ATTENDANCE_NO_CONTRACT": 15804,
            "INVOICE_CLOSED_ATTENDANCE_SUB_TOTAL_AMOUNT": 15805,
            "INVOICE_CLOSED_ATTENDANCE_TOTAL_AMOUNT": 15806,
            "INVOICE_CLOSED_ATTENDANCE_LEGAL_OVER_TIME_WITH_AMOUNT": 15807,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_WITH_AMOUNT": 15808,
            "INVOICE_CLOSED_ATTENDANCE_NIGHT_EXTRA_TIME_WITH_AMOUNT": 15809,
            "INVOICE_CLOSED_ATTENDANCE_OVER_WEEKLY_LEGAL_WORKING_HOUR_WITH_AMOUNT": 15810,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_45_TIME_WITH_AMOUNT": 15811,
            "INVOICE_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_60_TIME_WITH_AMOUNT": 15812,
            "INVOICE_CLOSED_ATTENDANCE_LEAVE_DEDUCTION_TIME_WITH_AMOUNT": 15813,
            "INVOICE_CLOSED_ATTENDANCE_PRESCRIBED_WORKING_HOUR_SHORT_TIME_WITH_AMOUNT": 15814,
            "PAYMENT_COPY_ATTENDANCE_ID": 15815,
            "PAYMENT_COPY_ATTENDANCE_PAYMENT_CLOSED_ATTENDANCE_ID": 15816,
            "PAYMENT_COPY_ATTENDANCE_ATTENDANCE_TYPE_ID": 15817,
            "PAYMENT_COPY_ATTENDANCE_ATTENDANCE_DATE": 15818,
            "PAYMENT_COPY_ATTENDANCE_IS_LIKE_NOT_WORKING": 15819,
            "PAYMENT_COPY_ATTENDANCE_SCHEDULED_START_TIME": 15820,
            "PAYMENT_COPY_ATTENDANCE_SCHEDULED_END_TIME": 15821,
            "PAYMENT_COPY_ATTENDANCE_BREAK_MINUTES": 15822,
            "PAYMENT_COPY_ATTENDANCE_MIDNIGHT_BREAK_MINUTES": 15823,
            "PAYMENT_COPY_ATTENDANCE_PERFORMED_START_TIME": 15824,
            "PAYMENT_COPY_ATTENDANCE_PERFORMED_END_TIME": 15825,
            "PAYMENT_COPY_ATTENDANCE_INVOICE_TRANSPORTATION_EXPENSES": 15826,
            "PAYMENT_COPY_ATTENDANCE_PAYMENT_TRANSPORTATION": 15827,
            "PAYMENT_COPY_ATTENDANCE_MEMO": 15828,
            "PAYMENT_COPY_ATTENDANCE_CREATED_AT": 15829,
            "PAYMENT_COPY_ATTENDANCE_UPDATED_AT": 15830,
            "PAYMENT_COPY_ATTENDANCE_CREATED_USER_ID": 15831,
            "PAYMENT_COPY_ATTENDANCE_UPDATED_USER_ID": 15832,
            "PAYMENT_CLOSED_ATTENDANCE_SUB_TOTAL_AMOUNT": 15833,
            "PAYMENT_CLOSED_ATTENDANCE_TOTAL_AMOUNT": 15834,
            "PAYMENT_CLOSED_ATTENDANCE_LEGAL_OVER_TIME_WITH_AMOUNT": 15835,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_WITH_AMOUNT": 15836,
            "PAYMENT_CLOSED_ATTENDANCE_NIGHT_EXTRA_TIME_WITH_AMOUNT": 15837,
            "PAYMENT_CLOSED_ATTENDANCE_OVER_WEEKLY_LEGAL_WORKING_HOUR_WITH_AMOUNT": 15838,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_45_TIME_WITH_AMOUNT": 15839,
            "PAYMENT_CLOSED_ATTENDANCE_NON_LEGAL_OVER_TIME_MONTH_60_TIME_WITH_AMOUNT": 15840,
            "PAYMENT_CLOSED_ATTENDANCE_LEAVE_DEDUCTION_TIME_WITH_AMOUNT": 15841,
            "PAYMENT_CLOSED_ATTENDANCE_PRESCRIBED_WORKING_HOUR_SHORT_TIME_WITH_AMOUNT": 15842,
            "PAYMENT_CLOSED_ATTENDANCE_IS_ATTENDANCE_CLOSING_COMPLETED": 15846,
            "PAYMENT_CLOSED_ATTENDANCE_IS_EMPLOYMENT_INSURANCE_DEDUCTION": 15847,
            "PAYMENT_CLOSED_ATTENDANCE_IS_HEALTH_INSURANCE_DEDUCTION": 15848,
            "PAYMENT_CLOSED_ATTENDANCE_IS_WELFARE_PENSION_DEDUCTION": 15849,
            "PAYMENT_CLOSED_ATTENDANCE_IS_CARE_INSURANCE_DEDUCTION": 15850,
            "INVOICE_CLOSED_INVOICE_SALES_DATE": 15851,
            "INVOICE_CLOSED_INVOICE_PAYMENT_SCHEDULE_DATE": 15852,
            "CONTRACT_AMOUNT_OVER_SHORT_NAME": 15853,
            "CONTRACT_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_ID": 15854,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_NAME": 15855,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_ID": 15856,
            "INVOICE_CLOSED_ATTENDANCE_CANDIDATE_ID": 15857,
            "INVOICE_CLOSED_ATTENDANCE_CONTRACT_ID": 15858,
            "CONTRACT_AMOUNT_OVER_SHORT_TAX_RATE_ID": 15859,
            "CONTRACT_AMOUNT_OVER_SHORT_ALLOWANCE_ID": 15860,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_TAX_RATE_ID": 15861,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_ALLOWANCE_ID": 15862,
            "ACTUAL_AMOUNT_OVER_SHORT_TAX_RATE_ID": 15863,
            "ACTUAL_AMOUNT_OVER_SHORT_ALLOWANCE_ID": 15864,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_TAX_RATE_ID": 15865,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_ALLOWANCE_ID": 15866,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_TAX_RATE_ID": 15867,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_ALLOWANCE_ID": 15868,
            "CANDIDATE_WAGE_ID": 15869,
            "CANDIDATE_WAGE_DELETE": 15870,
            "CANDIDATE_WAGE_PAYMENT_WAGE_TYPE_ID": 15871,
            "CANDIDATE_WAGE_PAYMENT_EARLY_ATTENDANCE_BOOLEAN_APPROVE_TYPE_ID": 15872,
            "CANDIDATE_WAGE_PAYMENT_BASIC_UNIT_WAGE": 15873,
            "CANDIDATE_WAGE_PAYMENT_LEGAL_OVER_TIME_UNIT_WAGE": 15874,
            "CANDIDATE_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_UNIT_WAGE": 15875,
            "CANDIDATE_WAGE_PAYMENT_LEGAL_HOLIDAY_UNIT_WAGE": 15876,
            "CANDIDATE_WAGE_PAYMENT_PRESCRIBED_HOLIDAY_UNIT_WAGE": 15877,
            "CANDIDATE_WAGE_PAYMENT_NIGHT_EXTRA_UNIT_WAGE": 15878,
            "CANDIDATE_WAGE_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR_UNIT_WAGE": 15879,
            "CANDIDATE_WAGE_PAYMENT_WEEKLY_LEGAL_WORKING_HOUR": 15880,
            "CANDIDATE_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_UNIT_WAGE": 15881,
            "CANDIDATE_WAGE_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_UNIT_WAGE": 15882,
            "CANDIDATE_WAGE_PAYMENT_LEAVE_DEDUCTION": 15883,
            "CANDIDATE_WAGE_PAYMENT_PRESCRIBED_HOUR_SHORT_DEDUCTION": 15884,
            "WAGE_INVOICE_HALF_HOLIDAY_ALLOCATION_HOUR": 15887,
            "CANDIDATE_WAGE_PAYMENT_HALF_HOLIDAY_ALLOCATION_HOUR": 15888,
            "DISPATCH_JOB_WAGE_INVOICE_HALF_HOLIDAY_ALLOCATION_HOUR": 15889,
            "DISPATCH_JOB_WAGE_PAYMENT_HALF_HOLIDAY_ALLOCATION_HOUR": 15890,
            "CONTRACT_WAGE_INVOICE_HALF_HOLIDAY_ALLOCATION_HOUR": 15891,
            "CONTRACT_WAGE_PAYMENT_HALF_HOLIDAY_ALLOCATION_HOUR": 15892,
            "DISPATCH_JOB_EMPLOYMENT_INSURANCE_INDUSTRY_ID": 15893,
            "CONTRACT_EMPLOYMENT_INSURANCE_INDUSTRY_ID": 15894,
            "CANDIDATE_DISPATCH_BASIC_SINGLE_PARENT_DEDUCTION_ID": 15895,
            "CANDIDATE_PAYMENT_DATA_ID": 15896,
            "CANDIDATE_PAYMENT_DATA_CALC_TIME_UNIT": 15897,
            "CANDIDATE_PAYMENT_DATA_TIME_ROUNDING_TYPE_ID": 15898,
            "CANDIDATE_PAYMENT_DATA_FRACTION_ROUNDING_TYPE_ID": 15899,
            "CANDIDATE_PAYMENT_DATA_DELETE": 15900,
            "INVOICE_CLOSED_INVOICE_HISTORY_ID": 15901,
            "INVOICE_CLOSED_INVOICE_HISTORY_INVOICE_CLOSED_INVOICE_ID": 15902,
            "INVOICE_CLOSED_INVOICE_HISTORY_INVOICE_DATE": 15903,
            "INVOICE_CLOSED_INVOICE_HISTORY_PAYMENT_LIMIT_DATE": 15904,
            "INVOICE_CLOSED_INVOICE_HISTORY_SALES_DATE": 15905,
            "INVOICE_CLOSED_INVOICE_HISTORY_PAYMENT_SCHEDULE_DATE": 15906,
            "INVOICE_CLOSED_INVOICE_HISTORY_INVOICE_CLOSED_INVOICE_STATE_ID": 15907,
            "INVOICE_CLOSED_INVOICE_HISTORY_WORKING_HOURS": 15908,
            "INVOICE_CLOSED_INVOICE_HISTORY_WORKING_HOUR_AMOUNT": 15909,
            "INVOICE_CLOSED_INVOICE_HISTORY_BASIC_TIME": 15910,
            "INVOICE_CLOSED_INVOICE_HISTORY_BASIC_AMOUNT": 15911,
            "INVOICE_CLOSED_INVOICE_HISTORY_LEGAL_OVER_TIME": 15912,
            "INVOICE_CLOSED_INVOICE_HISTORY_LEGAL_OVER_TIME_AMOUNT": 15913,
            "INVOICE_CLOSED_INVOICE_HISTORY_NON_LEGAL_OVER_TIME": 15914,
            "INVOICE_CLOSED_INVOICE_HISTORY_NON_LEGAL_OVER_TIME_AMOUNT": 15915,
            "INVOICE_CLOSED_INVOICE_HISTORY_NIGHT_EXTRA_TIME": 15916,
            "INVOICE_CLOSED_INVOICE_HISTORY_NIGHT_EXTRA_AMOUNT": 15917,
            "INVOICE_CLOSED_INVOICE_HISTORY_OVER_WEEKLY_LEGAL_WORKING_HOUR": 15918,
            "INVOICE_CLOSED_INVOICE_HISTORY_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 15919,
            "INVOICE_CLOSED_INVOICE_HISTORY_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 15920,
            "INVOICE_CLOSED_INVOICE_HISTORY_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 15921,
            "INVOICE_CLOSED_INVOICE_HISTORY_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 15922,
            "INVOICE_CLOSED_INVOICE_HISTORY_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 15923,
            "INVOICE_CLOSED_INVOICE_HISTORY_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 15924,
            "INVOICE_CLOSED_INVOICE_HISTORY_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 15925,
            "INVOICE_CLOSED_INVOICE_HISTORY_TRANSPORTATION_FEE": 15926,
            "INVOICE_CLOSED_INVOICE_HISTORY_ADVANCE_PAYMENT_AMOUNT_WITH_TAX": 15927,
            "INVOICE_CLOSED_INVOICE_HISTORY_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX": 15928,
            "INVOICE_CLOSED_INVOICE_HISTORY_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX": 15929,
            "INVOICE_CLOSED_INVOICE_HISTORY_INVOICE_CALCULATED_DATE": 15930,
            "INVOICE_CLOSED_INVOICE_HISTORY_CREATED_AT": 15931,
            "INVOICE_CLOSED_INVOICE_HISTORY_UPDATED_AT": 15932,
            "INVOICE_CLOSED_INVOICE_HISTORY_CREATED_USER_ID": 15933,
            "INVOICE_CLOSED_INVOICE_HISTORY_UPDATED_USER_ID": 15934,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_CONTRACT_ATTENDANCE_ID": 15935,
            "PAYMENT_CLOSED_ATTENDANCE_CONTRACT_ID": 15936,
            "PAYMENT_CLOSED_ATTENDANCE_COMPANY_ID": 15937,
            "PAYMENT_CLOSED_ATTENDANCE_DISPATCH_DESTINATION_ID": 15938,
            "PAYMENT_CLOSED_ATTENDANCE_DISPATCH_JOB_ID": 15939,
            "PAYMENT_CLOSED_PAYMENT_CLOSING_START_DATE": 15940,
            "PAYMENT_CLOSED_PAYMENT_CLOSING_END_DATE": 15941,
            "PAYMENT_CLOSED_PAYMENT_BASIC_AMOUNT_OF_PAYMENT": 15942,
            "PAYMENT_CLOSED_PAYMENT_AFTER_DEDUCTION_AMOUNT_OF_PAYMENT": 15943,
            "PAYMENT_CLOSED_PAYMENT_INSURANCE_CALCULATION_AMOUNT_OF_PAYMENT": 15944,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OF_PAYMENT": 15945,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OF_PAYMENT_WITH_TAX": 15946,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OF_PAYMENT_WITHOUT_TAX": 15947,
            "PAYMENT_CLOSED_PAYMENT_NUMBER_OF_WORKING_DAYS": 15948,
            "PAYMENT_CLOSED_PAYMENT_NUMBER_OF_PAID_LEAVES": 15949,
            "PAYMENT_CLOSED_PAYMENT_NUMBER_OF_ABSENT_WORKING_DAYS": 15950,
            "PAYMENT_CLOSED_PAYMENT_NUMBER_OF_NO_WORKING_DAYS": 15951,
            "PAYMENT_CLOSED_PAYMENT_NUMBER_OF_PRESCRIBED_HOLIDAYS": 15952,
            "PAYMENT_CLOSED_PAYMENT_NUMBER_OF_LEGAL_HOLIDAYS": 15953,
            "PAYMENT_CLOSED_PAYMENT_PRESCRIBED_HOLIDAYS_AMOUNT": 15954,
            "PAYMENT_CLOSED_PAYMENT_LEGAL_HOLIDAYS_AMOUNT": 15955,
            "PAYMENT_CLOSED_PAYMENT_PRESCRIBED_HOLIDAYS_TIME": 15956,
            "PAYMENT_CLOSED_PAYMENT_LEGAL_HOLIDAYS_TIME": 15957,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT": 15958,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT": 15959,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_ID": 15960,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PAYMENT_CLOSED_PAYMENT_ID": 15961,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PAYMENT_SCHEDULE_DATE": 15962,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PAYMENT_DATE": 15963,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PAYMENT_CLOSED_PAYMENT_STATE_ID": 15964,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_WORKING_HOURS": 15965,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_BASIC_TIME": 15966,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_BASIC_AMOUNT": 15967,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_LEGAL_OVER_TIME": 15968,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_LEGAL_OVER_TIME_AMOUNT": 15969,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NON_LEGAL_OVER_TIME": 15970,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NON_LEGAL_OVER_TIME_AMOUNT": 15971,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NIGHT_EXTRA_TIME": 15972,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NIGHT_EXTRA_AMOUNT": 15973,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_OVER_WEEKLY_LEGAL_WORKING_HOUR": 15974,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 15975,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 15976,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 15977,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 15978,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 15979,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_TRANSPORTATION_FEE": 15980,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX": 15981,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX": 15982,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_EMPLOYMENT_INSURANCE_FEE": 15983,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_HEALTH_INSURANCE_FEE": 15984,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_EMPLOYEE_PENSION": 15985,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_RESIDENT_TAX": 15986,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_WITHHOLDING_INCOME_TAX": 15987,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_TOTAL_AMOUNT_OF_PAYMENT": 15988,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OF_DEDUCTION": 15989,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NET_AMOUNT_OF_PAYMENT": 15990,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_CREDIT": 15991,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PAYMENT_CALCULATED_DATE": 15992,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_CREATED_AT": 15993,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_UPDATED_AT": 15994,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_CREATED_USER_ID": 15995,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_UPDATED_USER_ID": 15996,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_CLOSING_START_DATE": 15997,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_CLOSING_END_DATE": 15998,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_BASIC_AMOUNT_OF_PAYMENT": 15999,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AFTER_DEDUCTION_AMOUNT_OF_PAYMENT": 16000,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_INSURANCE_CALCULATION_AMOUNT_OF_PAYMENT": 16001,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OF_PAYMENT": 16002,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OF_PAYMENT_WITH_TAX": 16003,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OF_PAYMENT_WITHOUT_TAX": 16004,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NUMBER_OF_WORKING_DAYS": 16005,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NUMBER_OF_PAID_LEAVES": 16006,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NUMBER_OF_ABSENT_WORKING_DAYS": 16007,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NUMBER_OF_NO_WORKING_DAYS": 16008,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NUMBER_OF_PRESCRIBED_HOLIDAYS": 16009,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_NUMBER_OF_LEGAL_HOLIDAYS": 16010,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PRESCRIBED_HOLIDAYS_AMOUNT": 16011,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_LEGAL_HOLIDAYS_AMOUNT": 16012,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_PRESCRIBED_HOLIDAYS_TIME": 16013,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_LEGAL_HOLIDAYS_TIME": 16014,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT": 16015,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT": 16016,
            "FRACTION_PROCESS_ROUNDING_UNIT_TYPE_ID": 16017,
            "FRACTION_PROCESS_FIRST_DAY_OF_THE_WEEK_TYPE_ID": 16018,
            "INVOICE_DATA_ROUNDING_UNIT_TYPE_ID": 16019,
            "INVOICE_DATA_FIRST_DAY_OF_THE_WEEK_TYPE_ID": 16020,
            "CANDIDATE_PAYMENT_DATA_ROUNDING_UNIT_TYPE_ID": 16021,
            "CANDIDATE_PAYMENT_DATA_FIRST_DAY_OF_THE_WEEK_TYPE_ID": 16022,
            "INVOICE_CLOSED_INVOICE_TAX_RATE_ID": 16023,
            "ATTENDANCE_CALCULATION_ID": 16024,
            "ATTENDANCE_CALCULATION_INVOICE_BASIC_AMOUNT": 16025,
            "ATTENDANCE_CALCULATION_INVOICE_BASIC_TIME": 16026,
            "ATTENDANCE_CALCULATION_INVOICE_LEGAL_OVER_TIME_AMOUNT": 16027,
            "ATTENDANCE_CALCULATION_INVOICE_LEGAL_OVER_TIME": 16028,
            "ATTENDANCE_CALCULATION_INVOICE_NON_LEGAL_OVER_TIME_AMOUNT": 16029,
            "ATTENDANCE_CALCULATION_INVOICE_NON_LEGAL_OVER_TIME": 16030,
            "ATTENDANCE_CALCULATION_INVOICE_NIGHT_EXTRA_AMOUNT": 16031,
            "ATTENDANCE_CALCULATION_INVOICE_NIGHT_EXTRA_TIME": 16032,
            "ATTENDANCE_CALCULATION_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 16033,
            "ATTENDANCE_CALCULATION_INVOICE_OVER_WEEKLY_LEGAL_WORKING_HOUR": 16034,
            "ATTENDANCE_CALCULATION_INVOICE_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 16035,
            "ATTENDANCE_CALCULATION_INVOICE_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 16036,
            "ATTENDANCE_CALCULATION_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 16037,
            "ATTENDANCE_CALCULATION_INVOICE_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 16038,
            "ATTENDANCE_CALCULATION_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 16039,
            "ATTENDANCE_CALCULATION_INVOICE_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 16040,
            "ATTENDANCE_CALCULATION_INVOICE_LEGAL_HOLIDAY_AMOUNT": 16041,
            "ATTENDANCE_CALCULATION_INVOICE_PRESCRIBED_HOLIDAY_AMOUNT": 16042,
            "ATTENDANCE_CALCULATION_PAYMENT_BASIC_AMOUNT": 16043,
            "ATTENDANCE_CALCULATION_PAYMENT_BASIC_TIME": 16044,
            "ATTENDANCE_CALCULATION_PAYMENT_LEGAL_OVER_TIME_AMOUNT": 16045,
            "ATTENDANCE_CALCULATION_PAYMENT_LEGAL_OVER_TIME": 16046,
            "ATTENDANCE_CALCULATION_PAYMENT_NON_LEGAL_OVER_TIME_AMOUNT": 16047,
            "ATTENDANCE_CALCULATION_PAYMENT_NON_LEGAL_OVER_TIME": 16048,
            "ATTENDANCE_CALCULATION_PAYMENT_NIGHT_EXTRA_AMOUNT": 16049,
            "ATTENDANCE_CALCULATION_PAYMENT_NIGHT_EXTRA_TIME": 16050,
            "ATTENDANCE_CALCULATION_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR_AMOUNT": 16051,
            "ATTENDANCE_CALCULATION_PAYMENT_OVER_WEEKLY_LEGAL_WORKING_HOUR": 16052,
            "ATTENDANCE_CALCULATION_PAYMENT_PRESCRIBED_WORKING_HOUR_SHORT_AMOUNT": 16053,
            "ATTENDANCE_CALCULATION_PAYMENT_PRESCRIBED_WORKING_HOUR_SHORT_TIME": 16054,
            "ATTENDANCE_CALCULATION_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_AMOUNT": 16055,
            "ATTENDANCE_CALCULATION_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_45_TIME": 16056,
            "ATTENDANCE_CALCULATION_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_AMOUNT": 16057,
            "ATTENDANCE_CALCULATION_PAYMENT_NON_LEGAL_OVER_TIME_MONTH_60_TIME": 16058,
            "ATTENDANCE_CALCULATION_PAYMENT_LEGAL_HOLIDAY_AMOUNT": 16059,
            "ATTENDANCE_CALCULATION_PAYMENT_PRESCRIBED_HOLIDAY_AMOUNT": 16060,
            "ATTENDANCE_INVOICE_CLOSED_ATTENDANCE_ID": 16061,
            "ATTENDANCE_PAYMENT_CLOSED_ATTENDANCE_ID": 16062,
            "PAYMENT_CONTRACT_ATTENDANCE_CREATED_AT": 16063,
            "PAYMENT_CONTRACT_ATTENDANCE_UPDATED_AT": 16064,
            "PAYMENT_CONTRACT_ATTENDANCE_CREATED_USER_ID": 16065,
            "PAYMENT_CONTRACT_ATTENDANCE_UPDATED_USER_ID": 16066,
            "PAYMENT_CONTRACT_ATTENDANCE_ABSENT_WORKING_DAYS": 16067,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_ON_BILLING_SIDE_YEN": 16068,
            "PAYMENT_CONTRACT_ATTENDANCE_TOTAL_ON_PAYER_SIDE_YEN": 16069,
            "PAYMENT_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS_TIME": 16070,
            "PAYMENT_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS_TIME_ON_BILLING_SIDE_YEN": 16071,
            "PAYMENT_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS_TIME_ON_PAYER_SIDE_YEN": 16072,
            "PAYMENT_CONTRACT_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME": 16073,
            "PAYMENT_CONTRACT_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME_ON_BILLING_SIDE_YEN": 16074,
            "PAYMENT_CONTRACT_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME_ON_PAYER_SIDE_YEN": 16075,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX_ON_BILLING_SIDE_YEN": 16076,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX_ON_PAYER_SIDE_YEN": 16077,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX_ON_BILLING_SIDE_YEN": 16078,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX_ON_PAYER_SIDE_YEN": 16079,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT_ON_BILLING_SIDE_YEN": 16080,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT_ON_PAYER_SIDE_YEN": 16081,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT_ON_BILLING_SIDE_YEN": 16082,
            "PAYMENT_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT_ON_PAYER_SIDE_YEN": 16083,
            "PAYMENT_CONTRACT_ATTENDANCE_TRANSPORTATION_FEE_ON_BILLING_SIDE_YEN": 16084,
            "PAYMENT_CONTRACT_ATTENDANCE_TRANSPORTATION_FEE_ON_PAYER_SIDE_YEN": 16085,
            "INVOICE_CONTRACT_ATTENDANCE_CREATED_AT": 16086,
            "INVOICE_CONTRACT_ATTENDANCE_UPDATED_AT": 16087,
            "INVOICE_CONTRACT_ATTENDANCE_CREATED_USER_ID": 16088,
            "INVOICE_CONTRACT_ATTENDANCE_UPDATED_USER_ID": 16089,
            "INVOICE_CONTRACT_ATTENDANCE_ABSENT_WORKING_DAYS": 16090,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_ON_BILLING_SIDE_YEN": 16091,
            "INVOICE_CONTRACT_ATTENDANCE_TOTAL_ON_PAYER_SIDE_YEN": 16092,
            "INVOICE_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS_TIME": 16093,
            "INVOICE_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS_TIME_ON_BILLING_SIDE_YEN": 16094,
            "INVOICE_CONTRACT_ATTENDANCE_LEGAL_HOLIDAYS_TIME_ON_PAYER_SIDE_YEN": 16095,
            "INVOICE_CONTRACT_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME": 16096,
            "INVOICE_CONTRACT_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME_ON_BILLING_SIDE_YEN": 16097,
            "INVOICE_CONTRACT_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME_ON_PAYER_SIDE_YEN": 16098,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX_ON_BILLING_SIDE_YEN": 16099,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITH_TAX_ON_PAYER_SIDE_YEN": 16100,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX_ON_BILLING_SIDE_YEN": 16101,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_AMOUNT_WITHOUT_TAX_ON_PAYER_SIDE_YEN": 16102,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT_ON_BILLING_SIDE_YEN": 16103,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT_ON_PAYER_SIDE_YEN": 16104,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT_ON_BILLING_SIDE_YEN": 16105,
            "INVOICE_CONTRACT_ATTENDANCE_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT_ON_PAYER_SIDE_YEN": 16106,
            "INVOICE_CONTRACT_ATTENDANCE_TRANSPORTATION_FEE_ON_BILLING_SIDE_YEN": 16107,
            "INVOICE_CONTRACT_ATTENDANCE_TRANSPORTATION_FEE_ON_PAYER_SIDE_YEN": 16108,
            "INVOICE_CLOSED_INVOICE_CLOSING_START_DATE": 16109,
            "INVOICE_CLOSED_INVOICE_CLOSING_END_DATE": 16110,
            "INVOICE_CLOSED_INVOICE_ATTENDANCE_SALES_AMOUNT": 16111,
            "INVOICE_CLOSED_INVOICE_BASE_AMOUNT_SUBTOTAL": 16112,
            "INVOICE_CLOSED_INVOICE_TAX_AMOUNT": 16113,
            "INVOICE_CLOSED_INVOICE_CLAIM_AMOUNT": 16114,
            "INVOICE_CLOSED_INVOICE_PAYMENT_AMOUNT": 16115,
            "INVOICE_CLOSED_INVOICE_MEMO": 16116,
            "INVOICE_CLOSED_INVOICE_INVOICE_YEAR": 16117,
            "INVOICE_CLOSED_INVOICE_INVOICE_MONTH": 16118,
            "INVOICE_CLOSED_INVOICE_POSTAL_CODE": 16119,
            "INVOICE_CLOSED_INVOICE_FULL_ADDRESS": 16120,
            "INVOICE_CLOSED_INVOICE_COMPANY_NAME": 16121,
            "INVOICE_CLOSED_INVOICE_BILLING_DESTINATION_NAME": 16122,
            "INVOICE_CLOSED_INVOICE_USER_DISPLAY_NAME": 16123,
            "CANDIDATE_PAYMENT_DATA_INSURANCE_ROUNDING_TYPE_ID": 16124,
            "CANDIDATE_WAGE_WORKING_DAYS": 16125,
            "CANDIDATE_WAGE_PRESCRIBED_WORKING_HOURS": 16126,
            "DISPATCH_SOURCE_WELFARE_PENSION_FUND_ID": 16127,
            "CANDIDATE_DISPATCH_INSURANCE_HEALTH_INSURANCE_RATE": 16128,
            "CANDIDATE_DISPATCH_INSURANCE_NURSING_INSURANCE_RATE": 16129,
            "CANDIDATE_DISPATCH_INSURANCE_EMPLOYEE_PENSION_ID": 16130,
            "CANDIDATE_DISPATCH_INSURANCE_STANDARD_REWARD_ID": 16131,
            "CANDIDATE_DISPATCH_INSURANCE_WELFARE_PENSION_FUND_ID": 16132,
            "ATTENDANCE_CALCULATION_INVOICE_LEGAL_HOLIDAY_TIME": 16133,
            "ATTENDANCE_CALCULATION_INVOICE_PRESCRIBED_HOLIDAY_TIME": 16134,
            "ATTENDANCE_CALCULATION_INVOICE_TOTAL_AMOUNT": 16135,
            "ATTENDANCE_CALCULATION_PAYMENT_LEGAL_HOLIDAY_TIME": 16136,
            "ATTENDANCE_CALCULATION_PAYMENT_PRESCRIBED_HOLIDAY_TIME": 16137,
            "ATTENDANCE_CALCULATION_PAYMENT_TOTAL_AMOUNT": 16138,
            "DISPATCH_SOURCE_TEL": 16139,
            "PAYMENT_CLOSED_PAYMENT_MEMO": 16140,
            "PAYMENT_CLOSED_PAYMENT_CANDIDATE_NAME": 16141,
            "PAYMENT_CLOSED_PAYMENT_DISPATCH_SOURCE_NAME": 16142,
            "PAYMENT_CLOSED_PAYMENT_POSTAL_CODE": 16143,
            "PAYMENT_CLOSED_PAYMENT_FULL_ADDRESS": 16144,
            "PAYMENT_CLOSED_PAYMENT_TEL": 16145,
            "CANDIDATE_DISPATCH_INSURANCE_PENSION_STANDARD_REWARD_ID": 16146,
            "INVOICE_CLOSED_ATTENDANCE_CANDIDATE_NAME": 16147,
            "INVOICE_CLOSED_ATTENDANCE_CLOSING_START_DATE": 16148,
            "INVOICE_CLOSED_ATTENDANCE_CLOSING_END_DATE": 16149,
            "INVOICE_CLOSED_ATTENDANCE_DISPATCH_DESTINATION_NAME": 16150,
            "INVOICE_CLOSED_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME": 16151,
            "INVOICE_CLOSED_ATTENDANCE_LEGAL_HOLIDAYS_TIME": 16152,
            "PAYMENT_CLOSED_ATTENDANCE_CANDIDATE_NAME": 16153,
            "PAYMENT_CLOSED_ATTENDANCE_CLOSING_START_DATE": 16154,
            "PAYMENT_CLOSED_ATTENDANCE_CLOSING_END_DATE": 16155,
            "PAYMENT_CLOSED_ATTENDANCE_DISPATCH_DESTINATION_NAME": 16156,
            "PAYMENT_CLOSED_ATTENDANCE_PRESCRIBED_HOLIDAYS_TIME": 16157,
            "PAYMENT_CLOSED_ATTENDANCE_LEGAL_HOLIDAYS_TIME": 16158,
            "PAYMENT_CLOSED_ATTENDANCE_BASIC_AMOUNT_OF_PAYMENT": 16171,
            "PAYMENT_CLOSED_ATTENDANCE_AFTER_DEDUCTION_AMOUNT_OF_PAYMENT": 16172,
            "PAYMENT_CLOSED_ATTENDANCE_INSURANCE_CALCULATION_AMOUNT_OF_PAYMENT": 16173,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OF_PAYMENT": 16174,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OF_PAYMENT_WITH_TAX": 16175,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OF_PAYMENT_WITHOUT_TAX": 16176,
            "PAYMENT_CLOSED_ATTENDANCE_NUMBER_OF_ABSENT_WORKING_DAYS": 16177,
            "PAYMENT_CLOSED_ATTENDANCE_PRESCRIBED_HOLIDAYS_AMOUNT": 16178,
            "PAYMENT_CLOSED_ATTENDANCE_LEGAL_HOLIDAYS_AMOUNT": 16179,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_ADVANCE_PAYMENT_AMOUNT": 16180,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_DEDUCTION_AMOUNT": 16181,
            "PAYMENT_CLOSED_ATTENDANCE_EMPLOYMENT_INSURANCE_FEE": 16182,
            "PAYMENT_CLOSED_ATTENDANCE_HEALTH_INSURANCE_FEE": 16183,
            "PAYMENT_CLOSED_ATTENDANCE_EMPLOYEE_PENSION": 16184,
            "PAYMENT_CLOSED_ATTENDANCE_RESIDENT_TAX": 16185,
            "PAYMENT_CLOSED_ATTENDANCE_WITHHOLDING_INCOME_TAX": 16186,
            "PAYMENT_CLOSED_ATTENDANCE_TOTAL_AMOUNT_OF_PAYMENT": 16187,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OF_DEDUCTION": 16188,
            "PAYMENT_CLOSED_ATTENDANCE_NET_AMOUNT_OF_PAYMENT": 16189,
            "PAYMENT_CLOSED_ATTENDANCE_CREDIT": 16190,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_CALCULATED_DATE": 16191,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_VERSION": 16159,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_MEMO": 16160,
            "INVOICE_CLOSED_INVOICE_IS_OUTPUT": 16161,
            "INVOICE_CLOSED_INVOICE_HISTORY_CLOSING_START_DATE": 16162,
            "INVOICE_CLOSED_INVOICE_HISTORY_CLOSING_END_DATE": 16163,
            "INVOICE_CLOSED_INVOICE_HISTORY_ATTENDANCE_SALES_AMOUNT": 16164,
            "INVOICE_CLOSED_INVOICE_HISTORY_BASE_AMOUNT_SUBTOTAL": 16165,
            "INVOICE_CLOSED_INVOICE_HISTORY_TAX_AMOUNT": 16166,
            "INVOICE_CLOSED_INVOICE_HISTORY_CLAIM_AMOUNT": 16167,
            "INVOICE_CLOSED_INVOICE_HISTORY_PAYMENT_AMOUNT": 16168,
            "INVOICE_CLOSED_INVOICE_HISTORY_MEMO": 16169,
            "INVOICE_CLOSED_INVOICE_HISTORY_VERSION": 16170,
            "INVOICE_CLOSED_ATTENDANCE_IS_ATTENDANCE_CLOSING_COMPLETED": 16192,
            "INVOICE_CLOSED_ATTENDANCE_PRESCRIBED_HOLIDAYS_AMOUNT": 16193,
            "INVOICE_CLOSED_ATTENDANCE_LEGAL_HOLIDAYS_AMOUNT": 16194,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_CREATED_AT": 16195,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_UPDATED_AT": 16196,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_CREATED_USER_ID": 16197,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORT_UPDATED_USER_ID": 16198,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_CREATED_AT": 16199,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_UPDATED_AT": 16200,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_CREATED_USER_ID": 16201,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORT_UPDATED_USER_ID": 16202,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_REFUND": 16203,
            "PAYMENT_CLOSED_PAYMENT_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_COLLECTION": 16204,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_REFUND": 16205,
            "PAYMENT_CLOSED_PAYMENT_HISTORY_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_COLLECTION": 16206,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_REFUND": 16207,
            "PAYMENT_CLOSED_ATTENDANCE_AMOUNT_OVER_SHORT_YEAR_END_ADJUSTMENT_COLLECTION": 16208,
            "JOB_WORK_CONTENT_SCOPE_OF_CHANGE": 20001,
            "JOB_WORK_LOCATION_SCOPE_OF_CHANGE": 20002,
            "JOB_EMPLOYMENT_PERIOD_FIXED_TERM_OR_INDEFINITE": 20003,
            "JOB_BREAK_TIME": 20004,
            "JOB_WHETHER_OR_NOT_THERE_IS_OVERTIME_WORK": 20005,
            "JOB_TYPES_OF_INSURANCE": 20006,
            "JOB_TYPES_OF_INSURANCE_TEXT": 20007,
            "JOB_REMARKS_FOR_JOB_POSTING": 20008,
            "JOB_SALARY_CATEGORY_FOR_JOB_POSTING": 20009,
            "JOB_SALARY_RAISE": 20010,
            "JOB_BONUS": 20011,
            "JOB_ALLOWANCE": 20012,
            "JOB_RETIREMENT_ALLOWANCE": 20013,
            "JOB_WHETHER_OR_NOT_THE_CONTRACT_HAS_BEEN_RENEWED": 20014,
            "JOB_MATTERS_RELATED_TO_CONTRACT_AND_RENEWAL_LIMIT": 20015,
            "JOB_MIN_MONTHLY_SALARY": 20016,
            "JOB_MAX_MONTHLY_SALARY": 20017,
            "JOB_MIN_DAILY_SALARY": 20018,
            "JOB_MAX_DAILY_SALARY": 20019,
            "JOB_MIN_HOURLY_SALARY": 20020,
            "JOB_MAX_HOURLY_SALARY": 20021,
            "JOB_MIN_ANNUAL_SALARY": 20022,
            "JOB_MAX_ANNUAL_SALARY": 20023,
            "DISPATCH_JOB_WORK_CONTENT_SCOPE_OF_CHANGE": 20101,
            "DISPATCH_JOB_WORK_LOCATION_SCOPE_OF_CHANGE": 20102,
            "DISPATCH_JOB_EMPLOYMENT_PERIOD_FIXED_TERM_OR_INDEFINITE": 20103,
            "DISPATCH_JOB_BREAK_TIME": 20104,
            "DISPATCH_JOB_WHETHER_OR_NOT_THERE_IS_OVERTIME_WORK": 20105,
            "DISPATCH_JOB_TYPES_OF_INSURANCE": 20106,
            "DISPATCH_JOB_TYPES_OF_INSURANCE_TEXT": 20107,
            "DISPATCH_JOB_REMARKS_FOR_JOB_POSTING": 20108,
            "DISPATCH_JOB_SALARY_CATEGORY_FOR_JOB_POSTING": 20109,
            "DISPATCH_JOB_SALARY_RAISE": 20110,
            "DISPATCH_JOB_BONUS": 20111,
            "DISPATCH_JOB_ALLOWANCE": 20112,
            "DISPATCH_JOB_RETIREMENT_ALLOWANCE": 20113,
            "DISPATCH_JOB_WHETHER_OR_NOT_THE_CONTRACT_HAS_BEEN_RENEWED": 20114,
            "DISPATCH_JOB_MATTERS_RELATED_TO_CONTRACT_AND_RENEWAL_LIMIT": 20115,
            "CONTRACT_WHETHER_OR_NOT_THE_CONTRACT_HAS_BEEN_RENEWED": 20201,
            "CONTRACT_TOTAL_EMPLOYMENT_PERIOD": 20202,
            "CONTRACT_PERMANENT_CONVERSION_APPLICATION_RIGHT": 20203,
            "CONTRACT_LABOR_CONDITION_NOTICE_AGREEMENT_EMPLOYMENT_TYPE_ID": 21204,
            "CONTRACT_EXPLANATION_DISPATCH_SOURCE_STAFF_ID": 21205,
            "CONTRACT_LABOR_CONDITION_NOTICE_EXPLANATION_OTHER": 21206,
            "RECRUIT_INVISIBLE_COLUMNS": [
                73
            ],
            "DEFAULT_NOT_EDITABLE_COLUMNS": [
                165,
                24,
                193,
                194,
                163,
                195,
                196,
                148,
                197,
                198,
                375,
                376,
                5230,
                5231,
                5045,
                5054,
                5055,
                5056,
                5057,
                5060,
                5066,
                5067,
                5068,
                5069,
                5070,
                5076,
                5077,
                5078,
                5079,
                5080,
                5086,
                5087,
                5088,
                5089,
                5090,
                5098,
                5099,
                5100,
                5101,
                5110,
                5140,
                5201,
                5150,
                5151,
                5239,
                5269,
                5281,
                5279,
                5280
            ],
            "DATE_TIME_PROPERTY_COLUMNS": [
                193,
                194,
                268,
                195,
                196,
                269,
                197,
                198,
                260,
                375,
                376,
                275,
                279,
                280,
                188,
                224,
                225,
                5054,
                5055,
                5053,
                5066,
                5067,
                5076,
                5077,
                5086,
                5087,
                5098,
                5099,
                5140,
                5201,
                5269,
                5281,
                5355,
                5356,
                5363,
                5364,
                325,
                326,
                16086,
                16087,
                16063,
                16064,
                7318,
                7321,
                7346,
                7306,
                7292
            ],
            "CANNOT_CHANGE_EDITABLE_PROPERTY_COLUMNS": [
                165,
                4,
                24,
                194,
                163,
                44,
                196,
                148,
                76,
                73,
                198,
                260,
                268,
                269,
                375,
                376,
                5230,
                5231,
                5045,
                5047,
                5046,
                5052,
                5053,
                5054,
                5055,
                5056,
                5057,
                5060,
                5061,
                5062,
                5063,
                5064,
                5065,
                5066,
                5067,
                5068,
                5069,
                5070,
                5071,
                5072,
                5073,
                5074,
                5075,
                7005,
                7006,
                7007,
                7008,
                5076,
                5077,
                5078,
                5079,
                5080,
                5081,
                5082,
                5083,
                5084,
                5085,
                5086,
                5087,
                5088,
                5089,
                5090,
                5091,
                5092,
                5093,
                5094,
                5095,
                5096,
                5097,
                5098,
                5099,
                5100,
                5101,
                5110,
                5111,
                5113,
                5114,
                5115,
                5116,
                5150,
                5151,
                5140,
                5201,
                5239,
                5343,
                5344,
                5240,
                5242,
                5243,
                5244,
                5245,
                5279,
                5280,
                5269,
                5281,
                222,
                223,
                183,
                5348,
                5357,
                5358,
                5355,
                5356,
                5359,
                5361,
                5366,
                5367,
                5363,
                5364,
                15446,
                15447,
                15475,
                15476,
                15473,
                15474,
                15515,
                15545,
                15546,
                15542,
                15543,
                15478,
                15479,
                15512,
                15513,
                15510,
                15511,
                15585,
                15626,
                15627,
                15623,
                15624
            ],
            "NON_EDITABLE_ON_FORM": [
                5092,
                5091,
                5213,
                5002,
                4,
                44,
                76,
                73,
                257,
                5046,
                5056,
                5057,
                5052,
                5047,
                5113,
                5114,
                5111,
                5150,
                5151,
                5387,
                5388,
                7217,
                7218,
                5349,
                5360,
                5361,
                5061,
                5062,
                5063,
                5235,
                5236,
                5071,
                5072,
                5073,
                5237,
                5238,
                5081,
                5082,
                5083,
                5233,
                5234,
                5193,
                5195,
                5196,
                5197,
                16019,
                16020,
                5242,
                5243,
                5240,
                5279,
                5280,
                5343,
                5344,
                5390,
                5391,
                5414,
                5415,
                5416,
                5417,
                5418,
                5419,
                5655,
                129,
                5232,
                222,
                223,
                183,
                15658,
                15659,
                15660,
                15898,
                15899,
                16021,
                16022,
                16124,
                16023,
                7315,
                7290,
                7300,
                7330
            ],
            "SPECIAL_FORM_COLUMNS": [
                5390,
                5391,
                21205,
                5387,
                5388,
                5680
            ],
            "RESOURCE_HEADER_COLUMNS": [
                5046,
                5052,
                5047,
                5113,
                5114,
                5111,
                5242,
                5243,
                5240,
                7217,
                7234,
                7254,
                7271,
                7237,
                7257,
                7274,
                7235,
                7255,
                7272
            ],
            "MULTI_SELECT_PULLDOWN_COLUMNS": [
                5122,
                5123,
                5124,
                5251,
                5252,
                5253,
                5387,
                5388,
                5390,
                5391,
                21205
            ],
            "IMPORT_EMPLOYMENT_STABILITY_MEASURE_COLUMNS": [
                7316
            ],
            "IMPORT_EDUCATION_TRAINING_COLUMNS": [
                7302,
                7303,
                7301
            ],
            "STAFF_SELECTOR_COLUMNS": [
                5139,
                164
            ],
            "DISPATCH_ORGANIZATION_UNIT_SELECTOR_COLUMNS": [
                5115,
                5244
            ],
            "BILLING_DESTINATION_SELECTOR_COLUMNS": [
                5116,
                5245
            ],
            "DISPATCH_STAFF_MULTI_SELECTOR_COLUMNS": [
                5122,
                5123,
                5124,
                5251,
                5252,
                5253
            ],
            "DISPATCH_SOURCE_STAFF_MULTI_SELECTOR_COLUMNS": [
                5387,
                5388,
                5390,
                5391
            ],
            "SINGLE_AUTO_SUGGEST_COLUMNS": [
                7134
            ],
            "BUSINESS_REPORT_CONTRACT_COLUMNS": [
                7316,
                7301
            ],
            "BUSINESS_REPORT_EDUCATION_TRAINING_COLUMNS": [
                7303,
                7339
            ],
            "YUBINBANGO_COLUMNS": {
                "POSTAL_CODES": [
                    5095,
                    52,
                    9,
                    5351,
                    139,
                    7006,
                    7010,
                    7014,
                    5049
                ],
                "REGION_IDS": [
                    5096,
                    53,
                    10,
                    5352,
                    140,
                    7007,
                    7011,
                    7015,
                    5050
                ],
                "ADDRESSES": [
                    5097,
                    54,
                    11,
                    5353,
                    141,
                    7008,
                    7012,
                    7016,
                    5051
                ]
            },
            "AUTO_KANA_COLUMNS": {
                "2": 3,
                "45": 46,
                "130": 131
            },
            "CHANGE_SINGLE_DISABLED_COLUMNS": {
                "dispatch_source_report_settings_second_business_employment_agencies": 7198,
                "dispatch_source_report_settings_execution_contract_work": 7204,
                "dispatch_source_report_settings_margin_ratio_publication_on_the_other_way": 7210
            },
            "CHANGE_MULTIPLE_DISABLED_COLUMNS": {
                "dispatch_source_career_staffs_job_classification_type_id": [
                    7223,
                    7224
                ]
            },
            "CHANGE_MULTIPLE_DISABLED_COLUMN_KEYS": [
                7223,
                7224
            ],
            "BELONG_TO_ORIGINAL_PROPERTY_TABLE": {
                "5122": "representative_dispatch_staffs",
                "5123": "claim_representative_dispatch_staffs",
                "5124": "commander_dispatch_staffs",
                "5251": "contract_representative_dispatch_staffs",
                "5252": "contract_claim_representative_dispatch_staffs",
                "5253": "contract_commander_dispatch_staffs",
                "5387": "representative_dispatch_source_staffs",
                "5388": "claim_representative_dispatch_source_staffs",
                "5390": "contract_representative_dispatch_source_staffs",
                "5391": "contract_claim_representative_dispatch_source_staffs",
                "21205": "contract_explanation_dispatch_source_staffs"
            },
            "HIDDEN_COLUMNS": [
                257,
                5361,
                5655
            ],
            "INVISIBLE_REQUIRED_LABEL_COLUMNS": [
                252,
                253
            ],
            "DYNAMIC_DISPLAY_REQUIRED_COLUMNS": [
                7301,
                7316
            ],
            "PERFORMED_DATETIME_DYNAMIC_DISPLAY_REQUIRED_COLUMNS": [
                7321,
                7322
            ],
            "POLIMORPHIC_COLUMNS": [
                5071,
                5072,
                5081,
                5082,
                5061,
                5062
            ],
            "IRREGULAR_RELATION_COLUMNS": [
                5674,
                5675,
                5676,
                5677,
                5678
            ],
            "DEFAULT_INPUT_VALUES": {
                "7169": 154
            },
            "DISABLED_EDIT_COLUMNS": [
                7036
            ],
            "POLYMORPHIC_COLUMN_NAMES": [
                "resource_type",
                "resource_id"
            ],
            "DISPATCH_JOB_WAGE_COLUMNS": [
                5163,
                5165,
                5166,
                5167,
                5168,
                5169,
                5170,
                5171,
                5172,
                5173,
                5174,
                5175,
                5176,
                5177,
                15889,
                5178,
                5180,
                5181,
                5182,
                5183,
                5184,
                5185,
                5186,
                5187,
                5188,
                5189,
                5190,
                5191,
                5192,
                15890
            ],
            "CONTRACT_WAGE_COLUMNS": [
                5302,
                5304,
                5305,
                5306,
                5307,
                5308,
                5309,
                5310,
                5311,
                5312,
                5313,
                5314,
                5315,
                5316,
                15891,
                5317,
                5319,
                5320,
                5321,
                5322,
                5323,
                5324,
                5325,
                5326,
                5327,
                5328,
                5329,
                5330,
                5331,
                15892
            ],
            "SUGGEST_AJAX_MODEL_NAMES": [
                "BillingDestination",
                "Candidate",
                "Company",
                "DispatchDestination",
                "DispatchJob",
                "DispatchOrganizationUnit",
                "DispatchSource",
                "DispatchSourceStaff",
                "DispatchStaff",
                "Job",
                "Staff"
            ],
            "DIFFERENCE_OF_INPUT_CATEGORY_AND_RESOURCE_FIELD_TYPE_DATE_TYPE_COLUMN": [
                5098,
                5099,
                193,
                268,
                224,
                188,
                362,
                330,
                329,
                325,
                331,
                194,
                195,
                269,
                279,
                275,
                280,
                196,
                5269,
                5281,
                5054,
                5055,
                5140,
                5201,
                5086,
                7173,
                5087,
                5066,
                7171,
                5067,
                5076,
                7172,
                5077,
                197,
                260,
                198,
                180,
                364,
                375,
                376
            ],
            "DISPATCH_START_TIME_COLUMNS": [
                5157,
                5295
            ],
            "DISPATCH_END_TIME_COLUMNS": [
                5158,
                5296
            ],
            "DISPATCH_INSURANCE_WELFARE_PENSION_FUND_COLUMNS": [
                16132
            ],
            "MS_CALC_API_MASTER_COLUMNS": [
                16127,
                16131,
                16132,
                16146
            ],
            "REQUIRE_MODIFIED_SELECT_COLUMNS": [
                7291,
                7303
            ],
            "REQUIRE_CONTRACT_SELECT_DATE_COLUMNS": [
                7306,
                7321
            ],
            "PROFILE_INVISIBLE_COLUMNS": [
                7303,
                7302
            ],
            "CHANGE_RESOURCE_LIST_COLUMNS": {
                "7304": "trainingEntityTypeId",
                "7306": "trainingDatetime",
                "7321": "performedDatetime",
                "7322": "performedClassificationTypeId"
            },
            "SELECT_RESOURCE_LIST_COLUMNS": [
                7301,
                7316
            ],
            "REFLECT_API_RESULT_ON_CHANGE": {
                "7306": 7301
            },
            "USE_DIRECT_VALUE_DISABLE_MODEL_VALUE_READER": [
                7339
            ],
            "CAN_CHANGE_STATE_COLORS": [
                4,
                44,
                76,
                5111,
                5047
            ],
            "EXISTS_IS_SYSTEM_DEFAULT_MODELS": [
                "App\\Models\\Sex",
                "App\\Models\\JobState"
            ]
        },
        "properties": {
            "alias": null,
            "another_name": null,
            "created_at": null,
            "date_type_id": null,
            "default_value": null,
            "deleted_at": null,
            "dependent_property_column_id": null,
            "display_name": null,
            "editable": "1",
            "false_text": null,
            "free_items_group_id": null,
            "has_master_edit_form": "0",
            "help_text": null,
            "id": 0,
            "input_category_id": null,
            "is_display_middle_pane": "0",
            "is_export": "1",
            "is_fixed_item": "0",
            "is_free_item": "1",
            "is_highlighted": "0",
            "is_iframe_free_word": "0",
            "is_mail_print": "0",
            "is_matching_view": "1",
            "is_not_null": null,
            "is_public": "1",
            "is_summary": "0",
            "is_system_default": "0",
            "is_system_display_name": "0",
            "is_user_resource": "0",
            "is_validate_mail_domain": "1",
            "is_validate_mail_format": "1",
            "max_digit": null,
            "max_length": null,
            "medium_comment": null,
            "min_digit": null,
            "min_length": null,
            "model_name": null,
            "name": null,
            "placeholder": null,
            "position": null,
            "property_category_id": null,
            "property_table_id": null,
            "public_alias": null,
            "required": "0",
            "textarea_row_count": "10",
            "true_text": null,
            "updated_at": null,
            "propertyTable": null,
            "fixedDefaults": null,
            "propertyCategory": null,
            "inputCategory": null,
            "freeItemConfig": null,
            "resourceSubstance": null,
            "numberColumn": null,
            "propertyColumnCalculation": null,
            "searchColumns": null,
            "mypageDashboards": null,
            "searchProperties": null,
            "resultColumns": null,
            "freeItemsGroup": null,
            "freeRadioOptions": null,
            "freeSelectOptions": null,
            "freeCheckboxOptions": null,
            "alertSettingConditions": null
        },
        "relations": {
            "propertyTable": "PropertyTable",
            "fixedDefaults": "FixedDefault",
            "propertyCategory": "PropertyCategory",
            "inputCategory": "InputCategory",
            "freeItemConfig": "FreeItemConfig",
            "resourceSubstance": "ResourceSubstance",
            "numberColumn": "NumberColumn",
            "propertyColumnCalculation": "PropertyColumnCalculation",
            "searchColumns": "SearchColumn",
            "mypageDashboards": "MypageDashboard",
            "searchProperties": "SearchProperty",
            "resultColumns": "ResultColumn",
            "freeItemsGroup": "FreeItemsGroup",
            "freeRadioOptions": "FreeRadioOption",
            "freeSelectOptions": "FreeSelectOption",
            "freeCheckboxOptions": "FreeCheckboxOption",
            "alertSettingConditions": "AlertSettingCondition"
        },
        "appends": [
            "canChangeEditable",
            "isScoped",
            "modelOptions",
            "defaultInputValue",
            "disabledEdit"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_columns"
    },
    "PropertyColumnCalculation": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "formula": null,
            "id": 0,
            "property_column_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_column_calculations"
    },
    "PropertyDetailComponent": {
        "constants": {
            "COMPANY_PROPFILE": 1,
            "COMPANY_PROGRESS": 2,
            "COMPANY_JOB": 3,
            "COMPANY_FILE": 4,
            "COMPANY_STAFF": 5,
            "COMPANY_DATA": 6,
            "COMPANY_IMAGE": 7,
            "COMPANY_STEP": 8,
            "COMPANY_DISPATCH_DESTINATION": 26,
            "COMPANY_BILLING_DESTINATIONS": 27,
            "CANDIDATE_PROFILE": 9,
            "CANDIDATE_PROGRESS": 10,
            "CANDIDATE_FILE": 11,
            "CANDIDATE_STEP": 12,
            "JOB_PROFILE": 18,
            "JOB_PROGRESS": 19,
            "JOB_FILE": 21,
            "JOB_PHOTO": 23,
            "JOB_STAFF": 24,
            "JOB_DATA": 25,
            "BILLING_DESTINATIONS_PROFILE": 28,
            "BILLING_DESTINATIONS_STEP": 29,
            "DISPATCH_ORGANIZATION_UNIT_PROFILE": 30,
            "DISPATCH_ORGANIZATION_UNIT_STEP": 31,
            "DISPATCH_STAFF_PROFILE": 32,
            "DISPATCH_STAFF_STEP": 33,
            "DISPATCH_WORKING_PLACE_PROFILE": 34,
            "DISPATCH_WORKING_PLACE_STEP": 35,
            "DISPATCH_DESTINATION_STAFF": 36,
            "DISPATCH_JOB_PROFILE": 37,
            "DISPATCH_JOB_PROGRESS": 38,
            "DISPATCH_JOB_FILE": 48,
            "DISPATCH_DESTINATION_PROFILE": 39,
            "DISPATCH_DESTINATION_DISPATCH_JOB": 40,
            "COMPANY_DISPATCH_JOB": 41,
            "STAFF_PROFILE": 42,
            "STAFF_STEP": 43,
            "CONTRACT_PROFILE": 44,
            "CONTRACT_FILE": 49,
            "DISPATCH_SOURCE_PROFILE": 45,
            "DISPATCH_SOURCE_STAFF": 46,
            "DISPATCH_SOURCE_STAFF_PROFILE": 47,
            "DISPATCH_DESTINATION_DISPATCH_WORKING_PLACE": 50,
            "DISPATCH_DESTINATION_DISPATCH_ORGANIZATION_UNITS": 51,
            "DISPATCH_DESTINATION_CANDIDATE_JOB_STEP_RESOURCES": 52,
            "DISPATCH_DESTINATION_CONTRACTS": 53,
            "DISPATCH_JOB_CONTRACTS": 54,
            "CONTRACT_CONTRACT_MEMO": 55,
            "CONTRACT_MEMO_PROFILE": 56,
            "CANDIDATE_CONTRACTS": 57,
            "CANDIDATE_CONFLICT_DATE_MANAGEMENTS": 58,
            "DISPATCH_DESTINATION_CONFLICT_DATE_MANAGEMENTS": 59,
            "CONFLICT_DATE_DEFAULTS": 60,
            "INVOICE_CLOSED_ATTENDANCE_PROFILE": 61,
            "INVOICE_CLOSED_ATTENDANCE_BREAKDOWN": 62,
            "INVOICE_CLOSED_ATTENDANCE_ACTUAL_AMOUNT_OVER_SHORTS": 63,
            "PAYMENT_CLOSED_ATTENDANCE_ACTUAL_AMOUNT_OVER_SHORTS": 64,
            "PAYMENT_CLOSED_ATTENDANCE_PROFILE": 65,
            "PAYMENT_CLOSED_ATTENDANCE_BREAKDOWN": 66,
            "INVOICE_CLOSED_INVOICE_PROFILE": 67,
            "INVOICE_CLOSED_INVOICE_BREAKDOWN": 68,
            "PAYMENT_CLOSED_PAYMENT_PROFILE": 69,
            "PAYMENT_CLOSED_PAYMENT_BREAKDOWN": 70,
            "DISPATCH_SOURCE_CAREER_STAFF": 71,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_MASTER": 72,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_MASTER_2": 73,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_MASTER_3": 74,
            "DISPATCH_SOURCE_CAREER_STAFF_PROFILE": 75,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_PROFILE": 76,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_PROFILE": 77,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_PROFILE": 78,
            "CANDIDATE_CAREER_COUNSELLING_IN_CANDIDATE": 79,
            "CANDIDATE_EDUCATION_AND_TRAINING_IN_CANDIDATE": 80,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_IN_CANDIDATE": 81,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_IN_CANDIDATE": 82,
            "CANDIDATE_EDUCATION_AND_TRAINING_IN_CONTRACT": 83,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_IN_CONTRACT": 84,
            "CANDIDATE_CAREER_COUNSELLING_PROFILE": 85,
            "CANDIDATE_EDUCATION_AND_TRAINING_PROFILE": 86,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_PROFILE": 87,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_PROFILE": 88,
            "CANDIDATE_CONTRACT_IN_EDUCATION_AND_TRAINING": 89,
            "CANDIDATE_CONTRACT_IN_EMPLOYMENT_STABILITY_MEASURE": 90,
            "SALE_PROFILE": 91,
            "SALE_FILE": 92,
            "SALE_COMPANY": 93,
            "SALE_CANDIDATE": 94,
            "SALE_JOB": 95,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "detail_component_type_id": null,
            "detail_screen_property_table_id": null,
            "id": 0,
            "is_display_header": "1",
            "maintitle": null,
            "position": null,
            "property_sublist_id": null,
            "subtitle": null,
            "updated_at": null,
            "propertySublist": null,
            "propertyDetailComponents": null,
            "propertySublistBatchActions": null
        },
        "relations": {
            "propertySublist": "PropertySublist",
            "propertyDetailComponents": "PropertyDetailComponent",
            "propertySublistBatchActions": "PropertySublistBatchAction"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_detail_components"
    },
    "PropertyStaticColumn": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "display_name": null,
            "id": 0,
            "name": null,
            "property_table_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_static_columns"
    },
    "PropertySublist": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "is_editable": "1",
            "position": null,
            "sublist_property_table_id": null,
            "updated_at": null,
            "propertySublistColumns": null,
            "propertyTable": null,
            "propertyDetailComponents": null
        },
        "relations": {
            "propertySublistColumns": "PropertySublistColumn",
            "propertyTable": "PropertyTable",
            "propertyDetailComponents": "PropertyDetailComponent"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_sublists"
    },
    "PropertySublistBatchAction": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "option_label": null,
            "position": null,
            "property_detail_component_id": null,
            "updated_at": null,
            "vue_component": null,
            "vue_component_strategy": null,
            "propertyDetailComponent": null
        },
        "relations": {
            "propertyDetailComponent": "PropertyDetailComponent"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_sublist_batch_actions"
    },
    "PropertySublistColumn": {
        "constants": {
            "RESOURCE_DEFAULT_DUMMY_PROPERTY_CATEGORY": {
                "id": 8888,
                "display_name": "基本項目"
            },
            "RESOURCE_STATE_DUMMY_PROPERTY_CATEGORY": {
                "id": 9999,
                "display_name": "進捗日時表示"
            },
            "RESOURCE_STATE_PREFIX": "state-id-",
            "SYSTEM_FIX_POSITION": 10000,
            "RESOURCE_TABLE_DEFAULT_RESULT_COLUMNS": {
                "67": [
                    5001,
                    5002,
                    148,
                    5008,
                    5044,
                    80,
                    82,
                    7,
                    203
                ],
                "5014": [
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278
                ]
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "is_connect_state": "0",
            "is_editable": "1",
            "position": null,
            "property_column_id": null,
            "property_sublist_id": null,
            "state_id": null,
            "state_type": null,
            "updated_at": null,
            "propertySublist": null,
            "propertyColumn": null
        },
        "relations": {
            "propertySublist": "PropertySublist",
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_sublist_columns"
    },
    "PropertyTab": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "COMPANY_DISPATCH_RELATED_ITEMS": 7001,
            "DISPATCH_JOB_WORKING_CONDITIONS": 7002,
            "CONTRACT_WORKING_CONDITIONS": 7003,
            "CANDIDATE_DISPATCH_RELATED_ITEMS": 7004,
            "CS_MASTER_COMPANY_REPORT_RELATION_ITEMS": 7005,
            "CS_MASTER_DISPATCH_DESTINATION_REPORT_RELATION_ITEMS": 7006,
            "CS_MASTER_CONTRACT_REPORT_RELATION_ITEMS": 7007,
            "CS_MASTER_DISPATCH_JOB_REPORT_RELATION_ITEMS": 7008,
            "PAYMENT_CLOSED_ATTENDANCE_DEDUCTIONS": 8000,
            "DISPATCH_SOURCE_REPORT_SETTING_FIRST": 8001,
            "DISPATCH_SOURCE_REPORT_SETTING_FOURTH": 8002,
            "DISPATCH_SOURCE_REPORT_SETTING_FIFTH": 8002,
            "DISPATCH_SOURCE_REPORT_SETTING_TWELVE": 8003,
            "DISPATCH_SOURCE_CAREER_STAFF_DEFAULT": 8004,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREER_DEFAULT": 8005,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETY_DEFAULT": 8006,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHER_DEFAULT": 8007,
            "DISPATCH_SOURCE_REPORT_SETTING_SECOND": 8008,
            "CANDIDATE_CAREER_COUNSELLING_DEFAULT": 8009,
            "CANDIDATE_EDUCATION_AND_TRAINING_DEFAULT": 8010,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_DEFAULT": 8011,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCH_DEFAULT": 8012,
            "WOKING_CONDITION_TABS": [
                7002,
                7003,
                7004
            ],
            "SYSTEM_USE_CATEGORIES": []
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "is_plan_dispatch_basic": "1",
            "is_plan_dispatch_bill": "0",
            "is_plan_dispatch_payroll": "1",
            "is_plan_employment_agency": "1",
            "is_plan_spot": "1",
            "is_system_default": null,
            "name": null,
            "position": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyTable": null,
            "propertyCategories": null,
            "searchPropertyCategories": null
        },
        "relations": {
            "propertyTable": "PropertyTable",
            "propertyCategories": "PropertyCategory",
            "searchPropertyCategories": "SearchPropertyCategory"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_tabs"
    },
    "PropertyTable": {
        "constants": {
            "ITEM_SETTING_NAMES": {
                "2": "side.candidates",
                "3": "side.companies",
                "14": "side.staffs",
                "5001": "side.billing_destinations",
                "4": "display_setting.jobs",
                "78": "side.sales",
                "5012": "side.candidate_job_step_resources",
                "5013": "side.candidate_step_resources",
                "5014": "side.company_step_resources",
                "66": "side.candidate_step_states",
                "77": "side.company_step_states",
                "5018": "side.dispatch_destinations",
                "5021": "side.dispatch_staffs",
                "5023": "side.dispatch_working_places",
                "5025": "side.dispatch_organization_units",
                "5027": "side.dispatch_jobs",
                "5041": "side.contracts",
                "5052": "side.dispatch_sources",
                "5054": "side.dispatch_source_staffs",
                "5106": "side.candidate_career_counsellings",
                "5107": "side.candidate_education_and_trainings",
                "5108": "side.candidate_employment_stability_measures",
                "5075": "side.contract_memos"
            },
            "CANDIDATES": 2,
            "COMPANIES": 3,
            "JOBS": 4,
            "SCHEDULES_MIGRATION_FROM_MG1": 75,
            "MAIL_TEMPLATES": 10,
            "CANDIDATE_FILES": 12,
            "CANDIDATE_USERS": 18,
            "COMPANY_USERS": 19,
            "EDUCATIONS": 20,
            "CAREERS": 22,
            "JOB_USERS": 23,
            "STAFFS": 14,
            "FILES": 69,
            "JOB_FILES": 15,
            "JOB_PHOTOS": 93,
            "COMPANY_FILES": 94,
            "COMPANY_PHOTOS": 95,
            "USERS": 1,
            "INDUSTRIES": 46,
            "COMPANY_STEPS": 65,
            "PARENT_COMPANIES": 71,
            "BILLING_COMPANIES": 72,
            "FREE_ITEM_CATEGORIES": 25,
            "FREE_SELECT_OPTIONS": 26,
            "FREE_CHECKBOX_OPTIONS": 27,
            "FREE_RADIO_OPTIONS": 28,
            "FREE_TEXT_ITEMS": 29,
            "FREE_TEXTAREA_ITEMS": 30,
            "FREE_SELECT_ITEMS": 31,
            "FREE_CHECKBOX_ITEMS": 32,
            "FREE_URL_ITEMS": 33,
            "FREE_DATE_ITEMS": 34,
            "FREE_NUMBER_ITEMS": 35,
            "FREE_RADIO_ITEMS": 36,
            "FREE_BOOLEAN_OPTIONS": 104,
            "FREE_BOOLEAN_ITEMS": 105,
            "MYPAGE_DASHBOARDS": 41,
            "SETTINGS": 74,
            "CANDIDATE_PHOTOS": 76,
            "COMPANY_STEP_STATES": 77,
            "SALES": 78,
            "SALE_STATES": 79,
            "SALE_REFUNDS": 82,
            "AGENCY": 80,
            "AGENT": 81,
            "CANDIDATE_STEPS": 64,
            "CANDIDATE_JOB_STEPS": 67,
            "CANDIDATE_JOB_STEP_STATES": 68,
            "CANDIDATE_STEP_STATES": 66,
            "ROUDOUKYOKU_CATEGORIES": 62,
            "DEPARTMENT": 84,
            "STATIC_FUNCTIONS": 83,
            "SCHEDULES": 86,
            "SCHEDULE_COMPANIES": 89,
            "SCHEDULE_ROOMS": 90,
            "SCHEDULE_USERS": 91,
            "MEETING_SCHEDULES": 96,
            "VISITOR_SCHEDULES": 97,
            "VISITOR_USER_RESOURCES": 98,
            "SALES_SCHEDULES": 99,
            "SCHEDULE_STAFFS": 100,
            "OTHER_SCHEDULES": 101,
            "SCHEDULE_CANDIDATES": 102,
            "VISITOR_SCHEDULE_STAFFS": 103,
            "MAIL": 7,
            "TASKS": 85,
            "ACCOUNT_CATEGORIES": 106,
            "FEE_TYPES": 107,
            "LOCALES": 108,
            "MAIL_RECEIVE_PROTOCOLS": 109,
            "MAIL_TYPES": 110,
            "RECEIVE_MAIL_STATES": 111,
            "ROUNDING_TYPES": 112,
            "SCHEDULE_CATEGORIES": 113,
            "SEARCH_MODES": 114,
            "SEND_MAIL_STATES": 115,
            "TAX_RATES": 116,
            "TIMEZONES": 117,
            "USER_ROLES": 118,
            "STAFF_STATES": 119,
            "HAKEN_TABLE_START_ID": 5001,
            "HAKEN_POSITION_BASE": 5001,
            "BILLING_DESTINATIONS": 5001,
            "AMOUNT_OVER_SHORTS": 5002,
            "FRACTION_PROCESSES": 5003,
            "WAGES": 5004,
            "TRAVEL_EXPENSES": 5005,
            "FREE_ITEMS_GROUPS": 5006,
            "FREE_TEL_ITEMS": 5007,
            "FREE_TIME_ITEMS": 5008,
            "FREE_MAIL_ITEMS": 5009,
            "FREE_REFERENCE_ITEMS": 5010,
            "FREE_CALC_ITEMS": 5011,
            "CANDIDATE_JOB_STEP_RESOURCES": 5012,
            "CANDIDATE_STEP_RESOURCES": 5013,
            "COMPANY_STEP_RESOURCES": 5014,
            "CANDIDATE_JOB_STEP_RESOURCES_FOR_APIV2_STEP": 5015,
            "CANDIDATE_STEP_RESOURCES_FOR_APIV2_STEP": 5016,
            "COMPANY_STEP_RESOURCES_FOR_APIV2_STEP": 5017,
            "DISPATCH_DESTINATIONS": 5018,
            "DISPATCH_DESTINATION_STATES": 5019,
            "FREE_DATETIME_ITEMS": 5020,
            "DISPATCH_STAFFS": 5021,
            "DISPATCH_STAFF_STATES": 5022,
            "DISPATCH_WORKING_PLACES": 5023,
            "DISPATCH_WORKING_PLACE_STATES": 5024,
            "DISPATCH_ORGANIZATION_UNITS": 5025,
            "DISPATCH_ORGANIZATION_UNIT_STATES": 5026,
            "DISPATCH_JOBS": 5027,
            "DISPATCH_JOB_STATES": 5028,
            "DISPATCH_JOB_STAFF_MULTI_ASSIGNMENTS": 5029,
            "DISPATCH_JOB_WORKING_PLACES": 5030,
            "DISPATCH_JOB_WORKING_HOURS": 5031,
            "DISPATCH_JOB_WAGES": 5032,
            "DISPATCH_JOB_AMOUNT_OVER_SHORTS": 5033,
            "DISPATCH_JOB_USERS": 5034,
            "INVOICE_DATA": 5035,
            "PAYMENT_DATA": 5036,
            "PAID_LEAVES": 5037,
            "REPRESENTATIVE_DISPATCH_STAFFS": 5038,
            "CLAIM_REPRESENTATIVE_DISPATCH_STAFFS": 5039,
            "COMMANDER_DISPATCH_STAFFS": 5040,
            "CONTRACTS": 5041,
            "CONTRACT_STATES": 5042,
            "CONTRACT_STAFF_MULTI_ASSIGNMENTS": 5043,
            "CONTRACT_WORKING_PLACES": 5044,
            "CONTRACT_WORKING_HOURS": 5045,
            "CONTRACT_WAGES": 5046,
            "CONTRACT_AMOUNT_OVER_SHORTS": 5047,
            "CONTRACT_REPRESENTATIVE_DISPATCH_STAFFS": 5049,
            "CONTRACT_CLAIM_REPRESENTATIVE_DISPATCH_STAFFS": 5050,
            "CONTRACT_COMMANDER_DISPATCH_STAFFS": 5051,
            "DISPATCH_SOURCES": 5052,
            "DISPATCH_SOURCE_STATES": 5053,
            "DISPATCH_SOURCE_STAFFS": 5054,
            "DISPATCH_SOURCE_STAFF_STATES": 5055,
            "DISPATCH_JOB_AMOUNT_OVER_SHORT_DAYS": 5056,
            "CONTRACT_AMOUNT_OVER_SHORT_DAYS": 5057,
            "DISPATCH_JOB_REPRESENTATIVE_DISPATCH_SOURCE_STAFFS": 5058,
            "DISPATCH_JOB_CLAIM_REPRESENTATIVE_DISPATCH_SOURCE_STAFFS": 5059,
            "CONTRACT_REPRESENTATIVE_DISPATCH_SOURCE_STAFFS": 5060,
            "CONTRACT_CLAIM_REPRESENTATIVE_DISPATCH_SOURCE_STAFFS": 5061,
            "DISPATCH_JOB_SOURCE_STAFF_MULTI_ASSIGNMENTS": 5062,
            "CONTRACT_SOURCE_STAFF_MULTI_ASSIGNMENTS": 5063,
            "ACTUAL_AMOUNT_OVER_SHORTS": 5064,
            "INVOICE_CLOSED_ATTENDANCES": 5065,
            "INVOICE_CLOSED_ATTENDANCE_STATES": 5066,
            "INVOICE_CLOSED_INVOICES": 5067,
            "INVOICE_CLOSED_INVOICE_STATES": 5068,
            "PAYMENT_CLOSED_ATTENDANCES": 5069,
            "PAYMENT_CLOSED_ATTENDANCE_STATES": 5070,
            "PAYMENT_CLOSED_PAYMENTS": 5071,
            "PAYMENT_CLOSED_PAYMENT_STATES": 5072,
            "ATTENDANCES": 5074,
            "CONTRACT_MEMOS": 5075,
            "CANDIDATE_DISPATCH_BASICS": 5076,
            "CANDIDATE_DISPATCH_INSURANCES": 5077,
            "PAYMENT_DATE_SETTINGS": 5078,
            "CONFLICT_DATE_MANAGEMENTS": 5079,
            "CANDIDATE_CONFLICT_DATE_MANAGEMENTS": 5080,
            "DISPATCH_DESTINATION_CONFLICT_DATE_MANAGEMENTS": 5081,
            "DISPATCH_SPOT_JOBS": 5082,
            "ALERTS": 5083,
            "ALERT_NOTIFICATIONS": 5084,
            "CONFLICT_DATE_DEFAULTS": 5085,
            "CANDIDATE_CONFLICT_DATE_DEFAULTS": 5086,
            "INVOICE_CONTRACT_ATTENDANCES": 5089,
            "PAYMENT_CONTRACT_ATTENDANCES": 5090,
            "CALC_RECORDS_MAPPINGS": 5091,
            "INVOICE_COPY_ATTENDANCES": 5092,
            "PAYMENT_COPY_ATTENDANCES": 5093,
            "INVOICE_COPY_ACTUAL_AMOUNT_OVER_SHORTS": 5094,
            "PAYMENT_COPY_ACTUAL_AMOUNT_OVER_SHORTS": 5095,
            "CANDIDATE_WAGES": 5096,
            "CANDIDATE_PAYMENT_DATA": 5097,
            "INVOICE_CLOSED_INVOICE_HISTORIES": 5098,
            "PAYMENT_CLOSED_PAYMENT_HISTORIES": 5099,
            "ATTENDANCE_CALCULATIONS": 5100,
            "DISPATCH_SOURCE_REPORT_SETTINGS": 5101,
            "DISPATCH_SOURCE_CAREER_STAFFS": 5102,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_CAREERS": 5103,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_SAFETIES": 5104,
            "DISPATCH_SOURCE_EDUCATION_TRAINING_OTHERS": 5105,
            "CANDIDATE_CAREER_COUNSELLINGS": 5106,
            "CANDIDATE_EDUCATION_AND_TRAININGS": 5107,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURES": 5108,
            "CANDIDATE_EMPLOYMENT_PLACEMENT_DISPATCHES": 5109,
            "BILLING_DESTINATION_STATES": 5110,
            "SYSTEM_DEFAULT_OPTION_AGREEMENT_EMPLOYMENT_TYPES": 5111,
            "SYSTEM_DEFAULT_OPTION_AMOUNT_OVER_SHORT_TYPES": 5112,
            "SYSTEM_DEFAULT_OPTION_ATTENDANCE_TYPES": 5113,
            "SYSTEM_DEFAULT_OPTION_BILL_TYPES": 5114,
            "SYSTEM_DEFAULT_OPTION_BOOLEAN_APPROVE_TYPES": 5115,
            "SYSTEM_DEFAULT_OPTION_BOOLEAN_DEFAULT_TYPES": 5116,
            "SYSTEM_DEFAULT_OPTION_BOOLEAN_EXISTENCE_TYPES": 5117,
            "SYSTEM_DEFAULT_OPTION_CABINET_ORDER_INDUSTRY_TYPES": 5118,
            "SYSTEM_DEFAULT_OPTION_CONTRACT_MEMO_TYPES": 5119,
            "SYSTEM_DEFAULT_OPTION_DATE_ONLY_TYPES": 5120,
            "SYSTEM_DEFAULT_OPTION_DAY_OF_THE_WEEK_TYPES": 5121,
            "SYSTEM_DEFAULT_OPTION_DISPATCH_JOB_TYPES": 5122,
            "SYSTEM_DEFAULT_OPTION_EXPENSE_PROVISION_TYPES": 5123,
            "SYSTEM_DEFAULT_OPTION_FRACTION_ROUNDING_TYPES": 5124,
            "SYSTEM_DEFAULT_OPTION_IS_TARGET_OVER_AGE_60_TYPES": 5125,
            "SYSTEM_DEFAULT_OPTION_LEAVE_TIME_TYPES": 5126,
            "SYSTEM_DEFAULT_OPTION_MONTHLY_TYPES": 5127,
            "SYSTEM_DEFAULT_OPTION_PAYMENT_TIME_TYPES": 5128,
            "SYSTEM_DEFAULT_OPTION_REPEAT_INTERVAL_TYPES": 5129,
            "SYSTEM_DEFAULT_OPTION_REPEAT_MONTHLY_TYPES": 5130,
            "SYSTEM_DEFAULT_OPTION_TAX_ROUNDING_TYPES": 5131,
            "SYSTEM_DEFAULT_OPTION_TAXATION_TYPES": 5132,
            "SYSTEM_DEFAULT_OPTION_TERM_LIMIT_TYPES": 5133,
            "SYSTEM_DEFAULT_OPTION_TIME_ROUNDING_TYPES": 5134,
            "SYSTEM_DEFAULT_OPTION_WAGE_TYPES": 5135,
            "SYSTEM_DEFAULT_OPTION_WEEK_TYPES": 5136,
            "SYSTEM_DEFAULT_OPTION_YEARLY_WORKING_DAY_TYPES": 5137,
            "CONTRACT_EXPLANATION_DISPATCH_SOURCE_STAFFS": 5138,
            "DUMMY_DATA": 99998,
            "DUMMY_DATA_REPORTS": 99999,
            "DUMMY_DASHBOARD": 100000,
            "VIRTUAL_MODEL_PROPERTY_TABLES": [
                5027,
                5038,
                5039,
                5040,
                5049,
                5050,
                5051,
                5058,
                5059,
                5060,
                5061,
                5138
            ],
            "VIRTUAL_MODEL_PROPERTY_TABLES_FOR_DISPATCH_STAFF": [
                5038,
                5039,
                5040
            ],
            "VIRTUAL_MODEL_PROPERTY_TABLES_FOR_DISPATCH_SOURCE_STAFF": [
                5058,
                5059,
                5060,
                5061,
                5138
            ],
            "FREE_ITEM_TABLES": {
                "29": 1,
                "30": 2,
                "31": 3,
                "32": 4,
                "33": 5,
                "34": 6,
                "35": 7,
                "36": 8,
                "5007": 22,
                "5008": 16,
                "5009": 12,
                "5010": 18,
                "5011": 20,
                "5020": 21
            },
            "FREE_OPTIONS": {
                "31": 3,
                "32": 4,
                "36": 8
            },
            "SCHEDULE_TABLES": [
                96,
                97,
                99,
                101,
                98
            ],
            "STEP_RESOURCE_APIV2_VIRTUAL_TABLES": [
                5015,
                5016,
                5017
            ],
            "CASCADER_CATEGORY_TABLE_ID_ORDER": 0,
            "CASCADER_DISPLAY_TABLE_ID_ORDER": 1,
            "CASCADER_DISPLAY_COLUMN_ID_ORDER": 3,
            "TOP_REFERENCE_TABLES": [
                2,
                3,
                5052
            ],
            "EXISTING_RESOURCES": [
                2,
                3,
                4,
                67
            ],
            "STEP_TABLE_IDS": [
                64,
                67,
                65
            ],
            "BUSINESS_REPORT_TABLE_IDS": [
                5106,
                5107,
                5108
            ],
            "STEP_RESOURCE_TABLE_IDS": [
                5012,
                5013,
                5014
            ],
            "CLOSED_RESOURCE_TABLE_IDS": [
                5067,
                5071
            ],
            "ATTENDANCE_RESOURCE_TABLE_IDS": [
                5065,
                5069,
                5067,
                5071
            ],
            "CONFLICT_DATE_RESOURCE_TABLE_IDS": [
                5079,
                5080,
                5081,
                5085
            ],
            "STEP_TABLE_ID_TO_STEP_RESOURCE_ID_MAP": {
                "67": 5012,
                "64": 5013,
                "65": 5014
            },
            "EXPORT_PROPERTIES_FOR_CASCADER_REJECT_TABLES": {
                "5027": [
                    1,
                    14,
                    5001,
                    5052
                ],
                "5012": [
                    5001,
                    5018,
                    5052
                ],
                "64": [
                    1
                ],
                "65": [
                    1,
                    14
                ],
                "5041": [
                    1,
                    4,
                    14,
                    5052,
                    67
                ],
                "2": [
                    1
                ],
                "3": [
                    1
                ],
                "4": [
                    1
                ],
                "14": [
                    1
                ],
                "5001": [
                    1
                ],
                "5018": [
                    1
                ],
                "5021": [
                    1
                ],
                "78": [
                    5001,
                    5018,
                    5027,
                    5052
                ],
                "5089": [
                    1,
                    4
                ],
                "5090": [
                    1,
                    4
                ],
                "5064": [
                    1,
                    4
                ],
                "5065": [
                    1,
                    4,
                    5067
                ],
                "5092": [
                    1,
                    4,
                    5067
                ],
                "5094": [
                    1,
                    4,
                    5067
                ],
                "5067": [
                    1,
                    4
                ],
                "5069": [
                    1,
                    4
                ],
                "5093": [
                    1,
                    4,
                    5071
                ],
                "5095": [
                    1,
                    4,
                    5071
                ],
                "5071": [
                    1,
                    4
                ],
                "5075": [
                    1,
                    2,
                    3,
                    4,
                    5001,
                    5018,
                    5025,
                    5027,
                    14,
                    5052,
                    67
                ]
            },
            "EXPORT_PROPERTIES_FOR_CASCADER_REJECT_CATEGORIES": {
                "5027": [
                    5118
                ]
            },
            "EXPORT_PROPERTIES_FOR_CASCADER_REJECT_COLUMNS": {
                "67": [
                    5044
                ]
            },
            "STEPS_SUBLIST_PROPERTIES_FOR_CASCADER_REJECT_COLUMNS": {
                "67": [
                    184,
                    186
                ]
            },
            "MATCHING_VIEW_RESOURCES": [
                2,
                4,
                5027
            ],
            "LOAD_SEE_MORE_SUBLIST_TABLES": [
                5054,
                5102,
                5103,
                5104,
                5105,
                5075,
                5013,
                4,
                5027,
                14,
                5014,
                5018,
                5001,
                5021,
                5023,
                5025,
                5041,
                5080,
                5081,
                5085,
                5065,
                5069,
                5092,
                5093,
                5094,
                5095,
                5106,
                5107,
                5108,
                5109
            ],
            "PARSE_POLYMORPHIC_RESOURCE_REFERENCE_ONLY_AS_DISPATCH_DESTINATIONS": [
                5021,
                5023,
                5025
            ],
            "CONSIDERED_AS_OWN_RESOURCES": [
                [
                    67,
                    5012
                ],
                [
                    64,
                    5013
                ],
                [
                    65,
                    5014
                ]
            ],
            "RESOURCES_STATE_OPTIONS": {
                "5001": 5091,
                "67": 191,
                "64": 327,
                "2": 4,
                "65": 278,
                "3": 44,
                "5041": 5240,
                "5018": 5047,
                "5027": 5111,
                "5021": 5063,
                "4": 76,
                "78": 183,
                "14": 5232
            },
            "RESOURCES_STATE_MODELS": {
                "5001": "App\\Models\\BillingDestinationState",
                "67": "App\\Models\\CandidateJobStepState",
                "64": "App\\Models\\CandidateStepState",
                "2": "App\\Models\\CandidateState",
                "65": "App\\Models\\CompanyStepState",
                "3": "App\\Models\\CompanyState",
                "5041": "App\\Models\\ContractState",
                "5018": "App\\Models\\DispatchDestinationState",
                "5027": "App\\Models\\DispatchJobState",
                "5021": "App\\Models\\DispatchStaffState",
                "4": "App\\Models\\JobState",
                "78": "App\\Models\\SaleState",
                "14": "App\\Models\\StaffState"
            },
            "STEP_AND_RESOURCE_MODEL_PROPERTY_TABLE_MAPPINGS": {
                "App\\Models\\CandidateStepResource": 5013,
                "App\\Models\\CandidateJobStepResource": 5012,
                "App\\Models\\CandidateStep": 5013,
                "App\\Models\\CompanyStep": 5014
            },
            "HAS_NOT_SHOW_VIEW_PRIMARY_TABLE_NAMES": [
                "candidate_steps",
                "candidate_job_step_resources",
                "company_steps",
                "sales"
            ],
            "SPECIAL_PARENT_PROPERTY_TABLE_MAPPINGS": {
                "5085": 2
            },
            "DISPATCH_SOURCE_EDUCATION_TRAININGS": [
                5103,
                5104,
                5105
            ],
            "SPECIAL_NAME": {
                "96": "schedules",
                "97": "schedules",
                "99": "schedules",
                "101": "schedules",
                "98": "schedules",
                "103": "schedule_staffs",
                "5016": "candidate_step_resources",
                "5015": "candidate_job_step_resources",
                "5017": "company_step_resources",
                "5027": "jobs",
                "5034": "job_users",
                "5038": "dispatch_job_staff_multi_assignments",
                "5039": "dispatch_job_staff_multi_assignments",
                "5040": "dispatch_job_staff_multi_assignments",
                "5049": "contract_staff_multi_assignments",
                "5050": "contract_staff_multi_assignments",
                "5051": "contract_staff_multi_assignments",
                "5058": "dispatch_job_source_staff_multi_assignments",
                "5059": "dispatch_job_source_staff_multi_assignments",
                "5060": "contract_source_staff_multi_assignments",
                "5061": "contract_source_staff_multi_assignments",
                "5138": "contract_source_staff_multi_assignments"
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "css_base_color_class": null,
            "css_icon_class": null,
            "display_name": null,
            "enable_mail": "0",
            "enable_mail_print": "0",
            "id": 0,
            "is_nest": "0",
            "is_plan_dispatch_basic": "1",
            "is_plan_dispatch_bill": "0",
            "is_plan_dispatch_payroll": "1",
            "is_plan_employment_agency": "1",
            "is_plan_spot": "1",
            "is_show_master_settings": "0",
            "master_settings_position": null,
            "name": null,
            "position": null,
            "subtitle": null,
            "propertyTabs": null,
            "propertyCategories": null,
            "searchPropertyCategories": null,
            "propertyColumns": null,
            "exportSettings": null,
            "importSettings": null,
            "propertySublists": null
        },
        "relations": {
            "propertyTabs": "PropertyTab",
            "propertyCategories": "PropertyCategory",
            "searchPropertyCategories": "SearchPropertyCategory",
            "propertyColumns": "PropertyColumn",
            "exportSettings": "ExportSetting",
            "importSettings": "ImportSetting",
            "propertySublists": "PropertySublist"
        },
        "appends": [
            "inputCategoryId",
            "idColumnName",
            "resourceName"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "property_tables"
    },
    "Rank": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "ranks"
    },
    "ReceiveMailState": {
        "constants": {
            "NOT_OPEN_STATE": 0,
            "NOT_REPLY_STATE": 1,
            "REPLIED_STATE": 2,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "receive_mail_states"
    },
    "ReleaseNote": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "description": null,
            "id": 0,
            "manual_url": null,
            "released_at": null,
            "route_name": null,
            "updated_at": null,
            "url_function_name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "release_notes"
    },
    "Report": {
        "constants": {
            "USER_ROW_OFFSET_MS_TEMPLATE_ID": 10000,
            "MS_TEMPLATE_ID_AGENCY_BASIC_CONTRACT": 1,
            "MS_TEMPLATE_ID_CAREER_SHEET": 2,
            "MS_TEMPLATE_ID_RECOMMENDATION_LETTER": 3,
            "MS_TEMPLATE_ID_AGENCY_INVOICE": 4,
            "MS_TEMPLATE_ID_JOB_SHEET": 5,
            "MS_TEMPLATE_ID_JIS_APPLICATION": 6,
            "MS_TEMPLATE_ID_DISPATCH_CONDITION_NOTICE_AND_AGREEMENT": 7,
            "MS_TEMPLATE_ID_DISPATCH_INDIVIDUAL_CONTRACT": 8,
            "MS_TEMPLATE_ID_DISPATCH_BASIC_CONTRACT": 9,
            "MS_TEMPLATE_ID_DISPATCH_OUTSOURCING_CONTRACT": 10,
            "MS_TEMPLATE_ID_DISPATCH_CONTRACT_FOR_PERMANENT_EMPLOY": 11,
            "MS_TEMPLATE_ID_DISPATCH_SOURCE_MANAGEMENT": 12,
            "MS_TEMPLATE_ID_DISPATCH_WORKER_NOTIFICATION": 13,
            "MS_TEMPLATE_ID_DISPATCH_CONFLICT_DATE_NOTIFICATION": 14,
            "MS_TEMPLATE_ID_DISPATCH_DESTINATION_MANAGEMENT": 15,
            "MS_TEMPLATE_ID_DISPATCH_JOB_SHEET": 16,
            "MS_TEMPLATE_ID_DISPATCH_CAREER_SHEET": 17,
            "MS_TEMPLATE_ID_DISPATCH_INVOICE": 18,
            "MS_TEMPLATE_ID_DISPATCH_PAYMENT": 19,
            "MS_TEMPLATE_ID_DISPATCH_BILLING_ATTENDANCE_SHEET": 20,
            "MS_TEMPLATE_ID_DISPATCH_PAYMENT_ATTENDANCE_SHEET": 21,
            "MS_TEMPLATE_ID_DISPATCH_BUSINESS_REPORT": 22,
            "MS_TEMPLATE_ID_RELATED_CLIENT_COMPANY_DISPATCH_RATIO_REPORT": 23,
            "MS_TEMPLATE_ID_DISPATCH_WAGE_LEDGER": 24,
            "MS_TEMPLATE_ID_APPLICATION_2024": 25,
            "MS_TEMPLATE_ID_DISPATCH_APPLICATION_2024": 26,
            "MS_TEMPLATE_ID_AGENCY_BUSINESS_REPORT": 27,
            "MS_TEMPLATE_ID_COMMISSION_MANAGEMENT_BOOK": 28,
            "MS_TEMPLATE_ID_DISPATCH_CONDITION_NOTICE_AND_AGREEMENT_202610_01": 29,
            "MS_TEMPLATE_ID_MAPPINGS": {
                "人材紹介基本契約書": 1,
                "キャリアシート": 2,
                "推薦状": 3,
                "請求書": 18,
                "求人票": 5,
                "JIS履歴書": 6,
                "労働条件通知書兼就業条件明示書": 7,
                "労働者派遣個別契約書": 8,
                "労働者派遣基本契約書": 9,
                "業務委託契約書": 10,
                "紹介予定派遣基本契約書": 11,
                "派遣元管理台帳": 12,
                "労働者派遣通知書": 13,
                "抵触日通知書": 14,
                "派遣先管理台帳": 15,
                "派遣求人票": 16,
                "派遣用キャリアシート": 17,
                "給与明細書": 19,
                "請求勤怠表": 20,
                "支払勤怠表": 21,
                "労働者派遣事業報告書": 22,
                "関係派遣先派遣割合報告書": 23,
                "賃金台帳": 24
            },
            "EXCEL_EXTENSIONS": [
                "xlsx",
                "xlsm",
                "xls"
            ],
            "NEST_CASCADER_PROPERTY_CATEGORIES": {
                "5103": [
                    5122,
                    5123,
                    5124,
                    5251,
                    5252,
                    5253
                ],
                "5138": [
                    5387,
                    5388,
                    5390,
                    5391,
                    21205
                ]
            },
            "REPORT_CLASS_MAPPINGS": {
                "candidates": [
                    2,
                    11
                ],
                "jobs": [
                    1
                ],
                "companies": [
                    4
                ],
                "sales": [
                    5
                ],
                "dispatch_jobs": [
                    10
                ],
                "contracts": [
                    13,
                    12
                ],
                "invoice_closed_invoices": [
                    15
                ],
                "payment_closed_payments": [
                    16
                ],
                "invoice_closed_attendances": [
                    17
                ],
                "payment_closed_attendances": [
                    18
                ]
            },
            "INVOICE": 24,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "deleted_at": null,
            "file_id": null,
            "id": 0,
            "is_careers_order_asc": "1",
            "is_educations_order_asc": "1",
            "ms_template_id": null,
            "name": null,
            "position": null,
            "report_category_id": null,
            "reportSheets": null,
            "reportCategory": null,
            "file": null
        },
        "relations": {
            "reportSheets": "ReportSheet",
            "reportCategory": "ReportCategory",
            "file": "File"
        },
        "appends": [
            "reportSheetNames",
            "isDefaultReport",
            "fileName",
            "isNotConfigurable"
        ],
        "parents": [
            "App\\Models\\Bases\\FileModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "reports"
    },
    "ReportCategory": {
        "constants": {
            "JOB": 1,
            "CANDIDATE": 2,
            "CANDIDATE_JOB_STEP": 3,
            "COMPANY": 4,
            "SALE": 5,
            "JOB_DISPATCH_DESTINATION": 10,
            "CANDIDATE_DISPATCH_SOURCE": 11,
            "COMPANY_DISPATCH_SOURCE": 12,
            "DISPATCH_CONTRACT_MANAGEMENT": 13,
            "DISPATCH_RECOMMENDATION": 14,
            "BUSINESS_REPORT": 6,
            "CANDIDATE_MANAGEMENT_REPORT": 7,
            "JOB_MANAGEMENT_REPORT": 8,
            "COMMISSION_MANAGEMENT_REPORT": 9,
            "DISPATCH_BUSINESS_REPORT": 19,
            "INVOICE": 15,
            "PAYMENT": 16,
            "INVOICE_CLOSED_ATTENDANCE": 17,
            "PAYMENT_CLOSED_ATTENDANCE": 18,
            "CSV_EXPORT_CATEGORY": [
                7,
                8
            ],
            "HIDDEN_CATEGORIES": [
                15,
                16,
                17,
                18
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "is_legal": "0",
            "is_plan_dispatch_basic": "1",
            "is_plan_dispatch_bill": "0",
            "is_plan_dispatch_payroll": "1",
            "is_plan_employment_agency": "1",
            "is_plan_spot": "1",
            "name": null,
            "property_table_id": null,
            "reports": null,
            "propertyTable": null
        },
        "relations": {
            "reports": "Report",
            "propertyTable": "PropertyTable"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "report_categories"
    },
    "ReportCell": {
        "constants": {
            "SPECIAL_CATEGORIES": [
                {
                    "propertyCategoryId": 7054,
                    "propertyTableId": 2,
                    "isChildCategory": true
                },
                {
                    "propertyCategoryId": 7056,
                    "propertyTableId": 2,
                    "isChildCategory": true
                },
                {
                    "propertyCategoryId": 7058,
                    "propertyTableId": 2,
                    "isChildCategory": true
                },
                {
                    "propertyCategoryId": 7060,
                    "propertyTableId": 2,
                    "isChildCategory": true
                }
            ],
            "SPECIAL_COLUMNS": [
                {
                    "propertyColumnId": 166,
                    "propertyCategoryId": 2,
                    "propertyTableId": 2,
                    "displayName": "candidates.photo_alternative_text"
                },
                {
                    "propertyColumnId": 203,
                    "propertyCategoryId": 2,
                    "propertyTableId": 2,
                    "displayName": "candidates.user"
                },
                {
                    "propertyColumnId": 205,
                    "propertyCategoryId": 16,
                    "propertyTableId": 4,
                    "displayName": "jobs.user"
                },
                {
                    "propertyColumnId": 204,
                    "propertyCategoryId": 12,
                    "propertyTableId": 3,
                    "displayName": "companies.user"
                },
                {
                    "propertyColumnId": 257,
                    "propertyCategoryId": 22,
                    "propertyTableId": 78
                },
                {
                    "propertyColumnId": 239,
                    "propertyCategoryId": 23,
                    "propertyTableId": 78
                },
                {
                    "propertyColumnId": 178,
                    "propertyCategoryId": 24,
                    "propertyTableId": 78
                },
                {
                    "propertyColumnId": 179,
                    "propertyCategoryId": 24,
                    "propertyTableId": 78
                },
                {
                    "propertyColumnId": 181,
                    "propertyCategoryId": 24,
                    "propertyTableId": 78
                },
                {
                    "propertyColumnId": 182,
                    "propertyCategoryId": 24,
                    "propertyTableId": 78
                },
                {
                    "propertyColumnId": 5681,
                    "propertyCategoryId": 5159,
                    "propertyTableId": 5041
                },
                {
                    "propertyColumnId": 5682,
                    "propertyCategoryId": 5159,
                    "propertyTableId": 5041
                }
            ],
            "SPECIAL_ALIAS_NAME_MAP": {
                "166": "photo_id"
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "alias": null,
            "cell_address": null,
            "created_at": null,
            "id": 0,
            "index": "0",
            "position": null,
            "property_column_id": null,
            "property_table_id": null,
            "relation": null,
            "report_sheet_id": null,
            "updated_at": null,
            "propertyColumn": null,
            "propertyTable": null,
            "reportSheet": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn",
            "propertyTable": "PropertyTable",
            "reportSheet": "ReportSheet"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "report_cells"
    },
    "ReportSheet": {
        "constants": {
            "BUSINESS_REPORT_FRONT_PAGE": 9,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "name": null,
            "report_id": null,
            "updated_at": null,
            "reportTemplates": null,
            "reportCells": null,
            "report": null
        },
        "relations": {
            "reportTemplates": "ReportTemplate",
            "reportCells": "ReportCell",
            "report": "Report"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "report_sheets"
    },
    "ReportTemplate": {
        "constants": {
            "FEE_BOOK_FIRST_TEMPLATE": 8,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "first_row": null,
            "id": 0,
            "index": null,
            "parent_report_template_id": null,
            "property_static_column_id": null,
            "property_table_id": null,
            "report_sheet_id": null,
            "row_count": null,
            "updated_at": null,
            "propertyTable": null,
            "propertyStaticColumn": null,
            "reportTemplateCells": null
        },
        "relations": {
            "propertyTable": "PropertyTable",
            "propertyStaticColumn": "PropertyStaticColumn",
            "reportTemplateCells": "ReportTemplateCell"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "report_templates"
    },
    "ReportTemplateCell": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "column_address": null,
            "created_at": null,
            "id": 0,
            "property_column_id": null,
            "property_table_id": null,
            "report_template_id": null,
            "row_address": null,
            "updated_at": null,
            "reportTemplate": null,
            "propertyTable": null,
            "propertyColumn": null
        },
        "relations": {
            "reportTemplate": "ReportTemplate",
            "propertyTable": "PropertyTable",
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "report_template_cells"
    },
    "RepresentativeDispatchSourceStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5387,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchSourceStaff": [
                    [
                        "dispatch_source_id",
                        "App\\Models\\DispatchSource"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "dispatch_source_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_source_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\DispatchJobSourceStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchSourceStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_source_staff_multi_assignments"
    },
    "RepresentativeDispatchStaff": {
        "constants": {
            "PROPERTY_COLUMN_ID": 5122,
            "RESOURCES_RELATED_TO_MASTER": {
                "App\\Models\\DispatchStaff": [
                    [
                        "company_id",
                        "App\\Models\\Company"
                    ],
                    [
                        "dispatch_destination_id",
                        "App\\Models\\DispatchDestination"
                    ]
                ]
            },
            "SPECIFIC_WHITELIST_FACTOR_PROPERTIES": [
                "company_id",
                "dispatch_destination_id"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "dispatch_staff_id": null,
            "id": 0,
            "job_id": null,
            "property_column_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\DispatchJobStaffMultiAssignment",
            "App\\Models\\Bases\\DispatchStaffMultiAssignment",
            "App\\Models\\Bases\\MultiAssignment",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "dispatch_job_staff_multi_assignments"
    },
    "ResourceEventSqsSendLog": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "is_succeed_enqueue": "0",
            "message": null,
            "resource_id": null,
            "resource_type": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "resource_event_sqs_send_logs"
    },
    "ResourceMapping": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "parent_property_table_id": null,
            "property_table_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "resource_mappings"
    },
    "ResourceNameMap": {
        "constants": {
            "RESOURCE_SCHEDULE_CATEGORY_VISITOR": "visitor",
            "RESOURCE_VISITOR_SCHEDULE_CHILD_VISITOR_NAME": "visitors",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "front_search_enable": "0",
            "id": 0,
            "name": null,
            "request_property_table_id": null,
            "response_property_table_id": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "resource_name_maps"
    },
    "ResourceRelationMapping": {
        "constants": {
            "TYPE_DELETE": "delete",
            "TYPE_BATCH_MAIL": "batch_mail",
            "TYPE_EXPORT_GROUP": "export_group",
            "TYPE_FREE_ITEMS": "free_items",
            "TYPE_REPORTS": "reports",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "child_property_table_id": null,
            "id": 0,
            "parent_property_table_id": null,
            "type": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "resource_relation_mappings"
    },
    "ResourceSubstance": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "property_columns_alias": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyTable": null
        },
        "relations": {
            "propertyTable": "PropertyTable"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "resource_substances"
    },
    "ResultColumn": {
        "constants": {
            "RESOURCE_DEFAULT_DUMMY_PROPERTY_CATEGORY": {
                "id": 8888,
                "display_name": "基本項目"
            },
            "RESOURCE_STATE_DUMMY_PROPERTY_CATEGORY": {
                "id": 9999,
                "display_name": "進捗日時表示"
            },
            "RESOURCE_STATE_PREFIX": "state-id-",
            "RESOURCE_TABLE_DEFAULT_RESULT_COLUMNS": {
                "67": [
                    5001,
                    5002,
                    5008,
                    203,
                    205,
                    204
                ],
                "5014": [
                    271,
                    272,
                    273,
                    274,
                    275,
                    276,
                    277,
                    278
                ]
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "group_number": null,
            "id": 0,
            "is_connect_state": "0",
            "position": null,
            "property_column_id": null,
            "property_table_id": null,
            "state_id": null,
            "state_type": null,
            "updated_at": null,
            "propertyColumn": null
        },
        "relations": {
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "result_columns"
    },
    "Revision": {
        "constants": {
            "USER_COUNT_COLUMN_KEYS": [
                "enabled",
                "deleted_at"
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "free_item_config_id": null,
            "free_item_parent_object_id": null,
            "free_item_parent_table_id": null,
            "id": 0,
            "is_create": "0",
            "key": null,
            "new_value": null,
            "old_value": null,
            "revisionable_id": null,
            "revisionable_type": null,
            "updated_at": null,
            "user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "revisions"
    },
    "RolePermission": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "GRANT": "grant",
            "DENY": "deny"
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "permission": "deny",
            "route_name": null,
            "updated_at": null,
            "user_role_id": null,
            "userRole": null
        },
        "relations": {
            "userRole": "UserRole"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "role_permissions"
    },
    "Room": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "schedules": null
        },
        "relations": {
            "schedules": "Schedule"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "rooms"
    },
    "RoudoukyokuCategory": {
        "constants": {
            "MAX_DEPTH": 2,
            "TOTAL_SALES_UNIT": 1000
        },
        "properties": {
            "depth": null,
            "id": 0,
            "lft": null,
            "name": null,
            "parent_id": null,
            "rgt": null,
            "jobs": null
        },
        "relations": {
            "jobs": "Job"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Node",
            "Baum\\Node",
            "Baum\\Extensions\\Eloquent\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "roudoukyoku_categories"
    },
    "RoundingType": {
        "constants": {
            "ROUND_UP": 1,
            "ROUNDING": 2,
            "TRUNCATION": 3,
            "ONE_TRUNCATION": 4,
            "TEN_TRUNCATION": 5,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "updated_at": null,
            "sales": null
        },
        "relations": {
            "sales": "Sale"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "rounding_types"
    },
    "Sale": {
        "constants": {
            "DEFAULT_TAX_RATE_ID": 1,
            "DEFAULT_ROUND_TYPE_ID": 3,
            "INITIAL_INDEX_RELATIONS": [
                "saleRefund",
                "saleRefund.accountCategory",
                "saleState"
            ],
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "candidate_job_step_id"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "annual_income": "0",
            "candidate_job_step_id": null,
            "code": null,
            "created_at": null,
            "deleted_at": null,
            "entrance_date": null,
            "fee_type_id": null,
            "flat_fee": "0",
            "full_text": null,
            "id": 0,
            "memo": null,
            "payment_date": null,
            "payment_schedule_date": null,
            "rate": "0",
            "research_category": null,
            "researched_at": null,
            "retirement_date": null,
            "rounding_type_id": "2",
            "sale_state_id": null,
            "state_updated_at": null,
            "tax_included_sales": "0",
            "tax_rate_id": "1",
            "updated_at": null,
            "freeItems": null,
            "candidateJobStep": null,
            "roundingType": null,
            "feeType": null,
            "saleState": null,
            "taxRate": null,
            "saleRefund": null,
            "users": null
        },
        "relations": {
            "candidateJobStep": "CandidateJobStep",
            "roundingType": "RoundingType",
            "feeType": "FeeType",
            "saleState": "SaleState",
            "taxRate": "TaxRate",
            "saleRefund": "SaleRefund",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "sales"
    },
    "SaleRefund": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "refund_bank": null,
            "refund_bank_account_category_id": null,
            "refund_bank_account_name": null,
            "refund_bank_account_number": null,
            "refund_bank_branch": null,
            "refund_date": null,
            "refund_fee": null,
            "refund_rate": null,
            "refund_reason": null,
            "refund_schedule_date": null,
            "rounding_type_id": null,
            "sale_id": null,
            "tax_included_sale_refunds": "0",
            "tax_rate_id": null,
            "updated_at": null,
            "sale": null,
            "taxRate": null,
            "roundingType": null,
            "accountCategory": null
        },
        "relations": {
            "sale": "Sale",
            "taxRate": "TaxRate",
            "roundingType": "RoundingType",
            "accountCategory": "AccountCategory"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "sale_refunds"
    },
    "SaleState": {
        "constants": {
            "UNCLAIMED": 1,
            "CLAIMED": 2,
            "PAID": 3,
            "REFUNDED": 4,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null,
            "sales": null
        },
        "relations": {
            "sales": "Sale"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "sale_states"
    },
    "Schedule": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "end_at": null,
            "free_candidate": null,
            "free_company": null,
            "free_staff": null,
            "free_user": null,
            "id": 0,
            "memo": null,
            "schedule_category_id": null,
            "start_at": null,
            "scheduleCategory": null,
            "rooms": null,
            "companies": null,
            "candidates": null,
            "staffs": null,
            "candidateJobSteps": null,
            "candidateSteps": null,
            "users": null,
            "scheduleUsers": null,
            "scheduleCandidates": null,
            "scheduleStaffs": null,
            "scheduleRooms": null,
            "scheduleCompanies": null
        },
        "relations": {
            "scheduleCategory": "ScheduleCategory",
            "rooms": "Room",
            "companies": "Company",
            "candidates": "Candidate",
            "staffs": "Staff",
            "candidateJobSteps": "CandidateJobStep",
            "candidateSteps": "CandidateStep",
            "users": "User",
            "scheduleUsers": "ScheduleUser",
            "scheduleCandidates": "ScheduleCandidate",
            "scheduleStaffs": "ScheduleStaff",
            "scheduleRooms": "ScheduleRoom",
            "scheduleCompanies": "ScheduleCompany"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedules"
    },
    "ScheduleCandidate": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_id": null,
            "id": 0,
            "schedule_id": null,
            "candidate": null
        },
        "relations": {
            "candidate": "Candidate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_candidates"
    },
    "ScheduleCandidateJobStep": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_job_step_id": null,
            "created_at": null,
            "id": 0,
            "schedule_id": null,
            "updated_at": null,
            "schedule": null,
            "candidateJobStep": null
        },
        "relations": {
            "schedule": "Schedule",
            "candidateJobStep": "CandidateJobStep"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_candidate_job_steps"
    },
    "ScheduleCandidateStep": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "candidate_step_id": null,
            "created_at": null,
            "id": 0,
            "schedule_id": null,
            "updated_at": null,
            "schedule": null,
            "candidateStep": null
        },
        "relations": {
            "schedule": "Schedule",
            "candidateStep": "CandidateStep"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_candidate_steps"
    },
    "ScheduleCategory": {
        "constants": {
            "SALES": 1,
            "VISITOR": 2,
            "MEETING": 3,
            "INTERVIEW": 4,
            "OTHERS": 9,
            "GUARDED_SCHEDULE_ATTRIBUTES": {
                "1": [
                    "free_candidate",
                    "free_user",
                    "memo"
                ],
                "2": [
                    "free_company",
                    "free_staff",
                    "free_user",
                    "memo"
                ],
                "3": [
                    "free_candidate",
                    "free_company",
                    "free_staff",
                    "free_user"
                ],
                "4": [
                    "free_candidate",
                    "free_company",
                    "free_staff",
                    "free_user"
                ],
                "9": [
                    "free_candidate",
                    "free_company",
                    "free_staff",
                    "free_user"
                ]
            },
            "GUARDED_SCHEDULE_RELATIONS": {
                "1": [
                    "App\\Models\\ScheduleRoom"
                ],
                "2": [
                    "App\\Models\\ScheduleCompany"
                ],
                "3": [
                    "App\\Models\\ScheduleCompany",
                    "App\\Models\\ScheduleStaff"
                ],
                "4": [
                    "App\\Models\\ScheduleCompany",
                    "App\\Models\\ScheduleStaff"
                ],
                "9": [
                    "App\\Models\\ScheduleCompany",
                    "App\\Models\\ScheduleStaff"
                ]
            },
            "SYSTEM_NAMES": {
                "1": "sales",
                "2": "visitor",
                "3": "meeting",
                "9": "others"
            },
            "SCHEDULE_CATEGORY_MAP_FROM_PROPERTY_TABLE_ID": {
                "96": 3,
                "97": 2,
                "99": 1,
                "101": 9
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "schedule_category_name": null
        },
        "relations": [],
        "appends": [
            "systemName"
        ],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_categories"
    },
    "ScheduleCompany": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "company_id": null,
            "id": 0,
            "schedule_id": null,
            "company": null
        },
        "relations": {
            "company": "Company"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_companies"
    },
    "ScheduleRoom": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "room_id": null,
            "schedule_id": null,
            "schedule": null,
            "room": null
        },
        "relations": {
            "schedule": "Schedule",
            "room": "Room"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_rooms"
    },
    "ScheduleStaff": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "schedule_id": null,
            "staff_id": null,
            "staff": null
        },
        "relations": {
            "staff": "Staff"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_staffs"
    },
    "ScheduleUser": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "schedule_id": null,
            "user_id": null,
            "schedule": null,
            "user": null
        },
        "relations": {
            "schedule": "Schedule",
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "schedule_users"
    },
    "SchoolCategory": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "school_categories"
    },
    "SearchColumn": {
        "constants": {
            "CANDIDATE_FREE_WORD_SEARCH": 1,
            "CANDIDATE_NAME": 2,
            "CANDIDATE_KANA": 3,
            "CANDIDATE_STATE": 4,
            "CANDIDATE_CODE": 5,
            "CANDIDATE_BIRTH_DATE": 6,
            "CANDIDATE_AGE": 7,
            "CANDIDATE_SEX_ID": 8,
            "CANDIDATE_EMAIL": 14,
            "CANDIDATE_IS_MARRIED": 15,
            "CANDIDATE_FIGURE": 19,
            "EDUCATION_SCHOOL_CATEGORY": 38,
            "EDUCATION_SCHOOL": 39,
            "EDUCATION_ENTRANCE_DATE": 41,
            "CAREER_EMPLOYEE_NUMBER": 50,
            "CAREER_DETAIL": 53,
            "COMPANY_FREE_WORD_SEARCH": 55,
            "COMPANY_CODE": 56,
            "COMPANY_STATE": 57,
            "COMPANY_NAME": 58,
            "COMPANY_KANA": 59,
            "COMPANY_ESTABLISHMENT_DATE": 60,
            "COMPANY_EMPLOYEE_NUMBER": 62,
            "COMPANY_URL": 72,
            "COMPANY_ADVANTAGE": 76,
            "JOB_FREE_WORD_SEARCH": 84,
            "JOB_CODE": 85,
            "JOB_COMPANY_ID": 86,
            "JOB_TITLE": 88,
            "JOB_STATE": 89,
            "JOB_IS_TRIAL": 107,
            "JOB_INTERVIEW_COUNT": 114,
            "JOB_MEMO": 116,
            "CANDIDATE_ID": 125,
            "COMPANY_ID": 126,
            "JOB_ID": 127,
            "SALE_CODE": 128,
            "SALE_ENTRANCE_DATE": 129,
            "SALE_DUE_TO_PAYMENT": 130,
            "SALE_MEMO": 131,
            "SALE_ANNUAL_INCOME": 132,
            "SALE_RATE": 133,
            "SALE_FLAT_FEE": 134,
            "SALE_TAX_RATE_NAME": 135,
            "SALE_ROUND_TYPE_NAME": 136,
            "SALE_CANDIDATE_NAME": 137,
            "SALE_COMPANY_NAME": 138,
            "SALE_CREATE_AT": 139,
            "SALE_CANDIDATE_USER_ID": 140,
            "SALE_COMPANY_USER_ID": 141,
            "SALE_STATE": 142,
            "CANDIDATE_CREATED_AT": 143,
            "CANDIDATE_UPDATED_AT": 144,
            "COMPANY_CREATED_AT": 145,
            "COMPANY_UPDATED_AT": 146,
            "JOB_CREATED_AT": 147,
            "JOB_UPDATED_AT": 148,
            "COMPANY_FEE_RATE": 149,
            "COMPANY_MEMO": 150,
            "JOB_OCCUPATION_NAME": 151,
            "CANDIDATE_JOB_STEP_CANDIDATE_JOB_STEP_STATE_ID": 500,
            "CANDIDATE_JOB_STEP_START_AT": 501,
            "CANDIDATE_JOB_STEP_INTERVIEWER": 502,
            "CANDIDATE_JOB_STEP_MEMO": 503,
            "CANDIDATE_JOB_STEP_CANDIDATE_ID": 504,
            "CANDIDATE_JOB_STEP_CANDIDATE_USER_ID": 505,
            "CANDIDATE_JOB_STEP_COMPANY_ID": 506,
            "CANDIDATE_JOB_STEP_DEPARTMENT": 507,
            "CANDIDATE_JOB_STEP_OCCUPATION_ID": 508,
            "CANDIDATE_JOB_STEP_JOB_USER_ID": 509,
            "JOB_ANNUAL_INCOME": 510,
            "COMPANY_STEP_COMPANY_ID": 511,
            "COMPANY_STEP_STAFF_ID": 512,
            "COMPANY_STEP_COMPANY_STEP_STATE_ID": 513,
            "COMPANY_STEP_MEMO": 514,
            "COMPANY_STEP_USER_DEPARTMENT_ID": 515,
            "COMPANY_STEP_USER_ID": 516,
            "COMPANY_STEP_START_AT": 517,
            "USER_DEPARTMENT_ID": 518,
            "CANDIDATE_STEP_CANDIDATE_ID": 519,
            "CANDIDATE_STEP_CANDIDATE_STEP_STATE_ID": 520,
            "CANDIDATE_STEP_USER_DEPARTMENT_ID": 521,
            "CANDIDATE_STEP_USER_ID": 522,
            "CANDIDATE_STEP_MEMO": 523,
            "CANDIDATE_STEP_START_AT": 524,
            "CANDIDATE_STEP_CREATED_AT": 525,
            "SALE_FREE_WORD_SEARCH": 526,
            "CANDIDATE_JOB_STEP_RESOURCE_FREE_WORD_SEARCH": 527,
            "CANDIDATE_STEP_RESOURCE_FREE_WORD_SEARCH": 528,
            "COMPANY_STEP_RESOURCE_FREE_WORD_SEARCH": 529,
            "DISPATCH_DESTINATION_FREE_WORD_SEARCH": 530,
            "DISPATCH_STAFF_FREE_WORD_SEARCH": 531,
            "DISPATCH_WORKING_PLACE_FREE_WORD_SEARCH": 532,
            "DISPATCH_ORGANIZATION_UNIT_FREE_WORD_SEARCH": 533,
            "CANDIDATE_JOB_STEP_RESOURCES_JOB_ID": 534,
            "BILLING_DESTINATION_FREE_WORD_SEARCH": 535,
            "DISPATCH_JOB_FREE_WORD_SEARCH": 536,
            "STAFF_FREE_WORD_SEARCH": 537,
            "DISPATCH_JOB_COMPANY_ID": 538,
            "STAFF_COMPANY_ID": 539,
            "DISPATCH_DESTINATION_COMPANY_ID": 540,
            "BILLING_DESTINATION_COMPANY_ID": 541,
            "DISPATCH_JOB_DISPATCH_DESTINATION_ID": 542,
            "DISPATCH_STAFF_DISPATCH_DESTINATION_ID": 543,
            "CONTRACT_FREE_WORD_SEARCH": 544,
            "BILLING_DESTINATION_BILLING_DESTINATION_STATE_ID": 545,
            "STAFF_STAFF_STATE_ID": 546,
            "DISPATCH_DESTINATION_DISPATCH_DESTINATION_STATE_ID": 547,
            "DISPATCH_STAFF_DISPATCH_STAFF_STATE_ID": 548,
            "DISPATCH_ORGANIZATION_UNIT_DISPATCH_ORGANIZATION_UNIT_STATE_ID": 549,
            "DISPATCH_WORKING_PLACE_DISPATCH_WORKING_PLACE_STATE_ID": 550,
            "DISPATCH_JOB_DISPATCH_JOB_STATE_ID": 551,
            "CONTRACT_CONTRACT_STATE_ID": 552,
            "DISPATCH_SOURCE_DISPATCH_SOURCE_STATE_ID": 553,
            "DISPATCH_SOURCE_STAFF_DISPATCH_SOURCE_STAFF_STATE_ID": 554,
            "BILLING_DESTINATION_ID": 555,
            "STAFF_ID": 556,
            "DISPATCH_DESTINATION_ID": 557,
            "DISPATCH_STAFF_ID": 558,
            "DISPATCH_ORGANIZATION_UNIT_ID": 559,
            "DISPATCH_WORKING_PLACE_ID": 560,
            "DISPATCH_JOB_ID": 561,
            "CANDIDATE_JOB_STEP_RESOURCES_ID": 562,
            "COMPANY_STEP_ID": 563,
            "CANDIDATE_STEP_ID": 564,
            "CONTRACT_ID": 565,
            "DISPATCH_SOURCE_STAFF_ID": 566,
            "SALE_ID": 567,
            "SALES_RETIREMENT_DATE": 568,
            "SALE_RESEARCHED_AT": 569,
            "SALE_RESEARCH_CATEGORY": 570,
            "SALE_REFUNDS_REASON": 571,
            "SALE_REFUNDS_RATE": 572,
            "SALE_REFUNDS_FEE": 573,
            "SALE_REFUNDS_TAX_RATE_ID": 574,
            "SALE_REFUNDS_ROUNDING_TYPE_ID": 575,
            "SALES_INCLUDE_TAX": 576,
            "SALES_EXCLUDE_TAX": 577,
            "SALE_REFUNDS_DATE": 578,
            "SALE_REFUNDS_SCHEDULE_DATE": 579,
            "SALE_REFUNDS_BANK_NAME": 580,
            "SALE_REFUNDS_BANK_BRANCH_NAME": 581,
            "SALE_REFUNDS_BANK_ACCOUNT_CATEGORY_ID": 582,
            "SALE_REFUNDS_BANK_ACCOUNT_NUMBER": 583,
            "SALE_REFUNDS_BANK_ACCOUNT_NAME": 584,
            "CONTRACT_CANDIDATE_ID": 585,
            "CS_MASTER_DISPATCH_WORKING_PLACE_DISPATCH_DESTINATION_ID": 699,
            "CS_MASTER_DISPATCH_ORGANIZATION_UNIT_DISPATCH_DESTINATION_ID": 702,
            "CS_MASTER_CONTRACT_CANDIDATE_ID": 711,
            "CS_MASTER_CONTRACT_COMPANY_ID": 730,
            "CS_MASTER_CONTRACT_DISPATCH_DESTINATION_ID": 713,
            "INVOICE_CLOSED_ATTENDANCE_INVOICE_CLOSED_ATTENDANCE_STATE_ID": 1000,
            "INVOICE_CLOSED_ATTENDANCE_ID": 1001,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_CLOSED_ATTENDANCE_STATE_ID": 1002,
            "PAYMENT_CLOSED_ATTENDANCE_ID": 1003,
            "INVOICE_CLOSED_INVOICE_INVOICE_CLOSED_INVOICE_STATE_ID": 1004,
            "INVOICE_CLOSED_INVOICE_ID": 1005,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_CLOSED_PAYMENT_STATE_ID": 1006,
            "PAYMENT_CLOSED_PAYMENT_ID": 1007,
            "CONTRACT_ATTENDANCE_ATTENDANCE_DATE": 1008,
            "CONTRACT_ATTENDANCE_ATTENDANCE_TYPE_ID": 1009,
            "CONTRACT_ATTENDANCE_SCHEDULED_START_TIME": 1010,
            "CONTRACT_ATTENDANCE_PERFORMED_START_TIME": 1011,
            "CONTRACT_ATTENDANCE_SCHEDULED_END_TIME": 1012,
            "CONTRACT_ATTENDANCE_PERFORMED_END_TIME": 1013,
            "CONTRACT_ATTENDANCE_BREAK_MINUTES": 1014,
            "CONTRACT_ATTENDANCE_MIDNIGHT_BREAK_MINUTES": 1015,
            "CONTRACT_ATTENDANCE_INVOICE_TRANSPORTATION_EXPENSES": 1016,
            "CONTRACT_ATTENDANCE_PAYMENT_TRANSPORTATION": 1017,
            "CONTRACT_ATTENDANCE_IS_LIKE_NOT_WORKING": 2502,
            "CONTRACT_ATTENDANCE_MEMO": 2503,
            "DISPATCH_SPOT_JOB_FREE_WORD_SEARCH": 1100,
            "DISPATCH_SPOT_JOB_SPOT_DUE_DATE": 1101,
            "DISPATCH_SPOT_JOB_ID": 1102,
            "DISPATCH_SPOT_JOB_DISPATCH_JOB_STATE_ID": 1103,
            "DISPATCH_SPOT_JOB_COMPANY_ID": 1104,
            "DISPATCH_SPOT_JOB_DISPATCH_DESTINATION_ID": 1105,
            "CONFLICT_DATE_MANAGEMENT_CONTRACT_ID": 2000,
            "CONFLICT_DATE_MANAGEMENT_CANDIDATE_ID": 2001,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_DESTINATION_ID": 2002,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_START_DATE": 2003,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_END_DATE": 2004,
            "CONFLICT_DATE_MANAGEMENT_CONFLICT_DATE": 2005,
            "CONFLICT_DATE_MANAGEMENT_DISPATCH_ORGANIZATION_UNIT_ID": 2006,
            "DISPATCH_SOURCE_ID": 2100,
            "DISPATCH_JOB_USER_ID": 2101,
            "CANDIDATE_DEPARTMENT_ID": 2102,
            "COMPANY_DEPARTMENT_ID": 2103,
            "JOB_DEPARTMENT_ID": 2104,
            "DISPATCH_JOB_DEPARTMENT_ID": 2105,
            "CONTRACT_JOB_ID": 2501,
            "INVOICE_CONTRACT_ATTENDANCES_ATTENDANCE_DATE": 2504,
            "INVOICE_CONTRACT_ATTENDANCES_COMPANY_ID": 2505,
            "INVOICE_CONTRACT_ATTENDANCES_COMPANY_USER_ID": 2506,
            "INVOICE_CONTRACT_ATTENDANCES_PAYMENT_TIME_TYPE_ID": 2507,
            "INVOICE_CONTRACT_ATTENDANCES_CANDIDATE_ID": 2508,
            "INVOICE_CONTRACT_ATTENDANCES_CANDIDATE_USER_ID": 2509,
            "INVOICE_CONTRACT_ATTENDANCES_INDUSTRY_ID": 2510,
            "INVOICE_CONTRACT_ATTENDANCES_OCCUPATION_ID": 2511,
            "INVOICE_CONTRACT_ATTENDANCES_CONTRACT_DATE": 2512,
            "INVOICE_CONTRACT_ATTENDANCES_PREFECTURE_ID": 2513,
            "INVOICE_CONTRACT_ATTENDANCES_CONTRACTED_CONFLICT_DATE": 2514,
            "INVOICE_CONTRACT_ATTENDANCES_CONTRACTED_DISPATCH_DESTINATION_CONFLICT_DATE": 2515,
            "INVOICE_CONTRACT_ATTENDANCES_NO_REGISTER_ACHIEVEMENT": 2516,
            "INVOICE_CONTRACT_ATTENDANCES_NO_CONTRACT_ATTENDANCE": 2517,
            "INVOICE_CLOSED_ATTENDANCES_CLOSING_END_DATE": 2518,
            "INVOICE_CLOSED_ATTENDANCES_ATTENDANCE_DATE": 2519,
            "INVOICE_CLOSED_ATTENDANCES_COMPANY_ID": 2520,
            "INVOICE_CLOSED_ATTENDANCES_DISPATCH_DESTINATION_ID": 2521,
            "INVOICE_CLOSED_ATTENDANCES_BILLING_DESTINATION_ID": 2522,
            "INVOICE_CLOSED_ATTENDANCES_CANDIDATE_ID": 2523,
            "INVOICE_CLOSED_ATTENDANCES_CANDIDATE_USER_ID": 2524,
            "INVOICE_CLOSED_ATTENDANCES_COMPANY_USER_ID": 2525,
            "INVOICE_CLOSED_ATTENDANCES_DISPATCH_SOURCE_ID": 2526,
            "PAYMENT_CLOSED_ATTENDANCES_CLOSING_END_DATE": 2527,
            "PAYMENT_CLOSED_ATTENDANCES_ATTENDANCE_DATE": 2528,
            "PAYMENT_CLOSED_ATTENDANCES_PAYMENT_DATE": 2529,
            "PAYMENT_CLOSED_ATTENDANCES_COMPANY_ID": 2530,
            "PAYMENT_CLOSED_ATTENDANCES_DISPATCH_DESTINATION_ID": 2531,
            "PAYMENT_CLOSED_ATTENDANCES_CANDIDATE_ID": 2532,
            "PAYMENT_CLOSED_ATTENDANCES_PAYMENT_TIME_TYPE_ID": 2533,
            "PAYMENT_CLOSED_ATTENDANCES_CANDIDATE_USER_ID": 2534,
            "PAYMENT_CLOSED_ATTENDANCES_COMPANY_USER_ID": 2535,
            "PAYMENT_CLOSED_ATTENDANCES_DISPATCH_SOURCE_ID": 2536,
            "PAYMENT_CLOSED_ATTENDANCES_NO_CONTRACT": 2537,
            "INVOICE_CLOSED_INVOICES_CLOSING_END_DATE": 2538,
            "INVOICE_CLOSED_INVOICES_ATTENDANCE_DATE": 2539,
            "INVOICE_CLOSED_INVOICES_COMPANY_ID": 2540,
            "INVOICE_CLOSED_INVOICES_DISPATCH_DESTINATION_ID": 2541,
            "INVOICE_CLOSED_INVOICES_BILLING_DESTINATION_ID": 2542,
            "INVOICE_CLOSED_INVOICES_CANDIDATE_ID": 2543,
            "INVOICE_CLOSED_INVOICES_CANDIDATE_USER_ID": 2544,
            "INVOICE_CLOSED_INVOICES_COMPANY_USER_ID": 2545,
            "INVOICE_CLOSED_INVOICES_SALES_DATE": 2546,
            "INVOICE_CLOSED_INVOICES_INVOICE_DATE": 2547,
            "INVOICE_CLOSED_INVOICES_PAYMENT_SCHEDULE_DATE": 2548,
            "INVOICE_CLOSED_INVOICES_INVOICE_CLOSED_INVOICE_STATE_ID": 2549,
            "INVOICE_CLOSED_INVOICES_INVOICE_CONTRACT_ATTENDANCE_ID": 2550,
            "PAYMENT_CLOSED_PAYMENTS_CLOSING_END_DATE": 2551,
            "PAYMENT_CLOSED_PAYMENTS_ATTENDANCE_DATE": 2552,
            "PAYMENT_CLOSED_PAYMENTS_PAYMENT_DATE": 2553,
            "PAYMENT_CLOSED_PAYMENTS_COMPANY_ID": 2554,
            "PAYMENT_CLOSED_PAYMENTS_DISPATCH_DESTINATION_ID": 2555,
            "PAYMENT_CLOSED_PAYMENTS_CANDIDATE_ID": 2556,
            "PAYMENT_CLOSED_PAYMENTS_PAYMENT_TIME_TYPE_ID": 2557,
            "PAYMENT_CLOSED_PAYMENTS_CANDIDATE_USER_ID": 2558,
            "PAYMENT_CLOSED_PAYMENTS_COMPANY_USER_ID": 2559,
            "PAYMENT_CLOSED_PAYMENTS_DISPATCH_SOURCE_ID": 2560,
            "PAYMENT_CLOSED_PAYMENTS_PAYMENT_CLOSED_PAYMENT_STATE_ID": 2561,
            "PAYMENT_CLOSED_PAYMENTS_PAYMENT_CONTRACT_ATTENDANCE_ID": 2562,
            "INVOICE_CONTRACT_ATTENDANCES_ID": 2563,
            "CANDIDATE_USER_USER_ID": 2564,
            "COMPANY_USER_USER_ID": 2565,
            "JOB_USER_USER_ID": 2566,
            "DISPATCH_JOB_USER_USER_ID": 2567,
            "CANDIDATE_CAREER_COUNSELLING_ID": 2568,
            "CANDIDATE_CAREER_COUNSELLING_CANDIDATE_ID": 2569,
            "CANDIDATE_CAREER_COUNSELLING_CANDIDATE_STAFF_ID": 2570,
            "CANDIDATE_CAREER_COUNSELLING_DISPATCH_SOURCE_CAREER_STAFF_ID": 2571,
            "CANDIDATE_CAREER_COUNSELLING_JOB_CLASSIFICATION_TYPE_ID": 2572,
            "CANDIDATE_CAREER_COUNSELLING_COUNSELLING_DATETIME": 2573,
            "CANDIDATE_CAREER_COUNSELLING_INTERNAL_EXTERNAL_TYPE_ID": 2574,
            "CANDIDATE_CAREER_COUNSELLING_HAS_WORK_EXPERIENCE": 2575,
            "CANDIDATE_CAREER_COUNSELLING_CONCURRENTLY_DISPATCH_STAFF": 2576,
            "CANDIDATE_CAREER_COUNSELLING_HAS_KNOWLEDGE": 2577,
            "CANDIDATE_CAREER_COUNSELLING_EMPLOYMENT_START_DATE": 2578,
            "CANDIDATE_CAREER_COUNSELLING_EMPLOYMENT_END_DATE": 2579,
            "CANDIDATE_EDUCATION_AND_TRAINING_ID": 2580,
            "CANDIDATE_EDUCATION_AND_TRAINING_CANDIDATE_ID": 2581,
            "CANDIDATE_EDUCATION_AND_TRAINING_CANDIDATE_STAFF_ID": 2582,
            "CANDIDATE_EDUCATION_AND_TRAINING_EDUCATION_TRAINING_TITLE": 2583,
            "CANDIDATE_EDUCATION_AND_TRAINING_TRAINING_ENTITY_TYPE_ID": 2584,
            "CANDIDATE_EDUCATION_AND_TRAINING_TRAINING_DATETIME": 2585,
            "CANDIDATE_EDUCATION_AND_TRAINING_USER_ID": 2586,
            "CANDIDATE_EDUCATION_AND_TRAINING_WAGES": 2587,
            "CANDIDATE_EDUCATION_AND_TRAINING_EMPLOYMENT_START_DATE": 2588,
            "CANDIDATE_EDUCATION_AND_TRAINING_EMPLOYMENT_END_DATE": 2589,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_ID": 2590,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_CANDIDATE_ID": 2591,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_CANDIDATE_STAFF_ID": 2592,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_USER_ID": 2593,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_HOPE_CLASSIFICATION_TYPE_ID": 2594,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_HOPE_HEARING_DATETIME": 2595,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_PERFORMED_CLASSIFICATION_TYPE_ID": 2596,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_PERFORMED_DATETIME": 2597,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_EMPLOYMENT_START_DATE": 2598,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_EMPLOYMENT_END_DATE": 2699,
            "CANDIDATE_MHLW_OCCUPATION_ID": 2700,
            "JOB_MHLW_OCCUPATION_ID": 2701,
            "CANDIDATE_STEPS_CORRESPONDENCE_USER_ID": 2702,
            "CANDIDATE_STEPS_CREATE_USER_ID": 2703,
            "COMPANY_STEPS_CORRESPONDENCE_USER_ID": 2704,
            "COMPANY_STEPS_CREATE_USER_ID": 2705,
            "CANDIDATE_JOB_STEPS_CANDIDATE_CORRESPONDENCE_USER_ID": 2706,
            "CANDIDATE_JOB_STEPS_JOB_CORRESPONDENCE_USER_ID": 2707,
            "CANDIDATE_JOB_STEPS_CREATE_USER_ID": 2708,
            "CONTRACT_MEMO_ID": 2709,
            "CONTRACT_MEMO_CONTRACT_MEMO_TYPE_ID": 2711,
            "CONTRACT_MEMO_MEMO_DATE": 2712,
            "CONTRACT_MEMO_CONTRACT_CANDIDATE_ID": 2713,
            "CONTRACT_MEMO_CONTRACT_COMPANY_ID": 2714,
            "CONTRACT_MEMO_CONTRACT_DISPATCH_DESTINATION_ID": 2715,
            "CONTRACT_MEMO_CONTRACT_DISPATCH_START_DATE": 2716,
            "CONTRACT_MEMO_CONTRACT_DISPATCH_END_DATE": 2717,
            "STAFF_COMPANY_USER_USER_ID": 2718,
            "FILTER_USER": "user",
            "FILTER_DEPARTMENT": "department",
            "FILTER_USER_RESERVED_ID": 99999,
            "FILTER_DEPARTMENT_RESERVED_ID": 99999,
            "NOT_SEEDER_ROW_OFFSET": 100000,
            "USER_ROW_OFFSET_ID": 100001,
            "PRIMARY_TABLE_NAME_TO_SEARCH_RESOURCE_ID": {
                "candidates": 125,
                "candidate_steps": 564,
                "companies": 126,
                "company_steps": 563,
                "billing_destinations": 555,
                "staffs": 556,
                "dispatch_destinations": 557,
                "dispatch_staffs": 558,
                "dispatch_working_places": 560,
                "dispatch_organization_units": 559,
                "jobs": 127,
                "dispatch_jobs": 561,
                "contracts": 565,
                "candidate_job_step_resources": 562,
                "sales": 567
            }
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "display_name": null,
            "id": 0,
            "is_editable": "1",
            "name": null,
            "position": null,
            "property_category_id": null,
            "search_property_category_id": null,
            "updated_at": null,
            "propertyColumns": null,
            "propertyCategory": null,
            "searchPropertyCategory": null,
            "searchProperties": null
        },
        "relations": {
            "propertyColumns": "PropertyColumn",
            "propertyCategory": "PropertyCategory",
            "searchPropertyCategory": "SearchPropertyCategory",
            "searchProperties": "SearchProperty"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "search_columns"
    },
    "SearchCriterion": {
        "constants": {
            "CRITERION_NORMAL": [
                1,
                2,
                5,
                15,
                22
            ],
            "CRITERION_SELECT": [
                3,
                8,
                4
            ],
            "CRITERION_DATE": [
                6,
                11,
                21
            ],
            "CRITERION_NUMBER": [
                7
            ],
            "CRITERION_TIME": [
                16
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "property_table_id": null,
            "request_parameter": null,
            "updated_at": null,
            "user_id": null
        },
        "relations": [],
        "appends": [
            "conditions",
            "conditionItems"
        ],
        "parents": [
            "App\\Models\\Bases\\SearchCriterionModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "search_criteria"
    },
    "SearchCriterionModel": {
        "constants": {
            "CRITERION_NORMAL": [
                1,
                2,
                5,
                15,
                22
            ],
            "CRITERION_SELECT": [
                3,
                8,
                4
            ],
            "CRITERION_DATE": [
                6,
                11,
                21
            ],
            "CRITERION_NUMBER": [
                7
            ],
            "CRITERION_TIME": [
                16
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "SearchMode": {
        "constants": {
            "SEARCH_AND": 1,
            "SEARCH_OR": 2,
            "SEARCH_NOT": 3,
            "SEARCH_EMPTY": 4,
            "SEARCH_ENTERED": 5,
            "ALL_MODES": [
                1,
                2,
                3,
                4,
                5
            ],
            "INPUT_CATEGORY_DISABLE_MODES": {
                "7": [
                    1,
                    2
                ],
                "6": [
                    1,
                    2
                ],
                "21": [
                    1,
                    2
                ],
                "14": [
                    1,
                    2
                ],
                "16": [
                    1,
                    2
                ],
                "20": [
                    1,
                    2
                ],
                "11": [
                    1,
                    2
                ],
                "8": [
                    1,
                    2
                ]
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "search_modes"
    },
    "SearchProperty": {
        "constants": {
            "SEARCH_PROPERTY_COLUMN_GROUPS": {
                "2": [
                    153
                ],
                "3": [
                    154
                ],
                "5": [
                    155
                ],
                "45": [
                    156
                ],
                "46": [
                    157
                ],
                "43": [
                    158
                ],
                "72": [
                    159
                ]
            },
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "property_column_id": null,
            "search_column_id": null,
            "updated_at": null,
            "searchColumn": null,
            "propertyColumn": null
        },
        "relations": {
            "searchColumn": "SearchColumn",
            "propertyColumn": "PropertyColumn"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "search_properties"
    },
    "SearchPropertyCategory": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "CANDIDATE_FREE_WORD": 1,
            "CANDIDATE_BASIC_INFO": 2,
            "EDUCATION_CATEGORY": 3,
            "CAREER_CATEGORY": 4,
            "CANDIDATE_CIRCUMSTANCE": 5,
            "CANDIDATE_HOPE": 6,
            "CANDIDATE_ENGLISH_SKILL": 7,
            "OTHER": 8,
            "CANDIDATE_FREE_ITEM": 9,
            "CANDIDATE_FILES": 10,
            "COMPANY_FREE_WORD": 11,
            "COMPANY_BASIC_INFO": 12,
            "COMPANY_DETAIL": 13,
            "COMPANY_FREE_INPUT": 14,
            "JOB_FREE_WORD": 15,
            "JOB_BASIC_INFO": 16,
            "JOB_DETAIL": 17,
            "JOB_REQUIREMENT": 18,
            "JOB_FREE_INPUT": 19,
            "FREE_WORDS": [
                1,
                11,
                15,
                5013,
                5126,
                5135,
                5125,
                5119,
                5124,
                5101,
                5100,
                5120,
                5017,
                5121,
                5016
            ],
            "JOB_FILE": 20,
            "STAFF": 21,
            "SALES_BASIC_INFO": 22,
            "FEE_INFO": 23,
            "SALES_OTHER": 24,
            "AGENCY": 25,
            "AGENT": 26,
            "SALE_REFUND_BASIC_INFO": 27,
            "SALE_REFUND_BANK_INFO": 28,
            "SALE_REFUND_FEE_INFO": 29,
            "SALE_REFUND_OTHER": 30,
            "SETTINGS_BASIC_INFO": 31,
            "SETTINGS_BANK_INFO": 32,
            "CANDIDATE_JOB_STEPS_BASIC_INFO": 33,
            "CANDIDATE_JOB_STEPS_CANDIDATE": 34,
            "CANDIDATE_JOB_STEPS_JOB": 35,
            "STATIC_FUNCTION_DATE": 36,
            "COMPANY_STEPS_BASIC_INFO": 37,
            "USERS_BASIC_INFO": 38,
            "CANDIDATE_STEPS_BASIC_INFO": 39,
            "TASK_BASIC_INFO": 40,
            "SCHEDULE_BASIC_INFO": 41,
            "DISPATCH_REPORT": 5001,
            "DISPATCH_WORKING_NOTICE_AND_CONDITION_EXPLICIT": 5002,
            "DISPATCH_DISCRETE_CONTRACT": 5003,
            "DISPATCH_WORKING_CONDITIONS": 5004,
            "SALES_RETIREMENT_INFO": 5005,
            "SALES_REFUND_INFO": 5006,
            "SALES_REFUND_DESTINATION_INFO": 5007,
            "CANDIDATE_JOB_STEP_RESOURCES_BASIC_INFO": 5008,
            "CANDIDATE_STEP_STATES_BASIC_INFO": 5009,
            "CANDIDATE_JOB_STEP_RESOURCES_SEARCH_BASIC_INFO": 5010,
            "CANDIDATE_JOB_STEP_RESOURCES_CANDIDATE": 5011,
            "CANDIDATE_JOB_STEP_RESOURCES_JOB": 5012,
            "SALE_FREE_WORD": 5013,
            "CANDIDATE_STEP_RESOURCES_BASIC_INFO": 5014,
            "COMPANY_STEP_RESOURCES_BASIC_INFO": 5015,
            "CANDIDATE_JOB_STEP_RESOURCE_FREE_WORD": 5016,
            "CANDIDATE_STEP_RESOURCE_FREE_WORD": 5017,
            "COMPANY_STEP_RESOURCE_FREE_WORD": 5100,
            "DISPATCH_DESTINATION_FREE_WORD": 5101,
            "DISPATCH_DESTINATION_BASIC_INFO": 5102,
            "DISPATCH_STAFF_BASIC_INFO": 5103,
            "DISPATCH_STAFF_SYSTEM_INFO": 5104,
            "DISPATCH_WORKING_PLACE_BASIC_INFO": 5105,
            "DISPATCH_WORKING_PLACE_SYSTEM_INFO": 5106,
            "DISPATCH_ORGANIZATION_UNIT_BASIC_INFO": 5107,
            "DISPATCH_ORGANIZATION_UNIT_SYSTEM_INFO": 5108,
            "DISPATCH_STAFF_FREE_WORD": 5119,
            "DISPATCH_WORKING_PLACE_FREE_WORD": 5120,
            "DISPATCH_ORGANIZATION_UNIT_FREE_WORD": 5121,
            "BILLING_DESTINATION_FREE_WORD": 5124,
            "DISPATCH_JOB_FREE_WORD": 5125,
            "STAFF_FREE_WORD": 5126,
            "CONTRACT_FREE_WORD": 5135,
            "BILLING_DESTINATION_BASIC_INFO": 5109,
            "DISPATCH_JOB_BASIC_INFO": 5111,
            "CONTRACT_BASIC_INFO": 5127,
            "DISPATCH_SOURCE_BASIC_INFO": 5136,
            "DISPATCH_SOURCE_STAFF_BASIC_INFO": 5138,
            "DISPATCH_SPOT_JOB_FREE_WORD": 7010,
            "DISPATCH_SPOT_JOB_SPOT_DUE_DATE": 7011,
            "DISPATCH_SPOT_JOB_BASIC_INFO": 7012,
            "CONFLICT_DATE_MANAGEMENT_BASIC_INFO": 7013,
            "INVOICE_CLOSED_ATTENDANCE_INVOICE_INFO": 7001,
            "INVOICE_CLOSED_INVOICE_INVOICE_INFO": 7003,
            "PAYMENT_CLOSED_ATTENDANCE_PAYMENT_INFO": 7005,
            "PAYMENT_CLOSED_PAYMENT_PAYMENT_INFO": 7007,
            "CONTRACT_ATTENDANCE": 7009,
            "INVOICE_CONTRACT_ATTENDANCES": 7024,
            "INVOICE_CLOSED_ATTENDANCES": 7026,
            "PAYMENT_CLOSED_ATTENDANCES": 7027,
            "INVOICE_CLOSED_INVOICES": 7030,
            "CANDIDATE_CAREER_COUNSELLING_BASIC_INFO": 7054,
            "CANDIDATE_CAREER_COUNSELLING_SYSTEM_INFO": 7055,
            "CANDIDATE_EDUCATION_AND_TRAINING_BASIC_INFO": 7056,
            "CANDIDATE_EDUCATION_AND_TRAINING_SYSTEM_INFO": 7057,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_BASIC_INFO": 7058,
            "CANDIDATE_EMPLOYMENT_STABILITY_MEASURE_SYSTEM_INFO": 7059,
            "CONTRACT_MEMO_BASIC_INFO": 5155,
            "SYSTEM_USE_CATEGORIES": [
                1,
                10,
                11,
                15,
                20,
                5013,
                5016,
                5017,
                5100,
                5101,
                5119,
                5120,
                5121,
                5124,
                5125,
                5126,
                5135
            ],
            "FREE_WORD_NAME": "freeWord"
        },
        "properties": {
            "created_at": null,
            "display_name": null,
            "id": 0,
            "name": null,
            "position": null,
            "property_tab_id": null,
            "property_table_id": null,
            "updated_at": null,
            "propertyColumns": null,
            "searchColumns": null,
            "searchProperties": null,
            "propertyTable": null,
            "propertyTab": null
        },
        "relations": {
            "propertyColumns": "PropertyColumn",
            "searchColumns": "SearchColumn",
            "searchProperties": "SearchProperty",
            "propertyTable": "PropertyTable",
            "propertyTab": "PropertyTab"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "search_property_categories"
    },
    "SendMailState": {
        "constants": {
            "NOT_RESPONSE_STATE": 0,
            "RESPONSE_STATE": 1,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "name": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "send_mail_states"
    },
    "Setting": {
        "constants": {
            "SOFTWARE_CATEGORY": {
                "agent": "agent",
                "free_agent": "free_agent",
                "recruit": "recruit",
                "free_recruit": "free_recruit"
            },
            "KEY_APPLY_CANDIDATE_JOB_STEP_STATE_ID": "apply_candidate_job_step_state_id",
            "KEY_MATCHING_CANDIDATE_JOB_STEP_STATE_ID": "matching_candidate_job_step_state_id",
            "KEY_RECOMMEND_CANDIDATE_JOB_STEP_STATE_ID": "recommend_candidate_job_step_state_id",
            "KEY_IS_PLAN_EMPLOYMENT_AGENCY": "is_plan_employment_agency",
            "KEY_IS_PLAN_DISPATCH_BASIC": "is_plan_dispatch_basic",
            "KEY_IS_PLAN_DISPATCH_BILL": "is_plan_dispatch_bill",
            "KEY_IS_PLAN_DISPATCH_PAYROLL": "is_plan_dispatch_payroll",
            "KEY_OAUTH_PUBLIC_KEY": "oauth_public_key",
            "KEY_OAUTH_PRIVATE_KEY": "oauth_private_key",
            "KEY_IS_IFRAME_APPLICATION_ENTRY": "is_iframe_application_entry",
            "KEY_IS_IFRAME_APPLICATION_JOB": "is_iframe_application_job",
            "KEY_IS_OPTION_PLAN_MAP_MATCHING": "is_option_plan_map_matching",
            "KEY_IS_MAIL_TO_CC": "is_mail_to_cc",
            "KEY_IS_OPTION_PLAN_MYRIC_MYPAGE": "is_option_plan_myric_mypage",
            "KEY_IS_MYRIC_MYPAGE_INVITATION_URL": "is_myric_mypage_invitation_url",
            "KEY_IS_OPTION_PLAN_LINE_OPTION": "is_option_plan_line_option",
            "KEY_IS_OPTION_PLAN_ACES_MEET": "is_option_plan_aces_meet",
            "KEY_BULK_MAIL_INTERVAL_MS": "bulk_mail_interval_ms",
            "PLAN_KEYS": [
                "is_plan_employment_agency",
                "is_plan_dispatch_basic"
            ],
            "PLAN_AGENCY": "plan_agency",
            "PLAN_DISPATCH": "plan_dispatch",
            "PLAN_DISPATCH_BILL": "plan_dispatch_bill",
            "PLAN_DISPATCH_PAYROLL": "plan_dispatch_payroll",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "key": null,
            "updated_at": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "settings"
    },
    "Sex": {
        "constants": {
            "MALE": 1,
            "FEMALE": 2,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "is_system_default": "0",
            "name": null,
            "position": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "sexes"
    },
    "Signature": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "is_default": null,
            "position": null,
            "text": null,
            "title": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "signatures"
    },
    "Staff": {
        "constants": {
            "DISABLE_COLUMNS_FOR_APIV2_UPDATE": [
                "company_id"
            ],
            "INITIAL_INDEX_RELATIONS": [
                "company",
                "staffState"
            ],
            "INITIAL_SEARCH_COLUMNS": [],
            "PROFILE_RELATIONS": [],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "company_id": null,
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "department": null,
            "email": null,
            "fax": null,
            "full_text": null,
            "id": 0,
            "is_possible_bulk_mail": "1",
            "kana": null,
            "kana_normalized": null,
            "memo": null,
            "name": null,
            "name_normalized": null,
            "portable_tel": null,
            "post": null,
            "prefecture_id": null,
            "staff_state_id": null,
            "state_updated_at": null,
            "tel": null,
            "updated_at": null,
            "updated_user_id": null,
            "zip": null,
            "freeItems": null,
            "company": null,
            "prefecture": null,
            "companySteps": null,
            "jobs": null,
            "mails": null,
            "user": null,
            "staffState": null,
            "users": null
        },
        "relations": {
            "company": "Company",
            "prefecture": "Prefecture",
            "companySteps": "CompanyStep",
            "jobs": "Job",
            "mails": "Mail",
            "user": "User",
            "staffState": "StaffState",
            "users": "User"
        },
        "appends": [
            "is_close_state"
        ],
        "parents": [
            "App\\Models\\Bases\\PrimaryObjectModel",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "staffs"
    },
    "StaffState": {
        "constants": {
            "ENABLED_STATE_ID": 1,
            "DISABLED_STATE_ID": 2,
            "DEFAULT_STATE_COLOR": "ffffff",
            "CHECKED_STATE_COLOR": "feffce",
            "CLOSE_STATE_COLOR": "cccccc",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "position": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "staff_states"
    },
    "Station": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "address": null,
            "alignment_sequence": null,
            "code": null,
            "company_kana": null,
            "company_name": null,
            "id": 0,
            "kana": null,
            "name": null,
            "prefecture_id": null,
            "route_code": null,
            "route_kana": null,
            "route_name": null,
            "zip": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "stations"
    },
    "StepModel": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": [],
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": []
    },
    "SummaryCondition": {
        "constants": {
            "DISPATCH_TABLES": [
                5027,
                5018
            ],
            "EXCLUDE_COLUMNS_FOR_JOB_PLAN": [
                5829
            ],
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "name": null,
            "property_table_id": null,
            "updated_at": null,
            "xaxis_property_column_id": null,
            "yaxis_property_column_id": null,
            "propertyTable": null
        },
        "relations": {
            "propertyTable": "PropertyTable"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "summary_conditions"
    },
    "SystemDefaultOption": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionAgreementEmploymentType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionAmountOverShortType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionAttendanceType": {
        "constants": {
            "HOLIDAY_ATTENDANCE_TYPES": [
                22,
                26,
                27,
                20
            ],
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionBearTrainingCostType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionBillType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionBooleanApproveType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionBooleanDefaultType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionBooleanExistenceType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionBooleanYesNoType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionCabinetOrderIndustryType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionCompanyScaleType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionContractMemoType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionDateAndWeekType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionDateOnlyType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionDayOfTheWeekType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionDispatchJobType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionEducationMethodType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionEducationTrainingClassificationType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionEmployeePensionType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionEmploymentInsuranceIndustryType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionEmploymentPlacementDispatchStatesType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionEmploymentStabilityMeasuresType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionExpenseProvisionType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionExportEncodingType": {
        "constants": {
            "VALUES_SHIFT_JIS": 1,
            "VALUES_UTF8": 2,
            "VALUES_UTF8_WITH_BOM": 3,
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionFractionRoundingType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionInternalExternalType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionIsTargetOverAge60Type": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionJapanStdOccupationType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionJobClassificationType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionLaborSafetyHealthActOrRegulationsType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionLeaveTimeType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionMailOauth2ScopeType": {
        "constants": {
            "SEND_GROUP": [
                227,
                228
            ],
            "RECEIVE_GROUP": [
                227,
                229
            ],
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionMailOauth2Type": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionMhlwOccupationType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null,
            "jobs": null,
            "candidates": null
        },
        "relations": {
            "jobs": "Job",
            "candidates": "Candidate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionMonthlyAndWeekType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionMonthlyType": {
        "constants": {
            "ADD_MONTH_VALUES": {
                "103": 0,
                "104": 1,
                "153": 2
            },
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionMyricMypageStateType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null,
            "candidates": null
        },
        "relations": {
            "candidates": "Candidate"
        },
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionNumberOfBusinessesType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionNumberOfEmployeesType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionOtherTrainingMethodType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionPaymentTimeType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionRepeatIntervalType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionRepeatMonthlyType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionRoundingType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionRoundingUnitType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionSimpleStateType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionSpotProhibitionExceptionType": {
        "constants": {
            "VALID_SPOT_PROHIBITION_EXCEPTIONS": [
                155,
                156,
                157,
                158,
                159
            ],
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTargetWorkersClassificationType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTaxRoundingType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTaxTableSectionType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTaxationType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTermLimitType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTimeRoundingType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTrainingEntityType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionTrainingMethodType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionWagePaymentTrainingType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionWageType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionWeekType": {
        "constants": {
            "ADD_DAY_VALUES": {
                "105": 0,
                "106": 7
            },
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptionYearlyWorkingDayType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "SystemDefaultOptoinAmountOverShortType": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "Task": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "finished_at": null,
            "id": 0,
            "memo": null,
            "source_id": null,
            "source_type": null,
            "start_at": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "tasks"
    },
    "TaxApiPensionStandardReward": {
        "constants": {
            "MINIMUM_PENSION_STANDARD_REWARD_ID": 4,
            "MAXIMUM_PENSION_STANDARD_REWARD_ID": 35,
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\TaxApiStandardReward",
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "TaxApiStandardReward": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "TaxApiWelfarePensionFundRate": {
        "constants": {
            "ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "FRACTION_ROUNDING_TYPES_GROUP_KEY": "fraction_rounding_types",
            "EXPENSE_PROVISION_TYPES_GROUP_KEY": "expense_provision_types",
            "BILL_TYPES_GROUP_KEY": "bill_types",
            "AMOUNT_OVER_SHORT_TYPES_GROUP_KEY": "amount_over_short_types",
            "TAXATION_TYPES_GROUP_KEY": "taxation_types",
            "WAGE_TYPES_GROUP_KEY": "wage_types",
            "YEARLY_WORKING_DAY_TYPES_GROUP_KEY": "yearly_working_day_types",
            "LEAVE_TIMES_TYPES_GROUP_KEY": "leave_times_types",
            "TIME_ROUNDING_TYPES_GROUP_KEY": "time_rounding_types",
            "TAX_ROUNDING_TYPES_GROUP_KEY": "tax_rounding_types",
            "BOOLEAN_DEFAULT_TYPES_GROUP_KEY": "boolean_default_types",
            "BOOLEAN_APPROVE_TYPES_GROUP_KEY": "boolean_approve_types",
            "DATE_ONLY_TYPES_GROUP_KEY": "date_only_types",
            "REPEAT_INTERVAL_TYPES_GROUP_KEY": "repeat_interval_types",
            "REPEAT_MONTHLY_TYPES_GROUP_KEY": "repeat_monthly_types",
            "TERM_LIMIT_TYPES_GROUP_KEY": "term_limit_types",
            "BOOLEAN_EXISTENCE_TYPES_GROUP_KEY": "boolean_existence_types",
            "ATTENDANCE_TYPES_GROUP_KEY": "attendance_types",
            "CONTRACT_MEMO_TYPES_GROUP_KEY": "contract_memo_types",
            "MONTHLY_TYPES_GROUP_KEY": "monthly_types",
            "WEEK_TYPES_GROUP_KEY": "week_types",
            "DAY_OF_THE_WEEK_TYPES_GROUP_KEY": "day_of_the_week_types",
            "PAYMENT_TIME_TYPES_GROUP_KEY": "payment_time_types",
            "CABINET_ORDER_INDUSTRY_TYPES_GROUP_KEY": "cabinet_order_industry_types",
            "AGREEMENT_EMPLOYMENT_TYPES_GROUP_KEY": "agreement_employment_types",
            "DISPATCH_JOB_TYPES_GROUP_KEY": "dispatch_job_types",
            "TARGET_OVER_AGE_60_TYPES_GROUP_KEY": "target_over_age_60_types",
            "SPOT_PROHIBITION_EXCEPTION_TYPES_GROUP_KEY": "spot_prohibition_exception_types",
            "TAX_TABLE_SECTION_TYPES_GROUP_KEY": "tax_table_section_types",
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GROUP_KEY": "employment_insurance_industry_types",
            "ROUNDING_UNIT_TYPES_GROUP_KEY": "rounding_unit_types",
            "EMPLOYEE_PENSION_TYPES_GROUP_KEY": "employee_pension_types",
            "MAIL_OAUTH2_TYPES_GROUP_KEY": "mail_oauth2_types",
            "MAIL_OAUTH2_SCOPE_TYPES_GROUP_KEY": "mail_oauth2_scope_types",
            "COMPANY_SCALE_TYPES_GROUP_KEY": "company_scale_types",
            "BOOLEAN_YES_NO_TYPES_GROUP_KEY": "boolean_yes_no_types",
            "JOB_CLASSIFICATION_TYPES_GROUP_KEY": "job_classification_types",
            "INTERNAL_EXTERNAL_TYPES_GROUP_KEY": "internal_external_types",
            "TRAINING_ENTITY_TYPES_GROUP_KEY": "training_entity_types",
            "BEAR_TRAINING_COST_TYPES_GROUP_KEY": "bear_training_cost_types",
            "WAGE_PAYMENT_TRAINING_TYPES_GROUP_KEY": "wage_payment_training_types",
            "OTHER_TRAINING_METHOD_TYPES_GROUP_KEY": "other_training_method_types",
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_GROUP_KEY": "education_training_classification_types",
            "TARGET_WORKERS_CLASSIFICATION_TYPES_GROUP_KEY": "target_workers_classification_types",
            "TRAINING_METHOD_TYPES_GROUP_KEY": "training_method_types",
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_GROUP_KEY": "labor_safety_health_act_or_regulations_types",
            "EDUCATION_METHOD_TYPES_GROUP_KEY": "education_method_types",
            "SIMPLE_STATE_TYPES_GROUP_KEY": "simple_state_types",
            "NUMBER_OF_EMPLOYEES_TYPES_GROUP_KEY": "number_of_employees_types",
            "NUMBER_OF_BUSINESSES_TYPES_GROUP_KEY": "number_of_businesses_types",
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_GROUP_KEY": "employment_stability_measures_types",
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_GROUP_KEY": "employment_placement_dispatch_states_types",
            "MHLW_OCCUPATION_TYPES_GROUP_KEY": "mhlw_occupation_types",
            "JAPAN_STD_OCCUPATION_TYPES_GROUP_KEY": "japan_std_occupation_types",
            "EXPORT_ENCODING_TYPES_GROUP_KEY": "export_encoding_types",
            "MYRIC_MYPAGE_STATE_TYPES_GROUP_KEY": "myric_mypage_state_types",
            "ROUNDING_TYPES_DOWN_ID": 1,
            "ROUNDING_TYPES_UP_ID": 2,
            "ROUNDING_TYPES_OFF4_ID": 3,
            "ROUNDING_TYPES_OFF5_ID": 4,
            "EXPENSE_PROVISION_TYPES_FULL_SUPPLY_ID": 5,
            "EXPENSE_PROVISION_TYPES_FIXED_SUPPLY_ID": 6,
            "EXPENSE_PROVISION_TYPES_FULL_WITH_UPPER_LIMIT_SUPPLY_ID": 7,
            "EXPENSE_PROVISION_TYPES_NO_SUPPLY_ID": 8,
            "BILL_TYPES_INVOICE_ID": 9,
            "BILL_TYPES_DETAILS_ID": 10,
            "AMOUNT_OVER_SHORT_TYPES_PREPAID_ID": 11,
            "AMOUNT_OVER_SHORT_TYPES_MAIN_ID": 12,
            "TAXATION_TYPES_TAXABLE_ID": 13,
            "TAXATION_TYPES_NON_TAXABLE_ID": 14,
            "WAGE_TYPES_HOURLY_ID": 15,
            "WAGE_TYPES_DAILY_ID": 16,
            "WAGE_TYPES_MONTHLY_FIXED_ID": 17,
            "WAGE_TYPES_MONTHLY_ACHIEVED_ID": 18,
            "ATTENDANCE_TYPES_COMMUTING": 19,
            "ATTENDANCE_TYPES_PAID_HOLIDAY": 20,
            "ATTENDANCE_TYPES_HALF_HOLIDAY": 21,
            "ATTENDANCE_TYPES_ABSENCE": 22,
            "ATTENDANCE_TYPES_LEAVE_EARLY": 23,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY_WORK": 24,
            "ATTENDANCE_TYPES_NON_STATUTORY_HOLIDAY_WORK": 25,
            "ATTENDANCE_TYPES_LEGAL_HOLIDAY": 26,
            "ATTENDANCE_TYPES_PRESCRIBED_HOLIDAY": 27,
            "YEARLY_WORKING_DAY_TYPE_0_TO_47": 35,
            "YEARLY_WORKING_DAY_TYPE_48_TO_72": 36,
            "YEARLY_WORKING_DAY_TYPE_73_TO_120": 37,
            "YEARLY_WORKING_DAY_TYPE_121_TO_168": 38,
            "YEARLY_WORKING_DAY_TYPE_169_TO_216": 39,
            "YEARLY_WORKING_DAY_TYPE_217_TO": 40,
            "LEAVE_TIMES_TYPE_1_TIME": 41,
            "LEAVE_TIMES_TYPE_2_TIME": 42,
            "LEAVE_TIMES_TYPE_3_TIME": 43,
            "LEAVE_TIMES_TYPE_4_TIME": 44,
            "LEAVE_TIMES_TYPE_5_TIME": 45,
            "LEAVE_TIMES_TYPE_6_TIME": 46,
            "LEAVE_TIMES_TYPE_AFTER_7_TIME": 47,
            "TIME_ROUNDING_TYPES_DOWN_ID": 48,
            "TIME_ROUNDING_TYPES_UP_ID": 49,
            "TAX_ROUNDING_TYPES_DOWN_ID": 50,
            "TAX_ROUNDING_TYPES_UP_ID": 51,
            "BOOLEAN_DEFAULT_TYPES_TRUE_ID": 52,
            "BOOLEAN_DEFAULT_TYPES_FALSE_ID": 53,
            "BOOLEAN_APPROVE_TYPES_TRUE_ID": 54,
            "BOOLEAN_APPROVE_TYPES_FALSE_ID": 55,
            "DATE_ONLY_TYPES_1_ID": 56,
            "DATE_ONLY_TYPES_2_ID": 57,
            "DATE_ONLY_TYPES_3_ID": 58,
            "DATE_ONLY_TYPES_4_ID": 59,
            "DATE_ONLY_TYPES_5_ID": 60,
            "DATE_ONLY_TYPES_6_ID": 61,
            "DATE_ONLY_TYPES_7_ID": 62,
            "DATE_ONLY_TYPES_8_ID": 63,
            "DATE_ONLY_TYPES_9_ID": 64,
            "DATE_ONLY_TYPES_10_ID": 65,
            "DATE_ONLY_TYPES_11_ID": 66,
            "DATE_ONLY_TYPES_12_ID": 67,
            "DATE_ONLY_TYPES_13_ID": 68,
            "DATE_ONLY_TYPES_14_ID": 69,
            "DATE_ONLY_TYPES_15_ID": 70,
            "DATE_ONLY_TYPES_16_ID": 71,
            "DATE_ONLY_TYPES_17_ID": 72,
            "DATE_ONLY_TYPES_18_ID": 73,
            "DATE_ONLY_TYPES_19_ID": 74,
            "DATE_ONLY_TYPES_20_ID": 75,
            "DATE_ONLY_TYPES_21_ID": 76,
            "DATE_ONLY_TYPES_22_ID": 77,
            "DATE_ONLY_TYPES_23_ID": 78,
            "DATE_ONLY_TYPES_24_ID": 79,
            "DATE_ONLY_TYPES_25_ID": 80,
            "DATE_ONLY_TYPES_26_ID": 81,
            "DATE_ONLY_TYPES_27_ID": 82,
            "DATE_ONLY_TYPES_28_ID": 83,
            "DATE_ONLY_TYPES_29_ID": 84,
            "DATE_ONLY_TYPES_30_ID": 85,
            "DATE_ONLY_TYPES_LAST_DAY_ID": 86,
            "REPEAT_INTERVAL_TYPES_DAYLY_ID": 87,
            "REPEAT_INTERVAL_TYPES_WEEKLY_ID": 88,
            "REPEAT_INTERVAL_TYPES_MONTHLY_ID": 89,
            "REPEAT_MONTHLY_TYPES_LAST_DAY_ID": 90,
            "REPEAT_MONTHLY_TYPES_CLOSING_DAY_ID": 91,
            "TERM_LIMIT_TYPES_FIXED_TERM_PROJECT": 92,
            "TERM_LIMIT_TYPES_LIMITED_NUMBER_OF_DAYS": 93,
            "TERM_LIMIT_TYPES_CHILDCARE_LEAVE": 94,
            "TERM_LIMIT_TYPES_NURSING_CARE_LEAVE": 95,
            "BOOLEAN_EXISTENCE_TYPES_TRUE_ID": 96,
            "BOOLEAN_EXISTENCE_TYPES_FALSE_ID": 97,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_SOURCE": 98,
            "CONTRACT_MEMO_TYPES_CLAIM_DISPATCH_DESTINATION": 99,
            "CONTRACT_MEMO_TYPES_EDUCATION": 100,
            "CONTRACT_MEMO_TYPES_CAREER_CONSULTING": 101,
            "CONTRACT_MEMO_TYPES_EMPLOYMENT_STABILITY": 102,
            "MONTHLY_TYPES_THIS_MONTH": 103,
            "MONTHLY_TYPES_NEXT_MONTH": 104,
            "WEEK_TYPES_THIS_WEEK": 105,
            "WEEK_TYPES_NEXT_WEEK": 106,
            "DAY_OF_THE_WEEK_TYPES_MONDAY": 107,
            "DAY_OF_THE_WEEK_TYPES_TUESDAY": 108,
            "DAY_OF_THE_WEEK_TYPES_WEDNESDAY": 109,
            "DAY_OF_THE_WEEK_TYPES_THURSDAY": 110,
            "DAY_OF_THE_WEEK_TYPES_FRIDAY": 111,
            "DAY_OF_THE_WEEK_TYPES_SATURDAY": 112,
            "DAY_OF_THE_WEEK_TYPES_SUNDAY": 113,
            "PAYMENT_TIME_TYPES_MONTH": 114,
            "PAYMENT_TIME_TYPES_WEEK": 115,
            "PAYMENT_TIME_TYPES_DAY": 116,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_1": 117,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_2": 118,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_3": 119,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_4": 120,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_5": 121,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_6": 122,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_7": 123,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_8": 124,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_9": 125,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_10": 126,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_11": 127,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_12": 128,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_13": 129,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_14": 130,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_15": 131,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_16": 132,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_17": 133,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_18": 134,
            "CABINET_ORDER_INDUSTRY_TYPES_4_1_19": 243,
            "CABINET_ORDER_INDUSTRY_TYPES_5_1": 135,
            "CABINET_ORDER_INDUSTRY_TYPES_5_2": 136,
            "CABINET_ORDER_INDUSTRY_TYPES_5_3": 137,
            "CABINET_ORDER_INDUSTRY_TYPES_5_4": 138,
            "CABINET_ORDER_INDUSTRY_TYPES_5_5": 139,
            "CABINET_ORDER_INDUSTRY_TYPES_5_6": 140,
            "CABINET_ORDER_INDUSTRY_TYPES_5_7": 141,
            "CABINET_ORDER_INDUSTRY_TYPES_5_8": 142,
            "CABINET_ORDER_INDUSTRY_TYPES_5_9": 143,
            "CABINET_ORDER_INDUSTRY_TYPES_5_10": 144,
            "AGREEMENT_EMPLOYMENT_TYPES_FALSE_ID": 145,
            "AGREEMENT_EMPLOYMENT_TYPES_TRUE_ID": 146,
            "DISPATCH_JOB_TYPES_DISPATCH_JOB_ID": 147,
            "DISPATCH_JOB_TYPES_SPOT_JOB_ID": 148,
            "TARGET_OVER_AGE_60_TYPE_NOT_LIMITED_ID": 149,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_OVER_60_ID": 150,
            "TARGET_OVER_AGE_60_TYPE_LIMITED_TO_INDEFINITE_EMPLOYMENT_DISPATCH_ID": 151,
            "CONTRACT_MEMO_TYPES_EDUCATION_FROM_DISPATCH_DESTINATION": 152,
            "MONTHLY_TYPES_MONTH_AFTER_NEXT": 153,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_NOT_APPLICABLE": 154,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_MORE_60_YEARS_OLD": 155,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_STUDENT_DO_NOT_RECEIVE_EMPLOYMENT_INSURANCE_APPLYING": 156,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_ENGAGE_AS_SIDE_JOB": 157,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_EXCEPT_PRINCIPAL_LIVELIHOOD_PERSON": 158,
            "SPOT_PROHIBITION_EXCEPTION_TYPES_OTHER": 159,
            "TAX_TABLE_SECTION_TYPES_A_COLUMN": 160,
            "TAX_TABLE_SECTION_TYPES_B_COLUMN": 161,
            "TAX_TABLE_SECTION_TYPES_C_COLUMN": 162,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_GENERAL_ID": 163,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_AGRICULTURE_FISHERIES_ID": 164,
            "EMPLOYMENT_INSURANCE_INDUSTRY_TYPES_CONSTRUCTION_ID": 165,
            "ROUNDING_UNIT_TYPES_DAILY_ID": 166,
            "ROUNDING_UNIT_TYPES_SUMMARY_ID": 167,
            "EMPLOYEE_PENSION_TYPES_GENERAL_ID": 168,
            "COMPANY_SCALE_TYPES_BIG_ID": 169,
            "COMPANY_SCALE_TYPES_SMALL_ID": 170,
            "BOOLEAN_YES_NO_TYPES_YES_ID": 171,
            "BOOLEAN_YES_NO_TYPES_NO_ID": 172,
            "JOB_CLASSIFICATION_TYPES_CAREER_CONSULTANT_ID": 173,
            "JOB_CLASSIFICATION_TYPES_SALES_ID": 174,
            "JOB_CLASSIFICATION_TYPES_OTHER_ID": 175,
            "INTERNAL_EXTERNAL_TYPES_INTERNAL_ID": 176,
            "INTERNAL_EXTERNAL_TYPES_EXTERNAL_ID": 177,
            "TRAINING_ENTITY_TYPES_EMPLOYER_ID": 178,
            "TRAINING_ENTITY_TYPES_CLIENT_ID": 179,
            "TRAINING_ENTITY_TYPES_INSTITUTIONS_ID": 180,
            "TRAINING_ENTITY_TYPES_OTHER_ID": 181,
            "BEAR_TRAINING_COST_TYPES_FREE_NO_COST_ID": 182,
            "BEAR_TRAINING_COST_TYPES_FREE_COST_ID": 183,
            "BEAR_TRAINING_COST_TYPES_NOT_FREE_ID": 184,
            "WAGE_PAYMENT_TRAINING_TYPES_PAID_ID": 185,
            "WAGE_PAYMENT_TRAINING_TYPES_PARTIALLY_PAID_ID": 186,
            "WAGE_PAYMENT_TRAINING_TYPES_UNPAID_ID": 187,
            "OTHER_TRAINING_METHOD_TYPES_OJT_ID": 188,
            "OTHER_TRAINING_METHOD_TYPES_OFF_JT_ID": 189,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_ENTRY_ID": 190,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_FUNCTION_ID": 191,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_JOB_TRANSITION_ID": 192,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_LEVEL_ID": 193,
            "EDUCATION_TRAINING_CLASSIFICATION_TYPES_OTHER_ID": 194,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_NONE_ID": 195,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_ENTRY_ID": 196,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_DISPATCHING_ID": 197,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_WAITING_ID": 198,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_SOME_YEAR_ID": 199,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_UNEXPIRED_ID": 200,
            "TARGET_WORKERS_CLASSIFICATION_TYPES_OTHER_ID": 201,
            "TRAINING_METHOD_TYPES_PLANED_OJT_ID": 202,
            "TRAINING_METHOD_TYPES_OFF_JT_ID": 203,
            "TRAINING_METHOD_TYPES_OJT_ID": 204,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_1_ID": 206,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_2_ID": 207,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_3_ID": 208,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_4_ID": 209,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_5_ID": 210,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_6_ID": 211,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_7_ID": 212,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_8_ID": 213,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_9_ID": 214,
            "LABOR_SAFETY_HEALTH_ACT_OR_REGULATIONS_TYPES_10_ID": 215,
            "EDUCATION_METHOD_TYPES_LEARNING_ID": 216,
            "EDUCATION_METHOD_TYPES_SKILL_ID": 217,
            "SIMPLE_STATE_TYPES_ENABLE_ID": 218,
            "SIMPLE_STATE_TYPES_DISABLE_ID": 219,
            "NUMBER_OF_EMPLOYEES_TYPES_CONTRACT_ID": 220,
            "NUMBER_OF_EMPLOYEES_TYPES_REGISTRATION_ID": 221,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_DESTINATION_ID": 222,
            "NUMBER_OF_BUSINESSES_TYPES_DISPATCH_COMPANY_ID": 223,
            "MAIL_OAUTH2_TYPE_NONE": 224,
            "MAIL_OAUTH2_TYPE_OFFICE365": 225,
            "MAIL_OAUTH2_TYPE_GMAIL": 226,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE_AND_SEND": 227,
            "MAIL_OAUTH2_SCOPE_TYPE_SEND": 228,
            "MAIL_OAUTH2_SCOPE_TYPE_RECEIVE": 229,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_NONE_ID": 230,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_1_ID": 231,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_2_ID": 232,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_3_ID": 233,
            "EMPLOYMENT_STABILITY_MEASURES_TYPES_4_ID": 234,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_APPLICATION_ID": 235,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_DISPATCHING_ID": 236,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_PLACEMENT_ID": 237,
            "EMPLOYMENT_PLACEMENT_DISPATCH_STATES_TYPES_EMPLOYED_ID": 238,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 244,
            "MHLW_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 245,
            "MHLW_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 246,
            "MHLW_OCCUPATION_RESEARCHER_ID": 247,
            "MHLW_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 248,
            "MHLW_OCCUPATION_DEVELOPMENT_ENGINEERS_ID": 249,
            "MHLW_OCCUPATION_PRODUCTION_ENGINEER_ID": 250,
            "MHLW_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 251,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_SOFTWARE_DEVELOPMENT_ID": 252,
            "MHLW_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEERS_EXCLUDING_SOFTWARE_DEVELOPMENT_ID": 253,
            "MHLW_OCCUPATION_OTHER_TECHNICAL_OCCUPATIONS_ID": 254,
            "MHLW_OCCUPATION_LEGAL_PROFESSION_ID": 255,
            "MHLW_OCCUPATION_PROFESSIONAL_OCCUPATIONS_IN_MANAGEMENT_FINANCE_AND_INSURANCE_ID": 256,
            "MHLW_OCCUPATION_RELIGIOUS_PERSON_ID": 257,
            "MHLW_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 258,
            "MHLW_OCCUPATION_ARTISTS_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 259,
            "MHLW_OCCUPATION_DESIGNER_ID": 260,
            "MHLW_OCCUPATION_MUSICIAN_PERFORMING_ARTIST": 261,
            "MHLW_OCCUPATION_LIBRARIANS_CURATORS_COUNSELORS_EXCLUDING_MEDICAL_AND_WELFARE_FACILITIES_ID": 262,
            "MHLW_OCCUPATION_OTHER_PROFESSIONAL_OCCUPATIONS_SUCH_AS_LEGAL_MANAGEMENT_CULTURAL_ARTS_ETC_ID": 263,
            "MHLW_OCCUPATION_PHYSICIANS_DENTISTS_VETERINARIANS_PHARMACISTS_ID": 264,
            "MHLW_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 265,
            "MHLW_OCCUPATION_NURSE_LICENSED_PRACTICAL_NURSE_ID": 266,
            "MHLW_OCCUPATION_MEDICAL_TECHNICIAN_ID": 267,
            "MHLW_OCCUPATION_NUTRITIONIST_REGISTERED_DIETITIAN_ID": 268,
            "MHLW_OCCUPATION_MASSAGE_THERAPISTS_ACUPUNCTURISTS_MOXIBUSTION_THERAPISTS_JUDO_THERAPISTS_ID": 269,
            "MHLW_OCCUPATION_OTHER_MEDICAL_NURSING_AND_HEALTH_PROFESSIONS_ID": 270,
            "MHLW_OCCUPATION_HEALTH_CARE_ASSISTANT_ID": 271,
            "MHLW_OCCUPATION_NURSERY_SCHOOL_TEACHER_KINDERGARTEN_TEACHER_ID": 272,
            "MHLW_OCCUPATION_AFTER_SCHOOL_CHILDCARE_INSTRUCTORS_CHILDCARE_ASSISTANTS_HOMELY_CHILDCARE_WORKERS_ID": 273,
            "MHLW_OCCUPATION_SCHOOL_TEACHERS_ID": 274,
            "MHLW_OCCUPATION_EDUCATION_RELATED_OCCUPATIONS_SUCH_AS_INSTRUCTION_OF_LESSONS_ID": 275,
            "MHLW_OCCUPATION_GENERAL_AFFAIRS_PERSONNEL_AND_PLANNING_OFFICE_OCCUPATIONS_ID": 276,
            "MHLW_OCCUPATION_GENERAL_OFFICE_SECRETARIAL_AND_RECEPTIONIST_OCCUPATIONS_ID": 277,
            "MHLW_OCCUPATION_OTHER_ADMINISTRATIVE_AND_OTHER_CLERICAL_OCCUPATIONS_ID": 278,
            "MHLW_OCCUPATION_OCCUPATION_OF_RECEPTIONIST_BY_TELEPHONE_AND_INTERNET_ID": 279,
            "MHLW_OCCUPATION_MEDICAL_AND_NURSING_OFFICE_OCCUPATIONS_ID": 280,
            "MHLW_OCCUPATION_OCCUPATION_OF_ACCOUNTING_CLERKS_ID": 281,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_ADMINISTRATIVE_OCCUPATIONS_ID": 282,
            "MHLW_OCCUPATION_SALES_AND_SALES_RELATED_OFFICE_OCCUPATIONS_ID": 283,
            "MHLW_OCCUPATION_OCCUPATION_OF_OUTSIDE_OFFICE_WORK_ID": 284,
            "MHLW_OCCUPATION_TRANSPORTATION_AND_POSTAL_CLERICAL_OCCUPATIONS_ID": 285,
            "MHLW_OCCUPATION_OCCUPATION_OF_OPERATING_COMPUTERS_AND_OTHER_OFFICE_EQUIPMENT_ID": 286,
            "MHLW_OCCUPATION_RETAIL_AND_WHOLESALE_STORE_MANAGERS_ID": 287,
            "MHLW_OCCUPATION_SALESPERSON_ID": 288,
            "MHLW_OCCUPATION_OCCUPATION_OF_COMMODITY_PURCHASING_AND_WHOLESALE_OF_RECYCLED_RESOURCES_ID": 289,
            "MHLW_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 290,
            "MHLW_OCCUPATION_SALES_OCCUPATIONS_ID": 291,
            "MHLW_OCCUPATION_PROFESSIONAL_WELFARE_AND_NURSING_CARE_OCCUPATIONS_ID": 292,
            "MHLW_OCCUPATION_FACILITY_CARE_OCCUPATIONS_ID": 293,
            "MHLW_OCCUPATION_HOME_CARE_OCCUPATION_ID": 294,
            "MHLW_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATION_ID": 295,
            "MHLW_OCCUPATION_BARBER_HAIRDRESSER_AND_BEAUTY_RELATED_SERVICE_OCCUPATIONS_ID": 296,
            "MHLW_OCCUPATION_BATHROOM_AND_CLEANING_OCCUPATIONS_ID": 297,
            "MHLW_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_OCCUPATIONS_ID": 298,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_HOSPITALITY_AND_CATERING_ID": 299,
            "MHLW_OCCUPATION_OCCUPATIONS_IN_THE_MANAGEMENT_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 300,
            "MHLW_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 301,
            "MHLW_OCCUPATION_GUARD_ID": 302,
            "MHLW_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 303,
            "MHLW_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 304,
            "MHLW_OCCUPATION_GUARDS_FIREFIGHTERS_ID": 305,
            "MHLW_OCCUPATION_OTHER_SECURITY_OCCUPATIONS_ID": 306,
            "MHLW_OCCUPATION_AGRICULTURAL_OCCUPATIONS_ID": 307,
            "MHLW_OCCUPATION_FORESTRY_OCCUPATIONS_ID": 308,
            "MHLW_OCCUPATION_FISHING_OCCUPATIONS_ID": 309,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_METAL_PRODUCTS_ID": 310,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATOR_FOODSTUFFS_ID": 311,
            "MHLW_OCCUPATION_PRODUCTION_EQUIPMENT_OPERATORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 312,
            "MHLW_OCCUPATION_MACHINE_ASSEMBLY_EQUIPMENT_OPERATOR_ID": 313,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_METAL_PRODUCTS_ID": 314,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_FOODSTUFFS_ID": 315,
            "MHLW_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_PROCESSOR_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 316,
            "MHLW_OCCUPATION_MECHANICAL_ASSEMBLER_ID": 317,
            "MHLW_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIRMAN_ID": 318,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 319,
            "MHLW_OCCUPATION_PRODUCT_INSPECTOR_FOODSTUFFS_ID": 320,
            "MHLW_OCCUPATION_PRODUCT_INSPECTORS_EXCLUDING_METAL_PRODUCTS_FOODSTUFFS_ID": 321,
            "MHLW_OCCUPATION_MACHINE_INSPECTOR_ID": 322,
            "MHLW_OCCUPATION_PRODUCTION_RELATED_OCCUPATIONS_ID": 323,
            "MHLW_OCCUPATION_PRODUCTION_LIKE_OCCUPATIONS_ID": 324,
            "MHLW_OCCUPATION_SHIPPING_AND_PICKUP_OCCUPATIONS_ID": 325,
            "MHLW_OCCUPATION_OCCUPATION_OF_FREIGHT_VEHICLE_DRIVING_ID": 326,
            "MHLW_OCCUPATION_BUS_DRIVING_OCCUPATION_ID": 327,
            "MHLW_OCCUPATION_PASSENGER_CAR_DRIVING_OCCUPATIONS_ID": 328,
            "MHLW_OCCUPATION_OTHER_MOTOR_VEHICLE_DRIVING_OCCUPATIONS_ID": 329,
            "MHLW_OCCUPATION_OCCUPATION_OF_RAILROAD_SHIP_AND_AIRCRAFT_OPERATION_ID": 330,
            "MHLW_OCCUPATION_OTHER_TRANSPORTATION_OCCUPATIONS_ID": 331,
            "MHLW_OCCUPATION_OCCUPATION_OF_FACILITY_MACHINERY_AND_EQUIPMENT_OPERATION_AND_CONSTRUCTION_EQUIPMENT_OPERATION_ID": 332,
            "MHLW_OCCUPATION_OCCUPATION_OF_CONSTRUCTION_FRAME_WORK_ID": 333,
            "MHLW_OCCUPATION_CONSTRUCTION_OCCUPATIONS_ID": 334,
            "MHLW_OCCUPATION_CIVIL_ENGINEERING_PROFESSION_ID": 335,
            "MHLW_OCCUPATION_MINING_OCCUPATIONS_ID": 336,
            "MHLW_OCCUPATION_ELECTRICAL_AND_TELECOMMUNICATIONS_CONSTRUCTION_OCCUPATIONS_ID": 337,
            "MHLW_OCCUPATION_CARGO_HANDLING_AND_TRANSPORT_WORKERS_ID": 338,
            "MHLW_OCCUPATION_CLEANING_AND_WASHING_WORKERS_ID": 339,
            "MHLW_OCCUPATION_PACKAGING_WORKER_ID": 340,
            "MHLW_OCCUPATION_SORTING_AND_PICKING_WORKERS_ID": 341,
            "MHLW_OCCUPATION_OTHER_OCCUPATIONS_SUCH_AS_TRANSPORT_CLEANING_PACKAGING_SORTING_ID": 342,
            "MHLW_OCCUPATION_PERFORMER_ID": 343,
            "MHLW_OCCUPATION_HOMEMAKER_HUSBAND_ID": 344,
            "MHLW_OCCUPATION_WAITER_ID": 345,
            "MHLW_OCCUPATION_A_PROFESSIONAL_CHEF_ID": 346,
            "MHLW_OCCUPATION_MODEL_ID": 347,
            "MHLW_OCCUPATION_MANNEQUIN_ID": 348,
            "MHLW_OCCUPATION_DOCTOR_ID": 349,
            "MHLW_OCCUPATION_DAYCARE_TEACHER_ID": 350,
            "MHLW_OCCUPATION_JOB_INTRODUCTION_ID": 351,
            "JAPAN_STD_OCCUPATION_ADMINISTRATIVE_CIVIL_SERVANT_ID": 354,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_OFFICERS_ID": 355,
            "JAPAN_STD_OCCUPATION_CORPORATIONS_ORGANIZATION_MANAGEMENT_STAFF_ID": 356,
            "JAPAN_STD_OCCUPATION_OTHER_MANAGERIAL_OCCUPATIONS_ID": 357,
            "JAPAN_STD_OCCUPATION_RESEARCHER_ID": 358,
            "JAPAN_STD_OCCUPATION_MINISTRY_OF_AGRICULTURE_FORESTRY_AND_FISHERIES_ID": 359,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_DEVELOPMENT_ID": 360,
            "JAPAN_STD_OCCUPATION_MANUFACTURING_ENGINEER_EXCLUDING_DEVELOPMENT_ID": 361,
            "JAPAN_STD_OCCUPATION_ARCHITECTURAL_CIVIL_ENGINEERING_SURVEYING_ENGINEER_ID": 362,
            "JAPAN_STD_OCCUPATION_INFORMATION_PROCESSING_AND_COMMUNICATIONS_ENGINEER_ID": 363,
            "JAPAN_STD_OCCUPATION_OTHER_ENGINEERS_ID": 364,
            "JAPAN_STD_OCCUPATION_DOCTOR_ID": 365,
            "JAPAN_STD_OCCUPATION_PHARMACIST_ID": 366,
            "JAPAN_STD_OCCUPATION_DENTIST_VETERINARIAN_ID": 367,
            "JAPAN_STD_OCCUPATION_NURSE_ID": 368,
            "JAPAN_STD_OCCUPATION_PRACTICAL_NURSE_ID": 369,
            "JAPAN_STD_OCCUPATION_PUBLIC_HEALTH_NURSES_MIDWIVES_ID": 370,
            "JAPAN_STD_OCCUPATION_RADIOLOGIC_TECHNOLOGIST_ID": 371,
            "JAPAN_STD_OCCUPATION_MEDICAL_TECHNOLOGIST_ID": 372,
            "JAPAN_STD_OCCUPATION_OTHER_MEDICAL_TECHNICIANS_ID": 373,
            "JAPAN_STD_OCCUPATION_OTHER_HEALTH_CARE_PROFESSIONALS_ID": 374,
            "JAPAN_STD_OCCUPATION_SOCIAL_WELFARE_PROFESSIONALS_ID": 375,
            "JAPAN_STD_OCCUPATION_LEGAL_WORKER_ID": 376,
            "JAPAN_STD_OCCUPATION_MANAGEMENT_FINANCE_AND_INSURANCE_PROFESSIONALS_ID": 377,
            "JAPAN_STD_OCCUPATION_TEACHING_STAFF_ID": 378,
            "JAPAN_STD_OCCUPATION_RELIGIOUS_PERSON_ID": 379,
            "JAPAN_STD_OCCUPATION_AUTHOR_REPORTER_EDITOR_ID": 380,
            "JAPAN_STD_OCCUPATION_ARTISTS_DESIGNER_PHOTOGRAPHERS_VIDEO_GRAPHERS_ID": 381,
            "JAPAN_STD_OCCUPATION_MUSICIAN_PERFORMING_ARTIST_ID": 382,
            "JAPAN_STD_OCCUPATION_OTHER_PROFESSIONAL_WORKERS_ID": 383,
            "JAPAN_STD_OCCUPATION_GENERAL_OFFICE_WORKER_ID": 384,
            "JAPAN_STD_OCCUPATION_ACCOUNTING_CLERK_ID": 385,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_OFFICE_WORKERS_ID": 386,
            "JAPAN_STD_OCCUPATION_SALES_AND_SALES_OFFICE_WORKERS_ID": 387,
            "JAPAN_STD_OCCUPATION_OUTSIDE_OFFICE_WORKER_ID": 388,
            "JAPAN_STD_OCCUPATION_TRANSPORTATION_AND_POSTAL_OFFICE_WORKERS_ID": 389,
            "JAPAN_STD_OCCUPATION_OFFICE_EQUIPMENT_OPERATOR_ID": 390,
            "JAPAN_STD_OCCUPATION_MERCHANDISE_SALES_PERSONNEL_ID": 391,
            "JAPAN_STD_OCCUPATION_SALES_SIMILAR_OCCUPATIONS_ID": 392,
            "JAPAN_STD_OCCUPATION_SALESPERSON_ID": 393,
            "JAPAN_STD_OCCUPATION_FAMILY_LIFE_SUPPORT_SERVICES_OCCUPATIONAL_WORKER_ID": 394,
            "JAPAN_STD_OCCUPATION_NURSING_SERVICE_OCCUPATIONAL_WORKER_ID": 395,
            "JAPAN_STD_OCCUPATION_HEALTH_AND_MEDICAL_SERVICE_PROFESSIONALS_ID": 396,
            "JAPAN_STD_OCCUPATION_LIFE_AND_HEALTH_SERVICE_OCCUPATIONAL_WORKER_ID": 397,
            "JAPAN_STD_OCCUPATION_FOOD_AND_BEVERAGE_PREPARATION_WORKER_ID": 398,
            "JAPAN_STD_OCCUPATION_EMPLOYEES_IN_THE_HOSPITALITY_AND_CATERING_PROFESSIONS_ID": 399,
            "JAPAN_STD_OCCUPATION_CARETAKER_OF_RESIDENTIAL_FACILITIES_BUILDINGS_ID": 400,
            "JAPAN_STD_OCCUPATION_OTHER_SERVICE_OCCUPATIONS_ID": 401,
            "JAPAN_STD_OCCUPATION_SELF_DEFENSE_OFFICER_ID": 402,
            "JAPAN_STD_OCCUPATION_JUDICIAL_POLICE_OFFICER_ID": 403,
            "JAPAN_STD_OCCUPATION_OTHER_SECURITY_PROFESSIONALS_ID": 404,
            "JAPAN_STD_OCCUPATION_FARMER_ID": 405,
            "JAPAN_STD_OCCUPATION_FORESTRY_WORKER_ID": 406,
            "JAPAN_STD_OCCUPATION_FISHERMAN_ID": 407,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_METAL_PRODUCTS_ID": 408,
            "JAPAN_STD_OCCUPATION_PRODUCTION_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 409,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_EQUIPMENT_CONTROL_AND_MONITORING_PERSONNEL_ID": 410,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_METAL_PRODUCTS": 411,
            "JAPAN_STD_OCCUPATION_PRODUCT_MANUFACTURING_AND_PROCESSING_TREATMENT_WORKERS_EXCLUDING_METAL_PRODUCTS_ID": 412,
            "JAPAN_STD_OCCUPATION_MACHINERY_ASSEMBLY_WORKERS_ID": 413,
            "JAPAN_STD_OCCUPATION_MACHINERY_MAINTENANCE_AND_REPAIR_PERSONNEL_ID": 414,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTOR_METAL_PRODUCTS_ID": 415,
            "JAPAN_STD_OCCUPATION_PRODUCT_INSPECTION_PERSONNEL_EXCLUDING_METAL_PRODUCTS_ID": 416,
            "JAPAN_STD_OCCUPATION_MACHINE_INSPECTOR_ID": 417,
            "JAPAN_STD_OCCUPATION_PRODUCTION_RELATED_AND_PRODUCTION_LIKE_WORKERS_ID": 418,
            "JAPAN_STD_OCCUPATION_RAILWAY_OPERATOR_ID": 419,
            "JAPAN_STD_OCCUPATION_CAR_DRIVER_ID": 420,
            "JAPAN_STD_OCCUPATION_SHIP_AND_AIRCRAFT_OPERATORS_ID": 421,
            "JAPAN_STD_OCCUPATION_OTHER_TRANSPORT_WORKERS_ID": 422,
            "JAPAN_STD_OCCUPATION_STATIONARY_AND_CONSTRUCTION_EQUIPMENT_OPERATOR_ID": 423,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_FRAME_WORKER_ID": 424,
            "JAPAN_STD_OCCUPATION_CONSTRUCTION_WORKER_ID": 425,
            "JAPAN_STD_OCCUPATION_ELECTRICIAN_ID": 426,
            "JAPAN_STD_OCCUPATION_CIVIL_ENGINEERING_WORKER_ID": 427,
            "JAPAN_STD_OCCUPATION_MINER_ID": 428,
            "JAPAN_STD_OCCUPATION_CARRIER_ID": 429,
            "JAPAN_STD_OCCUPATION_GARBAGE_COLLECTOR_ID": 430,
            "JAPAN_STD_OCCUPATION_PACKAGING_WORKER_ID": 431,
            "JAPAN_STD_OCCUPATION_OTHER_WORKERS_ENGAGED_IN_TRANSPORTATION_CLEANING_PACKAGING_ID": 432,
            "JAPAN_STD_OCCUPATION_UNCLASSIFIABLE_OCCUPATIONS_ID": 433,
            "EXPORT_ENCODING_SHIFT_JIS": 434,
            "EXPORT_ENCODING_UTF8": 435,
            "EXPORT_ENCODING_UTF8_WITH_BOM": 436,
            "MYRIC_MYPAGE_STATES_TYPES_UNOPENED": 437,
            "MYRIC_MYPAGE_STATES_TYPES_PROGRESS": 438,
            "MYRIC_MYPAGE_STATES_TYPES_OPENED": 439,
            "MYRIC_MYPAGE_STATES_TYPES_CANCEL": 440,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "group_key": null,
            "id": 0,
            "label": null,
            "position": null,
            "value": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\SystemDefaultOption",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "system_default_options"
    },
    "TaxRate": {
        "constants": {
            "RATE_8_ID": 1,
            "RATE_10_ID": 2,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "is_default": "0",
            "name": null,
            "rate": null,
            "updated_at": null,
            "sales": null,
            "saleRefunds": null,
            "contractAmountOverShorts": null,
            "dispatchJobAmountOverShorts": null
        },
        "relations": {
            "sales": "Sale",
            "saleRefunds": "SaleRefund",
            "contractAmountOverShorts": "ContractAmountOverShort",
            "dispatchJobAmountOverShorts": "DispatchJobAmountOverShort"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "tax_rates"
    },
    "Timezone": {
        "constants": {
            "ASIA_TOKYO": 1,
            "ASIA_HONG_KONG": 2,
            "UTC": 3,
            "AMERICA_NEW_YORK": 4,
            "AMERICA_LOS_ANGELES": 5,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "code": null,
            "id": 0,
            "name": null,
            "position": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "timezones"
    },
    "TravelExpense": {
        "constants": {
            "RESOURCE_TYPE_COMPANY": "App\\Models\\Company",
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "RESOURCE_TYPE_CANDIDATE": "App\\Models\\Candidate",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "id": 0,
            "invoice_expense_provision_type_id": null,
            "invoice_or_limit": null,
            "name": null,
            "payment_expense_provision_type_id": null,
            "payment_or_limit": null,
            "resource_id": null,
            "resource_type": null,
            "updated_at": null,
            "updated_user_id": null,
            "dispatchJobs": null,
            "contracts": null,
            "dispatchDestinations": null
        },
        "relations": {
            "dispatchJobs": "DispatchJob",
            "contracts": "Contract",
            "dispatchDestinations": "DispatchDestination"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchMaster",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "travel_expenses"
    },
    "User": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "SYSTEM_ADMIN_USER_ID": 10001,
            "ALERT_USER_ID": 10002,
            "HP_APP_ID": 10003,
            "MYPAGE_USER_ID": 10004,
            "MAP_MATCHING_USER_ID": 10005,
            "MYRIC_MYPAGE_USER_ID": 10006,
            "LINE_OPTION_USER_ID": 10007,
            "ACES_MEET_USER_ID": 10008,
            "NONE": "NONE",
            "POP_BEFORE_SMTP": "POP_BEFORE_SMTP",
            "SMTP_AUTH": "SMTP_AUTH",
            "TLS": "tls",
            "SSL": "ssl",
            "SHARE_CONVERT_COLUMNS": [
                "locale_id",
                "timezone_id",
                "user_role_id"
            ],
            "GRANT_PERMISSION": "grant",
            "ABSTRACT_USER_PREFIX": "property-column-id-",
            "ABSTRACT_USER_PROPERTY_COLUMNS": {
                "2": [
                    203
                ],
                "3": [
                    204
                ],
                "4": [
                    204,
                    205
                ],
                "5018": [
                    204,
                    5052
                ],
                "67": [
                    203,
                    204,
                    205,
                    5222
                ],
                "5001": [
                    204,
                    5213
                ],
                "64": [
                    203
                ],
                "65": [
                    204
                ],
                "5041": [
                    203,
                    204,
                    5222
                ],
                "5027": [
                    204,
                    5052,
                    5222
                ],
                "5025": [
                    204,
                    5052
                ],
                "5021": [
                    204,
                    5052
                ],
                "5023": [
                    204,
                    5052
                ],
                "78": [
                    181,
                    182,
                    205
                ],
                "14": [
                    204
                ]
            }
        },
        "properties": {
            "can_receive_mail_auto": "0",
            "created_at": null,
            "deleted_at": null,
            "department_id": null,
            "display_name": null,
            "email": null,
            "enabled": "1",
            "id": 0,
            "is_mail_confirmed": "1",
            "is_system_default": "0",
            "last_mail_import_succeed_at": null,
            "locale_id": null,
            "mail_receive_protocol_id": null,
            "password": null,
            "pop_account": null,
            "pop_password": null,
            "pop_port": null,
            "pop_server": null,
            "position": null,
            "release_note_id": null,
            "remember_token": null,
            "signature": null,
            "smtp_account": null,
            "smtp_auth_method": "NONE",
            "smtp_encryption": null,
            "smtp_password": null,
            "smtp_port": null,
            "smtp_server": null,
            "timezone_id": "1",
            "updated_at": null,
            "user_role_id": null,
            "CURRENT_CONNECTIONS": null,
            "MAX_SESSION_CONTROLLED_MEMORY": null,
            "MAX_SESSION_TOTAL_MEMORY": null,
            "TOTAL_CONNECTIONS": null,
            "USER": null,
            "freeItems": null,
            "downloadFileServerCreationLogs": null,
            "oauthClients": null,
            "googleAccount": null,
            "userRole": null,
            "locale": null,
            "timezone": null,
            "userMailOauth2Datum": null,
            "mailBatches": null,
            "userPermissions": null,
            "mailStarredUsers": null,
            "userSession": null,
            "tasks": null,
            "candidates": null,
            "jobs": null,
            "companies": null,
            "dispatchJobs": null,
            "mailReceiveProtocol": null,
            "mails": null,
            "schedules": null,
            "department": null,
            "userPasswordManagementSetting": null,
            "passwordChangeHistories": null,
            "mailTemplateUserPositions": null,
            "billingDestinations": null,
            "dispatchDestinations": null,
            "notifications": null
        },
        "relations": {
            "downloadFileServerCreationLogs": "DownloadFileServerCreationLog",
            "oauthClients": "OauthClient",
            "googleAccount": "GoogleAccount",
            "userRole": "UserRole",
            "locale": "Locale",
            "timezone": "Timezone",
            "userMailOauth2Datum": "UserMailOauth2Datum",
            "mailBatches": "MailBatch",
            "userPermissions": "UserPermission",
            "mailStarredUsers": "MailStarredUser",
            "userSession": "UserSession",
            "tasks": "Task",
            "candidates": "Candidate",
            "jobs": "Job",
            "companies": "Company",
            "dispatchJobs": "DispatchJob",
            "mailReceiveProtocol": "MailReceiveProtocol",
            "mails": "Mail",
            "schedules": "Schedule",
            "department": "Department",
            "userPasswordManagementSetting": "UserPasswordManagementSetting",
            "passwordChangeHistories": "PasswordChangeHistory",
            "mailTemplateUserPositions": "MailTemplateUserPosition",
            "billingDestinations": "BillingDestination",
            "dispatchDestinations": "DispatchDestination",
            "notifications": "Notification"
        },
        "appends": [
            "can_send_mail",
            "is_logged_in"
        ],
        "parents": [
            "Illuminate\\Foundation\\Auth\\User",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "users"
    },
    "UserMailOauth2Datum": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "failed_at": null,
            "failed_token": null,
            "id": 0,
            "is_failed_token_notified": "0",
            "mail_oauth2_scope_type_id": null,
            "mail_oauth2_type_id": null,
            "refresh_token": null,
            "user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_mail_oauth2_data"
    },
    "UserPasswordManagementSetting": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "id": 0,
            "is_initial_password_changed": null,
            "password_expiration_date": null,
            "signature_attached_to_url": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_password_management_settings"
    },
    "UserPermission": {
        "constants": {
            "GRANT": "grant",
            "DENY": "deny",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "permission": "deny",
            "route_name": null,
            "updated_at": null,
            "user_id": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_permissions"
    },
    "UserPreference": {
        "constants": {
            "DASHBOARD_FILTER_CANDIDATES": "dashboard_filter_candidates",
            "DASHBOARD_FILTER_JOBS": "dashboard_filter_jobs",
            "DASHBOARD_PROGRESS_STATE_FILTER_CANDIDATES": "dashboard_progress_state_filter_candidates",
            "DASHBOARD_PROGRESS_STATE_FILTER_JOBS": "dashboard_progress_state_filter_jobs"
        },
        "properties": {
            "created_at": null,
            "id": 0,
            "key": null,
            "updated_at": null,
            "user_id": null,
            "value": null,
            "user": null
        },
        "relations": {
            "user": "User"
        },
        "appends": [],
        "parents": [
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_preferences"
    },
    "UserRole": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001,
            "ADMIN": 1,
            "NORMAL": 2,
            "SYSTEM_ADMIN": 3,
            "API_V2": 4
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "name": null,
            "updated_at": null,
            "rolePermissions": null,
            "userRoleDetails": null,
            "users": null
        },
        "relations": {
            "rolePermissions": "RolePermission",
            "userRoleDetails": "UserRoleDetail",
            "users": "User"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_roles"
    },
    "UserRoleDetail": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "id": 0,
            "updated_at": null,
            "user_role_detail_master_id": null,
            "user_role_id": null,
            "userRoleDetailMaster": null
        },
        "relations": {
            "userRoleDetailMaster": "UserRoleDetailMaster"
        },
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_role_details"
    },
    "UserRoleDetailMaster": {
        "constants": {
            "EXPORT_CANDIDATES": 1,
            "DESTROY_CANDIDATES": 2,
            "EXPORT_JOBS": 3,
            "DESTROY_JOBS": 4,
            "EXPORT_DISPATCH_JOBS": 5,
            "DESTROY_DISPATCH_JOBS": 6,
            "EXPORT_COMPANIES": 7,
            "DESTROY_COMPANIES": 8,
            "EXPORT_STAFFS": 9,
            "DESTROY_STAFFS": 10,
            "EXPORT_CANDIDATE_STEPS": 11,
            "DESTROY_CANDIDATE_STEPS": 12,
            "EXPORT_COMPANY_STEPS": 13,
            "DESTROY_COMPANY_STEPS": 14,
            "EXPORT_CANDIDATE_JOB_STEPS": 15,
            "DESTROY_CANDIDATE_JOB_STEPS": 16,
            "EXPORT_SALES": 17,
            "DESTROY_SALES": 18,
            "EXPORT_BILLING_DESTINATIONS": 19,
            "DESTROY_BILLING_DESTINATIONS": 20,
            "EXPORT_DISPATCH_DESTINATIONS": 21,
            "DESTROY_DISPATCH_DESTINATIONS": 22,
            "EXPORT_DISPATCH_STAFFS": 23,
            "DESTROY_DISPATCH_STAFFS": 24,
            "EXPORT_DISPATCH_WORKING_PLACES": 25,
            "DESTROY_DISPATCH_WORKING_PLACES": 26,
            "EXPORT_DISPATCH_ORGANIZATION_UNITS": 27,
            "DESTROY_DISPATCH_ORGANIZATION_UNITS": 28,
            "EXPORT_CONTRACTS": 29,
            "DESTROY_CONTRACTS": 30,
            "EDIT_CANDIDATES": 31,
            "EDIT_JOBS": 32,
            "EDIT_COMPANIES": 33,
            "EDIT_STAFFS": 34,
            "EDIT_CANDIDATE_STEPS": 35,
            "EDIT_COMPANY_STEPS": 36,
            "EDIT_CANDIDATE_JOB_STEPS": 37,
            "EDIT_SALES": 38,
            "STORE_CANDIDATES": 39,
            "STORE_JOBS": 40,
            "STORE_COMPANIES": 41,
            "STORE_STAFFS": 42,
            "STORE_CANDIDATE_STEPS": 43,
            "STORE_COMPANY_STEPS": 44,
            "STORE_CANDIDATE_JOB_STEPS": 45,
            "STORE_SALES": 46,
            "EDIT_DISPATCH_JOBS": 47,
            "EDIT_BILLING_DESTINATIONS": 48,
            "EDIT_DISPATCH_DESTINATIONS": 49,
            "EDIT_DISPATCH_STAFFS": 50,
            "EDIT_DISPATCH_WORKING_PLACES": 51,
            "EDIT_DISPATCH_ORGANIZATION_UNITS": 52,
            "EDIT_CONTRACTS": 53,
            "STORE_DISPATCH_JOBS": 54,
            "STORE_BILLING_DESTINATIONS": 55,
            "STORE_DISPATCH_DESTINATIONS": 56,
            "STORE_DISPATCH_STAFFS": 57,
            "STORE_DISPATCH_WORKING_PLACES": 58,
            "STORE_DISPATCH_ORGANIZATION_UNITS": 59,
            "STORE_CONTRACTS": 60,
            "IMPORT_CANDIDATES": 61,
            "IMPORT_JOBS": 62,
            "IMPORT_COMPANIES": 63,
            "IMPORT_STAFFS": 64,
            "IMPORT_CANDIDATE_STEPS": 65,
            "IMPORT_COMPANY_STEPS": 66,
            "IMPORT_CANDIDATE_JOB_STEPS": 67,
            "IMPORT_DISPATCH_JOBS": 68,
            "IMPORT_BILLING_DESTINATIONS": 69,
            "IMPORT_DISPATCH_DESTINATIONS": 70,
            "IMPORT_DISPATCH_STAFFS": 71,
            "IMPORT_DISPATCH_WORKING_PLACES": 72,
            "IMPORT_DISPATCH_ORGANIZATION_UNITS": 73,
            "IMPORT_CONTRACTS": 74,
            "REPORT_CANDIDATES": 75,
            "REPORT_JOBS": 76,
            "REPORT_COMPANIES": 77,
            "REPORT_SALES": 78,
            "REPORT_DATA_REPORTS": 79,
            "REPORT_DISPATCH_JOBS": 80,
            "REPORT_CONTRACTS": 81,
            "EXPORT_DATA": 82,
            "SUMMARY_DATA": 83,
            "MAIL_CANDIDATES": 84,
            "BULK_MAIL_CANDIDATES": 85,
            "MAIL_COMPANIES": 86,
            "MAIL_STAFFS": 87,
            "MAIL_DISPATCH_DESTINATIONS": 88,
            "MAIL_DISPATCH_STAFFS": 89,
            "MAIL_BILLING_DESTINATIONS": 90,
            "MAIL_DISPATCH_ORGANIZATION_UNITS": 91,
            "MAIL_DISPATCH_WORKING_PLACES": 92,
            "BULK_MAIL_COMPANIES": 93,
            "BULK_MAIL_STAFFS": 94,
            "BULK_MAIL_DISPATCH_DESTINATIONS": 95,
            "BULK_MAIL_DISPATCH_STAFFS": 96,
            "BULK_MAIL_BILLING_DESTINATIONS": 97,
            "BULK_MAIL_DISPATCH_ORGANIZATION_UNITS": 98,
            "BULK_MAIL_DISPATCH_WORKING_PLACES": 99,
            "DISPLAY_CANDIDATES": 100,
            "DISPLAY_JOBS": 101,
            "DISPLAY_COMPANIES": 102,
            "DISPLAY_STAFFS": 103,
            "DISPLAY_CANDIDATE_STEPS": 104,
            "DISPLAY_COMPANY_STEPS": 105,
            "DISPLAY_CANDIDATE_JOB_STEPS": 106,
            "DISPLAY_SALES": 107,
            "DISPLAY_DISPATCH_JOBS": 108,
            "DISPLAY_BILLING_DESTINATIONS": 109,
            "DISPLAY_DISPATCH_DESTINATIONS": 110,
            "DISPLAY_DISPATCH_STAFFS": 111,
            "DISPLAY_DISPATCH_WORKING_PLACES": 112,
            "DISPLAY_DISPATCH_ORGANIZATION_UNITS": 113,
            "DISPLAY_CONTRACTS": 114,
            "DISPLAY_CANDIDATE_DASHBOARDS": 115,
            "DISPLAY_JOB_DASHBOARDS": 116,
            "DISPLAY_DATA": 117,
            "EXPORT_CANDIDATE_DASHBOARD": 118,
            "EXPORT_JOB_DASHBOARD": 119,
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "deleted_at": null,
            "display_name": null,
            "id": 0,
            "position": null,
            "resource_table_name": null,
            "route_name": null,
            "updated_at": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_role_detail_masters"
    },
    "UserSession": {
        "constants": {
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "expire_at": null,
            "id": 0,
            "session_id": null,
            "updated_at": null,
            "user_id": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "user_sessions"
    },
    "Wage": {
        "constants": {
            "RESOURCE_TYPE_COMPANY": "App\\Models\\Company",
            "RESOURCE_TYPE_DISPATCH_DESTINATION": "App\\Models\\DispatchDestination",
            "RESOURCE_TYPE_CANDIDATE": "App\\Models\\Candidate",
            "USER_ROW_OFFSET_ID": 1000001
        },
        "properties": {
            "created_at": null,
            "created_user_id": null,
            "deleted_at": null,
            "id": 0,
            "invoice_basic_unit_wage": null,
            "invoice_early_attendance_boolean_approve_type_id": null,
            "invoice_half_holiday_allocation_hour": null,
            "invoice_leave_deduction": null,
            "invoice_legal_holiday_unit_wage": null,
            "invoice_legal_over_time_unit_wage": null,
            "invoice_night_extra_unit_wage": null,
            "invoice_non_legal_over_time_month_45_unit_wage": null,
            "invoice_non_legal_over_time_month_60_unit_wage": null,
            "invoice_non_legal_over_time_unit_wage": null,
            "invoice_over_weekly_legal_working_hour_unit_wage": null,
            "invoice_prescribed_holiday_unit_wage": null,
            "invoice_prescribed_hour_short_deduction": null,
            "invoice_wage_type_id": null,
            "invoice_weekly_legal_working_hour": null,
            "name": null,
            "prescribed_working_hours": null,
            "resource_id": null,
            "resource_type": null,
            "updated_at": null,
            "updated_user_id": null,
            "working_days": null
        },
        "relations": [],
        "appends": [],
        "parents": [
            "App\\Models\\Bases\\DispatchMaster",
            "App\\Models\\Bases\\Model",
            "Illuminate\\Database\\Eloquent\\Model"
        ],
        "table": "wages"
    }
}
